// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acquisition Store API
 * API for managing acquisition in-store.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AppHealthDto,
  AppVersionDto,
  BatchCsvControllerFindAllPaginated200,
  BatchCsvControllerFindAllPaginatedParams,
  ChangelogControllerGetVersions200,
  ChangelogControllerGetVersionsParams,
  CloseInternalLedgerSessionDto,
  CompanionBarcodeScanDto,
  CompanionFileDto,
  CompanionOfferCreateStateDto,
  CompanionOfferDisplayDto,
  CompanionOfferDisplayReceiptDto,
  CompanionSseMessageDto,
  CountInternalLedgerSessionDto,
  CreateBatchCsvDocumentDto,
  CreateCompanionBarcodeScanDto,
  CreateCompanionFileTokenDto,
  CreateCompanionOfferDto,
  CreateCompanionOfferImageDto,
  CreateCompanionSessionDto,
  CreateCustomSettingDto,
  CreateExternalIntegrationOfferDto,
  CreateExternalIntegrationOfferImageDto,
  CreateExternalIntegrationOfferItemDto,
  CreateExternalIntegrationWebhookDto,
  CreateHandlingItemDto,
  CreateHandlingItemImageDto,
  CreateInternalLedgerAdjustmentDto,
  CreateInternalLedgerDto,
  CreateOfferBatchCsvDto,
  CreateOfferCommentDto,
  CreateOfferDto,
  CreateOfferImageDto,
  CreateOfferItemDto,
  CreateOfferMarkupDto,
  CreateOfferMarkupFromCampaignDto,
  CreateOfferTemplateDto,
  CreateOfferTransactionDto,
  CreateOfferTransactionExternalDto,
  CreatePaypalPayoutQueueDto,
  CreateSettingsMarkupCampaignDto,
  CreateShopifyCashPayoutQueueDto,
  CreateSourceBuyerAddressDto,
  CreateSourceDto,
  CreateUploadS3MultipartDto,
  CreateUserClientDto,
  CreateUserDto,
  ErrorBadRequestDto,
  ErrorConflictDto,
  ErrorForbiddenDto,
  ErrorNotFoundDto,
  ErrorServerDto,
  ErrorTooManyRequestsDto,
  ErrorUnauthorizedDto,
  ExportOfferControllerExportAllParams,
  ExportOfferItemControllerExportAllParams,
  ExportSourceStatsControllerExportReceiptStatsParams,
  GenerateCreateOfferMarkupDto,
  HandlingItemControllerFindAll200,
  HandlingItemControllerFindAllParams,
  HandlingItemControllerTransition201,
  HandlingItemTransitionCompleteProcessingDto,
  HandlingItemTransitionDto,
  HandlingItemTransitionFailProcessingDto,
  HandlingItemTransitionFinishReviewDto,
  HandlingItemTransitionRevertTypeDto,
  HandlingItemTransitionSetTypeDto,
  HandlingItemTransitionSubmitForReviewDto,
  InstantiateOfferTemplateDto,
  InternalLedgerAdjustmentControllerFindAll200,
  InternalLedgerAdjustmentControllerFindAllParams,
  InternalLedgerControllerFindAll200,
  InternalLedgerControllerFindAllParams,
  InternalLedgerSessionControllerFindAll200,
  InternalLedgerSessionControllerFindAllParams,
  LogApiKeepaControllerPaginate200,
  LogApiKeepaControllerPaginateParams,
  LogApiLlmControllerPaginate200,
  LogApiLlmControllerPaginateParams,
  LogApiPaypalControllerPaginate200,
  LogApiPaypalControllerPaginateParams,
  LogApiShopifyControllerPaginate200,
  LogApiShopifyControllerPaginateParams,
  LogApiTricomaControllerPaginate200,
  LogApiTricomaControllerPaginateParams,
  LogAuthControllerPaginate200,
  LogAuthControllerPaginateParams,
  LogExternalIntegrationControllerPaginate200,
  LogExternalIntegrationControllerPaginateParams,
  LogHandlingItemTransitionControllerFindAllForItem200,
  LogHandlingItemTransitionControllerFindAllForItemParams,
  LogMailControllerPaginate200,
  LogMailControllerPaginateParams,
  LogOfferItemPriceControllerFindAllForOffer200,
  LogOfferItemPriceControllerFindAllForOfferItem200,
  LogOfferItemPriceControllerFindAllForOfferItemParams,
  LogOfferItemPriceControllerFindAllForOfferParams,
  LogOfferTransitionControllerFindAllForOffer200,
  LogOfferTransitionControllerFindAllForOfferParams,
  LogPushControllerPaginate200,
  LogPushControllerPaginateParams,
  LoginDto,
  LoginPinDto,
  LoginUserResponseDto,
  MergeOffersDto,
  OfferCommentControllerFindAll200,
  OfferCommentControllerFindAllParams,
  OfferControllerFindAll200,
  OfferControllerFindAllParams,
  OfferControllerFindAllWithIncompleteTransactions200,
  OfferControllerFindAllWithIncompleteTransactionsParams,
  OfferControllerFindOneParams,
  OfferFreezeDto,
  OfferItemControllerFindAllForOffer200,
  OfferItemControllerFindAllForOfferParams,
  OfferItemLookupControllerFindAll200,
  OfferItemLookupControllerFindAllParams,
  OfferItemResolveDuplicatesDto,
  OfferLockDto,
  OfferReceiptControllerFindAll200,
  OfferReceiptControllerFindAllParams,
  OfferReceiptControllerFindOneActiveParams,
  OfferTemplateControllerFindAll200,
  OfferTemplateControllerFindAllParams,
  OfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionParams,
  OfferTransitionCompleteDto,
  OfferTransitionDto,
  OfferTransitionProcessTransactionDto,
  OfferTransitionSelectItemsDto,
  OpenInternalLedgerSessionDto,
  PinTokenResponseDto,
  PosDeviceControllerFindAll200,
  PosDeviceControllerFindAllParams,
  PosTokenResponseDto,
  ProcessOfferTransactionDto,
  PushNotificationCustomMessageDto,
  PutPushNotificationListCustomDto,
  PutPushNotificationListHandlingItemDto,
  PutPushNotificationListOfferDto,
  RefExternalIntegrationOfferItemDto,
  RefOfferDto,
  RefUserDto,
  RegisterPosDto,
  ResponseBatchCsvDocumentDto,
  ResponseCompanionAuthDto,
  ResponseCompanionPairingDto,
  ResponseCompanionSessionDto,
  ResponseCompanionSessionStatusDto,
  ResponseCompanionSseTicketDto,
  ResponseExternalIntegrationCreateOfferDto,
  ResponseExternalIntegrationOfferDto,
  ResponseExternalIntegrationOfferImageDto,
  ResponseExternalIntegrationSourceDto,
  ResponseExternalIntegrationWebhookDto,
  ResponseHandlingItemDto,
  ResponseHandlingItemImageDto,
  ResponseHandlingKeepInStoreItemDto,
  ResponseHandlingManualItemDto,
  ResponseHandlingSendToBaseItemDto,
  ResponseHandlingSendToStoreItemDto,
  ResponseHandlingUndecidedItemDto,
  ResponseInternalLedgerAdjustmentDto,
  ResponseInternalLedgerDto,
  ResponseInternalLedgerSessionDto,
  ResponseOfferBatchCsvCreateDto,
  ResponseOfferBatchCsvJobDto,
  ResponseOfferBatchJobDto,
  ResponseOfferCommentDto,
  ResponseOfferDto,
  ResponseOfferImageDto,
  ResponseOfferItemDto,
  ResponseOfferMarkupDto,
  ResponseOfferReceiptDto,
  ResponseOfferTemplateDto,
  ResponseOfferTransactionDto,
  ResponsePaypalPayoutQueueDto,
  ResponsePosDeviceDto,
  ResponsePushNotificationBroadcastDto,
  ResponsePushNotificationListCustomDto,
  ResponsePushNotificationListHandlingItemDto,
  ResponsePushNotificationListOfferDto,
  ResponsePushNotificationSubscriptionDto,
  ResponseResponseOfferTransactionExternalDto,
  ResponseSettingCustomSettingDto,
  ResponseSettingGroupDto,
  ResponseSettingsMarkupCampaignDto,
  ResponseShopifyCashPayoutQueueDto,
  ResponseSourceBuyerAddressDto,
  ResponseSourceDto,
  ResponseSourceReceiptStatsDto,
  ResponseTransactionExternalProviderDto,
  ResponseUploadS3MultipartAbortDto,
  ResponseUploadS3MultipartCompleteDto,
  ResponseUploadS3MultipartCreateDto,
  ResponseUploadS3MultipartPartDto,
  ResponseUploadS3MultipartSignPartDto,
  ResponseUploadS3PresignDto,
  ResponseUploadS3SignDto,
  ResponseUserClientDto,
  ResponseUserClientTokenDto,
  ResponseUserDto,
  SearchControllerFindByReferenceParams,
  SearchControllerSearchParams,
  SearchResponseItemDto,
  SendTransactionReceiptMailDto,
  SetCompanionOfferDisplayDto,
  SetCompanionOfferDisplayReceiptDto,
  SetCompanionOfferSourceDto,
  SettingsMarkupCampaignControllerFindAll200,
  SettingsMarkupCampaignControllerFindAllParams,
  SignCompanionFileTokenDto,
  SignCompanionOfferImageDto,
  SourceStatsControllerFindReceiptStatsParams,
  SubscribePushNotificationDto,
  UnsubscribePushNotificationDto,
  UpdateCompanionOfferDisplayDto,
  UpdateExternalIntegrationOfferItemDto,
  UpdateHandlingItemDto,
  UpdateInternalLedgerDto,
  UpdateOfferCommentDto,
  UpdateOfferDto,
  UpdateOfferItemDto,
  UpdateOfferMarkupDto,
  UpdateOfferTemplateDto,
  UpdatePosDeviceDto,
  UpdateSettingsMarkupCampaignDto,
  UpdateSourceBuyerAddressDto,
  UpdateSourceDto,
  UpdateUserDto,
  UpdateUserPasswordDto,
  UpdateUserPinDto,
  UploadS3ControllerAbortMultipartParams,
  UploadS3ControllerCompleteMultipartParams,
  UploadS3ControllerListMultipartPartsParams,
  UploadS3ControllerSignMultipartPartParams,
  UploadS3ControllerSignWithParamsParams,
  UploadS3MultipartCompleteBodyDto,
  UploadS3PresignBodyDto,
  UploadS3SignBodyDto,
  UserControllerFindAll200,
  UserControllerFindAllParams
} from './model';

import { customFetch } from '../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type appControllerGetVersionResponse200 = {
  data: AppVersionDto
  status: 200
}

export type appControllerGetVersionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type appControllerGetVersionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type appControllerGetVersionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type appControllerGetVersionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type appControllerGetVersionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type appControllerGetVersionResponseSuccess = (appControllerGetVersionResponse200) & {
  headers: Headers;
};
export type appControllerGetVersionResponseError = (appControllerGetVersionResponse400 | appControllerGetVersionResponse401 | appControllerGetVersionResponse403 | appControllerGetVersionResponse404 | appControllerGetVersionResponse500) & {
  headers: Headers;
};

export type appControllerGetVersionResponse = (appControllerGetVersionResponseSuccess | appControllerGetVersionResponseError)

export const getAppControllerGetVersionUrl = () => {




  return `/version`
}

export const appControllerGetVersion = async ( options?: Parameters<typeof customFetch>[1]): Promise<appControllerGetVersionResponse> => {

  return customFetch<appControllerGetVersionResponse>(getAppControllerGetVersionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppControllerGetVersionQueryKey = () => {
    return [
    'version'
    ] as const;
    }


export const getAppControllerGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetVersion>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAppControllerGetVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetVersion>>> = ({ signal }) => appControllerGetVersion({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerGetVersion>>, TError, TData>
}

export type AppControllerGetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetVersion>>>
export type AppControllerGetVersionQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useAppControllerGetVersion<TData = Awaited<ReturnType<typeof appControllerGetVersion>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetVersion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppControllerGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type appControllerGetHealthResponse200 = {
  data: AppHealthDto
  status: 200
}

export type appControllerGetHealthResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type appControllerGetHealthResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type appControllerGetHealthResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type appControllerGetHealthResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type appControllerGetHealthResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type appControllerGetHealthResponseSuccess = (appControllerGetHealthResponse200) & {
  headers: Headers;
};
export type appControllerGetHealthResponseError = (appControllerGetHealthResponse400 | appControllerGetHealthResponse401 | appControllerGetHealthResponse403 | appControllerGetHealthResponse404 | appControllerGetHealthResponse500) & {
  headers: Headers;
};

export type appControllerGetHealthResponse = (appControllerGetHealthResponseSuccess | appControllerGetHealthResponseError)

export const getAppControllerGetHealthUrl = () => {




  return `/health`
}

export const appControllerGetHealth = async ( options?: Parameters<typeof customFetch>[1]): Promise<appControllerGetHealthResponse> => {

  return customFetch<appControllerGetHealthResponse>(getAppControllerGetHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppControllerGetHealthQueryKey = () => {
    return [
    'health'
    ] as const;
    }


export const getAppControllerGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetHealth>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getAppControllerGetHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetHealth>>> = ({ signal }) => appControllerGetHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHealth>>, TError, TData>
}

export type AppControllerGetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetHealth>>>
export type AppControllerGetHealthQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useAppControllerGetHealth<TData = Awaited<ReturnType<typeof appControllerGetHealth>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHealth>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppControllerGetHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type authControllerLoginResponse200 = {
  data: LoginUserResponseDto
  status: 200
}

export type authControllerLoginResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type authControllerLoginResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type authControllerLoginResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type authControllerLoginResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type authControllerLoginResponse429 = {
  data: ErrorTooManyRequestsDto
  status: 429
}

export type authControllerLoginResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type authControllerLoginResponseSuccess = (authControllerLoginResponse200) & {
  headers: Headers;
};
export type authControllerLoginResponseError = (authControllerLoginResponse400 | authControllerLoginResponse401 | authControllerLoginResponse403 | authControllerLoginResponse404 | authControllerLoginResponse429 | authControllerLoginResponse500) & {
  headers: Headers;
};

export type authControllerLoginResponse = (authControllerLoginResponseSuccess | authControllerLoginResponseError)

export const getAuthControllerLoginUrl = () => {




  return `/auth/login`
}

export const authControllerLogin = async (loginDto: LoginDto, options?: Parameters<typeof customFetch>[1]): Promise<authControllerLoginResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<authControllerLoginResponse>(getAuthControllerLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginDto)
  }
);}





export const getAuthControllerLoginMutationKey = () => ['authControllerLogin'] as const;

export const getAuthControllerLoginMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorTooManyRequestsDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,AuthControllerLoginMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,AuthControllerLoginMutationVariables, TContext> => {

const mutationKey = getAuthControllerLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLogin>>, AuthControllerLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authControllerLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLogin>>>
    export type AuthControllerLoginMutationBody = LoginDto
    export type AuthControllerLoginMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorTooManyRequestsDto | ErrorServerDto
    export type AuthControllerLoginMutationVariables = {data: LoginDto}

    export const useAuthControllerLogin = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorTooManyRequestsDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,AuthControllerLoginMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof authControllerLogin>>,
        TError,
        AuthControllerLoginMutationVariables,
        TContext
      > => {
      return useMutation(getAuthControllerLoginMutationOptions(options), queryClient);
    }

export type authControllerRefreshTokenResponse201 = {
  data: LoginUserResponseDto
  status: 201
}

export type authControllerRefreshTokenResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type authControllerRefreshTokenResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type authControllerRefreshTokenResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type authControllerRefreshTokenResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type authControllerRefreshTokenResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type authControllerRefreshTokenResponseSuccess = (authControllerRefreshTokenResponse201) & {
  headers: Headers;
};
export type authControllerRefreshTokenResponseError = (authControllerRefreshTokenResponse400 | authControllerRefreshTokenResponse401 | authControllerRefreshTokenResponse403 | authControllerRefreshTokenResponse404 | authControllerRefreshTokenResponse500) & {
  headers: Headers;
};

export type authControllerRefreshTokenResponse = (authControllerRefreshTokenResponseSuccess | authControllerRefreshTokenResponseError)

export const getAuthControllerRefreshTokenUrl = () => {




  return `/auth/refresh-token`
}

export const authControllerRefreshToken = async ( options?: Parameters<typeof customFetch>[1]): Promise<authControllerRefreshTokenResponse> => {

  return customFetch<authControllerRefreshTokenResponse>(getAuthControllerRefreshTokenUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAuthControllerRefreshTokenMutationKey = () => ['authControllerRefreshToken'] as const;

export const getAuthControllerRefreshTokenMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshToken>>, TError,void, TContext> => {

const mutationKey = getAuthControllerRefreshTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRefreshToken>>, void> = () => {


          return  authControllerRefreshToken(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRefreshToken>>>

    export type AuthControllerRefreshTokenMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


    export const useAuthControllerRefreshToken = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof authControllerRefreshToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthControllerRefreshTokenMutationOptions(options), queryClient);
    }

export type authControllerLoginPinResponse200 = {
  data: PinTokenResponseDto
  status: 200
}

export type authControllerLoginPinResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type authControllerLoginPinResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type authControllerLoginPinResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type authControllerLoginPinResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type authControllerLoginPinResponse429 = {
  data: ErrorTooManyRequestsDto
  status: 429
}

export type authControllerLoginPinResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type authControllerLoginPinResponseSuccess = (authControllerLoginPinResponse200) & {
  headers: Headers;
};
export type authControllerLoginPinResponseError = (authControllerLoginPinResponse400 | authControllerLoginPinResponse401 | authControllerLoginPinResponse403 | authControllerLoginPinResponse404 | authControllerLoginPinResponse429 | authControllerLoginPinResponse500) & {
  headers: Headers;
};

export type authControllerLoginPinResponse = (authControllerLoginPinResponseSuccess | authControllerLoginPinResponseError)

export const getAuthControllerLoginPinUrl = () => {




  return `/auth/pin/login`
}

export const authControllerLoginPin = async (loginPinDto: LoginPinDto, options?: Parameters<typeof customFetch>[1]): Promise<authControllerLoginPinResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<authControllerLoginPinResponse>(getAuthControllerLoginPinUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginPinDto)
  }
);}





export const getAuthControllerLoginPinMutationKey = () => ['authControllerLoginPin'] as const;

export const getAuthControllerLoginPinMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorTooManyRequestsDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLoginPin>>, TError,AuthControllerLoginPinMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerLoginPin>>, TError,AuthControllerLoginPinMutationVariables, TContext> => {

const mutationKey = getAuthControllerLoginPinMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLoginPin>>, AuthControllerLoginPinMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authControllerLoginPin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerLoginPinMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLoginPin>>>
    export type AuthControllerLoginPinMutationBody = LoginPinDto
    export type AuthControllerLoginPinMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorTooManyRequestsDto | ErrorServerDto
    export type AuthControllerLoginPinMutationVariables = {data: LoginPinDto}

    export const useAuthControllerLoginPin = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorTooManyRequestsDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLoginPin>>, TError,AuthControllerLoginPinMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof authControllerLoginPin>>,
        TError,
        AuthControllerLoginPinMutationVariables,
        TContext
      > => {
      return useMutation(getAuthControllerLoginPinMutationOptions(options), queryClient);
    }

export type authControllerRefreshPinResponse201 = {
  data: PinTokenResponseDto
  status: 201
}

export type authControllerRefreshPinResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type authControllerRefreshPinResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type authControllerRefreshPinResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type authControllerRefreshPinResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type authControllerRefreshPinResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type authControllerRefreshPinResponseSuccess = (authControllerRefreshPinResponse201) & {
  headers: Headers;
};
export type authControllerRefreshPinResponseError = (authControllerRefreshPinResponse400 | authControllerRefreshPinResponse401 | authControllerRefreshPinResponse403 | authControllerRefreshPinResponse404 | authControllerRefreshPinResponse500) & {
  headers: Headers;
};

export type authControllerRefreshPinResponse = (authControllerRefreshPinResponseSuccess | authControllerRefreshPinResponseError)

export const getAuthControllerRefreshPinUrl = () => {




  return `/auth/pin/refresh`
}

export const authControllerRefreshPin = async ( options?: Parameters<typeof customFetch>[1]): Promise<authControllerRefreshPinResponse> => {

  return customFetch<authControllerRefreshPinResponse>(getAuthControllerRefreshPinUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAuthControllerRefreshPinMutationKey = () => ['authControllerRefreshPin'] as const;

export const getAuthControllerRefreshPinMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshPin>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshPin>>, TError,void, TContext> => {

const mutationKey = getAuthControllerRefreshPinMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRefreshPin>>, void> = () => {


          return  authControllerRefreshPin(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerRefreshPinMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRefreshPin>>>

    export type AuthControllerRefreshPinMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


    export const useAuthControllerRefreshPin = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshPin>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof authControllerRefreshPin>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthControllerRefreshPinMutationOptions(options), queryClient);
    }

export type logApiShopifyControllerPaginateResponse200 = {
  data: LogApiShopifyControllerPaginate200
  status: 200
}

export type logApiShopifyControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logApiShopifyControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logApiShopifyControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logApiShopifyControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logApiShopifyControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logApiShopifyControllerPaginateResponseSuccess = (logApiShopifyControllerPaginateResponse200) & {
  headers: Headers;
};
export type logApiShopifyControllerPaginateResponseError = (logApiShopifyControllerPaginateResponse400 | logApiShopifyControllerPaginateResponse401 | logApiShopifyControllerPaginateResponse403 | logApiShopifyControllerPaginateResponse404 | logApiShopifyControllerPaginateResponse500) & {
  headers: Headers;
};

export type logApiShopifyControllerPaginateResponse = (logApiShopifyControllerPaginateResponseSuccess | logApiShopifyControllerPaginateResponseError)

export const getLogApiShopifyControllerPaginateUrl = (params?: LogApiShopifyControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.status","filter.operation","filter.operationType","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/api-shopify?${stringifiedParams}` : `/log/api-shopify`
}

export const logApiShopifyControllerPaginate = async (params?: LogApiShopifyControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logApiShopifyControllerPaginateResponse> => {

  return customFetch<logApiShopifyControllerPaginateResponse>(getLogApiShopifyControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogApiShopifyControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogApiShopifyControllerPaginateParams>,) => {
    return [
    'log','api-shopify', ...(params ? [params] : [])
    ] as const;
    }


export const getLogApiShopifyControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logApiShopifyControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogApiShopifyControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiShopifyControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogApiShopifyControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logApiShopifyControllerPaginate>>> = ({ signal }) => logApiShopifyControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logApiShopifyControllerPaginate>>, TError, TData>
}

export type LogApiShopifyControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logApiShopifyControllerPaginate>>>
export type LogApiShopifyControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogApiShopifyControllerPaginate<TData = Awaited<ReturnType<typeof logApiShopifyControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogApiShopifyControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiShopifyControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogApiShopifyControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type userControllerCreateResponse201 = {
  data: ResponseUserDto
  status: 201
}

export type userControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userControllerCreateResponseSuccess = (userControllerCreateResponse201) & {
  headers: Headers;
};
export type userControllerCreateResponseError = (userControllerCreateResponse400 | userControllerCreateResponse401 | userControllerCreateResponse403 | userControllerCreateResponse404 | userControllerCreateResponse500) & {
  headers: Headers;
};

export type userControllerCreateResponse = (userControllerCreateResponseSuccess | userControllerCreateResponseError)

export const getUserControllerCreateUrl = () => {




  return `/user`
}

export const userControllerCreate = async (createUserDto: CreateUserDto, options?: Parameters<typeof customFetch>[1]): Promise<userControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<userControllerCreateResponse>(getUserControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUserDto)
  }
);}





export const getUserControllerCreateMutationKey = () => ['userControllerCreate'] as const;

export const getUserControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerCreate>>, TError,UserControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerCreate>>, TError,UserControllerCreateMutationVariables, TContext> => {

const mutationKey = getUserControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerCreate>>, UserControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerCreate>>>
    export type UserControllerCreateMutationBody = CreateUserDto
    export type UserControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UserControllerCreateMutationVariables = {data: CreateUserDto}

    export const useUserControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerCreate>>, TError,UserControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof userControllerCreate>>,
        TError,
        UserControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerCreateMutationOptions(options), queryClient);
    }

export type userControllerFindAllResponse200 = {
  data: UserControllerFindAll200
  status: 200
}

export type userControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userControllerFindAllResponseSuccess = (userControllerFindAllResponse200) & {
  headers: Headers;
};
export type userControllerFindAllResponseError = (userControllerFindAllResponse400 | userControllerFindAllResponse401 | userControllerFindAllResponse403 | userControllerFindAllResponse404 | userControllerFindAllResponse500) & {
  headers: Headers;
};

export type userControllerFindAllResponse = (userControllerFindAllResponseSuccess | userControllerFindAllResponseError)

export const getUserControllerFindAllUrl = (params?: UserControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.createdAt","filter.updatedAt","filter.deletedAt","filter.primarySource.id","filter.roles.role","filter.hasPin","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/user?${stringifiedParams}` : `/user`
}

export const userControllerFindAll = async (params?: UserControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<userControllerFindAllResponse> => {

  return customFetch<userControllerFindAllResponse>(getUserControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserControllerFindAllQueryKey = (params?: MaybeRefOrGetter<UserControllerFindAllParams>,) => {
    return [
    'user', ...(params ? [params] : [])
    ] as const;
    }


export const getUserControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof userControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<UserControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUserControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindAll>>> = ({ signal }) => userControllerFindAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>
}

export type UserControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerFindAll>>>
export type UserControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useUserControllerFindAll<TData = Awaited<ReturnType<typeof userControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<UserControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type userControllerMeResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type userControllerMeResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userControllerMeResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userControllerMeResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userControllerMeResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userControllerMeResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userControllerMeResponseSuccess = (userControllerMeResponse200) & {
  headers: Headers;
};
export type userControllerMeResponseError = (userControllerMeResponse400 | userControllerMeResponse401 | userControllerMeResponse403 | userControllerMeResponse404 | userControllerMeResponse500) & {
  headers: Headers;
};

export type userControllerMeResponse = (userControllerMeResponseSuccess | userControllerMeResponseError)

export const getUserControllerMeUrl = () => {




  return `/user/me`
}

export const userControllerMe = async ( options?: Parameters<typeof customFetch>[1]): Promise<userControllerMeResponse> => {

  return customFetch<userControllerMeResponse>(getUserControllerMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserControllerMeQueryKey = () => {
    return [
    'user','me'
    ] as const;
    }


export const getUserControllerMeQueryOptions = <TData = Awaited<ReturnType<typeof userControllerMe>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUserControllerMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerMe>>> = ({ signal }) => userControllerMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>
}

export type UserControllerMeQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerMe>>>
export type UserControllerMeQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useUserControllerMe<TData = Awaited<ReturnType<typeof userControllerMe>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type userControllerFindOneResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type userControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userControllerFindOneResponseSuccess = (userControllerFindOneResponse200) & {
  headers: Headers;
};
export type userControllerFindOneResponseError = (userControllerFindOneResponse400 | userControllerFindOneResponse401 | userControllerFindOneResponse403 | userControllerFindOneResponse404 | userControllerFindOneResponse500) & {
  headers: Headers;
};

export type userControllerFindOneResponse = (userControllerFindOneResponseSuccess | userControllerFindOneResponseError)

export const getUserControllerFindOneUrl = (userId: number,) => {




  return `/user/${userId}`
}

export const userControllerFindOne = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<userControllerFindOneResponse> => {

  return customFetch<userControllerFindOneResponse>(getUserControllerFindOneUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserControllerFindOneQueryKey = (userId: MaybeRefOrGetter<number>,) => {
    return [
    'user',userId
    ] as const;
    }


export const getUserControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof userControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUserControllerFindOneQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindOne>>> = ({ signal }) => userControllerFindOne(toValue(userId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>
}

export type UserControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerFindOne>>>
export type UserControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useUserControllerFindOne<TData = Awaited<ReturnType<typeof userControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserControllerFindOneQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type userControllerUpdateResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type userControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userControllerUpdateResponseSuccess = (userControllerUpdateResponse200) & {
  headers: Headers;
};
export type userControllerUpdateResponseError = (userControllerUpdateResponse400 | userControllerUpdateResponse401 | userControllerUpdateResponse403 | userControllerUpdateResponse404 | userControllerUpdateResponse500) & {
  headers: Headers;
};

export type userControllerUpdateResponse = (userControllerUpdateResponseSuccess | userControllerUpdateResponseError)

export const getUserControllerUpdateUrl = (userId: number,) => {




  return `/user/${userId}`
}

export const userControllerUpdate = async (userId: number,
    updateUserDto: UpdateUserDto, options?: Parameters<typeof customFetch>[1]): Promise<userControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<userControllerUpdateResponse>(getUserControllerUpdateUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateUserDto)
  }
);}





export const getUserControllerUpdateMutationKey = () => ['userControllerUpdate'] as const;

export const getUserControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,UserControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,UserControllerUpdateMutationVariables, TContext> => {

const mutationKey = getUserControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdate>>, UserControllerUpdateMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  userControllerUpdate(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdate>>>
    export type UserControllerUpdateMutationBody = UpdateUserDto
    export type UserControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UserControllerUpdateMutationVariables = {userId: number;data: UpdateUserDto}

    export const useUserControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,UserControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof userControllerUpdate>>,
        TError,
        UserControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerUpdateMutationOptions(options), queryClient);
    }

export type userControllerRemoveResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type userControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userControllerRemoveResponseSuccess = (userControllerRemoveResponse200) & {
  headers: Headers;
};
export type userControllerRemoveResponseError = (userControllerRemoveResponse400 | userControllerRemoveResponse401 | userControllerRemoveResponse403 | userControllerRemoveResponse404 | userControllerRemoveResponse500) & {
  headers: Headers;
};

export type userControllerRemoveResponse = (userControllerRemoveResponseSuccess | userControllerRemoveResponseError)

export const getUserControllerRemoveUrl = (userId: number,) => {




  return `/user/${userId}`
}

export const userControllerRemove = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<userControllerRemoveResponse> => {

  return customFetch<userControllerRemoveResponse>(getUserControllerRemoveUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUserControllerRemoveMutationKey = () => ['userControllerRemove'] as const;

export const getUserControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerRemove>>, TError,UserControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerRemove>>, TError,UserControllerRemoveMutationVariables, TContext> => {

const mutationKey = getUserControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerRemove>>, UserControllerRemoveMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  userControllerRemove(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerRemove>>>

    export type UserControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UserControllerRemoveMutationVariables = {userId: number}

    export const useUserControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerRemove>>, TError,UserControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof userControllerRemove>>,
        TError,
        UserControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerRemoveMutationOptions(options), queryClient);
    }

export type userControllerUpdatePasswordResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type userControllerUpdatePasswordResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userControllerUpdatePasswordResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userControllerUpdatePasswordResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userControllerUpdatePasswordResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userControllerUpdatePasswordResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userControllerUpdatePasswordResponseSuccess = (userControllerUpdatePasswordResponse200) & {
  headers: Headers;
};
export type userControllerUpdatePasswordResponseError = (userControllerUpdatePasswordResponse400 | userControllerUpdatePasswordResponse401 | userControllerUpdatePasswordResponse403 | userControllerUpdatePasswordResponse404 | userControllerUpdatePasswordResponse500) & {
  headers: Headers;
};

export type userControllerUpdatePasswordResponse = (userControllerUpdatePasswordResponseSuccess | userControllerUpdatePasswordResponseError)

export const getUserControllerUpdatePasswordUrl = (userId: number,) => {




  return `/user/${userId}/password`
}

export const userControllerUpdatePassword = async (userId: number,
    updateUserPasswordDto: UpdateUserPasswordDto, options?: Parameters<typeof customFetch>[1]): Promise<userControllerUpdatePasswordResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<userControllerUpdatePasswordResponse>(getUserControllerUpdatePasswordUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateUserPasswordDto)
  }
);}





export const getUserControllerUpdatePasswordMutationKey = () => ['userControllerUpdatePassword'] as const;

export const getUserControllerUpdatePasswordMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdatePassword>>, TError,UserControllerUpdatePasswordMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdatePassword>>, TError,UserControllerUpdatePasswordMutationVariables, TContext> => {

const mutationKey = getUserControllerUpdatePasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdatePassword>>, UserControllerUpdatePasswordMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  userControllerUpdatePassword(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdatePassword>>>
    export type UserControllerUpdatePasswordMutationBody = UpdateUserPasswordDto
    export type UserControllerUpdatePasswordMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UserControllerUpdatePasswordMutationVariables = {userId: number;data: UpdateUserPasswordDto}

    export const useUserControllerUpdatePassword = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdatePassword>>, TError,UserControllerUpdatePasswordMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof userControllerUpdatePassword>>,
        TError,
        UserControllerUpdatePasswordMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerUpdatePasswordMutationOptions(options), queryClient);
    }

export type userControllerUpdatePinResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type userControllerUpdatePinResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userControllerUpdatePinResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userControllerUpdatePinResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userControllerUpdatePinResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userControllerUpdatePinResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userControllerUpdatePinResponseSuccess = (userControllerUpdatePinResponse200) & {
  headers: Headers;
};
export type userControllerUpdatePinResponseError = (userControllerUpdatePinResponse400 | userControllerUpdatePinResponse401 | userControllerUpdatePinResponse403 | userControllerUpdatePinResponse404 | userControllerUpdatePinResponse500) & {
  headers: Headers;
};

export type userControllerUpdatePinResponse = (userControllerUpdatePinResponseSuccess | userControllerUpdatePinResponseError)

export const getUserControllerUpdatePinUrl = (userId: number,) => {




  return `/user/${userId}/pin`
}

export const userControllerUpdatePin = async (userId: number,
    updateUserPinDto: UpdateUserPinDto, options?: Parameters<typeof customFetch>[1]): Promise<userControllerUpdatePinResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<userControllerUpdatePinResponse>(getUserControllerUpdatePinUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateUserPinDto)
  }
);}





export const getUserControllerUpdatePinMutationKey = () => ['userControllerUpdatePin'] as const;

export const getUserControllerUpdatePinMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdatePin>>, TError,UserControllerUpdatePinMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdatePin>>, TError,UserControllerUpdatePinMutationVariables, TContext> => {

const mutationKey = getUserControllerUpdatePinMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdatePin>>, UserControllerUpdatePinMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  userControllerUpdatePin(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdatePinMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdatePin>>>
    export type UserControllerUpdatePinMutationBody = UpdateUserPinDto
    export type UserControllerUpdatePinMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UserControllerUpdatePinMutationVariables = {userId: number;data: UpdateUserPinDto}

    export const useUserControllerUpdatePin = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdatePin>>, TError,UserControllerUpdatePinMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof userControllerUpdatePin>>,
        TError,
        UserControllerUpdatePinMutationVariables,
        TContext
      > => {
      return useMutation(getUserControllerUpdatePinMutationOptions(options), queryClient);
    }

export type userClientControllerCreateResponse201 = {
  data: ResponseUserClientTokenDto
  status: 201
}

export type userClientControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userClientControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userClientControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userClientControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userClientControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userClientControllerCreateResponseSuccess = (userClientControllerCreateResponse201) & {
  headers: Headers;
};
export type userClientControllerCreateResponseError = (userClientControllerCreateResponse400 | userClientControllerCreateResponse401 | userClientControllerCreateResponse403 | userClientControllerCreateResponse404 | userClientControllerCreateResponse500) & {
  headers: Headers;
};

export type userClientControllerCreateResponse = (userClientControllerCreateResponseSuccess | userClientControllerCreateResponseError)

export const getUserClientControllerCreateUrl = (userId: number,) => {




  return `/user/${userId}/client`
}

export const userClientControllerCreate = async (userId: number,
    createUserClientDto: CreateUserClientDto, options?: Parameters<typeof customFetch>[1]): Promise<userClientControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<userClientControllerCreateResponse>(getUserClientControllerCreateUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUserClientDto)
  }
);}





export const getUserClientControllerCreateMutationKey = () => ['userClientControllerCreate'] as const;

export const getUserClientControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClientControllerCreate>>, TError,UserClientControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userClientControllerCreate>>, TError,UserClientControllerCreateMutationVariables, TContext> => {

const mutationKey = getUserClientControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClientControllerCreate>>, UserClientControllerCreateMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  userClientControllerCreate(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserClientControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userClientControllerCreate>>>
    export type UserClientControllerCreateMutationBody = CreateUserClientDto
    export type UserClientControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UserClientControllerCreateMutationVariables = {userId: number;data: CreateUserClientDto}

    export const useUserClientControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClientControllerCreate>>, TError,UserClientControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof userClientControllerCreate>>,
        TError,
        UserClientControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getUserClientControllerCreateMutationOptions(options), queryClient);
    }

export type userClientControllerFindAllForUserResponse200 = {
  data: ResponseUserClientDto[]
  status: 200
}

export type userClientControllerFindAllForUserResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userClientControllerFindAllForUserResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userClientControllerFindAllForUserResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userClientControllerFindAllForUserResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userClientControllerFindAllForUserResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userClientControllerFindAllForUserResponseSuccess = (userClientControllerFindAllForUserResponse200) & {
  headers: Headers;
};
export type userClientControllerFindAllForUserResponseError = (userClientControllerFindAllForUserResponse400 | userClientControllerFindAllForUserResponse401 | userClientControllerFindAllForUserResponse403 | userClientControllerFindAllForUserResponse404 | userClientControllerFindAllForUserResponse500) & {
  headers: Headers;
};

export type userClientControllerFindAllForUserResponse = (userClientControllerFindAllForUserResponseSuccess | userClientControllerFindAllForUserResponseError)

export const getUserClientControllerFindAllForUserUrl = (userId: number,) => {




  return `/user/${userId}/client`
}

export const userClientControllerFindAllForUser = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<userClientControllerFindAllForUserResponse> => {

  return customFetch<userClientControllerFindAllForUserResponse>(getUserClientControllerFindAllForUserUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserClientControllerFindAllForUserQueryKey = (userId: MaybeRefOrGetter<number>,) => {
    return [
    'user',userId,'client'
    ] as const;
    }


export const getUserClientControllerFindAllForUserQueryOptions = <TData = Awaited<ReturnType<typeof userClientControllerFindAllForUser>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClientControllerFindAllForUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUserClientControllerFindAllForUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userClientControllerFindAllForUser>>> = ({ signal }) => userClientControllerFindAllForUser(toValue(userId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userClientControllerFindAllForUser>>, TError, TData>
}

export type UserClientControllerFindAllForUserQueryResult = NonNullable<Awaited<ReturnType<typeof userClientControllerFindAllForUser>>>
export type UserClientControllerFindAllForUserQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useUserClientControllerFindAllForUser<TData = Awaited<ReturnType<typeof userClientControllerFindAllForUser>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 userId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClientControllerFindAllForUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserClientControllerFindAllForUserQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type userClientControllerFindOneResponse200 = {
  data: ResponseUserClientDto
  status: 200
}

export type userClientControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userClientControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userClientControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userClientControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userClientControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userClientControllerFindOneResponseSuccess = (userClientControllerFindOneResponse200) & {
  headers: Headers;
};
export type userClientControllerFindOneResponseError = (userClientControllerFindOneResponse400 | userClientControllerFindOneResponse401 | userClientControllerFindOneResponse403 | userClientControllerFindOneResponse404 | userClientControllerFindOneResponse500) & {
  headers: Headers;
};

export type userClientControllerFindOneResponse = (userClientControllerFindOneResponseSuccess | userClientControllerFindOneResponseError)

export const getUserClientControllerFindOneUrl = (userId: number,
    clientId: string,) => {




  return `/user/${userId}/client/${clientId}`
}

export const userClientControllerFindOne = async (userId: number,
    clientId: string, options?: Parameters<typeof customFetch>[1]): Promise<userClientControllerFindOneResponse> => {

  return customFetch<userClientControllerFindOneResponse>(getUserClientControllerFindOneUrl(userId,clientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserClientControllerFindOneQueryKey = (userId: MaybeRefOrGetter<number>,
    clientId: MaybeRefOrGetter<string>,) => {
    return [
    'user',userId,'client',clientId
    ] as const;
    }


export const getUserClientControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof userClientControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(userId: MaybeRefOrGetter<number>,
    clientId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClientControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUserClientControllerFindOneQueryKey(userId,clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userClientControllerFindOne>>> = ({ signal }) => userClientControllerFindOne(toValue(userId),toValue(clientId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(userId) !== null && toValue(userId) !== undefined && toValue(clientId) !== null && toValue(clientId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userClientControllerFindOne>>, TError, TData>
}

export type UserClientControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof userClientControllerFindOne>>>
export type UserClientControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useUserClientControllerFindOne<TData = Awaited<ReturnType<typeof userClientControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 userId: MaybeRefOrGetter<number>,
    clientId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClientControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserClientControllerFindOneQueryOptions(userId,clientId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type userClientControllerCreateTokenResponse201 = {
  data: ResponseUserClientTokenDto
  status: 201
}

export type userClientControllerCreateTokenResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userClientControllerCreateTokenResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userClientControllerCreateTokenResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userClientControllerCreateTokenResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userClientControllerCreateTokenResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userClientControllerCreateTokenResponseSuccess = (userClientControllerCreateTokenResponse201) & {
  headers: Headers;
};
export type userClientControllerCreateTokenResponseError = (userClientControllerCreateTokenResponse400 | userClientControllerCreateTokenResponse401 | userClientControllerCreateTokenResponse403 | userClientControllerCreateTokenResponse404 | userClientControllerCreateTokenResponse500) & {
  headers: Headers;
};

export type userClientControllerCreateTokenResponse = (userClientControllerCreateTokenResponseSuccess | userClientControllerCreateTokenResponseError)

export const getUserClientControllerCreateTokenUrl = (userId: number,
    clientId: string,) => {




  return `/user/${userId}/client/${clientId}/token`
}

export const userClientControllerCreateToken = async (userId: number,
    clientId: string,
    createUserClientDto: CreateUserClientDto, options?: Parameters<typeof customFetch>[1]): Promise<userClientControllerCreateTokenResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<userClientControllerCreateTokenResponse>(getUserClientControllerCreateTokenUrl(userId,clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUserClientDto)
  }
);}





export const getUserClientControllerCreateTokenMutationKey = () => ['userClientControllerCreateToken'] as const;

export const getUserClientControllerCreateTokenMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClientControllerCreateToken>>, TError,UserClientControllerCreateTokenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userClientControllerCreateToken>>, TError,UserClientControllerCreateTokenMutationVariables, TContext> => {

const mutationKey = getUserClientControllerCreateTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClientControllerCreateToken>>, UserClientControllerCreateTokenMutationVariables> = (props) => {
          const {userId,clientId,data} = props ?? {};

          return  userClientControllerCreateToken(userId,clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserClientControllerCreateTokenMutationResult = NonNullable<Awaited<ReturnType<typeof userClientControllerCreateToken>>>
    export type UserClientControllerCreateTokenMutationBody = CreateUserClientDto
    export type UserClientControllerCreateTokenMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UserClientControllerCreateTokenMutationVariables = {userId: number;clientId: string;data: CreateUserClientDto}

    export const useUserClientControllerCreateToken = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClientControllerCreateToken>>, TError,UserClientControllerCreateTokenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof userClientControllerCreateToken>>,
        TError,
        UserClientControllerCreateTokenMutationVariables,
        TContext
      > => {
      return useMutation(getUserClientControllerCreateTokenMutationOptions(options), queryClient);
    }

export type userClientLookupControllerFindOneResponse200 = {
  data: ResponseUserClientDto
  status: 200
}

export type userClientLookupControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userClientLookupControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userClientLookupControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userClientLookupControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userClientLookupControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userClientLookupControllerFindOneResponseSuccess = (userClientLookupControllerFindOneResponse200) & {
  headers: Headers;
};
export type userClientLookupControllerFindOneResponseError = (userClientLookupControllerFindOneResponse400 | userClientLookupControllerFindOneResponse401 | userClientLookupControllerFindOneResponse403 | userClientLookupControllerFindOneResponse404 | userClientLookupControllerFindOneResponse500) & {
  headers: Headers;
};

export type userClientLookupControllerFindOneResponse = (userClientLookupControllerFindOneResponseSuccess | userClientLookupControllerFindOneResponseError)

export const getUserClientLookupControllerFindOneUrl = (clientId: string,) => {




  return `/user/client/${clientId}`
}

export const userClientLookupControllerFindOne = async (clientId: string, options?: Parameters<typeof customFetch>[1]): Promise<userClientLookupControllerFindOneResponse> => {

  return customFetch<userClientLookupControllerFindOneResponse>(getUserClientLookupControllerFindOneUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserClientLookupControllerFindOneQueryKey = (clientId: MaybeRefOrGetter<string>,) => {
    return [
    'user','client',clientId
    ] as const;
    }


export const getUserClientLookupControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof userClientLookupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(clientId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClientLookupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUserClientLookupControllerFindOneQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userClientLookupControllerFindOne>>> = ({ signal }) => userClientLookupControllerFindOne(toValue(clientId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(clientId) !== null && toValue(clientId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userClientLookupControllerFindOne>>, TError, TData>
}

export type UserClientLookupControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof userClientLookupControllerFindOne>>>
export type UserClientLookupControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useUserClientLookupControllerFindOne<TData = Awaited<ReturnType<typeof userClientLookupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 clientId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userClientLookupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserClientLookupControllerFindOneQueryOptions(clientId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type userClientLookupControllerCreateTokenResponse201 = {
  data: ResponseUserClientTokenDto
  status: 201
}

export type userClientLookupControllerCreateTokenResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type userClientLookupControllerCreateTokenResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type userClientLookupControllerCreateTokenResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type userClientLookupControllerCreateTokenResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type userClientLookupControllerCreateTokenResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type userClientLookupControllerCreateTokenResponseSuccess = (userClientLookupControllerCreateTokenResponse201) & {
  headers: Headers;
};
export type userClientLookupControllerCreateTokenResponseError = (userClientLookupControllerCreateTokenResponse400 | userClientLookupControllerCreateTokenResponse401 | userClientLookupControllerCreateTokenResponse403 | userClientLookupControllerCreateTokenResponse404 | userClientLookupControllerCreateTokenResponse500) & {
  headers: Headers;
};

export type userClientLookupControllerCreateTokenResponse = (userClientLookupControllerCreateTokenResponseSuccess | userClientLookupControllerCreateTokenResponseError)

export const getUserClientLookupControllerCreateTokenUrl = (clientId: string,) => {




  return `/user/client/${clientId}/token`
}

export const userClientLookupControllerCreateToken = async (clientId: string,
    createUserClientDto: CreateUserClientDto, options?: Parameters<typeof customFetch>[1]): Promise<userClientLookupControllerCreateTokenResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<userClientLookupControllerCreateTokenResponse>(getUserClientLookupControllerCreateTokenUrl(clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUserClientDto)
  }
);}





export const getUserClientLookupControllerCreateTokenMutationKey = () => ['userClientLookupControllerCreateToken'] as const;

export const getUserClientLookupControllerCreateTokenMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClientLookupControllerCreateToken>>, TError,UserClientLookupControllerCreateTokenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userClientLookupControllerCreateToken>>, TError,UserClientLookupControllerCreateTokenMutationVariables, TContext> => {

const mutationKey = getUserClientLookupControllerCreateTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userClientLookupControllerCreateToken>>, UserClientLookupControllerCreateTokenMutationVariables> = (props) => {
          const {clientId,data} = props ?? {};

          return  userClientLookupControllerCreateToken(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserClientLookupControllerCreateTokenMutationResult = NonNullable<Awaited<ReturnType<typeof userClientLookupControllerCreateToken>>>
    export type UserClientLookupControllerCreateTokenMutationBody = CreateUserClientDto
    export type UserClientLookupControllerCreateTokenMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UserClientLookupControllerCreateTokenMutationVariables = {clientId: string;data: CreateUserClientDto}

    export const useUserClientLookupControllerCreateToken = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userClientLookupControllerCreateToken>>, TError,UserClientLookupControllerCreateTokenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof userClientLookupControllerCreateToken>>,
        TError,
        UserClientLookupControllerCreateTokenMutationVariables,
        TContext
      > => {
      return useMutation(getUserClientLookupControllerCreateTokenMutationOptions(options), queryClient);
    }

export type pushNotificationListCustomControllerSetCustomListsResponse200 = {
  data: ResponsePushNotificationListCustomDto[]
  status: 200
}

export type pushNotificationListCustomControllerSetCustomListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationListCustomControllerSetCustomListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationListCustomControllerSetCustomListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationListCustomControllerSetCustomListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationListCustomControllerSetCustomListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationListCustomControllerSetCustomListsResponseSuccess = (pushNotificationListCustomControllerSetCustomListsResponse200) & {
  headers: Headers;
};
export type pushNotificationListCustomControllerSetCustomListsResponseError = (pushNotificationListCustomControllerSetCustomListsResponse400 | pushNotificationListCustomControllerSetCustomListsResponse401 | pushNotificationListCustomControllerSetCustomListsResponse403 | pushNotificationListCustomControllerSetCustomListsResponse404 | pushNotificationListCustomControllerSetCustomListsResponse500) & {
  headers: Headers;
};

export type pushNotificationListCustomControllerSetCustomListsResponse = (pushNotificationListCustomControllerSetCustomListsResponseSuccess | pushNotificationListCustomControllerSetCustomListsResponseError)

export const getPushNotificationListCustomControllerSetCustomListsUrl = () => {




  return `/push-notification/list/custom`
}

export const pushNotificationListCustomControllerSetCustomLists = async (putPushNotificationListCustomDto: PutPushNotificationListCustomDto, options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationListCustomControllerSetCustomListsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<pushNotificationListCustomControllerSetCustomListsResponse>(getPushNotificationListCustomControllerSetCustomListsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPushNotificationListCustomDto)
  }
);}





export const getPushNotificationListCustomControllerSetCustomListsMutationKey = () => ['pushNotificationListCustomControllerSetCustomLists'] as const;

export const getPushNotificationListCustomControllerSetCustomListsMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerSetCustomLists>>, TError,PushNotificationListCustomControllerSetCustomListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerSetCustomLists>>, TError,PushNotificationListCustomControllerSetCustomListsMutationVariables, TContext> => {

const mutationKey = getPushNotificationListCustomControllerSetCustomListsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushNotificationListCustomControllerSetCustomLists>>, PushNotificationListCustomControllerSetCustomListsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pushNotificationListCustomControllerSetCustomLists(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushNotificationListCustomControllerSetCustomListsMutationResult = NonNullable<Awaited<ReturnType<typeof pushNotificationListCustomControllerSetCustomLists>>>
    export type PushNotificationListCustomControllerSetCustomListsMutationBody = PutPushNotificationListCustomDto
    export type PushNotificationListCustomControllerSetCustomListsMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PushNotificationListCustomControllerSetCustomListsMutationVariables = {data: PutPushNotificationListCustomDto}

    export const usePushNotificationListCustomControllerSetCustomLists = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerSetCustomLists>>, TError,PushNotificationListCustomControllerSetCustomListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof pushNotificationListCustomControllerSetCustomLists>>,
        TError,
        PushNotificationListCustomControllerSetCustomListsMutationVariables,
        TContext
      > => {
      return useMutation(getPushNotificationListCustomControllerSetCustomListsMutationOptions(options), queryClient);
    }

export type pushNotificationListCustomControllerFindCustomListsResponse200 = {
  data: ResponsePushNotificationListCustomDto[]
  status: 200
}

export type pushNotificationListCustomControllerFindCustomListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationListCustomControllerFindCustomListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationListCustomControllerFindCustomListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationListCustomControllerFindCustomListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationListCustomControllerFindCustomListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationListCustomControllerFindCustomListsResponseSuccess = (pushNotificationListCustomControllerFindCustomListsResponse200) & {
  headers: Headers;
};
export type pushNotificationListCustomControllerFindCustomListsResponseError = (pushNotificationListCustomControllerFindCustomListsResponse400 | pushNotificationListCustomControllerFindCustomListsResponse401 | pushNotificationListCustomControllerFindCustomListsResponse403 | pushNotificationListCustomControllerFindCustomListsResponse404 | pushNotificationListCustomControllerFindCustomListsResponse500) & {
  headers: Headers;
};

export type pushNotificationListCustomControllerFindCustomListsResponse = (pushNotificationListCustomControllerFindCustomListsResponseSuccess | pushNotificationListCustomControllerFindCustomListsResponseError)

export const getPushNotificationListCustomControllerFindCustomListsUrl = () => {




  return `/push-notification/list/custom`
}

export const pushNotificationListCustomControllerFindCustomLists = async ( options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationListCustomControllerFindCustomListsResponse> => {

  return customFetch<pushNotificationListCustomControllerFindCustomListsResponse>(getPushNotificationListCustomControllerFindCustomListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPushNotificationListCustomControllerFindCustomListsQueryKey = () => {
    return [
    'push-notification','list','custom'
    ] as const;
    }


export const getPushNotificationListCustomControllerFindCustomListsQueryOptions = <TData = Awaited<ReturnType<typeof pushNotificationListCustomControllerFindCustomLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerFindCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPushNotificationListCustomControllerFindCustomListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pushNotificationListCustomControllerFindCustomLists>>> = ({ signal }) => pushNotificationListCustomControllerFindCustomLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerFindCustomLists>>, TError, TData>
}

export type PushNotificationListCustomControllerFindCustomListsQueryResult = NonNullable<Awaited<ReturnType<typeof pushNotificationListCustomControllerFindCustomLists>>>
export type PushNotificationListCustomControllerFindCustomListsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePushNotificationListCustomControllerFindCustomLists<TData = Awaited<ReturnType<typeof pushNotificationListCustomControllerFindCustomLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerFindCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPushNotificationListCustomControllerFindCustomListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type pushNotificationListCustomControllerBroadcastCustomMessageResponse201 = {
  data: ResponsePushNotificationBroadcastDto
  status: 201
}

export type pushNotificationListCustomControllerBroadcastCustomMessageResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationListCustomControllerBroadcastCustomMessageResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationListCustomControllerBroadcastCustomMessageResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationListCustomControllerBroadcastCustomMessageResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationListCustomControllerBroadcastCustomMessageResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationListCustomControllerBroadcastCustomMessageResponseSuccess = (pushNotificationListCustomControllerBroadcastCustomMessageResponse201) & {
  headers: Headers;
};
export type pushNotificationListCustomControllerBroadcastCustomMessageResponseError = (pushNotificationListCustomControllerBroadcastCustomMessageResponse400 | pushNotificationListCustomControllerBroadcastCustomMessageResponse401 | pushNotificationListCustomControllerBroadcastCustomMessageResponse403 | pushNotificationListCustomControllerBroadcastCustomMessageResponse404 | pushNotificationListCustomControllerBroadcastCustomMessageResponse500) & {
  headers: Headers;
};

export type pushNotificationListCustomControllerBroadcastCustomMessageResponse = (pushNotificationListCustomControllerBroadcastCustomMessageResponseSuccess | pushNotificationListCustomControllerBroadcastCustomMessageResponseError)

export const getPushNotificationListCustomControllerBroadcastCustomMessageUrl = (reason: string,) => {




  return `/push-notification/list/custom/broadcast/${reason}`
}

export const pushNotificationListCustomControllerBroadcastCustomMessage = async (reason: string,
    pushNotificationCustomMessageDto: PushNotificationCustomMessageDto, options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationListCustomControllerBroadcastCustomMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<pushNotificationListCustomControllerBroadcastCustomMessageResponse>(getPushNotificationListCustomControllerBroadcastCustomMessageUrl(reason),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pushNotificationCustomMessageDto)
  }
);}





export const getPushNotificationListCustomControllerBroadcastCustomMessageMutationKey = () => ['pushNotificationListCustomControllerBroadcastCustomMessage'] as const;

export const getPushNotificationListCustomControllerBroadcastCustomMessageMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerBroadcastCustomMessage>>, TError,PushNotificationListCustomControllerBroadcastCustomMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerBroadcastCustomMessage>>, TError,PushNotificationListCustomControllerBroadcastCustomMessageMutationVariables, TContext> => {

const mutationKey = getPushNotificationListCustomControllerBroadcastCustomMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushNotificationListCustomControllerBroadcastCustomMessage>>, PushNotificationListCustomControllerBroadcastCustomMessageMutationVariables> = (props) => {
          const {reason,data} = props ?? {};

          return  pushNotificationListCustomControllerBroadcastCustomMessage(reason,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushNotificationListCustomControllerBroadcastCustomMessageMutationResult = NonNullable<Awaited<ReturnType<typeof pushNotificationListCustomControllerBroadcastCustomMessage>>>
    export type PushNotificationListCustomControllerBroadcastCustomMessageMutationBody = PushNotificationCustomMessageDto
    export type PushNotificationListCustomControllerBroadcastCustomMessageMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PushNotificationListCustomControllerBroadcastCustomMessageMutationVariables = {reason: string;data: PushNotificationCustomMessageDto}

    export const usePushNotificationListCustomControllerBroadcastCustomMessage = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListCustomControllerBroadcastCustomMessage>>, TError,PushNotificationListCustomControllerBroadcastCustomMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof pushNotificationListCustomControllerBroadcastCustomMessage>>,
        TError,
        PushNotificationListCustomControllerBroadcastCustomMessageMutationVariables,
        TContext
      > => {
      return useMutation(getPushNotificationListCustomControllerBroadcastCustomMessageMutationOptions(options), queryClient);
    }

export type posPushNotificationListCustomControllerSetCustomListsResponse200 = {
  data: ResponsePushNotificationListCustomDto[]
  status: 200
}

export type posPushNotificationListCustomControllerSetCustomListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationListCustomControllerSetCustomListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationListCustomControllerSetCustomListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationListCustomControllerSetCustomListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationListCustomControllerSetCustomListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationListCustomControllerSetCustomListsResponseSuccess = (posPushNotificationListCustomControllerSetCustomListsResponse200) & {
  headers: Headers;
};
export type posPushNotificationListCustomControllerSetCustomListsResponseError = (posPushNotificationListCustomControllerSetCustomListsResponse400 | posPushNotificationListCustomControllerSetCustomListsResponse401 | posPushNotificationListCustomControllerSetCustomListsResponse403 | posPushNotificationListCustomControllerSetCustomListsResponse404 | posPushNotificationListCustomControllerSetCustomListsResponse500) & {
  headers: Headers;
};

export type posPushNotificationListCustomControllerSetCustomListsResponse = (posPushNotificationListCustomControllerSetCustomListsResponseSuccess | posPushNotificationListCustomControllerSetCustomListsResponseError)

export const getPosPushNotificationListCustomControllerSetCustomListsUrl = () => {




  return `/push-notification/list/custom/pos`
}

export const posPushNotificationListCustomControllerSetCustomLists = async (putPushNotificationListCustomDto: PutPushNotificationListCustomDto, options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationListCustomControllerSetCustomListsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<posPushNotificationListCustomControllerSetCustomListsResponse>(getPosPushNotificationListCustomControllerSetCustomListsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPushNotificationListCustomDto)
  }
);}





export const getPosPushNotificationListCustomControllerSetCustomListsMutationKey = () => ['posPushNotificationListCustomControllerSetCustomLists'] as const;

export const getPosPushNotificationListCustomControllerSetCustomListsMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListCustomControllerSetCustomLists>>, TError,PosPushNotificationListCustomControllerSetCustomListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListCustomControllerSetCustomLists>>, TError,PosPushNotificationListCustomControllerSetCustomListsMutationVariables, TContext> => {

const mutationKey = getPosPushNotificationListCustomControllerSetCustomListsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posPushNotificationListCustomControllerSetCustomLists>>, PosPushNotificationListCustomControllerSetCustomListsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  posPushNotificationListCustomControllerSetCustomLists(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosPushNotificationListCustomControllerSetCustomListsMutationResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationListCustomControllerSetCustomLists>>>
    export type PosPushNotificationListCustomControllerSetCustomListsMutationBody = PutPushNotificationListCustomDto
    export type PosPushNotificationListCustomControllerSetCustomListsMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PosPushNotificationListCustomControllerSetCustomListsMutationVariables = {data: PutPushNotificationListCustomDto}

    export const usePosPushNotificationListCustomControllerSetCustomLists = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListCustomControllerSetCustomLists>>, TError,PosPushNotificationListCustomControllerSetCustomListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posPushNotificationListCustomControllerSetCustomLists>>,
        TError,
        PosPushNotificationListCustomControllerSetCustomListsMutationVariables,
        TContext
      > => {
      return useMutation(getPosPushNotificationListCustomControllerSetCustomListsMutationOptions(options), queryClient);
    }

export type posPushNotificationListCustomControllerFindCustomListsResponse200 = {
  data: ResponsePushNotificationListCustomDto[]
  status: 200
}

export type posPushNotificationListCustomControllerFindCustomListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationListCustomControllerFindCustomListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationListCustomControllerFindCustomListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationListCustomControllerFindCustomListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationListCustomControllerFindCustomListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationListCustomControllerFindCustomListsResponseSuccess = (posPushNotificationListCustomControllerFindCustomListsResponse200) & {
  headers: Headers;
};
export type posPushNotificationListCustomControllerFindCustomListsResponseError = (posPushNotificationListCustomControllerFindCustomListsResponse400 | posPushNotificationListCustomControllerFindCustomListsResponse401 | posPushNotificationListCustomControllerFindCustomListsResponse403 | posPushNotificationListCustomControllerFindCustomListsResponse404 | posPushNotificationListCustomControllerFindCustomListsResponse500) & {
  headers: Headers;
};

export type posPushNotificationListCustomControllerFindCustomListsResponse = (posPushNotificationListCustomControllerFindCustomListsResponseSuccess | posPushNotificationListCustomControllerFindCustomListsResponseError)

export const getPosPushNotificationListCustomControllerFindCustomListsUrl = () => {




  return `/push-notification/list/custom/pos`
}

export const posPushNotificationListCustomControllerFindCustomLists = async ( options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationListCustomControllerFindCustomListsResponse> => {

  return customFetch<posPushNotificationListCustomControllerFindCustomListsResponse>(getPosPushNotificationListCustomControllerFindCustomListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPosPushNotificationListCustomControllerFindCustomListsQueryKey = () => {
    return [
    'push-notification','list','custom','pos'
    ] as const;
    }


export const getPosPushNotificationListCustomControllerFindCustomListsQueryOptions = <TData = Awaited<ReturnType<typeof posPushNotificationListCustomControllerFindCustomLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListCustomControllerFindCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPosPushNotificationListCustomControllerFindCustomListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof posPushNotificationListCustomControllerFindCustomLists>>> = ({ signal }) => posPushNotificationListCustomControllerFindCustomLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListCustomControllerFindCustomLists>>, TError, TData>
}

export type PosPushNotificationListCustomControllerFindCustomListsQueryResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationListCustomControllerFindCustomLists>>>
export type PosPushNotificationListCustomControllerFindCustomListsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePosPushNotificationListCustomControllerFindCustomLists<TData = Awaited<ReturnType<typeof posPushNotificationListCustomControllerFindCustomLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListCustomControllerFindCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPosPushNotificationListCustomControllerFindCustomListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type pushNotificationControllerSubscribePushResponse201 = {
  data: ResponsePushNotificationSubscriptionDto[]
  status: 201
}

export type pushNotificationControllerSubscribePushResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationControllerSubscribePushResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationControllerSubscribePushResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationControllerSubscribePushResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationControllerSubscribePushResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationControllerSubscribePushResponseSuccess = (pushNotificationControllerSubscribePushResponse201) & {
  headers: Headers;
};
export type pushNotificationControllerSubscribePushResponseError = (pushNotificationControllerSubscribePushResponse400 | pushNotificationControllerSubscribePushResponse401 | pushNotificationControllerSubscribePushResponse403 | pushNotificationControllerSubscribePushResponse404 | pushNotificationControllerSubscribePushResponse500) & {
  headers: Headers;
};

export type pushNotificationControllerSubscribePushResponse = (pushNotificationControllerSubscribePushResponseSuccess | pushNotificationControllerSubscribePushResponseError)

export const getPushNotificationControllerSubscribePushUrl = () => {




  return `/push-notification/subscribe`
}

export const pushNotificationControllerSubscribePush = async (subscribePushNotificationDto: SubscribePushNotificationDto, options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationControllerSubscribePushResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<pushNotificationControllerSubscribePushResponse>(getPushNotificationControllerSubscribePushUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(subscribePushNotificationDto)
  }
);}





export const getPushNotificationControllerSubscribePushMutationKey = () => ['pushNotificationControllerSubscribePush'] as const;

export const getPushNotificationControllerSubscribePushMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationControllerSubscribePush>>, TError,PushNotificationControllerSubscribePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushNotificationControllerSubscribePush>>, TError,PushNotificationControllerSubscribePushMutationVariables, TContext> => {

const mutationKey = getPushNotificationControllerSubscribePushMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushNotificationControllerSubscribePush>>, PushNotificationControllerSubscribePushMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pushNotificationControllerSubscribePush(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushNotificationControllerSubscribePushMutationResult = NonNullable<Awaited<ReturnType<typeof pushNotificationControllerSubscribePush>>>
    export type PushNotificationControllerSubscribePushMutationBody = SubscribePushNotificationDto
    export type PushNotificationControllerSubscribePushMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PushNotificationControllerSubscribePushMutationVariables = {data: SubscribePushNotificationDto}

    export const usePushNotificationControllerSubscribePush = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationControllerSubscribePush>>, TError,PushNotificationControllerSubscribePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof pushNotificationControllerSubscribePush>>,
        TError,
        PushNotificationControllerSubscribePushMutationVariables,
        TContext
      > => {
      return useMutation(getPushNotificationControllerSubscribePushMutationOptions(options), queryClient);
    }

export type pushNotificationControllerUnsubscribePushResponse201 = {
  data: ResponsePushNotificationSubscriptionDto[]
  status: 201
}

export type pushNotificationControllerUnsubscribePushResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationControllerUnsubscribePushResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationControllerUnsubscribePushResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationControllerUnsubscribePushResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationControllerUnsubscribePushResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationControllerUnsubscribePushResponseSuccess = (pushNotificationControllerUnsubscribePushResponse201) & {
  headers: Headers;
};
export type pushNotificationControllerUnsubscribePushResponseError = (pushNotificationControllerUnsubscribePushResponse400 | pushNotificationControllerUnsubscribePushResponse401 | pushNotificationControllerUnsubscribePushResponse403 | pushNotificationControllerUnsubscribePushResponse404 | pushNotificationControllerUnsubscribePushResponse500) & {
  headers: Headers;
};

export type pushNotificationControllerUnsubscribePushResponse = (pushNotificationControllerUnsubscribePushResponseSuccess | pushNotificationControllerUnsubscribePushResponseError)

export const getPushNotificationControllerUnsubscribePushUrl = () => {




  return `/push-notification/unsubscribe`
}

export const pushNotificationControllerUnsubscribePush = async (unsubscribePushNotificationDto: UnsubscribePushNotificationDto, options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationControllerUnsubscribePushResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<pushNotificationControllerUnsubscribePushResponse>(getPushNotificationControllerUnsubscribePushUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(unsubscribePushNotificationDto)
  }
);}





export const getPushNotificationControllerUnsubscribePushMutationKey = () => ['pushNotificationControllerUnsubscribePush'] as const;

export const getPushNotificationControllerUnsubscribePushMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationControllerUnsubscribePush>>, TError,PushNotificationControllerUnsubscribePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushNotificationControllerUnsubscribePush>>, TError,PushNotificationControllerUnsubscribePushMutationVariables, TContext> => {

const mutationKey = getPushNotificationControllerUnsubscribePushMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushNotificationControllerUnsubscribePush>>, PushNotificationControllerUnsubscribePushMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pushNotificationControllerUnsubscribePush(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushNotificationControllerUnsubscribePushMutationResult = NonNullable<Awaited<ReturnType<typeof pushNotificationControllerUnsubscribePush>>>
    export type PushNotificationControllerUnsubscribePushMutationBody = UnsubscribePushNotificationDto
    export type PushNotificationControllerUnsubscribePushMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PushNotificationControllerUnsubscribePushMutationVariables = {data: UnsubscribePushNotificationDto}

    export const usePushNotificationControllerUnsubscribePush = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationControllerUnsubscribePush>>, TError,PushNotificationControllerUnsubscribePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof pushNotificationControllerUnsubscribePush>>,
        TError,
        PushNotificationControllerUnsubscribePushMutationVariables,
        TContext
      > => {
      return useMutation(getPushNotificationControllerUnsubscribePushMutationOptions(options), queryClient);
    }

export type pushNotificationControllerGetPushSubscriptionsResponse200 = {
  data: ResponsePushNotificationSubscriptionDto[]
  status: 200
}

export type pushNotificationControllerGetPushSubscriptionsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationControllerGetPushSubscriptionsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationControllerGetPushSubscriptionsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationControllerGetPushSubscriptionsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationControllerGetPushSubscriptionsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationControllerGetPushSubscriptionsResponseSuccess = (pushNotificationControllerGetPushSubscriptionsResponse200) & {
  headers: Headers;
};
export type pushNotificationControllerGetPushSubscriptionsResponseError = (pushNotificationControllerGetPushSubscriptionsResponse400 | pushNotificationControllerGetPushSubscriptionsResponse401 | pushNotificationControllerGetPushSubscriptionsResponse403 | pushNotificationControllerGetPushSubscriptionsResponse404 | pushNotificationControllerGetPushSubscriptionsResponse500) & {
  headers: Headers;
};

export type pushNotificationControllerGetPushSubscriptionsResponse = (pushNotificationControllerGetPushSubscriptionsResponseSuccess | pushNotificationControllerGetPushSubscriptionsResponseError)

export const getPushNotificationControllerGetPushSubscriptionsUrl = () => {




  return `/push-notification/subscriptions`
}

export const pushNotificationControllerGetPushSubscriptions = async ( options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationControllerGetPushSubscriptionsResponse> => {

  return customFetch<pushNotificationControllerGetPushSubscriptionsResponse>(getPushNotificationControllerGetPushSubscriptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPushNotificationControllerGetPushSubscriptionsQueryKey = () => {
    return [
    'push-notification','subscriptions'
    ] as const;
    }


export const getPushNotificationControllerGetPushSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof pushNotificationControllerGetPushSubscriptions>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushNotificationControllerGetPushSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPushNotificationControllerGetPushSubscriptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pushNotificationControllerGetPushSubscriptions>>> = ({ signal }) => pushNotificationControllerGetPushSubscriptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pushNotificationControllerGetPushSubscriptions>>, TError, TData>
}

export type PushNotificationControllerGetPushSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof pushNotificationControllerGetPushSubscriptions>>>
export type PushNotificationControllerGetPushSubscriptionsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePushNotificationControllerGetPushSubscriptions<TData = Awaited<ReturnType<typeof pushNotificationControllerGetPushSubscriptions>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushNotificationControllerGetPushSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPushNotificationControllerGetPushSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type posPushNotificationControllerSubscribePushResponse201 = {
  data: ResponsePushNotificationSubscriptionDto[]
  status: 201
}

export type posPushNotificationControllerSubscribePushResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationControllerSubscribePushResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationControllerSubscribePushResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationControllerSubscribePushResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationControllerSubscribePushResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationControllerSubscribePushResponseSuccess = (posPushNotificationControllerSubscribePushResponse201) & {
  headers: Headers;
};
export type posPushNotificationControllerSubscribePushResponseError = (posPushNotificationControllerSubscribePushResponse400 | posPushNotificationControllerSubscribePushResponse401 | posPushNotificationControllerSubscribePushResponse403 | posPushNotificationControllerSubscribePushResponse404 | posPushNotificationControllerSubscribePushResponse500) & {
  headers: Headers;
};

export type posPushNotificationControllerSubscribePushResponse = (posPushNotificationControllerSubscribePushResponseSuccess | posPushNotificationControllerSubscribePushResponseError)

export const getPosPushNotificationControllerSubscribePushUrl = () => {




  return `/pos/push-notification/subscribe`
}

export const posPushNotificationControllerSubscribePush = async (subscribePushNotificationDto: SubscribePushNotificationDto, options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationControllerSubscribePushResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<posPushNotificationControllerSubscribePushResponse>(getPosPushNotificationControllerSubscribePushUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(subscribePushNotificationDto)
  }
);}





export const getPosPushNotificationControllerSubscribePushMutationKey = () => ['posPushNotificationControllerSubscribePush'] as const;

export const getPosPushNotificationControllerSubscribePushMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationControllerSubscribePush>>, TError,PosPushNotificationControllerSubscribePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationControllerSubscribePush>>, TError,PosPushNotificationControllerSubscribePushMutationVariables, TContext> => {

const mutationKey = getPosPushNotificationControllerSubscribePushMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posPushNotificationControllerSubscribePush>>, PosPushNotificationControllerSubscribePushMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  posPushNotificationControllerSubscribePush(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosPushNotificationControllerSubscribePushMutationResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationControllerSubscribePush>>>
    export type PosPushNotificationControllerSubscribePushMutationBody = SubscribePushNotificationDto
    export type PosPushNotificationControllerSubscribePushMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PosPushNotificationControllerSubscribePushMutationVariables = {data: SubscribePushNotificationDto}

    export const usePosPushNotificationControllerSubscribePush = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationControllerSubscribePush>>, TError,PosPushNotificationControllerSubscribePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posPushNotificationControllerSubscribePush>>,
        TError,
        PosPushNotificationControllerSubscribePushMutationVariables,
        TContext
      > => {
      return useMutation(getPosPushNotificationControllerSubscribePushMutationOptions(options), queryClient);
    }

export type posPushNotificationControllerUnsubscribePushResponse201 = {
  data: ResponsePushNotificationSubscriptionDto[]
  status: 201
}

export type posPushNotificationControllerUnsubscribePushResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationControllerUnsubscribePushResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationControllerUnsubscribePushResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationControllerUnsubscribePushResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationControllerUnsubscribePushResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationControllerUnsubscribePushResponseSuccess = (posPushNotificationControllerUnsubscribePushResponse201) & {
  headers: Headers;
};
export type posPushNotificationControllerUnsubscribePushResponseError = (posPushNotificationControllerUnsubscribePushResponse400 | posPushNotificationControllerUnsubscribePushResponse401 | posPushNotificationControllerUnsubscribePushResponse403 | posPushNotificationControllerUnsubscribePushResponse404 | posPushNotificationControllerUnsubscribePushResponse500) & {
  headers: Headers;
};

export type posPushNotificationControllerUnsubscribePushResponse = (posPushNotificationControllerUnsubscribePushResponseSuccess | posPushNotificationControllerUnsubscribePushResponseError)

export const getPosPushNotificationControllerUnsubscribePushUrl = () => {




  return `/pos/push-notification/unsubscribe`
}

export const posPushNotificationControllerUnsubscribePush = async (unsubscribePushNotificationDto: UnsubscribePushNotificationDto, options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationControllerUnsubscribePushResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<posPushNotificationControllerUnsubscribePushResponse>(getPosPushNotificationControllerUnsubscribePushUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(unsubscribePushNotificationDto)
  }
);}





export const getPosPushNotificationControllerUnsubscribePushMutationKey = () => ['posPushNotificationControllerUnsubscribePush'] as const;

export const getPosPushNotificationControllerUnsubscribePushMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationControllerUnsubscribePush>>, TError,PosPushNotificationControllerUnsubscribePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationControllerUnsubscribePush>>, TError,PosPushNotificationControllerUnsubscribePushMutationVariables, TContext> => {

const mutationKey = getPosPushNotificationControllerUnsubscribePushMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posPushNotificationControllerUnsubscribePush>>, PosPushNotificationControllerUnsubscribePushMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  posPushNotificationControllerUnsubscribePush(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosPushNotificationControllerUnsubscribePushMutationResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationControllerUnsubscribePush>>>
    export type PosPushNotificationControllerUnsubscribePushMutationBody = UnsubscribePushNotificationDto
    export type PosPushNotificationControllerUnsubscribePushMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PosPushNotificationControllerUnsubscribePushMutationVariables = {data: UnsubscribePushNotificationDto}

    export const usePosPushNotificationControllerUnsubscribePush = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationControllerUnsubscribePush>>, TError,PosPushNotificationControllerUnsubscribePushMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posPushNotificationControllerUnsubscribePush>>,
        TError,
        PosPushNotificationControllerUnsubscribePushMutationVariables,
        TContext
      > => {
      return useMutation(getPosPushNotificationControllerUnsubscribePushMutationOptions(options), queryClient);
    }

export type posPushNotificationControllerGetPushSubscriptionsResponse200 = {
  data: ResponsePushNotificationSubscriptionDto[]
  status: 200
}

export type posPushNotificationControllerGetPushSubscriptionsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationControllerGetPushSubscriptionsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationControllerGetPushSubscriptionsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationControllerGetPushSubscriptionsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationControllerGetPushSubscriptionsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationControllerGetPushSubscriptionsResponseSuccess = (posPushNotificationControllerGetPushSubscriptionsResponse200) & {
  headers: Headers;
};
export type posPushNotificationControllerGetPushSubscriptionsResponseError = (posPushNotificationControllerGetPushSubscriptionsResponse400 | posPushNotificationControllerGetPushSubscriptionsResponse401 | posPushNotificationControllerGetPushSubscriptionsResponse403 | posPushNotificationControllerGetPushSubscriptionsResponse404 | posPushNotificationControllerGetPushSubscriptionsResponse500) & {
  headers: Headers;
};

export type posPushNotificationControllerGetPushSubscriptionsResponse = (posPushNotificationControllerGetPushSubscriptionsResponseSuccess | posPushNotificationControllerGetPushSubscriptionsResponseError)

export const getPosPushNotificationControllerGetPushSubscriptionsUrl = () => {




  return `/pos/push-notification/subscriptions`
}

export const posPushNotificationControllerGetPushSubscriptions = async ( options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationControllerGetPushSubscriptionsResponse> => {

  return customFetch<posPushNotificationControllerGetPushSubscriptionsResponse>(getPosPushNotificationControllerGetPushSubscriptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPosPushNotificationControllerGetPushSubscriptionsQueryKey = () => {
    return [
    'pos','push-notification','subscriptions'
    ] as const;
    }


export const getPosPushNotificationControllerGetPushSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof posPushNotificationControllerGetPushSubscriptions>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationControllerGetPushSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPosPushNotificationControllerGetPushSubscriptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof posPushNotificationControllerGetPushSubscriptions>>> = ({ signal }) => posPushNotificationControllerGetPushSubscriptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationControllerGetPushSubscriptions>>, TError, TData>
}

export type PosPushNotificationControllerGetPushSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationControllerGetPushSubscriptions>>>
export type PosPushNotificationControllerGetPushSubscriptionsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePosPushNotificationControllerGetPushSubscriptions<TData = Awaited<ReturnType<typeof posPushNotificationControllerGetPushSubscriptions>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationControllerGetPushSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPosPushNotificationControllerGetPushSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type pushNotificationListOfferControllerSetOfferListsResponse200 = {
  data: ResponsePushNotificationListOfferDto[]
  status: 200
}

export type pushNotificationListOfferControllerSetOfferListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationListOfferControllerSetOfferListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationListOfferControllerSetOfferListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationListOfferControllerSetOfferListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationListOfferControllerSetOfferListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationListOfferControllerSetOfferListsResponseSuccess = (pushNotificationListOfferControllerSetOfferListsResponse200) & {
  headers: Headers;
};
export type pushNotificationListOfferControllerSetOfferListsResponseError = (pushNotificationListOfferControllerSetOfferListsResponse400 | pushNotificationListOfferControllerSetOfferListsResponse401 | pushNotificationListOfferControllerSetOfferListsResponse403 | pushNotificationListOfferControllerSetOfferListsResponse404 | pushNotificationListOfferControllerSetOfferListsResponse500) & {
  headers: Headers;
};

export type pushNotificationListOfferControllerSetOfferListsResponse = (pushNotificationListOfferControllerSetOfferListsResponseSuccess | pushNotificationListOfferControllerSetOfferListsResponseError)

export const getPushNotificationListOfferControllerSetOfferListsUrl = () => {




  return `/push-notification/list/offer`
}

export const pushNotificationListOfferControllerSetOfferLists = async (putPushNotificationListOfferDto: PutPushNotificationListOfferDto, options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationListOfferControllerSetOfferListsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<pushNotificationListOfferControllerSetOfferListsResponse>(getPushNotificationListOfferControllerSetOfferListsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPushNotificationListOfferDto)
  }
);}





export const getPushNotificationListOfferControllerSetOfferListsMutationKey = () => ['pushNotificationListOfferControllerSetOfferLists'] as const;

export const getPushNotificationListOfferControllerSetOfferListsMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListOfferControllerSetOfferLists>>, TError,PushNotificationListOfferControllerSetOfferListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListOfferControllerSetOfferLists>>, TError,PushNotificationListOfferControllerSetOfferListsMutationVariables, TContext> => {

const mutationKey = getPushNotificationListOfferControllerSetOfferListsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushNotificationListOfferControllerSetOfferLists>>, PushNotificationListOfferControllerSetOfferListsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pushNotificationListOfferControllerSetOfferLists(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushNotificationListOfferControllerSetOfferListsMutationResult = NonNullable<Awaited<ReturnType<typeof pushNotificationListOfferControllerSetOfferLists>>>
    export type PushNotificationListOfferControllerSetOfferListsMutationBody = PutPushNotificationListOfferDto
    export type PushNotificationListOfferControllerSetOfferListsMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PushNotificationListOfferControllerSetOfferListsMutationVariables = {data: PutPushNotificationListOfferDto}

    export const usePushNotificationListOfferControllerSetOfferLists = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListOfferControllerSetOfferLists>>, TError,PushNotificationListOfferControllerSetOfferListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof pushNotificationListOfferControllerSetOfferLists>>,
        TError,
        PushNotificationListOfferControllerSetOfferListsMutationVariables,
        TContext
      > => {
      return useMutation(getPushNotificationListOfferControllerSetOfferListsMutationOptions(options), queryClient);
    }

export type pushNotificationListOfferControllerFindOfferListsResponse200 = {
  data: ResponsePushNotificationListOfferDto[]
  status: 200
}

export type pushNotificationListOfferControllerFindOfferListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationListOfferControllerFindOfferListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationListOfferControllerFindOfferListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationListOfferControllerFindOfferListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationListOfferControllerFindOfferListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationListOfferControllerFindOfferListsResponseSuccess = (pushNotificationListOfferControllerFindOfferListsResponse200) & {
  headers: Headers;
};
export type pushNotificationListOfferControllerFindOfferListsResponseError = (pushNotificationListOfferControllerFindOfferListsResponse400 | pushNotificationListOfferControllerFindOfferListsResponse401 | pushNotificationListOfferControllerFindOfferListsResponse403 | pushNotificationListOfferControllerFindOfferListsResponse404 | pushNotificationListOfferControllerFindOfferListsResponse500) & {
  headers: Headers;
};

export type pushNotificationListOfferControllerFindOfferListsResponse = (pushNotificationListOfferControllerFindOfferListsResponseSuccess | pushNotificationListOfferControllerFindOfferListsResponseError)

export const getPushNotificationListOfferControllerFindOfferListsUrl = () => {




  return `/push-notification/list/offer`
}

export const pushNotificationListOfferControllerFindOfferLists = async ( options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationListOfferControllerFindOfferListsResponse> => {

  return customFetch<pushNotificationListOfferControllerFindOfferListsResponse>(getPushNotificationListOfferControllerFindOfferListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPushNotificationListOfferControllerFindOfferListsQueryKey = () => {
    return [
    'push-notification','list','offer'
    ] as const;
    }


export const getPushNotificationListOfferControllerFindOfferListsQueryOptions = <TData = Awaited<ReturnType<typeof pushNotificationListOfferControllerFindOfferLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListOfferControllerFindOfferLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPushNotificationListOfferControllerFindOfferListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pushNotificationListOfferControllerFindOfferLists>>> = ({ signal }) => pushNotificationListOfferControllerFindOfferLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListOfferControllerFindOfferLists>>, TError, TData>
}

export type PushNotificationListOfferControllerFindOfferListsQueryResult = NonNullable<Awaited<ReturnType<typeof pushNotificationListOfferControllerFindOfferLists>>>
export type PushNotificationListOfferControllerFindOfferListsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePushNotificationListOfferControllerFindOfferLists<TData = Awaited<ReturnType<typeof pushNotificationListOfferControllerFindOfferLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListOfferControllerFindOfferLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPushNotificationListOfferControllerFindOfferListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type posPushNotificationListOfferControllerSetOfferListsResponse200 = {
  data: ResponsePushNotificationListOfferDto[]
  status: 200
}

export type posPushNotificationListOfferControllerSetOfferListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationListOfferControllerSetOfferListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationListOfferControllerSetOfferListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationListOfferControllerSetOfferListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationListOfferControllerSetOfferListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationListOfferControllerSetOfferListsResponseSuccess = (posPushNotificationListOfferControllerSetOfferListsResponse200) & {
  headers: Headers;
};
export type posPushNotificationListOfferControllerSetOfferListsResponseError = (posPushNotificationListOfferControllerSetOfferListsResponse400 | posPushNotificationListOfferControllerSetOfferListsResponse401 | posPushNotificationListOfferControllerSetOfferListsResponse403 | posPushNotificationListOfferControllerSetOfferListsResponse404 | posPushNotificationListOfferControllerSetOfferListsResponse500) & {
  headers: Headers;
};

export type posPushNotificationListOfferControllerSetOfferListsResponse = (posPushNotificationListOfferControllerSetOfferListsResponseSuccess | posPushNotificationListOfferControllerSetOfferListsResponseError)

export const getPosPushNotificationListOfferControllerSetOfferListsUrl = () => {




  return `/push-notification/list/offer/pos`
}

export const posPushNotificationListOfferControllerSetOfferLists = async (putPushNotificationListOfferDto: PutPushNotificationListOfferDto, options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationListOfferControllerSetOfferListsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<posPushNotificationListOfferControllerSetOfferListsResponse>(getPosPushNotificationListOfferControllerSetOfferListsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPushNotificationListOfferDto)
  }
);}





export const getPosPushNotificationListOfferControllerSetOfferListsMutationKey = () => ['posPushNotificationListOfferControllerSetOfferLists'] as const;

export const getPosPushNotificationListOfferControllerSetOfferListsMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListOfferControllerSetOfferLists>>, TError,PosPushNotificationListOfferControllerSetOfferListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListOfferControllerSetOfferLists>>, TError,PosPushNotificationListOfferControllerSetOfferListsMutationVariables, TContext> => {

const mutationKey = getPosPushNotificationListOfferControllerSetOfferListsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posPushNotificationListOfferControllerSetOfferLists>>, PosPushNotificationListOfferControllerSetOfferListsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  posPushNotificationListOfferControllerSetOfferLists(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosPushNotificationListOfferControllerSetOfferListsMutationResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationListOfferControllerSetOfferLists>>>
    export type PosPushNotificationListOfferControllerSetOfferListsMutationBody = PutPushNotificationListOfferDto
    export type PosPushNotificationListOfferControllerSetOfferListsMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PosPushNotificationListOfferControllerSetOfferListsMutationVariables = {data: PutPushNotificationListOfferDto}

    export const usePosPushNotificationListOfferControllerSetOfferLists = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListOfferControllerSetOfferLists>>, TError,PosPushNotificationListOfferControllerSetOfferListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posPushNotificationListOfferControllerSetOfferLists>>,
        TError,
        PosPushNotificationListOfferControllerSetOfferListsMutationVariables,
        TContext
      > => {
      return useMutation(getPosPushNotificationListOfferControllerSetOfferListsMutationOptions(options), queryClient);
    }

export type posPushNotificationListOfferControllerFindOfferListsResponse200 = {
  data: ResponsePushNotificationListOfferDto[]
  status: 200
}

export type posPushNotificationListOfferControllerFindOfferListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationListOfferControllerFindOfferListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationListOfferControllerFindOfferListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationListOfferControllerFindOfferListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationListOfferControllerFindOfferListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationListOfferControllerFindOfferListsResponseSuccess = (posPushNotificationListOfferControllerFindOfferListsResponse200) & {
  headers: Headers;
};
export type posPushNotificationListOfferControllerFindOfferListsResponseError = (posPushNotificationListOfferControllerFindOfferListsResponse400 | posPushNotificationListOfferControllerFindOfferListsResponse401 | posPushNotificationListOfferControllerFindOfferListsResponse403 | posPushNotificationListOfferControllerFindOfferListsResponse404 | posPushNotificationListOfferControllerFindOfferListsResponse500) & {
  headers: Headers;
};

export type posPushNotificationListOfferControllerFindOfferListsResponse = (posPushNotificationListOfferControllerFindOfferListsResponseSuccess | posPushNotificationListOfferControllerFindOfferListsResponseError)

export const getPosPushNotificationListOfferControllerFindOfferListsUrl = () => {




  return `/push-notification/list/offer/pos`
}

export const posPushNotificationListOfferControllerFindOfferLists = async ( options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationListOfferControllerFindOfferListsResponse> => {

  return customFetch<posPushNotificationListOfferControllerFindOfferListsResponse>(getPosPushNotificationListOfferControllerFindOfferListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPosPushNotificationListOfferControllerFindOfferListsQueryKey = () => {
    return [
    'push-notification','list','offer','pos'
    ] as const;
    }


export const getPosPushNotificationListOfferControllerFindOfferListsQueryOptions = <TData = Awaited<ReturnType<typeof posPushNotificationListOfferControllerFindOfferLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListOfferControllerFindOfferLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPosPushNotificationListOfferControllerFindOfferListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof posPushNotificationListOfferControllerFindOfferLists>>> = ({ signal }) => posPushNotificationListOfferControllerFindOfferLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListOfferControllerFindOfferLists>>, TError, TData>
}

export type PosPushNotificationListOfferControllerFindOfferListsQueryResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationListOfferControllerFindOfferLists>>>
export type PosPushNotificationListOfferControllerFindOfferListsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePosPushNotificationListOfferControllerFindOfferLists<TData = Awaited<ReturnType<typeof posPushNotificationListOfferControllerFindOfferLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListOfferControllerFindOfferLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPosPushNotificationListOfferControllerFindOfferListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type logPushControllerPaginateResponse200 = {
  data: LogPushControllerPaginate200
  status: 200
}

export type logPushControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logPushControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logPushControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logPushControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logPushControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logPushControllerPaginateResponseSuccess = (logPushControllerPaginateResponse200) & {
  headers: Headers;
};
export type logPushControllerPaginateResponseError = (logPushControllerPaginateResponse400 | logPushControllerPaginateResponse401 | logPushControllerPaginateResponse403 | logPushControllerPaginateResponse404 | logPushControllerPaginateResponse500) & {
  headers: Headers;
};

export type logPushControllerPaginateResponse = (logPushControllerPaginateResponseSuccess | logPushControllerPaginateResponseError)

export const getLogPushControllerPaginateUrl = (params?: LogPushControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.subscriptionId","filter.posDeviceId","filter.type","filter.statusCode","filter.success","filter.topic","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/push?${stringifiedParams}` : `/log/push`
}

export const logPushControllerPaginate = async (params?: LogPushControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logPushControllerPaginateResponse> => {

  return customFetch<logPushControllerPaginateResponse>(getLogPushControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogPushControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogPushControllerPaginateParams>,) => {
    return [
    'log','push', ...(params ? [params] : [])
    ] as const;
    }


export const getLogPushControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logPushControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogPushControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logPushControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogPushControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logPushControllerPaginate>>> = ({ signal }) => logPushControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logPushControllerPaginate>>, TError, TData>
}

export type LogPushControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logPushControllerPaginate>>>
export type LogPushControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogPushControllerPaginate<TData = Awaited<ReturnType<typeof logPushControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogPushControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logPushControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogPushControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerControllerCreateResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerCreateResponseSuccess = (offerControllerCreateResponse201) & {
  headers: Headers;
};
export type offerControllerCreateResponseError = (offerControllerCreateResponse400 | offerControllerCreateResponse401 | offerControllerCreateResponse403 | offerControllerCreateResponse404 | offerControllerCreateResponse500) & {
  headers: Headers;
};

export type offerControllerCreateResponse = (offerControllerCreateResponseSuccess | offerControllerCreateResponseError)

export const getOfferControllerCreateUrl = () => {




  return `/offer`
}

export const offerControllerCreate = async (createOfferDto: CreateOfferDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerCreateResponse>(getOfferControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferDto)
  }
);}





export const getOfferControllerCreateMutationKey = () => ['offerControllerCreate'] as const;

export const getOfferControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerCreate>>, TError,OfferControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerCreate>>, TError,OfferControllerCreateMutationVariables, TContext> => {

const mutationKey = getOfferControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerCreate>>, OfferControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  offerControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerCreate>>>
    export type OfferControllerCreateMutationBody = CreateOfferDto
    export type OfferControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerCreateMutationVariables = {data: CreateOfferDto}

    export const useOfferControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerCreate>>, TError,OfferControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerCreate>>,
        TError,
        OfferControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerCreateMutationOptions(options), queryClient);
    }

export type offerControllerFindAllResponse200 = {
  data: OfferControllerFindAll200
  status: 200
}

export type offerControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerFindAllResponseSuccess = (offerControllerFindAllResponse200) & {
  headers: Headers;
};
export type offerControllerFindAllResponseError = (offerControllerFindAllResponse400 | offerControllerFindAllResponse401 | offerControllerFindAllResponse403 | offerControllerFindAllResponse404 | offerControllerFindAllResponse500) & {
  headers: Headers;
};

export type offerControllerFindAllResponse = (offerControllerFindAllResponseSuccess | offerControllerFindAllResponseError)

export const getOfferControllerFindAllUrl = (params?: OfferControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.needsReview","filter.status","filter.createdBy","filter.reviewedBy","filter.createdAt","filter.updatedAt","filter.source","filter.source.id","filter.receipts.transactionType","filter.frozenAt","filter.parentOffer.id","filter.jobId","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer?${stringifiedParams}` : `/offer`
}

export const offerControllerFindAll = async (params?: OfferControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerFindAllResponse> => {

  return customFetch<offerControllerFindAllResponse>(getOfferControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferControllerFindAllQueryKey = (params?: MaybeRefOrGetter<OfferControllerFindAllParams>,) => {
    return [
    'offer', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof offerControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<OfferControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerControllerFindAll>>> = ({ signal }) => offerControllerFindAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindAll>>, TError, TData>
}

export type OfferControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof offerControllerFindAll>>>
export type OfferControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferControllerFindAll<TData = Awaited<ReturnType<typeof offerControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<OfferControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerControllerFindAllWithIncompleteTransactionsResponse200 = {
  data: OfferControllerFindAllWithIncompleteTransactions200
  status: 200
}

export type offerControllerFindAllWithIncompleteTransactionsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerFindAllWithIncompleteTransactionsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerFindAllWithIncompleteTransactionsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerFindAllWithIncompleteTransactionsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerFindAllWithIncompleteTransactionsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerFindAllWithIncompleteTransactionsResponseSuccess = (offerControllerFindAllWithIncompleteTransactionsResponse200) & {
  headers: Headers;
};
export type offerControllerFindAllWithIncompleteTransactionsResponseError = (offerControllerFindAllWithIncompleteTransactionsResponse400 | offerControllerFindAllWithIncompleteTransactionsResponse401 | offerControllerFindAllWithIncompleteTransactionsResponse403 | offerControllerFindAllWithIncompleteTransactionsResponse404 | offerControllerFindAllWithIncompleteTransactionsResponse500) & {
  headers: Headers;
};

export type offerControllerFindAllWithIncompleteTransactionsResponse = (offerControllerFindAllWithIncompleteTransactionsResponseSuccess | offerControllerFindAllWithIncompleteTransactionsResponseError)

export const getOfferControllerFindAllWithIncompleteTransactionsUrl = (params?: OfferControllerFindAllWithIncompleteTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.needsReview","filter.status","filter.createdBy","filter.reviewedBy","filter.createdAt","filter.updatedAt","filter.source","filter.source.id","filter.receipts.transactionType","filter.frozenAt","filter.parentOffer.id","filter.jobId","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer/with-incomplete-transactions?${stringifiedParams}` : `/offer/with-incomplete-transactions`
}

export const offerControllerFindAllWithIncompleteTransactions = async (params?: OfferControllerFindAllWithIncompleteTransactionsParams, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerFindAllWithIncompleteTransactionsResponse> => {

  return customFetch<offerControllerFindAllWithIncompleteTransactionsResponse>(getOfferControllerFindAllWithIncompleteTransactionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferControllerFindAllWithIncompleteTransactionsQueryKey = (params?: MaybeRefOrGetter<OfferControllerFindAllWithIncompleteTransactionsParams>,) => {
    return [
    'offer','with-incomplete-transactions', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferControllerFindAllWithIncompleteTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof offerControllerFindAllWithIncompleteTransactions>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<OfferControllerFindAllWithIncompleteTransactionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindAllWithIncompleteTransactions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferControllerFindAllWithIncompleteTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerControllerFindAllWithIncompleteTransactions>>> = ({ signal }) => offerControllerFindAllWithIncompleteTransactions(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindAllWithIncompleteTransactions>>, TError, TData>
}

export type OfferControllerFindAllWithIncompleteTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof offerControllerFindAllWithIncompleteTransactions>>>
export type OfferControllerFindAllWithIncompleteTransactionsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferControllerFindAllWithIncompleteTransactions<TData = Awaited<ReturnType<typeof offerControllerFindAllWithIncompleteTransactions>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<OfferControllerFindAllWithIncompleteTransactionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindAllWithIncompleteTransactions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferControllerFindAllWithIncompleteTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerControllerFindOneResponse200 = {
  data: ResponseOfferDto
  status: 200
}

export type offerControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerFindOneResponseSuccess = (offerControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerControllerFindOneResponseError = (offerControllerFindOneResponse400 | offerControllerFindOneResponse401 | offerControllerFindOneResponse403 | offerControllerFindOneResponse404 | offerControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerControllerFindOneResponse = (offerControllerFindOneResponseSuccess | offerControllerFindOneResponseError)

export const getOfferControllerFindOneUrl = (offerId: number,
    params?: OfferControllerFindOneParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer/${offerId}?${stringifiedParams}` : `/offer/${offerId}`
}

export const offerControllerFindOne = async (offerId: number,
    params?: OfferControllerFindOneParams, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerFindOneResponse> => {

  return customFetch<offerControllerFindOneResponse>(getOfferControllerFindOneUrl(offerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferControllerFindOneQueryKey = (offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferControllerFindOneParams>,) => {
    return [
    'offer',offerId, ...(params ? [params] : [])
    ] as const;
    }


export const getOfferControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferControllerFindOneParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferControllerFindOneQueryKey(offerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerControllerFindOne>>> = ({ signal }) => offerControllerFindOne(toValue(offerId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindOne>>, TError, TData>
}

export type OfferControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerControllerFindOne>>>
export type OfferControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferControllerFindOne<TData = Awaited<ReturnType<typeof offerControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferControllerFindOneParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferControllerFindOneQueryOptions(offerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerControllerUpdateResponse200 = {
  data: ResponseOfferDto
  status: 200
}

export type offerControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerUpdateResponseSuccess = (offerControllerUpdateResponse200) & {
  headers: Headers;
};
export type offerControllerUpdateResponseError = (offerControllerUpdateResponse400 | offerControllerUpdateResponse401 | offerControllerUpdateResponse403 | offerControllerUpdateResponse404 | offerControllerUpdateResponse500) & {
  headers: Headers;
};

export type offerControllerUpdateResponse = (offerControllerUpdateResponseSuccess | offerControllerUpdateResponseError)

export const getOfferControllerUpdateUrl = (offerId: number,) => {




  return `/offer/${offerId}`
}

export const offerControllerUpdate = async (offerId: number,
    updateOfferDto: UpdateOfferDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerUpdateResponse>(getOfferControllerUpdateUrl(offerId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOfferDto)
  }
);}





export const getOfferControllerUpdateMutationKey = () => ['offerControllerUpdate'] as const;

export const getOfferControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerUpdate>>, TError,OfferControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerUpdate>>, TError,OfferControllerUpdateMutationVariables, TContext> => {

const mutationKey = getOfferControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerUpdate>>, OfferControllerUpdateMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerUpdate(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerUpdate>>>
    export type OfferControllerUpdateMutationBody = UpdateOfferDto
    export type OfferControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerUpdateMutationVariables = {offerId: number;data: UpdateOfferDto}

    export const useOfferControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerUpdate>>, TError,OfferControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerUpdate>>,
        TError,
        OfferControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerUpdateMutationOptions(options), queryClient);
    }

export type offerControllerRemoveResponse200 = {
  data: ResponseOfferDto
  status: 200
}

export type offerControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerRemoveResponseSuccess = (offerControllerRemoveResponse200) & {
  headers: Headers;
};
export type offerControllerRemoveResponseError = (offerControllerRemoveResponse400 | offerControllerRemoveResponse401 | offerControllerRemoveResponse403 | offerControllerRemoveResponse404 | offerControllerRemoveResponse500) & {
  headers: Headers;
};

export type offerControllerRemoveResponse = (offerControllerRemoveResponseSuccess | offerControllerRemoveResponseError)

export const getOfferControllerRemoveUrl = (offerId: number,) => {




  return `/offer/${offerId}`
}

export const offerControllerRemove = async (offerId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerRemoveResponse> => {

  return customFetch<offerControllerRemoveResponse>(getOfferControllerRemoveUrl(offerId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOfferControllerRemoveMutationKey = () => ['offerControllerRemove'] as const;

export const getOfferControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerRemove>>, TError,OfferControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerRemove>>, TError,OfferControllerRemoveMutationVariables, TContext> => {

const mutationKey = getOfferControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerRemove>>, OfferControllerRemoveMutationVariables> = (props) => {
          const {offerId} = props ?? {};

          return  offerControllerRemove(offerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerRemove>>>

    export type OfferControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerRemoveMutationVariables = {offerId: number}

    export const useOfferControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerRemove>>, TError,OfferControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerRemove>>,
        TError,
        OfferControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerRemoveMutationOptions(options), queryClient);
    }

export type offerControllerFindOneWithMarkupResponse200 = {
  data: ResponseOfferDto
  status: 200
}

export type offerControllerFindOneWithMarkupResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerFindOneWithMarkupResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerFindOneWithMarkupResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerFindOneWithMarkupResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerFindOneWithMarkupResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerFindOneWithMarkupResponseSuccess = (offerControllerFindOneWithMarkupResponse200) & {
  headers: Headers;
};
export type offerControllerFindOneWithMarkupResponseError = (offerControllerFindOneWithMarkupResponse400 | offerControllerFindOneWithMarkupResponse401 | offerControllerFindOneWithMarkupResponse403 | offerControllerFindOneWithMarkupResponse404 | offerControllerFindOneWithMarkupResponse500) & {
  headers: Headers;
};

export type offerControllerFindOneWithMarkupResponse = (offerControllerFindOneWithMarkupResponseSuccess | offerControllerFindOneWithMarkupResponseError)

export const getOfferControllerFindOneWithMarkupUrl = (offerId: number,) => {




  return `/offer/${offerId}/simulate-markup`
}

export const offerControllerFindOneWithMarkup = async (offerId: number,
    createOfferMarkupDto: CreateOfferMarkupDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerFindOneWithMarkupResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerFindOneWithMarkupResponse>(getOfferControllerFindOneWithMarkupUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferMarkupDto)
  }
);}





export const getOfferControllerFindOneWithMarkupMutationKey = () => ['offerControllerFindOneWithMarkup'] as const;

export const getOfferControllerFindOneWithMarkupMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerFindOneWithMarkup>>, TError,OfferControllerFindOneWithMarkupMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerFindOneWithMarkup>>, TError,OfferControllerFindOneWithMarkupMutationVariables, TContext> => {

const mutationKey = getOfferControllerFindOneWithMarkupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerFindOneWithMarkup>>, OfferControllerFindOneWithMarkupMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerFindOneWithMarkup(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerFindOneWithMarkupMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerFindOneWithMarkup>>>
    export type OfferControllerFindOneWithMarkupMutationBody = CreateOfferMarkupDto
    export type OfferControllerFindOneWithMarkupMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerFindOneWithMarkupMutationVariables = {offerId: number;data: CreateOfferMarkupDto}

    export const useOfferControllerFindOneWithMarkup = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerFindOneWithMarkup>>, TError,OfferControllerFindOneWithMarkupMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerFindOneWithMarkup>>,
        TError,
        OfferControllerFindOneWithMarkupMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerFindOneWithMarkupMutationOptions(options), queryClient);
    }

export type offerControllerTransitionResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerTransitionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerTransitionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerTransitionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerTransitionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerTransitionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerTransitionResponseSuccess = (offerControllerTransitionResponse201) & {
  headers: Headers;
};
export type offerControllerTransitionResponseError = (offerControllerTransitionResponse400 | offerControllerTransitionResponse401 | offerControllerTransitionResponse403 | offerControllerTransitionResponse404 | offerControllerTransitionResponse500) & {
  headers: Headers;
};

export type offerControllerTransitionResponse = (offerControllerTransitionResponseSuccess | offerControllerTransitionResponseError)

export const getOfferControllerTransitionUrl = (offerId: number,) => {




  return `/offer/${offerId}/transition`
}

export const offerControllerTransition = async (offerId: number,
    offerTransitionDtoOfferTransitionProcessTransactionDtoOfferTransitionSelectItemsDtoOfferTransitionCompleteDto: OfferTransitionDto | OfferTransitionProcessTransactionDto | OfferTransitionSelectItemsDto | OfferTransitionCompleteDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerTransitionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerTransitionResponse>(getOfferControllerTransitionUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(offerTransitionDtoOfferTransitionProcessTransactionDtoOfferTransitionSelectItemsDtoOfferTransitionCompleteDto)
  }
);}





export const getOfferControllerTransitionMutationKey = () => ['offerControllerTransition'] as const;

export const getOfferControllerTransitionMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerTransition>>, TError,OfferControllerTransitionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerTransition>>, TError,OfferControllerTransitionMutationVariables, TContext> => {

const mutationKey = getOfferControllerTransitionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerTransition>>, OfferControllerTransitionMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerTransition(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerTransitionMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerTransition>>>
    export type OfferControllerTransitionMutationBody = OfferTransitionDto | OfferTransitionProcessTransactionDto | OfferTransitionSelectItemsDto | OfferTransitionCompleteDto
    export type OfferControllerTransitionMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerTransitionMutationVariables = {offerId: number;data: OfferTransitionDto | OfferTransitionProcessTransactionDto | OfferTransitionSelectItemsDto | OfferTransitionCompleteDto}

    export const useOfferControllerTransition = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerTransition>>, TError,OfferControllerTransitionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerTransition>>,
        TError,
        OfferControllerTransitionMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerTransitionMutationOptions(options), queryClient);
    }

export type offerControllerPingResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerPingResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerPingResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerPingResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerPingResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerPingResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerPingResponseSuccess = (offerControllerPingResponse201) & {
  headers: Headers;
};
export type offerControllerPingResponseError = (offerControllerPingResponse400 | offerControllerPingResponse401 | offerControllerPingResponse403 | offerControllerPingResponse404 | offerControllerPingResponse500) & {
  headers: Headers;
};

export type offerControllerPingResponse = (offerControllerPingResponseSuccess | offerControllerPingResponseError)

export const getOfferControllerPingUrl = (offerId: number,) => {




  return `/offer/${offerId}/ping`
}

export const offerControllerPing = async (offerId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerPingResponse> => {

  return customFetch<offerControllerPingResponse>(getOfferControllerPingUrl(offerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOfferControllerPingMutationKey = () => ['offerControllerPing'] as const;

export const getOfferControllerPingMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerPing>>, TError,OfferControllerPingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerPing>>, TError,OfferControllerPingMutationVariables, TContext> => {

const mutationKey = getOfferControllerPingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerPing>>, OfferControllerPingMutationVariables> = (props) => {
          const {offerId} = props ?? {};

          return  offerControllerPing(offerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerPingMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerPing>>>

    export type OfferControllerPingMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerPingMutationVariables = {offerId: number}

    export const useOfferControllerPing = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerPing>>, TError,OfferControllerPingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerPing>>,
        TError,
        OfferControllerPingMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerPingMutationOptions(options), queryClient);
    }

export type offerControllerLockResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerLockResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerLockResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerLockResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerLockResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerLockResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerLockResponseSuccess = (offerControllerLockResponse201) & {
  headers: Headers;
};
export type offerControllerLockResponseError = (offerControllerLockResponse400 | offerControllerLockResponse401 | offerControllerLockResponse403 | offerControllerLockResponse404 | offerControllerLockResponse500) & {
  headers: Headers;
};

export type offerControllerLockResponse = (offerControllerLockResponseSuccess | offerControllerLockResponseError)

export const getOfferControllerLockUrl = (offerId: number,) => {




  return `/offer/${offerId}/lock`
}

export const offerControllerLock = async (offerId: number,
    offerLockDto: OfferLockDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerLockResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerLockResponse>(getOfferControllerLockUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(offerLockDto)
  }
);}





export const getOfferControllerLockMutationKey = () => ['offerControllerLock'] as const;

export const getOfferControllerLockMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerLock>>, TError,OfferControllerLockMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerLock>>, TError,OfferControllerLockMutationVariables, TContext> => {

const mutationKey = getOfferControllerLockMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerLock>>, OfferControllerLockMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerLock(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerLockMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerLock>>>
    export type OfferControllerLockMutationBody = OfferLockDto
    export type OfferControllerLockMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerLockMutationVariables = {offerId: number;data: OfferLockDto}

    export const useOfferControllerLock = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerLock>>, TError,OfferControllerLockMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerLock>>,
        TError,
        OfferControllerLockMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerLockMutationOptions(options), queryClient);
    }

export type offerControllerReleaseResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerReleaseResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerReleaseResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerReleaseResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerReleaseResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerReleaseResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerReleaseResponseSuccess = (offerControllerReleaseResponse201) & {
  headers: Headers;
};
export type offerControllerReleaseResponseError = (offerControllerReleaseResponse400 | offerControllerReleaseResponse401 | offerControllerReleaseResponse403 | offerControllerReleaseResponse404 | offerControllerReleaseResponse500) & {
  headers: Headers;
};

export type offerControllerReleaseResponse = (offerControllerReleaseResponseSuccess | offerControllerReleaseResponseError)

export const getOfferControllerReleaseUrl = (offerId: number,) => {




  return `/offer/${offerId}/release`
}

export const offerControllerRelease = async (offerId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerReleaseResponse> => {

  return customFetch<offerControllerReleaseResponse>(getOfferControllerReleaseUrl(offerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOfferControllerReleaseMutationKey = () => ['offerControllerRelease'] as const;

export const getOfferControllerReleaseMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerRelease>>, TError,OfferControllerReleaseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerRelease>>, TError,OfferControllerReleaseMutationVariables, TContext> => {

const mutationKey = getOfferControllerReleaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerRelease>>, OfferControllerReleaseMutationVariables> = (props) => {
          const {offerId} = props ?? {};

          return  offerControllerRelease(offerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerReleaseMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerRelease>>>

    export type OfferControllerReleaseMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerReleaseMutationVariables = {offerId: number}

    export const useOfferControllerRelease = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerRelease>>, TError,OfferControllerReleaseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerRelease>>,
        TError,
        OfferControllerReleaseMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerReleaseMutationOptions(options), queryClient);
    }

export type offerControllerFreezeResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerFreezeResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerFreezeResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerFreezeResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerFreezeResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerFreezeResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerFreezeResponseSuccess = (offerControllerFreezeResponse201) & {
  headers: Headers;
};
export type offerControllerFreezeResponseError = (offerControllerFreezeResponse400 | offerControllerFreezeResponse401 | offerControllerFreezeResponse403 | offerControllerFreezeResponse404 | offerControllerFreezeResponse500) & {
  headers: Headers;
};

export type offerControllerFreezeResponse = (offerControllerFreezeResponseSuccess | offerControllerFreezeResponseError)

export const getOfferControllerFreezeUrl = (offerId: number,) => {




  return `/offer/${offerId}/freeze`
}

export const offerControllerFreeze = async (offerId: number,
    offerFreezeDto: OfferFreezeDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerFreezeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerFreezeResponse>(getOfferControllerFreezeUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(offerFreezeDto)
  }
);}





export const getOfferControllerFreezeMutationKey = () => ['offerControllerFreeze'] as const;

export const getOfferControllerFreezeMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerFreeze>>, TError,OfferControllerFreezeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerFreeze>>, TError,OfferControllerFreezeMutationVariables, TContext> => {

const mutationKey = getOfferControllerFreezeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerFreeze>>, OfferControllerFreezeMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerFreeze(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerFreezeMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerFreeze>>>
    export type OfferControllerFreezeMutationBody = OfferFreezeDto
    export type OfferControllerFreezeMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerFreezeMutationVariables = {offerId: number;data: OfferFreezeDto}

    export const useOfferControllerFreeze = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerFreeze>>, TError,OfferControllerFreezeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerFreeze>>,
        TError,
        OfferControllerFreezeMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerFreezeMutationOptions(options), queryClient);
    }

export type offerControllerUnfreezeResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerUnfreezeResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerUnfreezeResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerUnfreezeResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerUnfreezeResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerUnfreezeResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerUnfreezeResponseSuccess = (offerControllerUnfreezeResponse201) & {
  headers: Headers;
};
export type offerControllerUnfreezeResponseError = (offerControllerUnfreezeResponse400 | offerControllerUnfreezeResponse401 | offerControllerUnfreezeResponse403 | offerControllerUnfreezeResponse404 | offerControllerUnfreezeResponse500) & {
  headers: Headers;
};

export type offerControllerUnfreezeResponse = (offerControllerUnfreezeResponseSuccess | offerControllerUnfreezeResponseError)

export const getOfferControllerUnfreezeUrl = (offerId: number,) => {




  return `/offer/${offerId}/unfreeze`
}

export const offerControllerUnfreeze = async (offerId: number,
    offerFreezeDto: OfferFreezeDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerUnfreezeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerUnfreezeResponse>(getOfferControllerUnfreezeUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(offerFreezeDto)
  }
);}





export const getOfferControllerUnfreezeMutationKey = () => ['offerControllerUnfreeze'] as const;

export const getOfferControllerUnfreezeMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerUnfreeze>>, TError,OfferControllerUnfreezeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerUnfreeze>>, TError,OfferControllerUnfreezeMutationVariables, TContext> => {

const mutationKey = getOfferControllerUnfreezeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerUnfreeze>>, OfferControllerUnfreezeMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerUnfreeze(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerUnfreezeMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerUnfreeze>>>
    export type OfferControllerUnfreezeMutationBody = OfferFreezeDto
    export type OfferControllerUnfreezeMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerUnfreezeMutationVariables = {offerId: number;data: OfferFreezeDto}

    export const useOfferControllerUnfreeze = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerUnfreeze>>, TError,OfferControllerUnfreezeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerUnfreeze>>,
        TError,
        OfferControllerUnfreezeMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerUnfreezeMutationOptions(options), queryClient);
    }

export type offerControllerSplitResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerSplitResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerSplitResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerSplitResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerSplitResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerSplitResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerSplitResponseSuccess = (offerControllerSplitResponse201) & {
  headers: Headers;
};
export type offerControllerSplitResponseError = (offerControllerSplitResponse400 | offerControllerSplitResponse401 | offerControllerSplitResponse403 | offerControllerSplitResponse404 | offerControllerSplitResponse500) & {
  headers: Headers;
};

export type offerControllerSplitResponse = (offerControllerSplitResponseSuccess | offerControllerSplitResponseError)

export const getOfferControllerSplitUrl = (offerId: number,) => {




  return `/offer/${offerId}/split`
}

export const offerControllerSplit = async (offerId: number,
    createOfferDto: CreateOfferDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerSplitResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerSplitResponse>(getOfferControllerSplitUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferDto)
  }
);}





export const getOfferControllerSplitMutationKey = () => ['offerControllerSplit'] as const;

export const getOfferControllerSplitMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerSplit>>, TError,OfferControllerSplitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerSplit>>, TError,OfferControllerSplitMutationVariables, TContext> => {

const mutationKey = getOfferControllerSplitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerSplit>>, OfferControllerSplitMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerSplit(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerSplitMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerSplit>>>
    export type OfferControllerSplitMutationBody = CreateOfferDto
    export type OfferControllerSplitMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerSplitMutationVariables = {offerId: number;data: CreateOfferDto}

    export const useOfferControllerSplit = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerSplit>>, TError,OfferControllerSplitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerSplit>>,
        TError,
        OfferControllerSplitMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerSplitMutationOptions(options), queryClient);
    }

export type offerControllerCloneResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerCloneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerCloneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerCloneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerCloneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerCloneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerCloneResponseSuccess = (offerControllerCloneResponse201) & {
  headers: Headers;
};
export type offerControllerCloneResponseError = (offerControllerCloneResponse400 | offerControllerCloneResponse401 | offerControllerCloneResponse403 | offerControllerCloneResponse404 | offerControllerCloneResponse500) & {
  headers: Headers;
};

export type offerControllerCloneResponse = (offerControllerCloneResponseSuccess | offerControllerCloneResponseError)

export const getOfferControllerCloneUrl = (offerId: number,) => {




  return `/offer/${offerId}/clone`
}

export const offerControllerClone = async (offerId: number,
    createOfferDto: CreateOfferDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerCloneResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerCloneResponse>(getOfferControllerCloneUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferDto)
  }
);}





export const getOfferControllerCloneMutationKey = () => ['offerControllerClone'] as const;

export const getOfferControllerCloneMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerClone>>, TError,OfferControllerCloneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerClone>>, TError,OfferControllerCloneMutationVariables, TContext> => {

const mutationKey = getOfferControllerCloneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerClone>>, OfferControllerCloneMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerClone(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerCloneMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerClone>>>
    export type OfferControllerCloneMutationBody = CreateOfferDto
    export type OfferControllerCloneMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerCloneMutationVariables = {offerId: number;data: CreateOfferDto}

    export const useOfferControllerClone = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerClone>>, TError,OfferControllerCloneMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerClone>>,
        TError,
        OfferControllerCloneMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerCloneMutationOptions(options), queryClient);
    }

export type offerControllerMergeResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerMergeResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerMergeResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerMergeResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerMergeResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerMergeResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerMergeResponseSuccess = (offerControllerMergeResponse201) & {
  headers: Headers;
};
export type offerControllerMergeResponseError = (offerControllerMergeResponse400 | offerControllerMergeResponse401 | offerControllerMergeResponse403 | offerControllerMergeResponse404 | offerControllerMergeResponse500) & {
  headers: Headers;
};

export type offerControllerMergeResponse = (offerControllerMergeResponseSuccess | offerControllerMergeResponseError)

export const getOfferControllerMergeUrl = (offerId: number,) => {




  return `/offer/${offerId}/merge`
}

export const offerControllerMerge = async (offerId: number,
    mergeOffersDto: MergeOffersDto, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerMergeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerControllerMergeResponse>(getOfferControllerMergeUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mergeOffersDto)
  }
);}





export const getOfferControllerMergeMutationKey = () => ['offerControllerMerge'] as const;

export const getOfferControllerMergeMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerMerge>>, TError,OfferControllerMergeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerMerge>>, TError,OfferControllerMergeMutationVariables, TContext> => {

const mutationKey = getOfferControllerMergeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerMerge>>, OfferControllerMergeMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerControllerMerge(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerMergeMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerMerge>>>
    export type OfferControllerMergeMutationBody = MergeOffersDto
    export type OfferControllerMergeMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerMergeMutationVariables = {offerId: number;data: MergeOffersDto}

    export const useOfferControllerMerge = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerMerge>>, TError,OfferControllerMergeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerMerge>>,
        TError,
        OfferControllerMergeMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerMergeMutationOptions(options), queryClient);
    }

export type offerControllerResetItemsResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerControllerResetItemsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerControllerResetItemsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerControllerResetItemsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerControllerResetItemsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerControllerResetItemsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerControllerResetItemsResponseSuccess = (offerControllerResetItemsResponse201) & {
  headers: Headers;
};
export type offerControllerResetItemsResponseError = (offerControllerResetItemsResponse400 | offerControllerResetItemsResponse401 | offerControllerResetItemsResponse403 | offerControllerResetItemsResponse404 | offerControllerResetItemsResponse500) & {
  headers: Headers;
};

export type offerControllerResetItemsResponse = (offerControllerResetItemsResponseSuccess | offerControllerResetItemsResponseError)

export const getOfferControllerResetItemsUrl = (offerId: number,) => {




  return `/offer/${offerId}/reset-items`
}

export const offerControllerResetItems = async (offerId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerControllerResetItemsResponse> => {

  return customFetch<offerControllerResetItemsResponse>(getOfferControllerResetItemsUrl(offerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOfferControllerResetItemsMutationKey = () => ['offerControllerResetItems'] as const;

export const getOfferControllerResetItemsMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerResetItems>>, TError,OfferControllerResetItemsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerControllerResetItems>>, TError,OfferControllerResetItemsMutationVariables, TContext> => {

const mutationKey = getOfferControllerResetItemsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerControllerResetItems>>, OfferControllerResetItemsMutationVariables> = (props) => {
          const {offerId} = props ?? {};

          return  offerControllerResetItems(offerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferControllerResetItemsMutationResult = NonNullable<Awaited<ReturnType<typeof offerControllerResetItems>>>

    export type OfferControllerResetItemsMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferControllerResetItemsMutationVariables = {offerId: number}

    export const useOfferControllerResetItems = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerControllerResetItems>>, TError,OfferControllerResetItemsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerControllerResetItems>>,
        TError,
        OfferControllerResetItemsMutationVariables,
        TContext
      > => {
      return useMutation(getOfferControllerResetItemsMutationOptions(options), queryClient);
    }

export type settingsControllerFindAllGroupsResponse200 = {
  data: ResponseSettingGroupDto[]
  status: 200
}

export type settingsControllerFindAllGroupsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsControllerFindAllGroupsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsControllerFindAllGroupsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsControllerFindAllGroupsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsControllerFindAllGroupsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsControllerFindAllGroupsResponseSuccess = (settingsControllerFindAllGroupsResponse200) & {
  headers: Headers;
};
export type settingsControllerFindAllGroupsResponseError = (settingsControllerFindAllGroupsResponse400 | settingsControllerFindAllGroupsResponse401 | settingsControllerFindAllGroupsResponse403 | settingsControllerFindAllGroupsResponse404 | settingsControllerFindAllGroupsResponse500) & {
  headers: Headers;
};

export type settingsControllerFindAllGroupsResponse = (settingsControllerFindAllGroupsResponseSuccess | settingsControllerFindAllGroupsResponseError)

export const getSettingsControllerFindAllGroupsUrl = () => {




  return `/settings/groups`
}

export const settingsControllerFindAllGroups = async ( options?: Parameters<typeof customFetch>[1]): Promise<settingsControllerFindAllGroupsResponse> => {

  return customFetch<settingsControllerFindAllGroupsResponse>(getSettingsControllerFindAllGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSettingsControllerFindAllGroupsQueryKey = () => {
    return [
    'settings','groups'
    ] as const;
    }


export const getSettingsControllerFindAllGroupsQueryOptions = <TData = Awaited<ReturnType<typeof settingsControllerFindAllGroups>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsControllerFindAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSettingsControllerFindAllGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsControllerFindAllGroups>>> = ({ signal }) => settingsControllerFindAllGroups({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsControllerFindAllGroups>>, TError, TData>
}

export type SettingsControllerFindAllGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof settingsControllerFindAllGroups>>>
export type SettingsControllerFindAllGroupsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSettingsControllerFindAllGroups<TData = Awaited<ReturnType<typeof settingsControllerFindAllGroups>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsControllerFindAllGroups>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsControllerFindAllGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type settingsControllerFindOneGroupResponse200 = {
  data: ResponseSettingGroupDto
  status: 200
}

export type settingsControllerFindOneGroupResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsControllerFindOneGroupResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsControllerFindOneGroupResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsControllerFindOneGroupResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsControllerFindOneGroupResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsControllerFindOneGroupResponseSuccess = (settingsControllerFindOneGroupResponse200) & {
  headers: Headers;
};
export type settingsControllerFindOneGroupResponseError = (settingsControllerFindOneGroupResponse400 | settingsControllerFindOneGroupResponse401 | settingsControllerFindOneGroupResponse403 | settingsControllerFindOneGroupResponse404 | settingsControllerFindOneGroupResponse500) & {
  headers: Headers;
};

export type settingsControllerFindOneGroupResponse = (settingsControllerFindOneGroupResponseSuccess | settingsControllerFindOneGroupResponseError)

export const getSettingsControllerFindOneGroupUrl = (groupId: number,) => {




  return `/settings/groups/${groupId}`
}

export const settingsControllerFindOneGroup = async (groupId: number, options?: Parameters<typeof customFetch>[1]): Promise<settingsControllerFindOneGroupResponse> => {

  return customFetch<settingsControllerFindOneGroupResponse>(getSettingsControllerFindOneGroupUrl(groupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSettingsControllerFindOneGroupQueryKey = (groupId: MaybeRefOrGetter<number>,) => {
    return [
    'settings','groups',groupId
    ] as const;
    }


export const getSettingsControllerFindOneGroupQueryOptions = <TData = Awaited<ReturnType<typeof settingsControllerFindOneGroup>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(groupId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsControllerFindOneGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSettingsControllerFindOneGroupQueryKey(groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsControllerFindOneGroup>>> = ({ signal }) => settingsControllerFindOneGroup(toValue(groupId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(groupId) !== null && toValue(groupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsControllerFindOneGroup>>, TError, TData>
}

export type SettingsControllerFindOneGroupQueryResult = NonNullable<Awaited<ReturnType<typeof settingsControllerFindOneGroup>>>
export type SettingsControllerFindOneGroupQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSettingsControllerFindOneGroup<TData = Awaited<ReturnType<typeof settingsControllerFindOneGroup>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 groupId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsControllerFindOneGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsControllerFindOneGroupQueryOptions(groupId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type settingsControllerCreateCustomSettingResponse201 = {
  data: ResponseSettingCustomSettingDto
  status: 201
}

export type settingsControllerCreateCustomSettingResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsControllerCreateCustomSettingResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsControllerCreateCustomSettingResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsControllerCreateCustomSettingResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsControllerCreateCustomSettingResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsControllerCreateCustomSettingResponseSuccess = (settingsControllerCreateCustomSettingResponse201) & {
  headers: Headers;
};
export type settingsControllerCreateCustomSettingResponseError = (settingsControllerCreateCustomSettingResponse400 | settingsControllerCreateCustomSettingResponse401 | settingsControllerCreateCustomSettingResponse403 | settingsControllerCreateCustomSettingResponse404 | settingsControllerCreateCustomSettingResponse500) & {
  headers: Headers;
};

export type settingsControllerCreateCustomSettingResponse = (settingsControllerCreateCustomSettingResponseSuccess | settingsControllerCreateCustomSettingResponseError)

export const getSettingsControllerCreateCustomSettingUrl = (groupId: number,) => {




  return `/settings/groups/${groupId}/custom`
}

export const settingsControllerCreateCustomSetting = async (groupId: number,
    createCustomSettingDto: CreateCustomSettingDto, options?: Parameters<typeof customFetch>[1]): Promise<settingsControllerCreateCustomSettingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<settingsControllerCreateCustomSettingResponse>(getSettingsControllerCreateCustomSettingUrl(groupId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCustomSettingDto)
  }
);}





export const getSettingsControllerCreateCustomSettingMutationKey = () => ['settingsControllerCreateCustomSetting'] as const;

export const getSettingsControllerCreateCustomSettingMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsControllerCreateCustomSetting>>, TError,SettingsControllerCreateCustomSettingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof settingsControllerCreateCustomSetting>>, TError,SettingsControllerCreateCustomSettingMutationVariables, TContext> => {

const mutationKey = getSettingsControllerCreateCustomSettingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settingsControllerCreateCustomSetting>>, SettingsControllerCreateCustomSettingMutationVariables> = (props) => {
          const {groupId,data} = props ?? {};

          return  settingsControllerCreateCustomSetting(groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SettingsControllerCreateCustomSettingMutationResult = NonNullable<Awaited<ReturnType<typeof settingsControllerCreateCustomSetting>>>
    export type SettingsControllerCreateCustomSettingMutationBody = CreateCustomSettingDto
    export type SettingsControllerCreateCustomSettingMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SettingsControllerCreateCustomSettingMutationVariables = {groupId: number;data: CreateCustomSettingDto}

    export const useSettingsControllerCreateCustomSetting = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsControllerCreateCustomSetting>>, TError,SettingsControllerCreateCustomSettingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof settingsControllerCreateCustomSetting>>,
        TError,
        SettingsControllerCreateCustomSettingMutationVariables,
        TContext
      > => {
      return useMutation(getSettingsControllerCreateCustomSettingMutationOptions(options), queryClient);
    }

export type settingsControllerDeleteCustomSettingResponse200 = {
  data: ResponseSettingGroupDto
  status: 200
}

export type settingsControllerDeleteCustomSettingResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsControllerDeleteCustomSettingResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsControllerDeleteCustomSettingResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsControllerDeleteCustomSettingResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsControllerDeleteCustomSettingResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsControllerDeleteCustomSettingResponseSuccess = (settingsControllerDeleteCustomSettingResponse200) & {
  headers: Headers;
};
export type settingsControllerDeleteCustomSettingResponseError = (settingsControllerDeleteCustomSettingResponse400 | settingsControllerDeleteCustomSettingResponse401 | settingsControllerDeleteCustomSettingResponse403 | settingsControllerDeleteCustomSettingResponse404 | settingsControllerDeleteCustomSettingResponse500) & {
  headers: Headers;
};

export type settingsControllerDeleteCustomSettingResponse = (settingsControllerDeleteCustomSettingResponseSuccess | settingsControllerDeleteCustomSettingResponseError)

export const getSettingsControllerDeleteCustomSettingUrl = (groupId: number,
    settingId: number,) => {




  return `/settings/groups/${groupId}/custom/${settingId}`
}

export const settingsControllerDeleteCustomSetting = async (groupId: number,
    settingId: number, options?: Parameters<typeof customFetch>[1]): Promise<settingsControllerDeleteCustomSettingResponse> => {

  return customFetch<settingsControllerDeleteCustomSettingResponse>(getSettingsControllerDeleteCustomSettingUrl(groupId,settingId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getSettingsControllerDeleteCustomSettingMutationKey = () => ['settingsControllerDeleteCustomSetting'] as const;

export const getSettingsControllerDeleteCustomSettingMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsControllerDeleteCustomSetting>>, TError,SettingsControllerDeleteCustomSettingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof settingsControllerDeleteCustomSetting>>, TError,SettingsControllerDeleteCustomSettingMutationVariables, TContext> => {

const mutationKey = getSettingsControllerDeleteCustomSettingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settingsControllerDeleteCustomSetting>>, SettingsControllerDeleteCustomSettingMutationVariables> = (props) => {
          const {groupId,settingId} = props ?? {};

          return  settingsControllerDeleteCustomSetting(groupId,settingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SettingsControllerDeleteCustomSettingMutationResult = NonNullable<Awaited<ReturnType<typeof settingsControllerDeleteCustomSetting>>>

    export type SettingsControllerDeleteCustomSettingMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SettingsControllerDeleteCustomSettingMutationVariables = {groupId: number;settingId: number}

    export const useSettingsControllerDeleteCustomSetting = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsControllerDeleteCustomSetting>>, TError,SettingsControllerDeleteCustomSettingMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof settingsControllerDeleteCustomSetting>>,
        TError,
        SettingsControllerDeleteCustomSettingMutationVariables,
        TContext
      > => {
      return useMutation(getSettingsControllerDeleteCustomSettingMutationOptions(options), queryClient);
    }

export type settingsControllerUpdateManyValuesResponse200 = {
  data: ResponseSettingGroupDto
  status: 200
}

export type settingsControllerUpdateManyValuesResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsControllerUpdateManyValuesResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsControllerUpdateManyValuesResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsControllerUpdateManyValuesResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsControllerUpdateManyValuesResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsControllerUpdateManyValuesResponseSuccess = (settingsControllerUpdateManyValuesResponse200) & {
  headers: Headers;
};
export type settingsControllerUpdateManyValuesResponseError = (settingsControllerUpdateManyValuesResponse400 | settingsControllerUpdateManyValuesResponse401 | settingsControllerUpdateManyValuesResponse403 | settingsControllerUpdateManyValuesResponse404 | settingsControllerUpdateManyValuesResponse500) & {
  headers: Headers;
};

export type settingsControllerUpdateManyValuesResponse = (settingsControllerUpdateManyValuesResponseSuccess | settingsControllerUpdateManyValuesResponseError)

export const getSettingsControllerUpdateManyValuesUrl = (groupId: number,
    environment: string,) => {




  return `/settings/groups/${groupId}/${environment}/values`
}

export const settingsControllerUpdateManyValues = async (groupId: number,
    environment: string,
    settingsControllerUpdateManyValuesBody: string[], options?: Parameters<typeof customFetch>[1]): Promise<settingsControllerUpdateManyValuesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<settingsControllerUpdateManyValuesResponse>(getSettingsControllerUpdateManyValuesUrl(groupId,environment),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(settingsControllerUpdateManyValuesBody)
  }
);}





export const getSettingsControllerUpdateManyValuesMutationKey = () => ['settingsControllerUpdateManyValues'] as const;

export const getSettingsControllerUpdateManyValuesMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsControllerUpdateManyValues>>, TError,SettingsControllerUpdateManyValuesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof settingsControllerUpdateManyValues>>, TError,SettingsControllerUpdateManyValuesMutationVariables, TContext> => {

const mutationKey = getSettingsControllerUpdateManyValuesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settingsControllerUpdateManyValues>>, SettingsControllerUpdateManyValuesMutationVariables> = (props) => {
          const {groupId,environment,data} = props ?? {};

          return  settingsControllerUpdateManyValues(groupId,environment,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SettingsControllerUpdateManyValuesMutationResult = NonNullable<Awaited<ReturnType<typeof settingsControllerUpdateManyValues>>>
    export type SettingsControllerUpdateManyValuesMutationBody = string[]
    export type SettingsControllerUpdateManyValuesMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SettingsControllerUpdateManyValuesMutationVariables = {groupId: number;environment: string;data: string[]}

    export const useSettingsControllerUpdateManyValues = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsControllerUpdateManyValues>>, TError,SettingsControllerUpdateManyValuesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof settingsControllerUpdateManyValues>>,
        TError,
        SettingsControllerUpdateManyValuesMutationVariables,
        TContext
      > => {
      return useMutation(getSettingsControllerUpdateManyValuesMutationOptions(options), queryClient);
    }

export type settingsMarkupCampaignControllerCreateResponse201 = {
  data: ResponseSettingsMarkupCampaignDto
  status: 201
}

export type settingsMarkupCampaignControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsMarkupCampaignControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsMarkupCampaignControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsMarkupCampaignControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsMarkupCampaignControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsMarkupCampaignControllerCreateResponseSuccess = (settingsMarkupCampaignControllerCreateResponse201) & {
  headers: Headers;
};
export type settingsMarkupCampaignControllerCreateResponseError = (settingsMarkupCampaignControllerCreateResponse400 | settingsMarkupCampaignControllerCreateResponse401 | settingsMarkupCampaignControllerCreateResponse403 | settingsMarkupCampaignControllerCreateResponse404 | settingsMarkupCampaignControllerCreateResponse500) & {
  headers: Headers;
};

export type settingsMarkupCampaignControllerCreateResponse = (settingsMarkupCampaignControllerCreateResponseSuccess | settingsMarkupCampaignControllerCreateResponseError)

export const getSettingsMarkupCampaignControllerCreateUrl = () => {




  return `/settings/markup-campaign`
}

export const settingsMarkupCampaignControllerCreate = async (createSettingsMarkupCampaignDto: CreateSettingsMarkupCampaignDto, options?: Parameters<typeof customFetch>[1]): Promise<settingsMarkupCampaignControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<settingsMarkupCampaignControllerCreateResponse>(getSettingsMarkupCampaignControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createSettingsMarkupCampaignDto)
  }
);}





export const getSettingsMarkupCampaignControllerCreateMutationKey = () => ['settingsMarkupCampaignControllerCreate'] as const;

export const getSettingsMarkupCampaignControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerCreate>>, TError,SettingsMarkupCampaignControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerCreate>>, TError,SettingsMarkupCampaignControllerCreateMutationVariables, TContext> => {

const mutationKey = getSettingsMarkupCampaignControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settingsMarkupCampaignControllerCreate>>, SettingsMarkupCampaignControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  settingsMarkupCampaignControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SettingsMarkupCampaignControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof settingsMarkupCampaignControllerCreate>>>
    export type SettingsMarkupCampaignControllerCreateMutationBody = CreateSettingsMarkupCampaignDto
    export type SettingsMarkupCampaignControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SettingsMarkupCampaignControllerCreateMutationVariables = {data: CreateSettingsMarkupCampaignDto}

    export const useSettingsMarkupCampaignControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerCreate>>, TError,SettingsMarkupCampaignControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof settingsMarkupCampaignControllerCreate>>,
        TError,
        SettingsMarkupCampaignControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSettingsMarkupCampaignControllerCreateMutationOptions(options), queryClient);
    }

export type settingsMarkupCampaignControllerFindAllResponse200 = {
  data: SettingsMarkupCampaignControllerFindAll200
  status: 200
}

export type settingsMarkupCampaignControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsMarkupCampaignControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsMarkupCampaignControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsMarkupCampaignControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsMarkupCampaignControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsMarkupCampaignControllerFindAllResponseSuccess = (settingsMarkupCampaignControllerFindAllResponse200) & {
  headers: Headers;
};
export type settingsMarkupCampaignControllerFindAllResponseError = (settingsMarkupCampaignControllerFindAllResponse400 | settingsMarkupCampaignControllerFindAllResponse401 | settingsMarkupCampaignControllerFindAllResponse403 | settingsMarkupCampaignControllerFindAllResponse404 | settingsMarkupCampaignControllerFindAllResponse500) & {
  headers: Headers;
};

export type settingsMarkupCampaignControllerFindAllResponse = (settingsMarkupCampaignControllerFindAllResponseSuccess | settingsMarkupCampaignControllerFindAllResponseError)

export const getSettingsMarkupCampaignControllerFindAllUrl = (params?: SettingsMarkupCampaignControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.code","filter.markupType","filter.transactionType","filter.isActive","filter.autoApply","filter.value","filter.minTotal","filter.validFrom","filter.validUntil","filter.createdAt","filter.updatedAt","filter.createdBy.id","filter.sources.id","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/settings/markup-campaign?${stringifiedParams}` : `/settings/markup-campaign`
}

export const settingsMarkupCampaignControllerFindAll = async (params?: SettingsMarkupCampaignControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<settingsMarkupCampaignControllerFindAllResponse> => {

  return customFetch<settingsMarkupCampaignControllerFindAllResponse>(getSettingsMarkupCampaignControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSettingsMarkupCampaignControllerFindAllQueryKey = (params?: MaybeRefOrGetter<SettingsMarkupCampaignControllerFindAllParams>,) => {
    return [
    'settings','markup-campaign', ...(params ? [params] : [])
    ] as const;
    }


export const getSettingsMarkupCampaignControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<SettingsMarkupCampaignControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSettingsMarkupCampaignControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindAll>>> = ({ signal }) => settingsMarkupCampaignControllerFindAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindAll>>, TError, TData>
}

export type SettingsMarkupCampaignControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindAll>>>
export type SettingsMarkupCampaignControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSettingsMarkupCampaignControllerFindAll<TData = Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<SettingsMarkupCampaignControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsMarkupCampaignControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type settingsMarkupCampaignControllerUpdateResponse200 = {
  data: ResponseSettingsMarkupCampaignDto
  status: 200
}

export type settingsMarkupCampaignControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsMarkupCampaignControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsMarkupCampaignControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsMarkupCampaignControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsMarkupCampaignControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsMarkupCampaignControllerUpdateResponseSuccess = (settingsMarkupCampaignControllerUpdateResponse200) & {
  headers: Headers;
};
export type settingsMarkupCampaignControllerUpdateResponseError = (settingsMarkupCampaignControllerUpdateResponse400 | settingsMarkupCampaignControllerUpdateResponse401 | settingsMarkupCampaignControllerUpdateResponse403 | settingsMarkupCampaignControllerUpdateResponse404 | settingsMarkupCampaignControllerUpdateResponse500) & {
  headers: Headers;
};

export type settingsMarkupCampaignControllerUpdateResponse = (settingsMarkupCampaignControllerUpdateResponseSuccess | settingsMarkupCampaignControllerUpdateResponseError)

export const getSettingsMarkupCampaignControllerUpdateUrl = (campaignId: number,) => {




  return `/settings/markup-campaign/${campaignId}`
}

export const settingsMarkupCampaignControllerUpdate = async (campaignId: number,
    updateSettingsMarkupCampaignDto: UpdateSettingsMarkupCampaignDto, options?: Parameters<typeof customFetch>[1]): Promise<settingsMarkupCampaignControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<settingsMarkupCampaignControllerUpdateResponse>(getSettingsMarkupCampaignControllerUpdateUrl(campaignId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateSettingsMarkupCampaignDto)
  }
);}





export const getSettingsMarkupCampaignControllerUpdateMutationKey = () => ['settingsMarkupCampaignControllerUpdate'] as const;

export const getSettingsMarkupCampaignControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerUpdate>>, TError,SettingsMarkupCampaignControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerUpdate>>, TError,SettingsMarkupCampaignControllerUpdateMutationVariables, TContext> => {

const mutationKey = getSettingsMarkupCampaignControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settingsMarkupCampaignControllerUpdate>>, SettingsMarkupCampaignControllerUpdateMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  settingsMarkupCampaignControllerUpdate(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SettingsMarkupCampaignControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof settingsMarkupCampaignControllerUpdate>>>
    export type SettingsMarkupCampaignControllerUpdateMutationBody = UpdateSettingsMarkupCampaignDto
    export type SettingsMarkupCampaignControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SettingsMarkupCampaignControllerUpdateMutationVariables = {campaignId: number;data: UpdateSettingsMarkupCampaignDto}

    export const useSettingsMarkupCampaignControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerUpdate>>, TError,SettingsMarkupCampaignControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof settingsMarkupCampaignControllerUpdate>>,
        TError,
        SettingsMarkupCampaignControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getSettingsMarkupCampaignControllerUpdateMutationOptions(options), queryClient);
    }

export type settingsMarkupCampaignControllerRemoveResponse200 = {
  data: ResponseSettingsMarkupCampaignDto
  status: 200
}

export type settingsMarkupCampaignControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsMarkupCampaignControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsMarkupCampaignControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsMarkupCampaignControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsMarkupCampaignControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsMarkupCampaignControllerRemoveResponseSuccess = (settingsMarkupCampaignControllerRemoveResponse200) & {
  headers: Headers;
};
export type settingsMarkupCampaignControllerRemoveResponseError = (settingsMarkupCampaignControllerRemoveResponse400 | settingsMarkupCampaignControllerRemoveResponse401 | settingsMarkupCampaignControllerRemoveResponse403 | settingsMarkupCampaignControllerRemoveResponse404 | settingsMarkupCampaignControllerRemoveResponse500) & {
  headers: Headers;
};

export type settingsMarkupCampaignControllerRemoveResponse = (settingsMarkupCampaignControllerRemoveResponseSuccess | settingsMarkupCampaignControllerRemoveResponseError)

export const getSettingsMarkupCampaignControllerRemoveUrl = (campaignId: number,) => {




  return `/settings/markup-campaign/${campaignId}`
}

export const settingsMarkupCampaignControllerRemove = async (campaignId: number, options?: Parameters<typeof customFetch>[1]): Promise<settingsMarkupCampaignControllerRemoveResponse> => {

  return customFetch<settingsMarkupCampaignControllerRemoveResponse>(getSettingsMarkupCampaignControllerRemoveUrl(campaignId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getSettingsMarkupCampaignControllerRemoveMutationKey = () => ['settingsMarkupCampaignControllerRemove'] as const;

export const getSettingsMarkupCampaignControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerRemove>>, TError,SettingsMarkupCampaignControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerRemove>>, TError,SettingsMarkupCampaignControllerRemoveMutationVariables, TContext> => {

const mutationKey = getSettingsMarkupCampaignControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof settingsMarkupCampaignControllerRemove>>, SettingsMarkupCampaignControllerRemoveMutationVariables> = (props) => {
          const {campaignId} = props ?? {};

          return  settingsMarkupCampaignControllerRemove(campaignId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SettingsMarkupCampaignControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof settingsMarkupCampaignControllerRemove>>>

    export type SettingsMarkupCampaignControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SettingsMarkupCampaignControllerRemoveMutationVariables = {campaignId: number}

    export const useSettingsMarkupCampaignControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerRemove>>, TError,SettingsMarkupCampaignControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof settingsMarkupCampaignControllerRemove>>,
        TError,
        SettingsMarkupCampaignControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getSettingsMarkupCampaignControllerRemoveMutationOptions(options), queryClient);
    }

export type settingsMarkupCampaignControllerFindOneResponse200 = {
  data: ResponseSettingsMarkupCampaignDto
  status: 200
}

export type settingsMarkupCampaignControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsMarkupCampaignControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsMarkupCampaignControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsMarkupCampaignControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsMarkupCampaignControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsMarkupCampaignControllerFindOneResponseSuccess = (settingsMarkupCampaignControllerFindOneResponse200) & {
  headers: Headers;
};
export type settingsMarkupCampaignControllerFindOneResponseError = (settingsMarkupCampaignControllerFindOneResponse400 | settingsMarkupCampaignControllerFindOneResponse401 | settingsMarkupCampaignControllerFindOneResponse403 | settingsMarkupCampaignControllerFindOneResponse404 | settingsMarkupCampaignControllerFindOneResponse500) & {
  headers: Headers;
};

export type settingsMarkupCampaignControllerFindOneResponse = (settingsMarkupCampaignControllerFindOneResponseSuccess | settingsMarkupCampaignControllerFindOneResponseError)

export const getSettingsMarkupCampaignControllerFindOneUrl = (campaignId: number,) => {




  return `/settings/markup-campaign/${campaignId}`
}

export const settingsMarkupCampaignControllerFindOne = async (campaignId: number, options?: Parameters<typeof customFetch>[1]): Promise<settingsMarkupCampaignControllerFindOneResponse> => {

  return customFetch<settingsMarkupCampaignControllerFindOneResponse>(getSettingsMarkupCampaignControllerFindOneUrl(campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSettingsMarkupCampaignControllerFindOneQueryKey = (campaignId: MaybeRefOrGetter<number>,) => {
    return [
    'settings','markup-campaign',campaignId
    ] as const;
    }


export const getSettingsMarkupCampaignControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(campaignId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSettingsMarkupCampaignControllerFindOneQueryKey(campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindOne>>> = ({ signal }) => settingsMarkupCampaignControllerFindOne(toValue(campaignId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(campaignId) !== null && toValue(campaignId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindOne>>, TError, TData>
}

export type SettingsMarkupCampaignControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindOne>>>
export type SettingsMarkupCampaignControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSettingsMarkupCampaignControllerFindOne<TData = Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 campaignId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsMarkupCampaignControllerFindOneQueryOptions(campaignId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type settingsMarkupCampaignControllerGetByCodeResponse200 = {
  data: ResponseSettingsMarkupCampaignDto
  status: 200
}

export type settingsMarkupCampaignControllerGetByCodeResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsMarkupCampaignControllerGetByCodeResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsMarkupCampaignControllerGetByCodeResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsMarkupCampaignControllerGetByCodeResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsMarkupCampaignControllerGetByCodeResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsMarkupCampaignControllerGetByCodeResponseSuccess = (settingsMarkupCampaignControllerGetByCodeResponse200) & {
  headers: Headers;
};
export type settingsMarkupCampaignControllerGetByCodeResponseError = (settingsMarkupCampaignControllerGetByCodeResponse400 | settingsMarkupCampaignControllerGetByCodeResponse401 | settingsMarkupCampaignControllerGetByCodeResponse403 | settingsMarkupCampaignControllerGetByCodeResponse404 | settingsMarkupCampaignControllerGetByCodeResponse500) & {
  headers: Headers;
};

export type settingsMarkupCampaignControllerGetByCodeResponse = (settingsMarkupCampaignControllerGetByCodeResponseSuccess | settingsMarkupCampaignControllerGetByCodeResponseError)

export const getSettingsMarkupCampaignControllerGetByCodeUrl = (code: string,) => {




  return `/settings/markup-campaign/by-code/${code}`
}

export const settingsMarkupCampaignControllerGetByCode = async (code: string, options?: Parameters<typeof customFetch>[1]): Promise<settingsMarkupCampaignControllerGetByCodeResponse> => {

  return customFetch<settingsMarkupCampaignControllerGetByCodeResponse>(getSettingsMarkupCampaignControllerGetByCodeUrl(code),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSettingsMarkupCampaignControllerGetByCodeQueryKey = (code: MaybeRefOrGetter<string>,) => {
    return [
    'settings','markup-campaign','by-code',code
    ] as const;
    }


export const getSettingsMarkupCampaignControllerGetByCodeQueryOptions = <TData = Awaited<ReturnType<typeof settingsMarkupCampaignControllerGetByCode>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(code: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerGetByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSettingsMarkupCampaignControllerGetByCodeQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsMarkupCampaignControllerGetByCode>>> = ({ signal }) => settingsMarkupCampaignControllerGetByCode(toValue(code), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(code) !== null && toValue(code) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerGetByCode>>, TError, TData>
}

export type SettingsMarkupCampaignControllerGetByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof settingsMarkupCampaignControllerGetByCode>>>
export type SettingsMarkupCampaignControllerGetByCodeQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSettingsMarkupCampaignControllerGetByCode<TData = Awaited<ReturnType<typeof settingsMarkupCampaignControllerGetByCode>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 code: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsMarkupCampaignControllerGetByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsMarkupCampaignControllerGetByCodeQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type settingsTransactionControllerFindTransactionExternalProvidersResponse200 = {
  data: ResponseTransactionExternalProviderDto[]
  status: 200
}

export type settingsTransactionControllerFindTransactionExternalProvidersResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type settingsTransactionControllerFindTransactionExternalProvidersResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type settingsTransactionControllerFindTransactionExternalProvidersResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type settingsTransactionControllerFindTransactionExternalProvidersResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type settingsTransactionControllerFindTransactionExternalProvidersResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type settingsTransactionControllerFindTransactionExternalProvidersResponseSuccess = (settingsTransactionControllerFindTransactionExternalProvidersResponse200) & {
  headers: Headers;
};
export type settingsTransactionControllerFindTransactionExternalProvidersResponseError = (settingsTransactionControllerFindTransactionExternalProvidersResponse400 | settingsTransactionControllerFindTransactionExternalProvidersResponse401 | settingsTransactionControllerFindTransactionExternalProvidersResponse403 | settingsTransactionControllerFindTransactionExternalProvidersResponse404 | settingsTransactionControllerFindTransactionExternalProvidersResponse500) & {
  headers: Headers;
};

export type settingsTransactionControllerFindTransactionExternalProvidersResponse = (settingsTransactionControllerFindTransactionExternalProvidersResponseSuccess | settingsTransactionControllerFindTransactionExternalProvidersResponseError)

export const getSettingsTransactionControllerFindTransactionExternalProvidersUrl = () => {




  return `/settings/transaction/external-providers`
}

export const settingsTransactionControllerFindTransactionExternalProviders = async ( options?: Parameters<typeof customFetch>[1]): Promise<settingsTransactionControllerFindTransactionExternalProvidersResponse> => {

  return customFetch<settingsTransactionControllerFindTransactionExternalProvidersResponse>(getSettingsTransactionControllerFindTransactionExternalProvidersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSettingsTransactionControllerFindTransactionExternalProvidersQueryKey = () => {
    return [
    'settings','transaction','external-providers'
    ] as const;
    }


export const getSettingsTransactionControllerFindTransactionExternalProvidersQueryOptions = <TData = Awaited<ReturnType<typeof settingsTransactionControllerFindTransactionExternalProviders>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsTransactionControllerFindTransactionExternalProviders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSettingsTransactionControllerFindTransactionExternalProvidersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof settingsTransactionControllerFindTransactionExternalProviders>>> = ({ signal }) => settingsTransactionControllerFindTransactionExternalProviders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settingsTransactionControllerFindTransactionExternalProviders>>, TError, TData>
}

export type SettingsTransactionControllerFindTransactionExternalProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof settingsTransactionControllerFindTransactionExternalProviders>>>
export type SettingsTransactionControllerFindTransactionExternalProvidersQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSettingsTransactionControllerFindTransactionExternalProviders<TData = Awaited<ReturnType<typeof settingsTransactionControllerFindTransactionExternalProviders>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settingsTransactionControllerFindTransactionExternalProviders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSettingsTransactionControllerFindTransactionExternalProvidersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerCommentControllerCreateResponse201 = {
  data: ResponseOfferCommentDto
  status: 201
}

export type offerCommentControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerCommentControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerCommentControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerCommentControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerCommentControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerCommentControllerCreateResponseSuccess = (offerCommentControllerCreateResponse201) & {
  headers: Headers;
};
export type offerCommentControllerCreateResponseError = (offerCommentControllerCreateResponse400 | offerCommentControllerCreateResponse401 | offerCommentControllerCreateResponse403 | offerCommentControllerCreateResponse404 | offerCommentControllerCreateResponse500) & {
  headers: Headers;
};

export type offerCommentControllerCreateResponse = (offerCommentControllerCreateResponseSuccess | offerCommentControllerCreateResponseError)

export const getOfferCommentControllerCreateUrl = (offerId: number,) => {




  return `/offers/${offerId}/comment`
}

export const offerCommentControllerCreate = async (offerId: number,
    createOfferCommentDto: CreateOfferCommentDto, options?: Parameters<typeof customFetch>[1]): Promise<offerCommentControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerCommentControllerCreateResponse>(getOfferCommentControllerCreateUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferCommentDto)
  }
);}





export const getOfferCommentControllerCreateMutationKey = () => ['offerCommentControllerCreate'] as const;

export const getOfferCommentControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerCreate>>, TError,OfferCommentControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerCreate>>, TError,OfferCommentControllerCreateMutationVariables, TContext> => {

const mutationKey = getOfferCommentControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerCommentControllerCreate>>, OfferCommentControllerCreateMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerCommentControllerCreate(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferCommentControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof offerCommentControllerCreate>>>
    export type OfferCommentControllerCreateMutationBody = CreateOfferCommentDto
    export type OfferCommentControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferCommentControllerCreateMutationVariables = {offerId: number;data: CreateOfferCommentDto}

    export const useOfferCommentControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerCreate>>, TError,OfferCommentControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerCommentControllerCreate>>,
        TError,
        OfferCommentControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferCommentControllerCreateMutationOptions(options), queryClient);
    }

export type offerCommentControllerFindAllResponse200 = {
  data: OfferCommentControllerFindAll200
  status: 200
}

export type offerCommentControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerCommentControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerCommentControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerCommentControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerCommentControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerCommentControllerFindAllResponseSuccess = (offerCommentControllerFindAllResponse200) & {
  headers: Headers;
};
export type offerCommentControllerFindAllResponseError = (offerCommentControllerFindAllResponse400 | offerCommentControllerFindAllResponse401 | offerCommentControllerFindAllResponse403 | offerCommentControllerFindAllResponse404 | offerCommentControllerFindAllResponse500) & {
  headers: Headers;
};

export type offerCommentControllerFindAllResponse = (offerCommentControllerFindAllResponseSuccess | offerCommentControllerFindAllResponseError)

export const getOfferCommentControllerFindAllUrl = (offerId: number,
    params?: OfferCommentControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.user.id","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offers/${offerId}/comment?${stringifiedParams}` : `/offers/${offerId}/comment`
}

export const offerCommentControllerFindAll = async (offerId: number,
    params?: OfferCommentControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<offerCommentControllerFindAllResponse> => {

  return customFetch<offerCommentControllerFindAllResponse>(getOfferCommentControllerFindAllUrl(offerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferCommentControllerFindAllQueryKey = (offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferCommentControllerFindAllParams>,) => {
    return [
    'offers',offerId,'comment', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferCommentControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof offerCommentControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferCommentControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerCommentControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferCommentControllerFindAllQueryKey(offerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerCommentControllerFindAll>>> = ({ signal }) => offerCommentControllerFindAll(toValue(offerId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerCommentControllerFindAll>>, TError, TData>
}

export type OfferCommentControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof offerCommentControllerFindAll>>>
export type OfferCommentControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferCommentControllerFindAll<TData = Awaited<ReturnType<typeof offerCommentControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferCommentControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerCommentControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferCommentControllerFindAllQueryOptions(offerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerCommentControllerUpdateResponse200 = {
  data: ResponseOfferCommentDto
  status: 200
}

export type offerCommentControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerCommentControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerCommentControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerCommentControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerCommentControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerCommentControllerUpdateResponseSuccess = (offerCommentControllerUpdateResponse200) & {
  headers: Headers;
};
export type offerCommentControllerUpdateResponseError = (offerCommentControllerUpdateResponse400 | offerCommentControllerUpdateResponse401 | offerCommentControllerUpdateResponse403 | offerCommentControllerUpdateResponse404 | offerCommentControllerUpdateResponse500) & {
  headers: Headers;
};

export type offerCommentControllerUpdateResponse = (offerCommentControllerUpdateResponseSuccess | offerCommentControllerUpdateResponseError)

export const getOfferCommentControllerUpdateUrl = (offerId: number,
    commentId: number,) => {




  return `/offers/${offerId}/comment/${commentId}`
}

export const offerCommentControllerUpdate = async (offerId: number,
    commentId: number,
    updateOfferCommentDto: UpdateOfferCommentDto, options?: Parameters<typeof customFetch>[1]): Promise<offerCommentControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerCommentControllerUpdateResponse>(getOfferCommentControllerUpdateUrl(offerId,commentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOfferCommentDto)
  }
);}





export const getOfferCommentControllerUpdateMutationKey = () => ['offerCommentControllerUpdate'] as const;

export const getOfferCommentControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerUpdate>>, TError,OfferCommentControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerUpdate>>, TError,OfferCommentControllerUpdateMutationVariables, TContext> => {

const mutationKey = getOfferCommentControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerCommentControllerUpdate>>, OfferCommentControllerUpdateMutationVariables> = (props) => {
          const {offerId,commentId,data} = props ?? {};

          return  offerCommentControllerUpdate(offerId,commentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferCommentControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof offerCommentControllerUpdate>>>
    export type OfferCommentControllerUpdateMutationBody = UpdateOfferCommentDto
    export type OfferCommentControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferCommentControllerUpdateMutationVariables = {offerId: number;commentId: number;data: UpdateOfferCommentDto}

    export const useOfferCommentControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerUpdate>>, TError,OfferCommentControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerCommentControllerUpdate>>,
        TError,
        OfferCommentControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferCommentControllerUpdateMutationOptions(options), queryClient);
    }

export type offerCommentControllerRemoveResponse200 = {
  data: ResponseOfferCommentDto
  status: 200
}

export type offerCommentControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerCommentControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerCommentControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerCommentControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerCommentControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerCommentControllerRemoveResponseSuccess = (offerCommentControllerRemoveResponse200) & {
  headers: Headers;
};
export type offerCommentControllerRemoveResponseError = (offerCommentControllerRemoveResponse400 | offerCommentControllerRemoveResponse401 | offerCommentControllerRemoveResponse403 | offerCommentControllerRemoveResponse404 | offerCommentControllerRemoveResponse500) & {
  headers: Headers;
};

export type offerCommentControllerRemoveResponse = (offerCommentControllerRemoveResponseSuccess | offerCommentControllerRemoveResponseError)

export const getOfferCommentControllerRemoveUrl = (offerId: number,
    commentId: number,) => {




  return `/offers/${offerId}/comment/${commentId}`
}

export const offerCommentControllerRemove = async (offerId: number,
    commentId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerCommentControllerRemoveResponse> => {

  return customFetch<offerCommentControllerRemoveResponse>(getOfferCommentControllerRemoveUrl(offerId,commentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOfferCommentControllerRemoveMutationKey = () => ['offerCommentControllerRemove'] as const;

export const getOfferCommentControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerRemove>>, TError,OfferCommentControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerRemove>>, TError,OfferCommentControllerRemoveMutationVariables, TContext> => {

const mutationKey = getOfferCommentControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerCommentControllerRemove>>, OfferCommentControllerRemoveMutationVariables> = (props) => {
          const {offerId,commentId} = props ?? {};

          return  offerCommentControllerRemove(offerId,commentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferCommentControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof offerCommentControllerRemove>>>

    export type OfferCommentControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferCommentControllerRemoveMutationVariables = {offerId: number;commentId: number}

    export const useOfferCommentControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerCommentControllerRemove>>, TError,OfferCommentControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerCommentControllerRemove>>,
        TError,
        OfferCommentControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getOfferCommentControllerRemoveMutationOptions(options), queryClient);
    }

export type offerImageControllerCreateResponse201 = {
  data: ResponseOfferImageDto
  status: 201
}

export type offerImageControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerImageControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerImageControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerImageControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerImageControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerImageControllerCreateResponseSuccess = (offerImageControllerCreateResponse201) & {
  headers: Headers;
};
export type offerImageControllerCreateResponseError = (offerImageControllerCreateResponse400 | offerImageControllerCreateResponse401 | offerImageControllerCreateResponse403 | offerImageControllerCreateResponse404 | offerImageControllerCreateResponse500) & {
  headers: Headers;
};

export type offerImageControllerCreateResponse = (offerImageControllerCreateResponseSuccess | offerImageControllerCreateResponseError)

export const getOfferImageControllerCreateUrl = (offerId: number,) => {




  return `/offer/${offerId}/image`
}

export const offerImageControllerCreate = async (offerId: number,
    createOfferImageDto: CreateOfferImageDto, options?: Parameters<typeof customFetch>[1]): Promise<offerImageControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerImageControllerCreateResponse>(getOfferImageControllerCreateUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferImageDto)
  }
);}





export const getOfferImageControllerCreateMutationKey = () => ['offerImageControllerCreate'] as const;

export const getOfferImageControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerImageControllerCreate>>, TError,OfferImageControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerImageControllerCreate>>, TError,OfferImageControllerCreateMutationVariables, TContext> => {

const mutationKey = getOfferImageControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerImageControllerCreate>>, OfferImageControllerCreateMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerImageControllerCreate(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferImageControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof offerImageControllerCreate>>>
    export type OfferImageControllerCreateMutationBody = CreateOfferImageDto
    export type OfferImageControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferImageControllerCreateMutationVariables = {offerId: number;data: CreateOfferImageDto}

    export const useOfferImageControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerImageControllerCreate>>, TError,OfferImageControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerImageControllerCreate>>,
        TError,
        OfferImageControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferImageControllerCreateMutationOptions(options), queryClient);
    }

export type offerImageControllerFindManyResponse200 = {
  data: ResponseOfferImageDto[]
  status: 200
}

export type offerImageControllerFindManyResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerImageControllerFindManyResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerImageControllerFindManyResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerImageControllerFindManyResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerImageControllerFindManyResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerImageControllerFindManyResponseSuccess = (offerImageControllerFindManyResponse200) & {
  headers: Headers;
};
export type offerImageControllerFindManyResponseError = (offerImageControllerFindManyResponse400 | offerImageControllerFindManyResponse401 | offerImageControllerFindManyResponse403 | offerImageControllerFindManyResponse404 | offerImageControllerFindManyResponse500) & {
  headers: Headers;
};

export type offerImageControllerFindManyResponse = (offerImageControllerFindManyResponseSuccess | offerImageControllerFindManyResponseError)

export const getOfferImageControllerFindManyUrl = (offerId: number,) => {




  return `/offer/${offerId}/image`
}

export const offerImageControllerFindMany = async (offerId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerImageControllerFindManyResponse> => {

  return customFetch<offerImageControllerFindManyResponse>(getOfferImageControllerFindManyUrl(offerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferImageControllerFindManyQueryKey = (offerId: MaybeRefOrGetter<number>,) => {
    return [
    'offer',offerId,'image'
    ] as const;
    }


export const getOfferImageControllerFindManyQueryOptions = <TData = Awaited<ReturnType<typeof offerImageControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerImageControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferImageControllerFindManyQueryKey(offerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerImageControllerFindMany>>> = ({ signal }) => offerImageControllerFindMany(toValue(offerId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerImageControllerFindMany>>, TError, TData>
}

export type OfferImageControllerFindManyQueryResult = NonNullable<Awaited<ReturnType<typeof offerImageControllerFindMany>>>
export type OfferImageControllerFindManyQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferImageControllerFindMany<TData = Awaited<ReturnType<typeof offerImageControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerImageControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferImageControllerFindManyQueryOptions(offerId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerImageControllerFindOneResponse200 = {
  data: ResponseOfferImageDto
  status: 200
}

export type offerImageControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerImageControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerImageControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerImageControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerImageControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerImageControllerFindOneResponseSuccess = (offerImageControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerImageControllerFindOneResponseError = (offerImageControllerFindOneResponse400 | offerImageControllerFindOneResponse401 | offerImageControllerFindOneResponse403 | offerImageControllerFindOneResponse404 | offerImageControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerImageControllerFindOneResponse = (offerImageControllerFindOneResponseSuccess | offerImageControllerFindOneResponseError)

export const getOfferImageControllerFindOneUrl = (offerId: number,
    imageId: number,) => {




  return `/offer/${offerId}/image/${imageId}`
}

export const offerImageControllerFindOne = async (offerId: number,
    imageId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerImageControllerFindOneResponse> => {

  return customFetch<offerImageControllerFindOneResponse>(getOfferImageControllerFindOneUrl(offerId,imageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferImageControllerFindOneQueryKey = (offerId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>,) => {
    return [
    'offer',offerId,'image',imageId
    ] as const;
    }


export const getOfferImageControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerImageControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerImageControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferImageControllerFindOneQueryKey(offerId,imageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerImageControllerFindOne>>> = ({ signal }) => offerImageControllerFindOne(toValue(offerId),toValue(imageId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined && toValue(imageId) !== null && toValue(imageId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerImageControllerFindOne>>, TError, TData>
}

export type OfferImageControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerImageControllerFindOne>>>
export type OfferImageControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferImageControllerFindOne<TData = Awaited<ReturnType<typeof offerImageControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerImageControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferImageControllerFindOneQueryOptions(offerId,imageId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerImageControllerRemoveResponse200 = {
  data: ResponseOfferImageDto
  status: 200
}

export type offerImageControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerImageControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerImageControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerImageControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerImageControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerImageControllerRemoveResponseSuccess = (offerImageControllerRemoveResponse200) & {
  headers: Headers;
};
export type offerImageControllerRemoveResponseError = (offerImageControllerRemoveResponse400 | offerImageControllerRemoveResponse401 | offerImageControllerRemoveResponse403 | offerImageControllerRemoveResponse404 | offerImageControllerRemoveResponse500) & {
  headers: Headers;
};

export type offerImageControllerRemoveResponse = (offerImageControllerRemoveResponseSuccess | offerImageControllerRemoveResponseError)

export const getOfferImageControllerRemoveUrl = (offerId: number,
    imageId: number,) => {




  return `/offer/${offerId}/image/${imageId}`
}

export const offerImageControllerRemove = async (offerId: number,
    imageId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerImageControllerRemoveResponse> => {

  return customFetch<offerImageControllerRemoveResponse>(getOfferImageControllerRemoveUrl(offerId,imageId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOfferImageControllerRemoveMutationKey = () => ['offerImageControllerRemove'] as const;

export const getOfferImageControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerImageControllerRemove>>, TError,OfferImageControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerImageControllerRemove>>, TError,OfferImageControllerRemoveMutationVariables, TContext> => {

const mutationKey = getOfferImageControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerImageControllerRemove>>, OfferImageControllerRemoveMutationVariables> = (props) => {
          const {offerId,imageId} = props ?? {};

          return  offerImageControllerRemove(offerId,imageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferImageControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof offerImageControllerRemove>>>

    export type OfferImageControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferImageControllerRemoveMutationVariables = {offerId: number;imageId: number}

    export const useOfferImageControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerImageControllerRemove>>, TError,OfferImageControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerImageControllerRemove>>,
        TError,
        OfferImageControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getOfferImageControllerRemoveMutationOptions(options), queryClient);
    }

export type offerItemImageControllerCreateResponse201 = {
  data: ResponseOfferImageDto
  status: 201
}

export type offerItemImageControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemImageControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemImageControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemImageControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemImageControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemImageControllerCreateResponseSuccess = (offerItemImageControllerCreateResponse201) & {
  headers: Headers;
};
export type offerItemImageControllerCreateResponseError = (offerItemImageControllerCreateResponse400 | offerItemImageControllerCreateResponse401 | offerItemImageControllerCreateResponse403 | offerItemImageControllerCreateResponse404 | offerItemImageControllerCreateResponse500) & {
  headers: Headers;
};

export type offerItemImageControllerCreateResponse = (offerItemImageControllerCreateResponseSuccess | offerItemImageControllerCreateResponseError)

export const getOfferItemImageControllerCreateUrl = (offerId: number,
    offerItemId: number,) => {




  return `/offer/${offerId}/item/${offerItemId}/image`
}

export const offerItemImageControllerCreate = async (offerId: number,
    offerItemId: number,
    createOfferImageDto: CreateOfferImageDto, options?: Parameters<typeof customFetch>[1]): Promise<offerItemImageControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerItemImageControllerCreateResponse>(getOfferItemImageControllerCreateUrl(offerId,offerItemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferImageDto)
  }
);}





export const getOfferItemImageControllerCreateMutationKey = () => ['offerItemImageControllerCreate'] as const;

export const getOfferItemImageControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemImageControllerCreate>>, TError,OfferItemImageControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerItemImageControllerCreate>>, TError,OfferItemImageControllerCreateMutationVariables, TContext> => {

const mutationKey = getOfferItemImageControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerItemImageControllerCreate>>, OfferItemImageControllerCreateMutationVariables> = (props) => {
          const {offerId,offerItemId,data} = props ?? {};

          return  offerItemImageControllerCreate(offerId,offerItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferItemImageControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof offerItemImageControllerCreate>>>
    export type OfferItemImageControllerCreateMutationBody = CreateOfferImageDto
    export type OfferItemImageControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferItemImageControllerCreateMutationVariables = {offerId: number;offerItemId: number;data: CreateOfferImageDto}

    export const useOfferItemImageControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemImageControllerCreate>>, TError,OfferItemImageControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerItemImageControllerCreate>>,
        TError,
        OfferItemImageControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferItemImageControllerCreateMutationOptions(options), queryClient);
    }

export type offerItemImageControllerFindManyResponse200 = {
  data: ResponseOfferImageDto[]
  status: 200
}

export type offerItemImageControllerFindManyResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemImageControllerFindManyResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemImageControllerFindManyResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemImageControllerFindManyResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemImageControllerFindManyResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemImageControllerFindManyResponseSuccess = (offerItemImageControllerFindManyResponse200) & {
  headers: Headers;
};
export type offerItemImageControllerFindManyResponseError = (offerItemImageControllerFindManyResponse400 | offerItemImageControllerFindManyResponse401 | offerItemImageControllerFindManyResponse403 | offerItemImageControllerFindManyResponse404 | offerItemImageControllerFindManyResponse500) & {
  headers: Headers;
};

export type offerItemImageControllerFindManyResponse = (offerItemImageControllerFindManyResponseSuccess | offerItemImageControllerFindManyResponseError)

export const getOfferItemImageControllerFindManyUrl = (offerId: number,
    offerItemId: number,) => {




  return `/offer/${offerId}/item/${offerItemId}/image`
}

export const offerItemImageControllerFindMany = async (offerId: number,
    offerItemId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerItemImageControllerFindManyResponse> => {

  return customFetch<offerItemImageControllerFindManyResponse>(getOfferItemImageControllerFindManyUrl(offerId,offerItemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferItemImageControllerFindManyQueryKey = (offerId: MaybeRefOrGetter<number>,
    offerItemId: MaybeRefOrGetter<number>,) => {
    return [
    'offer',offerId,'item',offerItemId,'image'
    ] as const;
    }


export const getOfferItemImageControllerFindManyQueryOptions = <TData = Awaited<ReturnType<typeof offerItemImageControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    offerItemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemImageControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferItemImageControllerFindManyQueryKey(offerId,offerItemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerItemImageControllerFindMany>>> = ({ signal }) => offerItemImageControllerFindMany(toValue(offerId),toValue(offerItemId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined && toValue(offerItemId) !== null && toValue(offerItemId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerItemImageControllerFindMany>>, TError, TData>
}

export type OfferItemImageControllerFindManyQueryResult = NonNullable<Awaited<ReturnType<typeof offerItemImageControllerFindMany>>>
export type OfferItemImageControllerFindManyQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferItemImageControllerFindMany<TData = Awaited<ReturnType<typeof offerItemImageControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    offerItemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemImageControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferItemImageControllerFindManyQueryOptions(offerId,offerItemId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerItemImageControllerFindOneResponse200 = {
  data: ResponseOfferImageDto
  status: 200
}

export type offerItemImageControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemImageControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemImageControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemImageControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemImageControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemImageControllerFindOneResponseSuccess = (offerItemImageControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerItemImageControllerFindOneResponseError = (offerItemImageControllerFindOneResponse400 | offerItemImageControllerFindOneResponse401 | offerItemImageControllerFindOneResponse403 | offerItemImageControllerFindOneResponse404 | offerItemImageControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerItemImageControllerFindOneResponse = (offerItemImageControllerFindOneResponseSuccess | offerItemImageControllerFindOneResponseError)

export const getOfferItemImageControllerFindOneUrl = (offerId: number,
    offerItemId: number,
    imageId: number,) => {




  return `/offer/${offerId}/item/${offerItemId}/image/${imageId}`
}

export const offerItemImageControllerFindOne = async (offerId: number,
    offerItemId: number,
    imageId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerItemImageControllerFindOneResponse> => {

  return customFetch<offerItemImageControllerFindOneResponse>(getOfferItemImageControllerFindOneUrl(offerId,offerItemId,imageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferItemImageControllerFindOneQueryKey = (offerId: MaybeRefOrGetter<number>,
    offerItemId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>,) => {
    return [
    'offer',offerId,'item',offerItemId,'image',imageId
    ] as const;
    }


export const getOfferItemImageControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerItemImageControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    offerItemId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemImageControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferItemImageControllerFindOneQueryKey(offerId,offerItemId,imageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerItemImageControllerFindOne>>> = ({ signal }) => offerItemImageControllerFindOne(toValue(offerId),toValue(offerItemId),toValue(imageId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined && toValue(offerItemId) !== null && toValue(offerItemId) !== undefined && toValue(imageId) !== null && toValue(imageId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerItemImageControllerFindOne>>, TError, TData>
}

export type OfferItemImageControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerItemImageControllerFindOne>>>
export type OfferItemImageControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferItemImageControllerFindOne<TData = Awaited<ReturnType<typeof offerItemImageControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    offerItemId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemImageControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferItemImageControllerFindOneQueryOptions(offerId,offerItemId,imageId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerItemImageControllerRemoveResponse200 = {
  data: ResponseOfferImageDto
  status: 200
}

export type offerItemImageControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemImageControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemImageControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemImageControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemImageControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemImageControllerRemoveResponseSuccess = (offerItemImageControllerRemoveResponse200) & {
  headers: Headers;
};
export type offerItemImageControllerRemoveResponseError = (offerItemImageControllerRemoveResponse400 | offerItemImageControllerRemoveResponse401 | offerItemImageControllerRemoveResponse403 | offerItemImageControllerRemoveResponse404 | offerItemImageControllerRemoveResponse500) & {
  headers: Headers;
};

export type offerItemImageControllerRemoveResponse = (offerItemImageControllerRemoveResponseSuccess | offerItemImageControllerRemoveResponseError)

export const getOfferItemImageControllerRemoveUrl = (offerId: number,
    offerItemId: number,
    imageId: number,) => {




  return `/offer/${offerId}/item/${offerItemId}/image/${imageId}`
}

export const offerItemImageControllerRemove = async (offerId: number,
    offerItemId: number,
    imageId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerItemImageControllerRemoveResponse> => {

  return customFetch<offerItemImageControllerRemoveResponse>(getOfferItemImageControllerRemoveUrl(offerId,offerItemId,imageId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOfferItemImageControllerRemoveMutationKey = () => ['offerItemImageControllerRemove'] as const;

export const getOfferItemImageControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemImageControllerRemove>>, TError,OfferItemImageControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerItemImageControllerRemove>>, TError,OfferItemImageControllerRemoveMutationVariables, TContext> => {

const mutationKey = getOfferItemImageControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerItemImageControllerRemove>>, OfferItemImageControllerRemoveMutationVariables> = (props) => {
          const {offerId,offerItemId,imageId} = props ?? {};

          return  offerItemImageControllerRemove(offerId,offerItemId,imageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferItemImageControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof offerItemImageControllerRemove>>>

    export type OfferItemImageControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferItemImageControllerRemoveMutationVariables = {offerId: number;offerItemId: number;imageId: number}

    export const useOfferItemImageControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemImageControllerRemove>>, TError,OfferItemImageControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerItemImageControllerRemove>>,
        TError,
        OfferItemImageControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getOfferItemImageControllerRemoveMutationOptions(options), queryClient);
    }

export type offerItemControllerCreateResponse201 = {
  data: ResponseOfferItemDto
  status: 201
}

export type offerItemControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemControllerCreateResponseSuccess = (offerItemControllerCreateResponse201) & {
  headers: Headers;
};
export type offerItemControllerCreateResponseError = (offerItemControllerCreateResponse400 | offerItemControllerCreateResponse401 | offerItemControllerCreateResponse403 | offerItemControllerCreateResponse404 | offerItemControllerCreateResponse500) & {
  headers: Headers;
};

export type offerItemControllerCreateResponse = (offerItemControllerCreateResponseSuccess | offerItemControllerCreateResponseError)

export const getOfferItemControllerCreateUrl = (offerId: number,) => {




  return `/offer/${offerId}/item`
}

export const offerItemControllerCreate = async (offerId: number,
    createOfferItemDto: CreateOfferItemDto, options?: Parameters<typeof customFetch>[1]): Promise<offerItemControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerItemControllerCreateResponse>(getOfferItemControllerCreateUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferItemDto)
  }
);}





export const getOfferItemControllerCreateMutationKey = () => ['offerItemControllerCreate'] as const;

export const getOfferItemControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerCreate>>, TError,OfferItemControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerCreate>>, TError,OfferItemControllerCreateMutationVariables, TContext> => {

const mutationKey = getOfferItemControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerItemControllerCreate>>, OfferItemControllerCreateMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerItemControllerCreate(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferItemControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof offerItemControllerCreate>>>
    export type OfferItemControllerCreateMutationBody = CreateOfferItemDto
    export type OfferItemControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferItemControllerCreateMutationVariables = {offerId: number;data: CreateOfferItemDto}

    export const useOfferItemControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerCreate>>, TError,OfferItemControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerItemControllerCreate>>,
        TError,
        OfferItemControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferItemControllerCreateMutationOptions(options), queryClient);
    }

export type offerItemControllerFindAllForOfferResponse200 = {
  data: OfferItemControllerFindAllForOffer200
  status: 200
}

export type offerItemControllerFindAllForOfferResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemControllerFindAllForOfferResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemControllerFindAllForOfferResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemControllerFindAllForOfferResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemControllerFindAllForOfferResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemControllerFindAllForOfferResponseSuccess = (offerItemControllerFindAllForOfferResponse200) & {
  headers: Headers;
};
export type offerItemControllerFindAllForOfferResponseError = (offerItemControllerFindAllForOfferResponse400 | offerItemControllerFindAllForOfferResponse401 | offerItemControllerFindAllForOfferResponse403 | offerItemControllerFindAllForOfferResponse404 | offerItemControllerFindAllForOfferResponse500) & {
  headers: Headers;
};

export type offerItemControllerFindAllForOfferResponse = (offerItemControllerFindAllForOfferResponseSuccess | offerItemControllerFindAllForOfferResponseError)

export const getOfferItemControllerFindAllForOfferUrl = (offerId: number,
    params?: OfferItemControllerFindAllForOfferParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.needsReview","filter.isIncluded","filter.createdAt","filter.offer.createdAt","filter.offer.id","filter.offer.status","filter.offer.source.id","filter.offer.createdBy.id","filter.handlingItems.id","filter.handlingItems.status","filter.handlingItems.handlingType","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer/${offerId}/item?${stringifiedParams}` : `/offer/${offerId}/item`
}

export const offerItemControllerFindAllForOffer = async (offerId: number,
    params?: OfferItemControllerFindAllForOfferParams, options?: Parameters<typeof customFetch>[1]): Promise<offerItemControllerFindAllForOfferResponse> => {

  return customFetch<offerItemControllerFindAllForOfferResponse>(getOfferItemControllerFindAllForOfferUrl(offerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferItemControllerFindAllForOfferQueryKey = (offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferItemControllerFindAllForOfferParams>,) => {
    return [
    'offer',offerId,'item', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferItemControllerFindAllForOfferQueryOptions = <TData = Awaited<ReturnType<typeof offerItemControllerFindAllForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferItemControllerFindAllForOfferParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemControllerFindAllForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferItemControllerFindAllForOfferQueryKey(offerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerItemControllerFindAllForOffer>>> = ({ signal }) => offerItemControllerFindAllForOffer(toValue(offerId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerItemControllerFindAllForOffer>>, TError, TData>
}

export type OfferItemControllerFindAllForOfferQueryResult = NonNullable<Awaited<ReturnType<typeof offerItemControllerFindAllForOffer>>>
export type OfferItemControllerFindAllForOfferQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferItemControllerFindAllForOffer<TData = Awaited<ReturnType<typeof offerItemControllerFindAllForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferItemControllerFindAllForOfferParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemControllerFindAllForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferItemControllerFindAllForOfferQueryOptions(offerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerItemControllerFindOneResponse200 = {
  data: ResponseOfferItemDto
  status: 200
}

export type offerItemControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemControllerFindOneResponseSuccess = (offerItemControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerItemControllerFindOneResponseError = (offerItemControllerFindOneResponse400 | offerItemControllerFindOneResponse401 | offerItemControllerFindOneResponse403 | offerItemControllerFindOneResponse404 | offerItemControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerItemControllerFindOneResponse = (offerItemControllerFindOneResponseSuccess | offerItemControllerFindOneResponseError)

export const getOfferItemControllerFindOneUrl = (offerId: number,
    itemId: number,) => {




  return `/offer/${offerId}/item/${itemId}`
}

export const offerItemControllerFindOne = async (offerId: number,
    itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerItemControllerFindOneResponse> => {

  return customFetch<offerItemControllerFindOneResponse>(getOfferItemControllerFindOneUrl(offerId,itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferItemControllerFindOneQueryKey = (offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>,) => {
    return [
    'offer',offerId,'item',itemId
    ] as const;
    }


export const getOfferItemControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerItemControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferItemControllerFindOneQueryKey(offerId,itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerItemControllerFindOne>>> = ({ signal }) => offerItemControllerFindOne(toValue(offerId),toValue(itemId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined && toValue(itemId) !== null && toValue(itemId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerItemControllerFindOne>>, TError, TData>
}

export type OfferItemControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerItemControllerFindOne>>>
export type OfferItemControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferItemControllerFindOne<TData = Awaited<ReturnType<typeof offerItemControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferItemControllerFindOneQueryOptions(offerId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerItemControllerUpdateResponse200 = {
  data: ResponseOfferItemDto
  status: 200
}

export type offerItemControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemControllerUpdateResponseSuccess = (offerItemControllerUpdateResponse200) & {
  headers: Headers;
};
export type offerItemControllerUpdateResponseError = (offerItemControllerUpdateResponse400 | offerItemControllerUpdateResponse401 | offerItemControllerUpdateResponse403 | offerItemControllerUpdateResponse404 | offerItemControllerUpdateResponse500) & {
  headers: Headers;
};

export type offerItemControllerUpdateResponse = (offerItemControllerUpdateResponseSuccess | offerItemControllerUpdateResponseError)

export const getOfferItemControllerUpdateUrl = (offerId: number,
    itemId: number,) => {




  return `/offer/${offerId}/item/${itemId}`
}

export const offerItemControllerUpdate = async (offerId: number,
    itemId: number,
    updateOfferItemDto: UpdateOfferItemDto, options?: Parameters<typeof customFetch>[1]): Promise<offerItemControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerItemControllerUpdateResponse>(getOfferItemControllerUpdateUrl(offerId,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOfferItemDto)
  }
);}





export const getOfferItemControllerUpdateMutationKey = () => ['offerItemControllerUpdate'] as const;

export const getOfferItemControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerUpdate>>, TError,OfferItemControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerUpdate>>, TError,OfferItemControllerUpdateMutationVariables, TContext> => {

const mutationKey = getOfferItemControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerItemControllerUpdate>>, OfferItemControllerUpdateMutationVariables> = (props) => {
          const {offerId,itemId,data} = props ?? {};

          return  offerItemControllerUpdate(offerId,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferItemControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof offerItemControllerUpdate>>>
    export type OfferItemControllerUpdateMutationBody = UpdateOfferItemDto
    export type OfferItemControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferItemControllerUpdateMutationVariables = {offerId: number;itemId: number;data: UpdateOfferItemDto}

    export const useOfferItemControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerUpdate>>, TError,OfferItemControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerItemControllerUpdate>>,
        TError,
        OfferItemControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferItemControllerUpdateMutationOptions(options), queryClient);
    }

export type offerItemControllerRemoveResponse200 = {
  data: ResponseOfferItemDto
  status: 200
}

export type offerItemControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemControllerRemoveResponseSuccess = (offerItemControllerRemoveResponse200) & {
  headers: Headers;
};
export type offerItemControllerRemoveResponseError = (offerItemControllerRemoveResponse400 | offerItemControllerRemoveResponse401 | offerItemControllerRemoveResponse403 | offerItemControllerRemoveResponse404 | offerItemControllerRemoveResponse500) & {
  headers: Headers;
};

export type offerItemControllerRemoveResponse = (offerItemControllerRemoveResponseSuccess | offerItemControllerRemoveResponseError)

export const getOfferItemControllerRemoveUrl = (offerId: number,
    itemId: number,) => {




  return `/offer/${offerId}/item/${itemId}`
}

export const offerItemControllerRemove = async (offerId: number,
    itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerItemControllerRemoveResponse> => {

  return customFetch<offerItemControllerRemoveResponse>(getOfferItemControllerRemoveUrl(offerId,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOfferItemControllerRemoveMutationKey = () => ['offerItemControllerRemove'] as const;

export const getOfferItemControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerRemove>>, TError,OfferItemControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerRemove>>, TError,OfferItemControllerRemoveMutationVariables, TContext> => {

const mutationKey = getOfferItemControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerItemControllerRemove>>, OfferItemControllerRemoveMutationVariables> = (props) => {
          const {offerId,itemId} = props ?? {};

          return  offerItemControllerRemove(offerId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferItemControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof offerItemControllerRemove>>>

    export type OfferItemControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferItemControllerRemoveMutationVariables = {offerId: number;itemId: number}

    export const useOfferItemControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerRemove>>, TError,OfferItemControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerItemControllerRemove>>,
        TError,
        OfferItemControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getOfferItemControllerRemoveMutationOptions(options), queryClient);
    }

export type offerItemControllerResolveDuplicatesResponse201 = {
  data: ResponseOfferItemDto[]
  status: 201
}

export type offerItemControllerResolveDuplicatesResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemControllerResolveDuplicatesResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemControllerResolveDuplicatesResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemControllerResolveDuplicatesResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemControllerResolveDuplicatesResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemControllerResolveDuplicatesResponseSuccess = (offerItemControllerResolveDuplicatesResponse201) & {
  headers: Headers;
};
export type offerItemControllerResolveDuplicatesResponseError = (offerItemControllerResolveDuplicatesResponse400 | offerItemControllerResolveDuplicatesResponse401 | offerItemControllerResolveDuplicatesResponse403 | offerItemControllerResolveDuplicatesResponse404 | offerItemControllerResolveDuplicatesResponse500) & {
  headers: Headers;
};

export type offerItemControllerResolveDuplicatesResponse = (offerItemControllerResolveDuplicatesResponseSuccess | offerItemControllerResolveDuplicatesResponseError)

export const getOfferItemControllerResolveDuplicatesUrl = (offerId: number,
    duplicateGroup: number,) => {




  return `/offer/${offerId}/item/resolve-duplicates/${duplicateGroup}`
}

export const offerItemControllerResolveDuplicates = async (offerId: number,
    duplicateGroup: number,
    offerItemResolveDuplicatesDto: OfferItemResolveDuplicatesDto, options?: Parameters<typeof customFetch>[1]): Promise<offerItemControllerResolveDuplicatesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerItemControllerResolveDuplicatesResponse>(getOfferItemControllerResolveDuplicatesUrl(offerId,duplicateGroup),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(offerItemResolveDuplicatesDto)
  }
);}





export const getOfferItemControllerResolveDuplicatesMutationKey = () => ['offerItemControllerResolveDuplicates'] as const;

export const getOfferItemControllerResolveDuplicatesMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerResolveDuplicates>>, TError,OfferItemControllerResolveDuplicatesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerResolveDuplicates>>, TError,OfferItemControllerResolveDuplicatesMutationVariables, TContext> => {

const mutationKey = getOfferItemControllerResolveDuplicatesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerItemControllerResolveDuplicates>>, OfferItemControllerResolveDuplicatesMutationVariables> = (props) => {
          const {offerId,duplicateGroup,data} = props ?? {};

          return  offerItemControllerResolveDuplicates(offerId,duplicateGroup,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferItemControllerResolveDuplicatesMutationResult = NonNullable<Awaited<ReturnType<typeof offerItemControllerResolveDuplicates>>>
    export type OfferItemControllerResolveDuplicatesMutationBody = OfferItemResolveDuplicatesDto
    export type OfferItemControllerResolveDuplicatesMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferItemControllerResolveDuplicatesMutationVariables = {offerId: number;duplicateGroup: number;data: OfferItemResolveDuplicatesDto}

    export const useOfferItemControllerResolveDuplicates = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerResolveDuplicates>>, TError,OfferItemControllerResolveDuplicatesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerItemControllerResolveDuplicates>>,
        TError,
        OfferItemControllerResolveDuplicatesMutationVariables,
        TContext
      > => {
      return useMutation(getOfferItemControllerResolveDuplicatesMutationOptions(options), queryClient);
    }

export type offerItemControllerResetResponse201 = {
  data: ResponseOfferItemDto
  status: 201
}

export type offerItemControllerResetResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemControllerResetResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemControllerResetResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemControllerResetResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemControllerResetResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemControllerResetResponseSuccess = (offerItemControllerResetResponse201) & {
  headers: Headers;
};
export type offerItemControllerResetResponseError = (offerItemControllerResetResponse400 | offerItemControllerResetResponse401 | offerItemControllerResetResponse403 | offerItemControllerResetResponse404 | offerItemControllerResetResponse500) & {
  headers: Headers;
};

export type offerItemControllerResetResponse = (offerItemControllerResetResponseSuccess | offerItemControllerResetResponseError)

export const getOfferItemControllerResetUrl = (offerId: number,
    itemId: number,) => {




  return `/offer/${offerId}/item/${itemId}/reset`
}

export const offerItemControllerReset = async (offerId: number,
    itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerItemControllerResetResponse> => {

  return customFetch<offerItemControllerResetResponse>(getOfferItemControllerResetUrl(offerId,itemId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOfferItemControllerResetMutationKey = () => ['offerItemControllerReset'] as const;

export const getOfferItemControllerResetMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerReset>>, TError,OfferItemControllerResetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerReset>>, TError,OfferItemControllerResetMutationVariables, TContext> => {

const mutationKey = getOfferItemControllerResetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerItemControllerReset>>, OfferItemControllerResetMutationVariables> = (props) => {
          const {offerId,itemId} = props ?? {};

          return  offerItemControllerReset(offerId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferItemControllerResetMutationResult = NonNullable<Awaited<ReturnType<typeof offerItemControllerReset>>>

    export type OfferItemControllerResetMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferItemControllerResetMutationVariables = {offerId: number;itemId: number}

    export const useOfferItemControllerReset = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerItemControllerReset>>, TError,OfferItemControllerResetMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerItemControllerReset>>,
        TError,
        OfferItemControllerResetMutationVariables,
        TContext
      > => {
      return useMutation(getOfferItemControllerResetMutationOptions(options), queryClient);
    }

export type offerItemLookupControllerFindAllResponse200 = {
  data: OfferItemLookupControllerFindAll200
  status: 200
}

export type offerItemLookupControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemLookupControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemLookupControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemLookupControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemLookupControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemLookupControllerFindAllResponseSuccess = (offerItemLookupControllerFindAllResponse200) & {
  headers: Headers;
};
export type offerItemLookupControllerFindAllResponseError = (offerItemLookupControllerFindAllResponse400 | offerItemLookupControllerFindAllResponse401 | offerItemLookupControllerFindAllResponse403 | offerItemLookupControllerFindAllResponse404 | offerItemLookupControllerFindAllResponse500) & {
  headers: Headers;
};

export type offerItemLookupControllerFindAllResponse = (offerItemLookupControllerFindAllResponseSuccess | offerItemLookupControllerFindAllResponseError)

export const getOfferItemLookupControllerFindAllUrl = (params?: OfferItemLookupControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.needsReview","filter.isIncluded","filter.createdAt","filter.offer.createdAt","filter.offer.id","filter.offer.status","filter.offer.source.id","filter.offer.createdBy.id","filter.handlingItems.id","filter.handlingItems.status","filter.handlingItems.handlingType","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer/item/search?${stringifiedParams}` : `/offer/item/search`
}

export const offerItemLookupControllerFindAll = async (params?: OfferItemLookupControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<offerItemLookupControllerFindAllResponse> => {

  return customFetch<offerItemLookupControllerFindAllResponse>(getOfferItemLookupControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferItemLookupControllerFindAllQueryKey = (params?: MaybeRefOrGetter<OfferItemLookupControllerFindAllParams>,) => {
    return [
    'offer','item','search', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferItemLookupControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof offerItemLookupControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<OfferItemLookupControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemLookupControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferItemLookupControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerItemLookupControllerFindAll>>> = ({ signal }) => offerItemLookupControllerFindAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerItemLookupControllerFindAll>>, TError, TData>
}

export type OfferItemLookupControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof offerItemLookupControllerFindAll>>>
export type OfferItemLookupControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferItemLookupControllerFindAll<TData = Awaited<ReturnType<typeof offerItemLookupControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<OfferItemLookupControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemLookupControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferItemLookupControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerItemLookupControllerFindOneResponse200 = {
  data: ResponseOfferItemDto
  status: 200
}

export type offerItemLookupControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerItemLookupControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerItemLookupControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerItemLookupControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerItemLookupControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerItemLookupControllerFindOneResponseSuccess = (offerItemLookupControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerItemLookupControllerFindOneResponseError = (offerItemLookupControllerFindOneResponse400 | offerItemLookupControllerFindOneResponse401 | offerItemLookupControllerFindOneResponse403 | offerItemLookupControllerFindOneResponse404 | offerItemLookupControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerItemLookupControllerFindOneResponse = (offerItemLookupControllerFindOneResponseSuccess | offerItemLookupControllerFindOneResponseError)

export const getOfferItemLookupControllerFindOneUrl = (itemId: number,) => {




  return `/offer/item/${itemId}`
}

export const offerItemLookupControllerFindOne = async (itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerItemLookupControllerFindOneResponse> => {

  return customFetch<offerItemLookupControllerFindOneResponse>(getOfferItemLookupControllerFindOneUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferItemLookupControllerFindOneQueryKey = (itemId: MaybeRefOrGetter<number>,) => {
    return [
    'offer','item',itemId
    ] as const;
    }


export const getOfferItemLookupControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerItemLookupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemLookupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferItemLookupControllerFindOneQueryKey(itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerItemLookupControllerFindOne>>> = ({ signal }) => offerItemLookupControllerFindOne(toValue(itemId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(itemId) !== null && toValue(itemId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerItemLookupControllerFindOne>>, TError, TData>
}

export type OfferItemLookupControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerItemLookupControllerFindOne>>>
export type OfferItemLookupControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferItemLookupControllerFindOne<TData = Awaited<ReturnType<typeof offerItemLookupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerItemLookupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferItemLookupControllerFindOneQueryOptions(itemId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerMarkupControllerFindAllForOfferResponse200 = {
  data: ResponseOfferMarkupDto[]
  status: 200
}

export type offerMarkupControllerFindAllForOfferResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerMarkupControllerFindAllForOfferResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerMarkupControllerFindAllForOfferResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerMarkupControllerFindAllForOfferResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerMarkupControllerFindAllForOfferResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerMarkupControllerFindAllForOfferResponseSuccess = (offerMarkupControllerFindAllForOfferResponse200) & {
  headers: Headers;
};
export type offerMarkupControllerFindAllForOfferResponseError = (offerMarkupControllerFindAllForOfferResponse400 | offerMarkupControllerFindAllForOfferResponse401 | offerMarkupControllerFindAllForOfferResponse403 | offerMarkupControllerFindAllForOfferResponse404 | offerMarkupControllerFindAllForOfferResponse500) & {
  headers: Headers;
};

export type offerMarkupControllerFindAllForOfferResponse = (offerMarkupControllerFindAllForOfferResponseSuccess | offerMarkupControllerFindAllForOfferResponseError)

export const getOfferMarkupControllerFindAllForOfferUrl = (offerId: number,) => {




  return `/offer/${offerId}/markup`
}

export const offerMarkupControllerFindAllForOffer = async (offerId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerMarkupControllerFindAllForOfferResponse> => {

  return customFetch<offerMarkupControllerFindAllForOfferResponse>(getOfferMarkupControllerFindAllForOfferUrl(offerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferMarkupControllerFindAllForOfferQueryKey = (offerId: MaybeRefOrGetter<number>,) => {
    return [
    'offer',offerId,'markup'
    ] as const;
    }


export const getOfferMarkupControllerFindAllForOfferQueryOptions = <TData = Awaited<ReturnType<typeof offerMarkupControllerFindAllForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerMarkupControllerFindAllForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferMarkupControllerFindAllForOfferQueryKey(offerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerMarkupControllerFindAllForOffer>>> = ({ signal }) => offerMarkupControllerFindAllForOffer(toValue(offerId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerMarkupControllerFindAllForOffer>>, TError, TData>
}

export type OfferMarkupControllerFindAllForOfferQueryResult = NonNullable<Awaited<ReturnType<typeof offerMarkupControllerFindAllForOffer>>>
export type OfferMarkupControllerFindAllForOfferQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferMarkupControllerFindAllForOffer<TData = Awaited<ReturnType<typeof offerMarkupControllerFindAllForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerMarkupControllerFindAllForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferMarkupControllerFindAllForOfferQueryOptions(offerId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerMarkupControllerCreateResponse201 = {
  data: ResponseOfferMarkupDto
  status: 201
}

export type offerMarkupControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerMarkupControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerMarkupControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerMarkupControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerMarkupControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerMarkupControllerCreateResponseSuccess = (offerMarkupControllerCreateResponse201) & {
  headers: Headers;
};
export type offerMarkupControllerCreateResponseError = (offerMarkupControllerCreateResponse400 | offerMarkupControllerCreateResponse401 | offerMarkupControllerCreateResponse403 | offerMarkupControllerCreateResponse404 | offerMarkupControllerCreateResponse500) & {
  headers: Headers;
};

export type offerMarkupControllerCreateResponse = (offerMarkupControllerCreateResponseSuccess | offerMarkupControllerCreateResponseError)

export const getOfferMarkupControllerCreateUrl = (offerId: number,) => {




  return `/offer/${offerId}/markup`
}

export const offerMarkupControllerCreate = async (offerId: number,
    createOfferMarkupDto: CreateOfferMarkupDto, options?: Parameters<typeof customFetch>[1]): Promise<offerMarkupControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerMarkupControllerCreateResponse>(getOfferMarkupControllerCreateUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferMarkupDto)
  }
);}





export const getOfferMarkupControllerCreateMutationKey = () => ['offerMarkupControllerCreate'] as const;

export const getOfferMarkupControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerCreate>>, TError,OfferMarkupControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerCreate>>, TError,OfferMarkupControllerCreateMutationVariables, TContext> => {

const mutationKey = getOfferMarkupControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerMarkupControllerCreate>>, OfferMarkupControllerCreateMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerMarkupControllerCreate(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferMarkupControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof offerMarkupControllerCreate>>>
    export type OfferMarkupControllerCreateMutationBody = CreateOfferMarkupDto
    export type OfferMarkupControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferMarkupControllerCreateMutationVariables = {offerId: number;data: CreateOfferMarkupDto}

    export const useOfferMarkupControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerCreate>>, TError,OfferMarkupControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerMarkupControllerCreate>>,
        TError,
        OfferMarkupControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferMarkupControllerCreateMutationOptions(options), queryClient);
    }

export type offerMarkupControllerFindOneResponse200 = {
  data: ResponseOfferMarkupDto
  status: 200
}

export type offerMarkupControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerMarkupControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerMarkupControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerMarkupControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerMarkupControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerMarkupControllerFindOneResponseSuccess = (offerMarkupControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerMarkupControllerFindOneResponseError = (offerMarkupControllerFindOneResponse400 | offerMarkupControllerFindOneResponse401 | offerMarkupControllerFindOneResponse403 | offerMarkupControllerFindOneResponse404 | offerMarkupControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerMarkupControllerFindOneResponse = (offerMarkupControllerFindOneResponseSuccess | offerMarkupControllerFindOneResponseError)

export const getOfferMarkupControllerFindOneUrl = (offerId: number,
    markupId: number,) => {




  return `/offer/${offerId}/markup/${markupId}`
}

export const offerMarkupControllerFindOne = async (offerId: number,
    markupId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerMarkupControllerFindOneResponse> => {

  return customFetch<offerMarkupControllerFindOneResponse>(getOfferMarkupControllerFindOneUrl(offerId,markupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferMarkupControllerFindOneQueryKey = (offerId: MaybeRefOrGetter<number>,
    markupId: MaybeRefOrGetter<number>,) => {
    return [
    'offer',offerId,'markup',markupId
    ] as const;
    }


export const getOfferMarkupControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerMarkupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    markupId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerMarkupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferMarkupControllerFindOneQueryKey(offerId,markupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerMarkupControllerFindOne>>> = ({ signal }) => offerMarkupControllerFindOne(toValue(offerId),toValue(markupId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined && toValue(markupId) !== null && toValue(markupId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerMarkupControllerFindOne>>, TError, TData>
}

export type OfferMarkupControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerMarkupControllerFindOne>>>
export type OfferMarkupControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferMarkupControllerFindOne<TData = Awaited<ReturnType<typeof offerMarkupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    markupId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerMarkupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferMarkupControllerFindOneQueryOptions(offerId,markupId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerMarkupControllerUpdateResponse200 = {
  data: ResponseOfferMarkupDto
  status: 200
}

export type offerMarkupControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerMarkupControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerMarkupControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerMarkupControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerMarkupControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerMarkupControllerUpdateResponseSuccess = (offerMarkupControllerUpdateResponse200) & {
  headers: Headers;
};
export type offerMarkupControllerUpdateResponseError = (offerMarkupControllerUpdateResponse400 | offerMarkupControllerUpdateResponse401 | offerMarkupControllerUpdateResponse403 | offerMarkupControllerUpdateResponse404 | offerMarkupControllerUpdateResponse500) & {
  headers: Headers;
};

export type offerMarkupControllerUpdateResponse = (offerMarkupControllerUpdateResponseSuccess | offerMarkupControllerUpdateResponseError)

export const getOfferMarkupControllerUpdateUrl = (offerId: number,
    markupId: number,) => {




  return `/offer/${offerId}/markup/${markupId}`
}

export const offerMarkupControllerUpdate = async (offerId: number,
    markupId: number,
    updateOfferMarkupDto: UpdateOfferMarkupDto, options?: Parameters<typeof customFetch>[1]): Promise<offerMarkupControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerMarkupControllerUpdateResponse>(getOfferMarkupControllerUpdateUrl(offerId,markupId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOfferMarkupDto)
  }
);}





export const getOfferMarkupControllerUpdateMutationKey = () => ['offerMarkupControllerUpdate'] as const;

export const getOfferMarkupControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerUpdate>>, TError,OfferMarkupControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerUpdate>>, TError,OfferMarkupControllerUpdateMutationVariables, TContext> => {

const mutationKey = getOfferMarkupControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerMarkupControllerUpdate>>, OfferMarkupControllerUpdateMutationVariables> = (props) => {
          const {offerId,markupId,data} = props ?? {};

          return  offerMarkupControllerUpdate(offerId,markupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferMarkupControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof offerMarkupControllerUpdate>>>
    export type OfferMarkupControllerUpdateMutationBody = UpdateOfferMarkupDto
    export type OfferMarkupControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferMarkupControllerUpdateMutationVariables = {offerId: number;markupId: number;data: UpdateOfferMarkupDto}

    export const useOfferMarkupControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerUpdate>>, TError,OfferMarkupControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerMarkupControllerUpdate>>,
        TError,
        OfferMarkupControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferMarkupControllerUpdateMutationOptions(options), queryClient);
    }

export type offerMarkupControllerGenerateCreateResponse200 = {
  data: CreateOfferMarkupDto
  status: 200
}

export type offerMarkupControllerGenerateCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerMarkupControllerGenerateCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerMarkupControllerGenerateCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerMarkupControllerGenerateCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerMarkupControllerGenerateCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerMarkupControllerGenerateCreateResponseSuccess = (offerMarkupControllerGenerateCreateResponse200) & {
  headers: Headers;
};
export type offerMarkupControllerGenerateCreateResponseError = (offerMarkupControllerGenerateCreateResponse400 | offerMarkupControllerGenerateCreateResponse401 | offerMarkupControllerGenerateCreateResponse403 | offerMarkupControllerGenerateCreateResponse404 | offerMarkupControllerGenerateCreateResponse500) & {
  headers: Headers;
};

export type offerMarkupControllerGenerateCreateResponse = (offerMarkupControllerGenerateCreateResponseSuccess | offerMarkupControllerGenerateCreateResponseError)

export const getOfferMarkupControllerGenerateCreateUrl = (offerId: number,) => {




  return `/offer/${offerId}/markup/target-price`
}

export const offerMarkupControllerGenerateCreate = async (offerId: number,
    generateCreateOfferMarkupDto: GenerateCreateOfferMarkupDto, options?: Parameters<typeof customFetch>[1]): Promise<offerMarkupControllerGenerateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerMarkupControllerGenerateCreateResponse>(getOfferMarkupControllerGenerateCreateUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(generateCreateOfferMarkupDto)
  }
);}





export const getOfferMarkupControllerGenerateCreateMutationKey = () => ['offerMarkupControllerGenerateCreate'] as const;

export const getOfferMarkupControllerGenerateCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerGenerateCreate>>, TError,OfferMarkupControllerGenerateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerGenerateCreate>>, TError,OfferMarkupControllerGenerateCreateMutationVariables, TContext> => {

const mutationKey = getOfferMarkupControllerGenerateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerMarkupControllerGenerateCreate>>, OfferMarkupControllerGenerateCreateMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerMarkupControllerGenerateCreate(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferMarkupControllerGenerateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof offerMarkupControllerGenerateCreate>>>
    export type OfferMarkupControllerGenerateCreateMutationBody = GenerateCreateOfferMarkupDto
    export type OfferMarkupControllerGenerateCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferMarkupControllerGenerateCreateMutationVariables = {offerId: number;data: GenerateCreateOfferMarkupDto}

    export const useOfferMarkupControllerGenerateCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerGenerateCreate>>, TError,OfferMarkupControllerGenerateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerMarkupControllerGenerateCreate>>,
        TError,
        OfferMarkupControllerGenerateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferMarkupControllerGenerateCreateMutationOptions(options), queryClient);
    }

export type offerMarkupControllerApplyCampaignResponse201 = {
  data: ResponseOfferMarkupDto
  status: 201
}

export type offerMarkupControllerApplyCampaignResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerMarkupControllerApplyCampaignResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerMarkupControllerApplyCampaignResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerMarkupControllerApplyCampaignResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerMarkupControllerApplyCampaignResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerMarkupControllerApplyCampaignResponseSuccess = (offerMarkupControllerApplyCampaignResponse201) & {
  headers: Headers;
};
export type offerMarkupControllerApplyCampaignResponseError = (offerMarkupControllerApplyCampaignResponse400 | offerMarkupControllerApplyCampaignResponse401 | offerMarkupControllerApplyCampaignResponse403 | offerMarkupControllerApplyCampaignResponse404 | offerMarkupControllerApplyCampaignResponse500) & {
  headers: Headers;
};

export type offerMarkupControllerApplyCampaignResponse = (offerMarkupControllerApplyCampaignResponseSuccess | offerMarkupControllerApplyCampaignResponseError)

export const getOfferMarkupControllerApplyCampaignUrl = (offerId: number,) => {




  return `/offer/${offerId}/markup/apply`
}

export const offerMarkupControllerApplyCampaign = async (offerId: number,
    createOfferMarkupFromCampaignDto: CreateOfferMarkupFromCampaignDto, options?: Parameters<typeof customFetch>[1]): Promise<offerMarkupControllerApplyCampaignResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerMarkupControllerApplyCampaignResponse>(getOfferMarkupControllerApplyCampaignUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferMarkupFromCampaignDto)
  }
);}





export const getOfferMarkupControllerApplyCampaignMutationKey = () => ['offerMarkupControllerApplyCampaign'] as const;

export const getOfferMarkupControllerApplyCampaignMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerApplyCampaign>>, TError,OfferMarkupControllerApplyCampaignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerApplyCampaign>>, TError,OfferMarkupControllerApplyCampaignMutationVariables, TContext> => {

const mutationKey = getOfferMarkupControllerApplyCampaignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerMarkupControllerApplyCampaign>>, OfferMarkupControllerApplyCampaignMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  offerMarkupControllerApplyCampaign(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferMarkupControllerApplyCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof offerMarkupControllerApplyCampaign>>>
    export type OfferMarkupControllerApplyCampaignMutationBody = CreateOfferMarkupFromCampaignDto
    export type OfferMarkupControllerApplyCampaignMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferMarkupControllerApplyCampaignMutationVariables = {offerId: number;data: CreateOfferMarkupFromCampaignDto}

    export const useOfferMarkupControllerApplyCampaign = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerMarkupControllerApplyCampaign>>, TError,OfferMarkupControllerApplyCampaignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerMarkupControllerApplyCampaign>>,
        TError,
        OfferMarkupControllerApplyCampaignMutationVariables,
        TContext
      > => {
      return useMutation(getOfferMarkupControllerApplyCampaignMutationOptions(options), queryClient);
    }

export type offerReceiptControllerFindAllResponse200 = {
  data: OfferReceiptControllerFindAll200
  status: 200
}

export type offerReceiptControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerReceiptControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerReceiptControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerReceiptControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerReceiptControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerReceiptControllerFindAllResponseSuccess = (offerReceiptControllerFindAllResponse200) & {
  headers: Headers;
};
export type offerReceiptControllerFindAllResponseError = (offerReceiptControllerFindAllResponse400 | offerReceiptControllerFindAllResponse401 | offerReceiptControllerFindAllResponse403 | offerReceiptControllerFindAllResponse404 | offerReceiptControllerFindAllResponse500) & {
  headers: Headers;
};

export type offerReceiptControllerFindAllResponse = (offerReceiptControllerFindAllResponseSuccess | offerReceiptControllerFindAllResponseError)

export const getOfferReceiptControllerFindAllUrl = (offerId: number,
    params?: OfferReceiptControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sortBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer/${offerId}/receipt?${stringifiedParams}` : `/offer/${offerId}/receipt`
}

export const offerReceiptControllerFindAll = async (offerId: number,
    params?: OfferReceiptControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<offerReceiptControllerFindAllResponse> => {

  return customFetch<offerReceiptControllerFindAllResponse>(getOfferReceiptControllerFindAllUrl(offerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferReceiptControllerFindAllQueryKey = (offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferReceiptControllerFindAllParams>,) => {
    return [
    'offer',offerId,'receipt', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferReceiptControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof offerReceiptControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferReceiptControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferReceiptControllerFindAllQueryKey(offerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerReceiptControllerFindAll>>> = ({ signal }) => offerReceiptControllerFindAll(toValue(offerId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindAll>>, TError, TData>
}

export type OfferReceiptControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof offerReceiptControllerFindAll>>>
export type OfferReceiptControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferReceiptControllerFindAll<TData = Awaited<ReturnType<typeof offerReceiptControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferReceiptControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferReceiptControllerFindAllQueryOptions(offerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerReceiptControllerFindOneActiveResponse200 = {
  data: ResponseOfferReceiptDto
  status: 200
}

export type offerReceiptControllerFindOneActiveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerReceiptControllerFindOneActiveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerReceiptControllerFindOneActiveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerReceiptControllerFindOneActiveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerReceiptControllerFindOneActiveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerReceiptControllerFindOneActiveResponseSuccess = (offerReceiptControllerFindOneActiveResponse200) & {
  headers: Headers;
};
export type offerReceiptControllerFindOneActiveResponseError = (offerReceiptControllerFindOneActiveResponse400 | offerReceiptControllerFindOneActiveResponse401 | offerReceiptControllerFindOneActiveResponse403 | offerReceiptControllerFindOneActiveResponse404 | offerReceiptControllerFindOneActiveResponse500) & {
  headers: Headers;
};

export type offerReceiptControllerFindOneActiveResponse = (offerReceiptControllerFindOneActiveResponseSuccess | offerReceiptControllerFindOneActiveResponseError)

export const getOfferReceiptControllerFindOneActiveUrl = (offerId: number,
    params?: OfferReceiptControllerFindOneActiveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer/${offerId}/receipt/active?${stringifiedParams}` : `/offer/${offerId}/receipt/active`
}

export const offerReceiptControllerFindOneActive = async (offerId: number,
    params?: OfferReceiptControllerFindOneActiveParams, options?: Parameters<typeof customFetch>[1]): Promise<offerReceiptControllerFindOneActiveResponse> => {

  return customFetch<offerReceiptControllerFindOneActiveResponse>(getOfferReceiptControllerFindOneActiveUrl(offerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferReceiptControllerFindOneActiveQueryKey = (offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferReceiptControllerFindOneActiveParams>,) => {
    return [
    'offer',offerId,'receipt','active', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferReceiptControllerFindOneActiveQueryOptions = <TData = Awaited<ReturnType<typeof offerReceiptControllerFindOneActive>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferReceiptControllerFindOneActiveParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindOneActive>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferReceiptControllerFindOneActiveQueryKey(offerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerReceiptControllerFindOneActive>>> = ({ signal }) => offerReceiptControllerFindOneActive(toValue(offerId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindOneActive>>, TError, TData>
}

export type OfferReceiptControllerFindOneActiveQueryResult = NonNullable<Awaited<ReturnType<typeof offerReceiptControllerFindOneActive>>>
export type OfferReceiptControllerFindOneActiveQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferReceiptControllerFindOneActive<TData = Awaited<ReturnType<typeof offerReceiptControllerFindOneActive>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferReceiptControllerFindOneActiveParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindOneActive>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferReceiptControllerFindOneActiveQueryOptions(offerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerReceiptControllerFindOneResponse200 = {
  data: ResponseOfferReceiptDto
  status: 200
}

export type offerReceiptControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerReceiptControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerReceiptControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerReceiptControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerReceiptControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerReceiptControllerFindOneResponseSuccess = (offerReceiptControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerReceiptControllerFindOneResponseError = (offerReceiptControllerFindOneResponse400 | offerReceiptControllerFindOneResponse401 | offerReceiptControllerFindOneResponse403 | offerReceiptControllerFindOneResponse404 | offerReceiptControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerReceiptControllerFindOneResponse = (offerReceiptControllerFindOneResponseSuccess | offerReceiptControllerFindOneResponseError)

export const getOfferReceiptControllerFindOneUrl = (offerId: number,
    receiptId: number,) => {




  return `/offer/${offerId}/receipt/${receiptId}`
}

export const offerReceiptControllerFindOne = async (offerId: number,
    receiptId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerReceiptControllerFindOneResponse> => {

  return customFetch<offerReceiptControllerFindOneResponse>(getOfferReceiptControllerFindOneUrl(offerId,receiptId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferReceiptControllerFindOneQueryKey = (offerId: MaybeRefOrGetter<number>,
    receiptId: MaybeRefOrGetter<number>,) => {
    return [
    'offer',offerId,'receipt',receiptId
    ] as const;
    }


export const getOfferReceiptControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerReceiptControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    receiptId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferReceiptControllerFindOneQueryKey(offerId,receiptId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerReceiptControllerFindOne>>> = ({ signal }) => offerReceiptControllerFindOne(toValue(offerId),toValue(receiptId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined && toValue(receiptId) !== null && toValue(receiptId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindOne>>, TError, TData>
}

export type OfferReceiptControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerReceiptControllerFindOne>>>
export type OfferReceiptControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferReceiptControllerFindOne<TData = Awaited<ReturnType<typeof offerReceiptControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    receiptId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerReceiptControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferReceiptControllerFindOneQueryOptions(offerId,receiptId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerReceiptControllerSendReceiptMailResponse201 = {
  data: void
  status: 201
}

export type offerReceiptControllerSendReceiptMailResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerReceiptControllerSendReceiptMailResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerReceiptControllerSendReceiptMailResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerReceiptControllerSendReceiptMailResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerReceiptControllerSendReceiptMailResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerReceiptControllerSendReceiptMailResponseSuccess = (offerReceiptControllerSendReceiptMailResponse201) & {
  headers: Headers;
};
export type offerReceiptControllerSendReceiptMailResponseError = (offerReceiptControllerSendReceiptMailResponse400 | offerReceiptControllerSendReceiptMailResponse401 | offerReceiptControllerSendReceiptMailResponse403 | offerReceiptControllerSendReceiptMailResponse404 | offerReceiptControllerSendReceiptMailResponse500) & {
  headers: Headers;
};

export type offerReceiptControllerSendReceiptMailResponse = (offerReceiptControllerSendReceiptMailResponseSuccess | offerReceiptControllerSendReceiptMailResponseError)

export const getOfferReceiptControllerSendReceiptMailUrl = (offerId: number,
    receiptId: number,) => {




  return `/offer/${offerId}/receipt/${receiptId}/send-mail`
}

export const offerReceiptControllerSendReceiptMail = async (offerId: number,
    receiptId: number,
    sendTransactionReceiptMailDto: SendTransactionReceiptMailDto, options?: Parameters<typeof customFetch>[1]): Promise<offerReceiptControllerSendReceiptMailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerReceiptControllerSendReceiptMailResponse>(getOfferReceiptControllerSendReceiptMailUrl(offerId,receiptId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendTransactionReceiptMailDto)
  }
);}





export const getOfferReceiptControllerSendReceiptMailMutationKey = () => ['offerReceiptControllerSendReceiptMail'] as const;

export const getOfferReceiptControllerSendReceiptMailMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerReceiptControllerSendReceiptMail>>, TError,OfferReceiptControllerSendReceiptMailMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerReceiptControllerSendReceiptMail>>, TError,OfferReceiptControllerSendReceiptMailMutationVariables, TContext> => {

const mutationKey = getOfferReceiptControllerSendReceiptMailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerReceiptControllerSendReceiptMail>>, OfferReceiptControllerSendReceiptMailMutationVariables> = (props) => {
          const {offerId,receiptId,data} = props ?? {};

          return  offerReceiptControllerSendReceiptMail(offerId,receiptId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferReceiptControllerSendReceiptMailMutationResult = NonNullable<Awaited<ReturnType<typeof offerReceiptControllerSendReceiptMail>>>
    export type OfferReceiptControllerSendReceiptMailMutationBody = SendTransactionReceiptMailDto
    export type OfferReceiptControllerSendReceiptMailMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferReceiptControllerSendReceiptMailMutationVariables = {offerId: number;receiptId: number;data: SendTransactionReceiptMailDto}

    export const useOfferReceiptControllerSendReceiptMail = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerReceiptControllerSendReceiptMail>>, TError,OfferReceiptControllerSendReceiptMailMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerReceiptControllerSendReceiptMail>>,
        TError,
        OfferReceiptControllerSendReceiptMailMutationVariables,
        TContext
      > => {
      return useMutation(getOfferReceiptControllerSendReceiptMailMutationOptions(options), queryClient);
    }

export type offerReceiptLookupControllerFindOneResponse200 = {
  data: ResponseOfferReceiptDto
  status: 200
}

export type offerReceiptLookupControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerReceiptLookupControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerReceiptLookupControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerReceiptLookupControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerReceiptLookupControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerReceiptLookupControllerFindOneResponseSuccess = (offerReceiptLookupControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerReceiptLookupControllerFindOneResponseError = (offerReceiptLookupControllerFindOneResponse400 | offerReceiptLookupControllerFindOneResponse401 | offerReceiptLookupControllerFindOneResponse403 | offerReceiptLookupControllerFindOneResponse404 | offerReceiptLookupControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerReceiptLookupControllerFindOneResponse = (offerReceiptLookupControllerFindOneResponseSuccess | offerReceiptLookupControllerFindOneResponseError)

export const getOfferReceiptLookupControllerFindOneUrl = (receiptId: number,) => {




  return `/offer/receipt/${receiptId}`
}

export const offerReceiptLookupControllerFindOne = async (receiptId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerReceiptLookupControllerFindOneResponse> => {

  return customFetch<offerReceiptLookupControllerFindOneResponse>(getOfferReceiptLookupControllerFindOneUrl(receiptId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferReceiptLookupControllerFindOneQueryKey = (receiptId: MaybeRefOrGetter<number>,) => {
    return [
    'offer','receipt',receiptId
    ] as const;
    }


export const getOfferReceiptLookupControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerReceiptLookupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(receiptId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerReceiptLookupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferReceiptLookupControllerFindOneQueryKey(receiptId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerReceiptLookupControllerFindOne>>> = ({ signal }) => offerReceiptLookupControllerFindOne(toValue(receiptId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(receiptId) !== null && toValue(receiptId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerReceiptLookupControllerFindOne>>, TError, TData>
}

export type OfferReceiptLookupControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerReceiptLookupControllerFindOne>>>
export type OfferReceiptLookupControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferReceiptLookupControllerFindOne<TData = Awaited<ReturnType<typeof offerReceiptLookupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 receiptId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerReceiptLookupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferReceiptLookupControllerFindOneQueryOptions(receiptId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type handlingItemControllerCreateResponse201 = {
  data: ResponseHandlingItemDto | ResponseHandlingUndecidedItemDto | ResponseHandlingManualItemDto | ResponseHandlingSendToBaseItemDto | ResponseHandlingKeepInStoreItemDto | ResponseHandlingSendToStoreItemDto
  status: 201
}

export type handlingItemControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemControllerCreateResponseSuccess = (handlingItemControllerCreateResponse201) & {
  headers: Headers;
};
export type handlingItemControllerCreateResponseError = (handlingItemControllerCreateResponse400 | handlingItemControllerCreateResponse401 | handlingItemControllerCreateResponse403 | handlingItemControllerCreateResponse404 | handlingItemControllerCreateResponse500) & {
  headers: Headers;
};

export type handlingItemControllerCreateResponse = (handlingItemControllerCreateResponseSuccess | handlingItemControllerCreateResponseError)

export const getHandlingItemControllerCreateUrl = () => {




  return `/handling/item`
}

export const handlingItemControllerCreate = async (createHandlingItemDto: CreateHandlingItemDto, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<handlingItemControllerCreateResponse>(getHandlingItemControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createHandlingItemDto)
  }
);}





export const getHandlingItemControllerCreateMutationKey = () => ['handlingItemControllerCreate'] as const;

export const getHandlingItemControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerCreate>>, TError,HandlingItemControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerCreate>>, TError,HandlingItemControllerCreateMutationVariables, TContext> => {

const mutationKey = getHandlingItemControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handlingItemControllerCreate>>, HandlingItemControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  handlingItemControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandlingItemControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof handlingItemControllerCreate>>>
    export type HandlingItemControllerCreateMutationBody = CreateHandlingItemDto
    export type HandlingItemControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type HandlingItemControllerCreateMutationVariables = {data: CreateHandlingItemDto}

    export const useHandlingItemControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerCreate>>, TError,HandlingItemControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof handlingItemControllerCreate>>,
        TError,
        HandlingItemControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHandlingItemControllerCreateMutationOptions(options), queryClient);
    }

export type handlingItemControllerFindAllResponse200 = {
  data: HandlingItemControllerFindAll200
  status: 200
}

export type handlingItemControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemControllerFindAllResponseSuccess = (handlingItemControllerFindAllResponse200) & {
  headers: Headers;
};
export type handlingItemControllerFindAllResponseError = (handlingItemControllerFindAllResponse400 | handlingItemControllerFindAllResponse401 | handlingItemControllerFindAllResponse403 | handlingItemControllerFindAllResponse404 | handlingItemControllerFindAllResponse500) & {
  headers: Headers;
};

export type handlingItemControllerFindAllResponse = (handlingItemControllerFindAllResponseSuccess | handlingItemControllerFindAllResponseError)

export const getHandlingItemControllerFindAllUrl = (params?: HandlingItemControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.handlingType","filter.reference.productType","filter.status","filter.needsReview","filter.createdAt","filter.source.id","filter.item.id","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/handling/item/search?${stringifiedParams}` : `/handling/item/search`
}

export const handlingItemControllerFindAll = async (params?: HandlingItemControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemControllerFindAllResponse> => {

  return customFetch<handlingItemControllerFindAllResponse>(getHandlingItemControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHandlingItemControllerFindAllQueryKey = (params?: MaybeRefOrGetter<HandlingItemControllerFindAllParams>,) => {
    return [
    'handling','item','search', ...(params ? [params] : [])
    ] as const;
    }


export const getHandlingItemControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof handlingItemControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<HandlingItemControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlingItemControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getHandlingItemControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof handlingItemControllerFindAll>>> = ({ signal }) => handlingItemControllerFindAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof handlingItemControllerFindAll>>, TError, TData>
}

export type HandlingItemControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof handlingItemControllerFindAll>>>
export type HandlingItemControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useHandlingItemControllerFindAll<TData = Awaited<ReturnType<typeof handlingItemControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<HandlingItemControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlingItemControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHandlingItemControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type handlingItemControllerFindOneResponse200 = {
  data: ResponseHandlingItemDto | ResponseHandlingUndecidedItemDto | ResponseHandlingManualItemDto | ResponseHandlingSendToBaseItemDto | ResponseHandlingKeepInStoreItemDto | ResponseHandlingSendToStoreItemDto
  status: 200
}

export type handlingItemControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemControllerFindOneResponseSuccess = (handlingItemControllerFindOneResponse200) & {
  headers: Headers;
};
export type handlingItemControllerFindOneResponseError = (handlingItemControllerFindOneResponse400 | handlingItemControllerFindOneResponse401 | handlingItemControllerFindOneResponse403 | handlingItemControllerFindOneResponse404 | handlingItemControllerFindOneResponse500) & {
  headers: Headers;
};

export type handlingItemControllerFindOneResponse = (handlingItemControllerFindOneResponseSuccess | handlingItemControllerFindOneResponseError)

export const getHandlingItemControllerFindOneUrl = (itemId: number,) => {




  return `/handling/item/${itemId}`
}

export const handlingItemControllerFindOne = async (itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemControllerFindOneResponse> => {

  return customFetch<handlingItemControllerFindOneResponse>(getHandlingItemControllerFindOneUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHandlingItemControllerFindOneQueryKey = (itemId: MaybeRefOrGetter<number>,) => {
    return [
    'handling','item',itemId
    ] as const;
    }


export const getHandlingItemControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof handlingItemControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlingItemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getHandlingItemControllerFindOneQueryKey(itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof handlingItemControllerFindOne>>> = ({ signal }) => handlingItemControllerFindOne(toValue(itemId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(itemId) !== null && toValue(itemId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof handlingItemControllerFindOne>>, TError, TData>
}

export type HandlingItemControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof handlingItemControllerFindOne>>>
export type HandlingItemControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useHandlingItemControllerFindOne<TData = Awaited<ReturnType<typeof handlingItemControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlingItemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHandlingItemControllerFindOneQueryOptions(itemId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type handlingItemControllerUpdateResponse200 = {
  data: ResponseHandlingItemDto | ResponseHandlingUndecidedItemDto | ResponseHandlingManualItemDto | ResponseHandlingSendToBaseItemDto | ResponseHandlingKeepInStoreItemDto | ResponseHandlingSendToStoreItemDto
  status: 200
}

export type handlingItemControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemControllerUpdateResponseSuccess = (handlingItemControllerUpdateResponse200) & {
  headers: Headers;
};
export type handlingItemControllerUpdateResponseError = (handlingItemControllerUpdateResponse400 | handlingItemControllerUpdateResponse401 | handlingItemControllerUpdateResponse403 | handlingItemControllerUpdateResponse404 | handlingItemControllerUpdateResponse500) & {
  headers: Headers;
};

export type handlingItemControllerUpdateResponse = (handlingItemControllerUpdateResponseSuccess | handlingItemControllerUpdateResponseError)

export const getHandlingItemControllerUpdateUrl = (itemId: number,) => {




  return `/handling/item/${itemId}`
}

export const handlingItemControllerUpdate = async (itemId: number,
    updateHandlingItemDto: UpdateHandlingItemDto, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<handlingItemControllerUpdateResponse>(getHandlingItemControllerUpdateUrl(itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateHandlingItemDto)
  }
);}





export const getHandlingItemControllerUpdateMutationKey = () => ['handlingItemControllerUpdate'] as const;

export const getHandlingItemControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerUpdate>>, TError,HandlingItemControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerUpdate>>, TError,HandlingItemControllerUpdateMutationVariables, TContext> => {

const mutationKey = getHandlingItemControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handlingItemControllerUpdate>>, HandlingItemControllerUpdateMutationVariables> = (props) => {
          const {itemId,data} = props ?? {};

          return  handlingItemControllerUpdate(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandlingItemControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof handlingItemControllerUpdate>>>
    export type HandlingItemControllerUpdateMutationBody = UpdateHandlingItemDto
    export type HandlingItemControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type HandlingItemControllerUpdateMutationVariables = {itemId: number;data: UpdateHandlingItemDto}

    export const useHandlingItemControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerUpdate>>, TError,HandlingItemControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof handlingItemControllerUpdate>>,
        TError,
        HandlingItemControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getHandlingItemControllerUpdateMutationOptions(options), queryClient);
    }

export type handlingItemControllerRemoveResponse200 = {
  data: ResponseHandlingItemDto | ResponseHandlingUndecidedItemDto | ResponseHandlingManualItemDto | ResponseHandlingSendToBaseItemDto | ResponseHandlingKeepInStoreItemDto | ResponseHandlingSendToStoreItemDto
  status: 200
}

export type handlingItemControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemControllerRemoveResponseSuccess = (handlingItemControllerRemoveResponse200) & {
  headers: Headers;
};
export type handlingItemControllerRemoveResponseError = (handlingItemControllerRemoveResponse400 | handlingItemControllerRemoveResponse401 | handlingItemControllerRemoveResponse403 | handlingItemControllerRemoveResponse404 | handlingItemControllerRemoveResponse500) & {
  headers: Headers;
};

export type handlingItemControllerRemoveResponse = (handlingItemControllerRemoveResponseSuccess | handlingItemControllerRemoveResponseError)

export const getHandlingItemControllerRemoveUrl = (itemId: number,) => {




  return `/handling/item/${itemId}`
}

export const handlingItemControllerRemove = async (itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemControllerRemoveResponse> => {

  return customFetch<handlingItemControllerRemoveResponse>(getHandlingItemControllerRemoveUrl(itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getHandlingItemControllerRemoveMutationKey = () => ['handlingItemControllerRemove'] as const;

export const getHandlingItemControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerRemove>>, TError,HandlingItemControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerRemove>>, TError,HandlingItemControllerRemoveMutationVariables, TContext> => {

const mutationKey = getHandlingItemControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handlingItemControllerRemove>>, HandlingItemControllerRemoveMutationVariables> = (props) => {
          const {itemId} = props ?? {};

          return  handlingItemControllerRemove(itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandlingItemControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof handlingItemControllerRemove>>>

    export type HandlingItemControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type HandlingItemControllerRemoveMutationVariables = {itemId: number}

    export const useHandlingItemControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerRemove>>, TError,HandlingItemControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof handlingItemControllerRemove>>,
        TError,
        HandlingItemControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getHandlingItemControllerRemoveMutationOptions(options), queryClient);
    }

export type handlingItemControllerTransitionResponse200 = {
  data: ResponseHandlingItemDto | ResponseHandlingUndecidedItemDto | ResponseHandlingManualItemDto | ResponseHandlingSendToBaseItemDto | ResponseHandlingKeepInStoreItemDto | ResponseHandlingSendToStoreItemDto
  status: 200
}

export type handlingItemControllerTransitionResponse201 = {
  data: HandlingItemControllerTransition201
  status: 201
}

export type handlingItemControllerTransitionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemControllerTransitionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemControllerTransitionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemControllerTransitionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemControllerTransitionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemControllerTransitionResponseSuccess = (handlingItemControllerTransitionResponse200 | handlingItemControllerTransitionResponse201) & {
  headers: Headers;
};
export type handlingItemControllerTransitionResponseError = (handlingItemControllerTransitionResponse400 | handlingItemControllerTransitionResponse401 | handlingItemControllerTransitionResponse403 | handlingItemControllerTransitionResponse404 | handlingItemControllerTransitionResponse500) & {
  headers: Headers;
};

export type handlingItemControllerTransitionResponse = (handlingItemControllerTransitionResponseSuccess | handlingItemControllerTransitionResponseError)

export const getHandlingItemControllerTransitionUrl = (itemId: number,) => {




  return `/handling/item/${itemId}/transition`
}

export const handlingItemControllerTransition = async (itemId: number,
    handlingItemTransitionDtoHandlingItemTransitionSetTypeDtoHandlingItemTransitionSubmitForReviewDtoHandlingItemTransitionFinishReviewDtoHandlingItemTransitionCompleteProcessingDtoHandlingItemTransitionFailProcessingDtoHandlingItemTransitionRevertTypeDto: HandlingItemTransitionDto | HandlingItemTransitionSetTypeDto | HandlingItemTransitionSubmitForReviewDto | HandlingItemTransitionFinishReviewDto | HandlingItemTransitionCompleteProcessingDto | HandlingItemTransitionFailProcessingDto | HandlingItemTransitionRevertTypeDto, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemControllerTransitionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<handlingItemControllerTransitionResponse>(getHandlingItemControllerTransitionUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(handlingItemTransitionDtoHandlingItemTransitionSetTypeDtoHandlingItemTransitionSubmitForReviewDtoHandlingItemTransitionFinishReviewDtoHandlingItemTransitionCompleteProcessingDtoHandlingItemTransitionFailProcessingDtoHandlingItemTransitionRevertTypeDto)
  }
);}





export const getHandlingItemControllerTransitionMutationKey = () => ['handlingItemControllerTransition'] as const;

export const getHandlingItemControllerTransitionMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerTransition>>, TError,HandlingItemControllerTransitionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerTransition>>, TError,HandlingItemControllerTransitionMutationVariables, TContext> => {

const mutationKey = getHandlingItemControllerTransitionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handlingItemControllerTransition>>, HandlingItemControllerTransitionMutationVariables> = (props) => {
          const {itemId,data} = props ?? {};

          return  handlingItemControllerTransition(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandlingItemControllerTransitionMutationResult = NonNullable<Awaited<ReturnType<typeof handlingItemControllerTransition>>>
    export type HandlingItemControllerTransitionMutationBody = HandlingItemTransitionDto | HandlingItemTransitionSetTypeDto | HandlingItemTransitionSubmitForReviewDto | HandlingItemTransitionFinishReviewDto | HandlingItemTransitionCompleteProcessingDto | HandlingItemTransitionFailProcessingDto | HandlingItemTransitionRevertTypeDto
    export type HandlingItemControllerTransitionMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type HandlingItemControllerTransitionMutationVariables = {itemId: number;data: HandlingItemTransitionDto | HandlingItemTransitionSetTypeDto | HandlingItemTransitionSubmitForReviewDto | HandlingItemTransitionFinishReviewDto | HandlingItemTransitionCompleteProcessingDto | HandlingItemTransitionFailProcessingDto | HandlingItemTransitionRevertTypeDto}

    export const useHandlingItemControllerTransition = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemControllerTransition>>, TError,HandlingItemControllerTransitionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof handlingItemControllerTransition>>,
        TError,
        HandlingItemControllerTransitionMutationVariables,
        TContext
      > => {
      return useMutation(getHandlingItemControllerTransitionMutationOptions(options), queryClient);
    }

export type sourceBuyerAddressControllerCreateResponse201 = {
  data: ResponseSourceBuyerAddressDto
  status: 201
}

export type sourceBuyerAddressControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceBuyerAddressControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceBuyerAddressControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceBuyerAddressControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceBuyerAddressControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceBuyerAddressControllerCreateResponseSuccess = (sourceBuyerAddressControllerCreateResponse201) & {
  headers: Headers;
};
export type sourceBuyerAddressControllerCreateResponseError = (sourceBuyerAddressControllerCreateResponse400 | sourceBuyerAddressControllerCreateResponse401 | sourceBuyerAddressControllerCreateResponse403 | sourceBuyerAddressControllerCreateResponse404 | sourceBuyerAddressControllerCreateResponse500) & {
  headers: Headers;
};

export type sourceBuyerAddressControllerCreateResponse = (sourceBuyerAddressControllerCreateResponseSuccess | sourceBuyerAddressControllerCreateResponseError)

export const getSourceBuyerAddressControllerCreateUrl = () => {




  return `/source/buyer-address`
}

export const sourceBuyerAddressControllerCreate = async (createSourceBuyerAddressDto: CreateSourceBuyerAddressDto, options?: Parameters<typeof customFetch>[1]): Promise<sourceBuyerAddressControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<sourceBuyerAddressControllerCreateResponse>(getSourceBuyerAddressControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createSourceBuyerAddressDto)
  }
);}





export const getSourceBuyerAddressControllerCreateMutationKey = () => ['sourceBuyerAddressControllerCreate'] as const;

export const getSourceBuyerAddressControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerCreate>>, TError,SourceBuyerAddressControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerCreate>>, TError,SourceBuyerAddressControllerCreateMutationVariables, TContext> => {

const mutationKey = getSourceBuyerAddressControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourceBuyerAddressControllerCreate>>, SourceBuyerAddressControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sourceBuyerAddressControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SourceBuyerAddressControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof sourceBuyerAddressControllerCreate>>>
    export type SourceBuyerAddressControllerCreateMutationBody = CreateSourceBuyerAddressDto
    export type SourceBuyerAddressControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SourceBuyerAddressControllerCreateMutationVariables = {data: CreateSourceBuyerAddressDto}

    export const useSourceBuyerAddressControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerCreate>>, TError,SourceBuyerAddressControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sourceBuyerAddressControllerCreate>>,
        TError,
        SourceBuyerAddressControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSourceBuyerAddressControllerCreateMutationOptions(options), queryClient);
    }

export type sourceBuyerAddressControllerFindAllResponse200 = {
  data: ResponseSourceBuyerAddressDto[]
  status: 200
}

export type sourceBuyerAddressControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceBuyerAddressControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceBuyerAddressControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceBuyerAddressControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceBuyerAddressControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceBuyerAddressControllerFindAllResponseSuccess = (sourceBuyerAddressControllerFindAllResponse200) & {
  headers: Headers;
};
export type sourceBuyerAddressControllerFindAllResponseError = (sourceBuyerAddressControllerFindAllResponse400 | sourceBuyerAddressControllerFindAllResponse401 | sourceBuyerAddressControllerFindAllResponse403 | sourceBuyerAddressControllerFindAllResponse404 | sourceBuyerAddressControllerFindAllResponse500) & {
  headers: Headers;
};

export type sourceBuyerAddressControllerFindAllResponse = (sourceBuyerAddressControllerFindAllResponseSuccess | sourceBuyerAddressControllerFindAllResponseError)

export const getSourceBuyerAddressControllerFindAllUrl = () => {




  return `/source/buyer-address`
}

export const sourceBuyerAddressControllerFindAll = async ( options?: Parameters<typeof customFetch>[1]): Promise<sourceBuyerAddressControllerFindAllResponse> => {

  return customFetch<sourceBuyerAddressControllerFindAllResponse>(getSourceBuyerAddressControllerFindAllUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSourceBuyerAddressControllerFindAllQueryKey = () => {
    return [
    'source','buyer-address'
    ] as const;
    }


export const getSourceBuyerAddressControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof sourceBuyerAddressControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSourceBuyerAddressControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindAll>>> = ({ signal }) => sourceBuyerAddressControllerFindAll({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindAll>>, TError, TData>
}

export type SourceBuyerAddressControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindAll>>>
export type SourceBuyerAddressControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSourceBuyerAddressControllerFindAll<TData = Awaited<ReturnType<typeof sourceBuyerAddressControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSourceBuyerAddressControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type sourceBuyerAddressControllerFindOneResponse200 = {
  data: ResponseSourceBuyerAddressDto
  status: 200
}

export type sourceBuyerAddressControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceBuyerAddressControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceBuyerAddressControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceBuyerAddressControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceBuyerAddressControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceBuyerAddressControllerFindOneResponseSuccess = (sourceBuyerAddressControllerFindOneResponse200) & {
  headers: Headers;
};
export type sourceBuyerAddressControllerFindOneResponseError = (sourceBuyerAddressControllerFindOneResponse400 | sourceBuyerAddressControllerFindOneResponse401 | sourceBuyerAddressControllerFindOneResponse403 | sourceBuyerAddressControllerFindOneResponse404 | sourceBuyerAddressControllerFindOneResponse500) & {
  headers: Headers;
};

export type sourceBuyerAddressControllerFindOneResponse = (sourceBuyerAddressControllerFindOneResponseSuccess | sourceBuyerAddressControllerFindOneResponseError)

export const getSourceBuyerAddressControllerFindOneUrl = (buyerAddressId: number,) => {




  return `/source/buyer-address/${buyerAddressId}`
}

export const sourceBuyerAddressControllerFindOne = async (buyerAddressId: number, options?: Parameters<typeof customFetch>[1]): Promise<sourceBuyerAddressControllerFindOneResponse> => {

  return customFetch<sourceBuyerAddressControllerFindOneResponse>(getSourceBuyerAddressControllerFindOneUrl(buyerAddressId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSourceBuyerAddressControllerFindOneQueryKey = (buyerAddressId: MaybeRefOrGetter<number>,) => {
    return [
    'source','buyer-address',buyerAddressId
    ] as const;
    }


export const getSourceBuyerAddressControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof sourceBuyerAddressControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(buyerAddressId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSourceBuyerAddressControllerFindOneQueryKey(buyerAddressId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindOne>>> = ({ signal }) => sourceBuyerAddressControllerFindOne(toValue(buyerAddressId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(buyerAddressId) !== null && toValue(buyerAddressId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindOne>>, TError, TData>
}

export type SourceBuyerAddressControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindOne>>>
export type SourceBuyerAddressControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSourceBuyerAddressControllerFindOne<TData = Awaited<ReturnType<typeof sourceBuyerAddressControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 buyerAddressId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSourceBuyerAddressControllerFindOneQueryOptions(buyerAddressId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type sourceBuyerAddressControllerUpdateResponse200 = {
  data: ResponseSourceBuyerAddressDto
  status: 200
}

export type sourceBuyerAddressControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceBuyerAddressControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceBuyerAddressControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceBuyerAddressControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceBuyerAddressControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceBuyerAddressControllerUpdateResponseSuccess = (sourceBuyerAddressControllerUpdateResponse200) & {
  headers: Headers;
};
export type sourceBuyerAddressControllerUpdateResponseError = (sourceBuyerAddressControllerUpdateResponse400 | sourceBuyerAddressControllerUpdateResponse401 | sourceBuyerAddressControllerUpdateResponse403 | sourceBuyerAddressControllerUpdateResponse404 | sourceBuyerAddressControllerUpdateResponse500) & {
  headers: Headers;
};

export type sourceBuyerAddressControllerUpdateResponse = (sourceBuyerAddressControllerUpdateResponseSuccess | sourceBuyerAddressControllerUpdateResponseError)

export const getSourceBuyerAddressControllerUpdateUrl = (buyerAddressId: number,) => {




  return `/source/buyer-address/${buyerAddressId}`
}

export const sourceBuyerAddressControllerUpdate = async (buyerAddressId: number,
    updateSourceBuyerAddressDto: UpdateSourceBuyerAddressDto, options?: Parameters<typeof customFetch>[1]): Promise<sourceBuyerAddressControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<sourceBuyerAddressControllerUpdateResponse>(getSourceBuyerAddressControllerUpdateUrl(buyerAddressId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateSourceBuyerAddressDto)
  }
);}





export const getSourceBuyerAddressControllerUpdateMutationKey = () => ['sourceBuyerAddressControllerUpdate'] as const;

export const getSourceBuyerAddressControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerUpdate>>, TError,SourceBuyerAddressControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerUpdate>>, TError,SourceBuyerAddressControllerUpdateMutationVariables, TContext> => {

const mutationKey = getSourceBuyerAddressControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourceBuyerAddressControllerUpdate>>, SourceBuyerAddressControllerUpdateMutationVariables> = (props) => {
          const {buyerAddressId,data} = props ?? {};

          return  sourceBuyerAddressControllerUpdate(buyerAddressId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SourceBuyerAddressControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof sourceBuyerAddressControllerUpdate>>>
    export type SourceBuyerAddressControllerUpdateMutationBody = UpdateSourceBuyerAddressDto
    export type SourceBuyerAddressControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SourceBuyerAddressControllerUpdateMutationVariables = {buyerAddressId: number;data: UpdateSourceBuyerAddressDto}

    export const useSourceBuyerAddressControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerUpdate>>, TError,SourceBuyerAddressControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sourceBuyerAddressControllerUpdate>>,
        TError,
        SourceBuyerAddressControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getSourceBuyerAddressControllerUpdateMutationOptions(options), queryClient);
    }

export type sourceBuyerAddressControllerRemoveResponse200 = {
  data: ResponseSourceBuyerAddressDto
  status: 200
}

export type sourceBuyerAddressControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceBuyerAddressControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceBuyerAddressControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceBuyerAddressControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceBuyerAddressControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceBuyerAddressControllerRemoveResponseSuccess = (sourceBuyerAddressControllerRemoveResponse200) & {
  headers: Headers;
};
export type sourceBuyerAddressControllerRemoveResponseError = (sourceBuyerAddressControllerRemoveResponse400 | sourceBuyerAddressControllerRemoveResponse401 | sourceBuyerAddressControllerRemoveResponse403 | sourceBuyerAddressControllerRemoveResponse404 | sourceBuyerAddressControllerRemoveResponse500) & {
  headers: Headers;
};

export type sourceBuyerAddressControllerRemoveResponse = (sourceBuyerAddressControllerRemoveResponseSuccess | sourceBuyerAddressControllerRemoveResponseError)

export const getSourceBuyerAddressControllerRemoveUrl = (buyerAddressId: number,) => {




  return `/source/buyer-address/${buyerAddressId}`
}

export const sourceBuyerAddressControllerRemove = async (buyerAddressId: number, options?: Parameters<typeof customFetch>[1]): Promise<sourceBuyerAddressControllerRemoveResponse> => {

  return customFetch<sourceBuyerAddressControllerRemoveResponse>(getSourceBuyerAddressControllerRemoveUrl(buyerAddressId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getSourceBuyerAddressControllerRemoveMutationKey = () => ['sourceBuyerAddressControllerRemove'] as const;

export const getSourceBuyerAddressControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerRemove>>, TError,SourceBuyerAddressControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerRemove>>, TError,SourceBuyerAddressControllerRemoveMutationVariables, TContext> => {

const mutationKey = getSourceBuyerAddressControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourceBuyerAddressControllerRemove>>, SourceBuyerAddressControllerRemoveMutationVariables> = (props) => {
          const {buyerAddressId} = props ?? {};

          return  sourceBuyerAddressControllerRemove(buyerAddressId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SourceBuyerAddressControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof sourceBuyerAddressControllerRemove>>>

    export type SourceBuyerAddressControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SourceBuyerAddressControllerRemoveMutationVariables = {buyerAddressId: number}

    export const useSourceBuyerAddressControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceBuyerAddressControllerRemove>>, TError,SourceBuyerAddressControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sourceBuyerAddressControllerRemove>>,
        TError,
        SourceBuyerAddressControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getSourceBuyerAddressControllerRemoveMutationOptions(options), queryClient);
    }

export type sourceControllerCreateResponse201 = {
  data: ResponseSourceDto
  status: 201
}

export type sourceControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceControllerCreateResponseSuccess = (sourceControllerCreateResponse201) & {
  headers: Headers;
};
export type sourceControllerCreateResponseError = (sourceControllerCreateResponse400 | sourceControllerCreateResponse401 | sourceControllerCreateResponse403 | sourceControllerCreateResponse404 | sourceControllerCreateResponse500) & {
  headers: Headers;
};

export type sourceControllerCreateResponse = (sourceControllerCreateResponseSuccess | sourceControllerCreateResponseError)

export const getSourceControllerCreateUrl = () => {




  return `/source`
}

export const sourceControllerCreate = async (createSourceDto: CreateSourceDto, options?: Parameters<typeof customFetch>[1]): Promise<sourceControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<sourceControllerCreateResponse>(getSourceControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createSourceDto)
  }
);}





export const getSourceControllerCreateMutationKey = () => ['sourceControllerCreate'] as const;

export const getSourceControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceControllerCreate>>, TError,SourceControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sourceControllerCreate>>, TError,SourceControllerCreateMutationVariables, TContext> => {

const mutationKey = getSourceControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourceControllerCreate>>, SourceControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sourceControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SourceControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof sourceControllerCreate>>>
    export type SourceControllerCreateMutationBody = CreateSourceDto
    export type SourceControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SourceControllerCreateMutationVariables = {data: CreateSourceDto}

    export const useSourceControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceControllerCreate>>, TError,SourceControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sourceControllerCreate>>,
        TError,
        SourceControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getSourceControllerCreateMutationOptions(options), queryClient);
    }

export type sourceControllerFindAllResponse200 = {
  data: ResponseSourceDto[]
  status: 200
}

export type sourceControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceControllerFindAllResponseSuccess = (sourceControllerFindAllResponse200) & {
  headers: Headers;
};
export type sourceControllerFindAllResponseError = (sourceControllerFindAllResponse400 | sourceControllerFindAllResponse401 | sourceControllerFindAllResponse403 | sourceControllerFindAllResponse404 | sourceControllerFindAllResponse500) & {
  headers: Headers;
};

export type sourceControllerFindAllResponse = (sourceControllerFindAllResponseSuccess | sourceControllerFindAllResponseError)

export const getSourceControllerFindAllUrl = () => {




  return `/source`
}

export const sourceControllerFindAll = async ( options?: Parameters<typeof customFetch>[1]): Promise<sourceControllerFindAllResponse> => {

  return customFetch<sourceControllerFindAllResponse>(getSourceControllerFindAllUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSourceControllerFindAllQueryKey = () => {
    return [
    'source'
    ] as const;
    }


export const getSourceControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof sourceControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSourceControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourceControllerFindAll>>> = ({ signal }) => sourceControllerFindAll({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourceControllerFindAll>>, TError, TData>
}

export type SourceControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof sourceControllerFindAll>>>
export type SourceControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSourceControllerFindAll<TData = Awaited<ReturnType<typeof sourceControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSourceControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type sourceControllerFindOneResponse200 = {
  data: ResponseSourceDto
  status: 200
}

export type sourceControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceControllerFindOneResponseSuccess = (sourceControllerFindOneResponse200) & {
  headers: Headers;
};
export type sourceControllerFindOneResponseError = (sourceControllerFindOneResponse400 | sourceControllerFindOneResponse401 | sourceControllerFindOneResponse403 | sourceControllerFindOneResponse404 | sourceControllerFindOneResponse500) & {
  headers: Headers;
};

export type sourceControllerFindOneResponse = (sourceControllerFindOneResponseSuccess | sourceControllerFindOneResponseError)

export const getSourceControllerFindOneUrl = (sourceId: number,) => {




  return `/source/${sourceId}`
}

export const sourceControllerFindOne = async (sourceId: number, options?: Parameters<typeof customFetch>[1]): Promise<sourceControllerFindOneResponse> => {

  return customFetch<sourceControllerFindOneResponse>(getSourceControllerFindOneUrl(sourceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSourceControllerFindOneQueryKey = (sourceId: MaybeRefOrGetter<number>,) => {
    return [
    'source',sourceId
    ] as const;
    }


export const getSourceControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof sourceControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(sourceId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSourceControllerFindOneQueryKey(sourceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourceControllerFindOne>>> = ({ signal }) => sourceControllerFindOne(toValue(sourceId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(sourceId) !== null && toValue(sourceId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourceControllerFindOne>>, TError, TData>
}

export type SourceControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof sourceControllerFindOne>>>
export type SourceControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSourceControllerFindOne<TData = Awaited<ReturnType<typeof sourceControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 sourceId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSourceControllerFindOneQueryOptions(sourceId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type sourceControllerUpdateResponse200 = {
  data: ResponseSourceDto
  status: 200
}

export type sourceControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceControllerUpdateResponseSuccess = (sourceControllerUpdateResponse200) & {
  headers: Headers;
};
export type sourceControllerUpdateResponseError = (sourceControllerUpdateResponse400 | sourceControllerUpdateResponse401 | sourceControllerUpdateResponse403 | sourceControllerUpdateResponse404 | sourceControllerUpdateResponse500) & {
  headers: Headers;
};

export type sourceControllerUpdateResponse = (sourceControllerUpdateResponseSuccess | sourceControllerUpdateResponseError)

export const getSourceControllerUpdateUrl = (sourceId: number,) => {




  return `/source/${sourceId}`
}

export const sourceControllerUpdate = async (sourceId: number,
    updateSourceDto: UpdateSourceDto, options?: Parameters<typeof customFetch>[1]): Promise<sourceControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<sourceControllerUpdateResponse>(getSourceControllerUpdateUrl(sourceId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateSourceDto)
  }
);}





export const getSourceControllerUpdateMutationKey = () => ['sourceControllerUpdate'] as const;

export const getSourceControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceControllerUpdate>>, TError,SourceControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sourceControllerUpdate>>, TError,SourceControllerUpdateMutationVariables, TContext> => {

const mutationKey = getSourceControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourceControllerUpdate>>, SourceControllerUpdateMutationVariables> = (props) => {
          const {sourceId,data} = props ?? {};

          return  sourceControllerUpdate(sourceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SourceControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof sourceControllerUpdate>>>
    export type SourceControllerUpdateMutationBody = UpdateSourceDto
    export type SourceControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SourceControllerUpdateMutationVariables = {sourceId: number;data: UpdateSourceDto}

    export const useSourceControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceControllerUpdate>>, TError,SourceControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sourceControllerUpdate>>,
        TError,
        SourceControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getSourceControllerUpdateMutationOptions(options), queryClient);
    }

export type sourceControllerRemoveResponse200 = {
  data: ResponseSourceDto
  status: 200
}

export type sourceControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceControllerRemoveResponseSuccess = (sourceControllerRemoveResponse200) & {
  headers: Headers;
};
export type sourceControllerRemoveResponseError = (sourceControllerRemoveResponse400 | sourceControllerRemoveResponse401 | sourceControllerRemoveResponse403 | sourceControllerRemoveResponse404 | sourceControllerRemoveResponse500) & {
  headers: Headers;
};

export type sourceControllerRemoveResponse = (sourceControllerRemoveResponseSuccess | sourceControllerRemoveResponseError)

export const getSourceControllerRemoveUrl = (sourceId: number,) => {




  return `/source/${sourceId}`
}

export const sourceControllerRemove = async (sourceId: number, options?: Parameters<typeof customFetch>[1]): Promise<sourceControllerRemoveResponse> => {

  return customFetch<sourceControllerRemoveResponse>(getSourceControllerRemoveUrl(sourceId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getSourceControllerRemoveMutationKey = () => ['sourceControllerRemove'] as const;

export const getSourceControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceControllerRemove>>, TError,SourceControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sourceControllerRemove>>, TError,SourceControllerRemoveMutationVariables, TContext> => {

const mutationKey = getSourceControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourceControllerRemove>>, SourceControllerRemoveMutationVariables> = (props) => {
          const {sourceId} = props ?? {};

          return  sourceControllerRemove(sourceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SourceControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof sourceControllerRemove>>>

    export type SourceControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type SourceControllerRemoveMutationVariables = {sourceId: number}

    export const useSourceControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourceControllerRemove>>, TError,SourceControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sourceControllerRemove>>,
        TError,
        SourceControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getSourceControllerRemoveMutationOptions(options), queryClient);
    }

export type logApiTricomaControllerPaginateResponse200 = {
  data: LogApiTricomaControllerPaginate200
  status: 200
}

export type logApiTricomaControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logApiTricomaControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logApiTricomaControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logApiTricomaControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logApiTricomaControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logApiTricomaControllerPaginateResponseSuccess = (logApiTricomaControllerPaginateResponse200) & {
  headers: Headers;
};
export type logApiTricomaControllerPaginateResponseError = (logApiTricomaControllerPaginateResponse400 | logApiTricomaControllerPaginateResponse401 | logApiTricomaControllerPaginateResponse403 | logApiTricomaControllerPaginateResponse404 | logApiTricomaControllerPaginateResponse500) & {
  headers: Headers;
};

export type logApiTricomaControllerPaginateResponse = (logApiTricomaControllerPaginateResponseSuccess | logApiTricomaControllerPaginateResponseError)

export const getLogApiTricomaControllerPaginateUrl = (params?: LogApiTricomaControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.status","filter.method","filter.apiTask","filter.apiId","filter.path","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/api-tricoma?${stringifiedParams}` : `/log/api-tricoma`
}

export const logApiTricomaControllerPaginate = async (params?: LogApiTricomaControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logApiTricomaControllerPaginateResponse> => {

  return customFetch<logApiTricomaControllerPaginateResponse>(getLogApiTricomaControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogApiTricomaControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogApiTricomaControllerPaginateParams>,) => {
    return [
    'log','api-tricoma', ...(params ? [params] : [])
    ] as const;
    }


export const getLogApiTricomaControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logApiTricomaControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogApiTricomaControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiTricomaControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogApiTricomaControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logApiTricomaControllerPaginate>>> = ({ signal }) => logApiTricomaControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logApiTricomaControllerPaginate>>, TError, TData>
}

export type LogApiTricomaControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logApiTricomaControllerPaginate>>>
export type LogApiTricomaControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogApiTricomaControllerPaginate<TData = Awaited<ReturnType<typeof logApiTricomaControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogApiTricomaControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiTricomaControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogApiTricomaControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type handlingItemImageControllerCreateResponse201 = {
  data: ResponseHandlingItemImageDto
  status: 201
}

export type handlingItemImageControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemImageControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemImageControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemImageControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemImageControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemImageControllerCreateResponseSuccess = (handlingItemImageControllerCreateResponse201) & {
  headers: Headers;
};
export type handlingItemImageControllerCreateResponseError = (handlingItemImageControllerCreateResponse400 | handlingItemImageControllerCreateResponse401 | handlingItemImageControllerCreateResponse403 | handlingItemImageControllerCreateResponse404 | handlingItemImageControllerCreateResponse500) & {
  headers: Headers;
};

export type handlingItemImageControllerCreateResponse = (handlingItemImageControllerCreateResponseSuccess | handlingItemImageControllerCreateResponseError)

export const getHandlingItemImageControllerCreateUrl = (itemId: number,) => {




  return `/handling/item/${itemId}/image`
}

export const handlingItemImageControllerCreate = async (itemId: number,
    createHandlingItemImageDto: CreateHandlingItemImageDto, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemImageControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<handlingItemImageControllerCreateResponse>(getHandlingItemImageControllerCreateUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createHandlingItemImageDto)
  }
);}





export const getHandlingItemImageControllerCreateMutationKey = () => ['handlingItemImageControllerCreate'] as const;

export const getHandlingItemImageControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemImageControllerCreate>>, TError,HandlingItemImageControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof handlingItemImageControllerCreate>>, TError,HandlingItemImageControllerCreateMutationVariables, TContext> => {

const mutationKey = getHandlingItemImageControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handlingItemImageControllerCreate>>, HandlingItemImageControllerCreateMutationVariables> = (props) => {
          const {itemId,data} = props ?? {};

          return  handlingItemImageControllerCreate(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandlingItemImageControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof handlingItemImageControllerCreate>>>
    export type HandlingItemImageControllerCreateMutationBody = CreateHandlingItemImageDto
    export type HandlingItemImageControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type HandlingItemImageControllerCreateMutationVariables = {itemId: number;data: CreateHandlingItemImageDto}

    export const useHandlingItemImageControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemImageControllerCreate>>, TError,HandlingItemImageControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof handlingItemImageControllerCreate>>,
        TError,
        HandlingItemImageControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHandlingItemImageControllerCreateMutationOptions(options), queryClient);
    }

export type handlingItemImageControllerFindManyResponse200 = {
  data: ResponseHandlingItemImageDto[]
  status: 200
}

export type handlingItemImageControllerFindManyResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemImageControllerFindManyResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemImageControllerFindManyResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemImageControllerFindManyResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemImageControllerFindManyResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemImageControllerFindManyResponseSuccess = (handlingItemImageControllerFindManyResponse200) & {
  headers: Headers;
};
export type handlingItemImageControllerFindManyResponseError = (handlingItemImageControllerFindManyResponse400 | handlingItemImageControllerFindManyResponse401 | handlingItemImageControllerFindManyResponse403 | handlingItemImageControllerFindManyResponse404 | handlingItemImageControllerFindManyResponse500) & {
  headers: Headers;
};

export type handlingItemImageControllerFindManyResponse = (handlingItemImageControllerFindManyResponseSuccess | handlingItemImageControllerFindManyResponseError)

export const getHandlingItemImageControllerFindManyUrl = (itemId: number,) => {




  return `/handling/item/${itemId}/image`
}

export const handlingItemImageControllerFindMany = async (itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemImageControllerFindManyResponse> => {

  return customFetch<handlingItemImageControllerFindManyResponse>(getHandlingItemImageControllerFindManyUrl(itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHandlingItemImageControllerFindManyQueryKey = (itemId: MaybeRefOrGetter<number>,) => {
    return [
    'handling','item',itemId,'image'
    ] as const;
    }


export const getHandlingItemImageControllerFindManyQueryOptions = <TData = Awaited<ReturnType<typeof handlingItemImageControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlingItemImageControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getHandlingItemImageControllerFindManyQueryKey(itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof handlingItemImageControllerFindMany>>> = ({ signal }) => handlingItemImageControllerFindMany(toValue(itemId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(itemId) !== null && toValue(itemId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof handlingItemImageControllerFindMany>>, TError, TData>
}

export type HandlingItemImageControllerFindManyQueryResult = NonNullable<Awaited<ReturnType<typeof handlingItemImageControllerFindMany>>>
export type HandlingItemImageControllerFindManyQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useHandlingItemImageControllerFindMany<TData = Awaited<ReturnType<typeof handlingItemImageControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlingItemImageControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHandlingItemImageControllerFindManyQueryOptions(itemId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type handlingItemImageControllerFindOneResponse200 = {
  data: ResponseHandlingItemImageDto
  status: 200
}

export type handlingItemImageControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemImageControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemImageControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemImageControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemImageControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemImageControllerFindOneResponseSuccess = (handlingItemImageControllerFindOneResponse200) & {
  headers: Headers;
};
export type handlingItemImageControllerFindOneResponseError = (handlingItemImageControllerFindOneResponse400 | handlingItemImageControllerFindOneResponse401 | handlingItemImageControllerFindOneResponse403 | handlingItemImageControllerFindOneResponse404 | handlingItemImageControllerFindOneResponse500) & {
  headers: Headers;
};

export type handlingItemImageControllerFindOneResponse = (handlingItemImageControllerFindOneResponseSuccess | handlingItemImageControllerFindOneResponseError)

export const getHandlingItemImageControllerFindOneUrl = (itemId: number,
    imageId: number,) => {




  return `/handling/item/${itemId}/image/${imageId}`
}

export const handlingItemImageControllerFindOne = async (itemId: number,
    imageId: number, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemImageControllerFindOneResponse> => {

  return customFetch<handlingItemImageControllerFindOneResponse>(getHandlingItemImageControllerFindOneUrl(itemId,imageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHandlingItemImageControllerFindOneQueryKey = (itemId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>,) => {
    return [
    'handling','item',itemId,'image',imageId
    ] as const;
    }


export const getHandlingItemImageControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof handlingItemImageControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(itemId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlingItemImageControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getHandlingItemImageControllerFindOneQueryKey(itemId,imageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof handlingItemImageControllerFindOne>>> = ({ signal }) => handlingItemImageControllerFindOne(toValue(itemId),toValue(imageId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(itemId) !== null && toValue(itemId) !== undefined && toValue(imageId) !== null && toValue(imageId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof handlingItemImageControllerFindOne>>, TError, TData>
}

export type HandlingItemImageControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof handlingItemImageControllerFindOne>>>
export type HandlingItemImageControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useHandlingItemImageControllerFindOne<TData = Awaited<ReturnType<typeof handlingItemImageControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 itemId: MaybeRefOrGetter<number>,
    imageId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlingItemImageControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHandlingItemImageControllerFindOneQueryOptions(itemId,imageId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type handlingItemImageControllerRemoveResponse200 = {
  data: ResponseHandlingItemImageDto
  status: 200
}

export type handlingItemImageControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type handlingItemImageControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type handlingItemImageControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type handlingItemImageControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type handlingItemImageControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type handlingItemImageControllerRemoveResponseSuccess = (handlingItemImageControllerRemoveResponse200) & {
  headers: Headers;
};
export type handlingItemImageControllerRemoveResponseError = (handlingItemImageControllerRemoveResponse400 | handlingItemImageControllerRemoveResponse401 | handlingItemImageControllerRemoveResponse403 | handlingItemImageControllerRemoveResponse404 | handlingItemImageControllerRemoveResponse500) & {
  headers: Headers;
};

export type handlingItemImageControllerRemoveResponse = (handlingItemImageControllerRemoveResponseSuccess | handlingItemImageControllerRemoveResponseError)

export const getHandlingItemImageControllerRemoveUrl = (itemId: number,
    imageId: number,) => {




  return `/handling/item/${itemId}/image/${imageId}`
}

export const handlingItemImageControllerRemove = async (itemId: number,
    imageId: number, options?: Parameters<typeof customFetch>[1]): Promise<handlingItemImageControllerRemoveResponse> => {

  return customFetch<handlingItemImageControllerRemoveResponse>(getHandlingItemImageControllerRemoveUrl(itemId,imageId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getHandlingItemImageControllerRemoveMutationKey = () => ['handlingItemImageControllerRemove'] as const;

export const getHandlingItemImageControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemImageControllerRemove>>, TError,HandlingItemImageControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof handlingItemImageControllerRemove>>, TError,HandlingItemImageControllerRemoveMutationVariables, TContext> => {

const mutationKey = getHandlingItemImageControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handlingItemImageControllerRemove>>, HandlingItemImageControllerRemoveMutationVariables> = (props) => {
          const {itemId,imageId} = props ?? {};

          return  handlingItemImageControllerRemove(itemId,imageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandlingItemImageControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof handlingItemImageControllerRemove>>>

    export type HandlingItemImageControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type HandlingItemImageControllerRemoveMutationVariables = {itemId: number;imageId: number}

    export const useHandlingItemImageControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handlingItemImageControllerRemove>>, TError,HandlingItemImageControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof handlingItemImageControllerRemove>>,
        TError,
        HandlingItemImageControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getHandlingItemImageControllerRemoveMutationOptions(options), queryClient);
    }

export type searchControllerSearchResponse200 = {
  data: SearchResponseItemDto[]
  status: 200
}

export type searchControllerSearchResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type searchControllerSearchResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type searchControllerSearchResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type searchControllerSearchResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type searchControllerSearchResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type searchControllerSearchResponseSuccess = (searchControllerSearchResponse200) & {
  headers: Headers;
};
export type searchControllerSearchResponseError = (searchControllerSearchResponse400 | searchControllerSearchResponse401 | searchControllerSearchResponse403 | searchControllerSearchResponse404 | searchControllerSearchResponse500) & {
  headers: Headers;
};

export type searchControllerSearchResponse = (searchControllerSearchResponseSuccess | searchControllerSearchResponseError)

export const getSearchControllerSearchUrl = (params: SearchControllerSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/search?${stringifiedParams}` : `/search`
}

export const searchControllerSearch = async (params: SearchControllerSearchParams, options?: Parameters<typeof customFetch>[1]): Promise<searchControllerSearchResponse> => {

  return customFetch<searchControllerSearchResponse>(getSearchControllerSearchUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchControllerSearchQueryKey = (params?: MaybeRefOrGetter<SearchControllerSearchParams>,) => {
    return [
    'search', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchControllerSearchQueryOptions = <TData = Awaited<ReturnType<typeof searchControllerSearch>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params: MaybeRefOrGetter<SearchControllerSearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchControllerSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchControllerSearch>>> = ({ signal }) => searchControllerSearch(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchControllerSearch>>, TError, TData>
}

export type SearchControllerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof searchControllerSearch>>>
export type SearchControllerSearchQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSearchControllerSearch<TData = Awaited<ReturnType<typeof searchControllerSearch>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params: MaybeRefOrGetter<SearchControllerSearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchControllerSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type searchControllerFindByReferenceResponse200 = {
  data: SearchResponseItemDto
  status: 200
}

export type searchControllerFindByReferenceResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type searchControllerFindByReferenceResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type searchControllerFindByReferenceResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type searchControllerFindByReferenceResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type searchControllerFindByReferenceResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type searchControllerFindByReferenceResponseSuccess = (searchControllerFindByReferenceResponse200) & {
  headers: Headers;
};
export type searchControllerFindByReferenceResponseError = (searchControllerFindByReferenceResponse400 | searchControllerFindByReferenceResponse401 | searchControllerFindByReferenceResponse403 | searchControllerFindByReferenceResponse404 | searchControllerFindByReferenceResponse500) & {
  headers: Headers;
};

export type searchControllerFindByReferenceResponse = (searchControllerFindByReferenceResponseSuccess | searchControllerFindByReferenceResponseError)

export const getSearchControllerFindByReferenceUrl = (reference: string,
    params?: SearchControllerFindByReferenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/search/${reference}?${stringifiedParams}` : `/search/${reference}`
}

export const searchControllerFindByReference = async (reference: string,
    params?: SearchControllerFindByReferenceParams, options?: Parameters<typeof customFetch>[1]): Promise<searchControllerFindByReferenceResponse> => {

  return customFetch<searchControllerFindByReferenceResponse>(getSearchControllerFindByReferenceUrl(reference,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchControllerFindByReferenceQueryKey = (reference: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SearchControllerFindByReferenceParams>,) => {
    return [
    'search',reference, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchControllerFindByReferenceQueryOptions = <TData = Awaited<ReturnType<typeof searchControllerFindByReference>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(reference: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SearchControllerFindByReferenceParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchControllerFindByReference>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSearchControllerFindByReferenceQueryKey(reference,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchControllerFindByReference>>> = ({ signal }) => searchControllerFindByReference(toValue(reference),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(reference) !== null && toValue(reference) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchControllerFindByReference>>, TError, TData>
}

export type SearchControllerFindByReferenceQueryResult = NonNullable<Awaited<ReturnType<typeof searchControllerFindByReference>>>
export type SearchControllerFindByReferenceQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSearchControllerFindByReference<TData = Awaited<ReturnType<typeof searchControllerFindByReference>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 reference: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<SearchControllerFindByReferenceParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchControllerFindByReference>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchControllerFindByReferenceQueryOptions(reference,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type logApiKeepaControllerPaginateResponse200 = {
  data: LogApiKeepaControllerPaginate200
  status: 200
}

export type logApiKeepaControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logApiKeepaControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logApiKeepaControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logApiKeepaControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logApiKeepaControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logApiKeepaControllerPaginateResponseSuccess = (logApiKeepaControllerPaginateResponse200) & {
  headers: Headers;
};
export type logApiKeepaControllerPaginateResponseError = (logApiKeepaControllerPaginateResponse400 | logApiKeepaControllerPaginateResponse401 | logApiKeepaControllerPaginateResponse403 | logApiKeepaControllerPaginateResponse404 | logApiKeepaControllerPaginateResponse500) & {
  headers: Headers;
};

export type logApiKeepaControllerPaginateResponse = (logApiKeepaControllerPaginateResponseSuccess | logApiKeepaControllerPaginateResponseError)

export const getLogApiKeepaControllerPaginateUrl = (params?: LogApiKeepaControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.status","filter.method","filter.path","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/api-keepa?${stringifiedParams}` : `/log/api-keepa`
}

export const logApiKeepaControllerPaginate = async (params?: LogApiKeepaControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logApiKeepaControllerPaginateResponse> => {

  return customFetch<logApiKeepaControllerPaginateResponse>(getLogApiKeepaControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogApiKeepaControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogApiKeepaControllerPaginateParams>,) => {
    return [
    'log','api-keepa', ...(params ? [params] : [])
    ] as const;
    }


export const getLogApiKeepaControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logApiKeepaControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogApiKeepaControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiKeepaControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogApiKeepaControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logApiKeepaControllerPaginate>>> = ({ signal }) => logApiKeepaControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logApiKeepaControllerPaginate>>, TError, TData>
}

export type LogApiKeepaControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logApiKeepaControllerPaginate>>>
export type LogApiKeepaControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogApiKeepaControllerPaginate<TData = Awaited<ReturnType<typeof logApiKeepaControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogApiKeepaControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiKeepaControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogApiKeepaControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerBatchControllerCreateFromCsvResponse201 = {
  data: ResponseOfferBatchCsvCreateDto
  status: 201
}

export type offerBatchControllerCreateFromCsvResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerBatchControllerCreateFromCsvResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerBatchControllerCreateFromCsvResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerBatchControllerCreateFromCsvResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerBatchControllerCreateFromCsvResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerBatchControllerCreateFromCsvResponseSuccess = (offerBatchControllerCreateFromCsvResponse201) & {
  headers: Headers;
};
export type offerBatchControllerCreateFromCsvResponseError = (offerBatchControllerCreateFromCsvResponse400 | offerBatchControllerCreateFromCsvResponse401 | offerBatchControllerCreateFromCsvResponse403 | offerBatchControllerCreateFromCsvResponse404 | offerBatchControllerCreateFromCsvResponse500) & {
  headers: Headers;
};

export type offerBatchControllerCreateFromCsvResponse = (offerBatchControllerCreateFromCsvResponseSuccess | offerBatchControllerCreateFromCsvResponseError)

export const getOfferBatchControllerCreateFromCsvUrl = () => {




  return `/offer-batch/csv`
}

export const offerBatchControllerCreateFromCsv = async (createOfferBatchCsvDto: CreateOfferBatchCsvDto, options?: Parameters<typeof customFetch>[1]): Promise<offerBatchControllerCreateFromCsvResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerBatchControllerCreateFromCsvResponse>(getOfferBatchControllerCreateFromCsvUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferBatchCsvDto)
  }
);}





export const getOfferBatchControllerCreateFromCsvMutationKey = () => ['offerBatchControllerCreateFromCsv'] as const;

export const getOfferBatchControllerCreateFromCsvMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerBatchControllerCreateFromCsv>>, TError,OfferBatchControllerCreateFromCsvMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerBatchControllerCreateFromCsv>>, TError,OfferBatchControllerCreateFromCsvMutationVariables, TContext> => {

const mutationKey = getOfferBatchControllerCreateFromCsvMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerBatchControllerCreateFromCsv>>, OfferBatchControllerCreateFromCsvMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  offerBatchControllerCreateFromCsv(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferBatchControllerCreateFromCsvMutationResult = NonNullable<Awaited<ReturnType<typeof offerBatchControllerCreateFromCsv>>>
    export type OfferBatchControllerCreateFromCsvMutationBody = CreateOfferBatchCsvDto
    export type OfferBatchControllerCreateFromCsvMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferBatchControllerCreateFromCsvMutationVariables = {data: CreateOfferBatchCsvDto}

    export const useOfferBatchControllerCreateFromCsv = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerBatchControllerCreateFromCsv>>, TError,OfferBatchControllerCreateFromCsvMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerBatchControllerCreateFromCsv>>,
        TError,
        OfferBatchControllerCreateFromCsvMutationVariables,
        TContext
      > => {
      return useMutation(getOfferBatchControllerCreateFromCsvMutationOptions(options), queryClient);
    }

export type offerBatchControllerFindOneJobResponse200 = {
  data: ResponseOfferBatchJobDto
  status: 200
}

export type offerBatchControllerFindOneJobResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerBatchControllerFindOneJobResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerBatchControllerFindOneJobResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerBatchControllerFindOneJobResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerBatchControllerFindOneJobResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerBatchControllerFindOneJobResponseSuccess = (offerBatchControllerFindOneJobResponse200) & {
  headers: Headers;
};
export type offerBatchControllerFindOneJobResponseError = (offerBatchControllerFindOneJobResponse400 | offerBatchControllerFindOneJobResponse401 | offerBatchControllerFindOneJobResponse403 | offerBatchControllerFindOneJobResponse404 | offerBatchControllerFindOneJobResponse500) & {
  headers: Headers;
};

export type offerBatchControllerFindOneJobResponse = (offerBatchControllerFindOneJobResponseSuccess | offerBatchControllerFindOneJobResponseError)

export const getOfferBatchControllerFindOneJobUrl = (jobId: string,) => {




  return `/offer-batch/job/${jobId}`
}

export const offerBatchControllerFindOneJob = async (jobId: string, options?: Parameters<typeof customFetch>[1]): Promise<offerBatchControllerFindOneJobResponse> => {

  return customFetch<offerBatchControllerFindOneJobResponse>(getOfferBatchControllerFindOneJobUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferBatchControllerFindOneJobQueryKey = (jobId: MaybeRefOrGetter<string>,) => {
    return [
    'offer-batch','job',jobId
    ] as const;
    }


export const getOfferBatchControllerFindOneJobQueryOptions = <TData = Awaited<ReturnType<typeof offerBatchControllerFindOneJob>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(jobId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerBatchControllerFindOneJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferBatchControllerFindOneJobQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerBatchControllerFindOneJob>>> = ({ signal }) => offerBatchControllerFindOneJob(toValue(jobId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(jobId) !== null && toValue(jobId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerBatchControllerFindOneJob>>, TError, TData>
}

export type OfferBatchControllerFindOneJobQueryResult = NonNullable<Awaited<ReturnType<typeof offerBatchControllerFindOneJob>>>
export type OfferBatchControllerFindOneJobQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferBatchControllerFindOneJob<TData = Awaited<ReturnType<typeof offerBatchControllerFindOneJob>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 jobId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerBatchControllerFindOneJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferBatchControllerFindOneJobQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerBatchControllerFindOneCsvJobResponse200 = {
  data: ResponseOfferBatchCsvJobDto
  status: 200
}

export type offerBatchControllerFindOneCsvJobResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerBatchControllerFindOneCsvJobResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerBatchControllerFindOneCsvJobResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerBatchControllerFindOneCsvJobResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerBatchControllerFindOneCsvJobResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerBatchControllerFindOneCsvJobResponseSuccess = (offerBatchControllerFindOneCsvJobResponse200) & {
  headers: Headers;
};
export type offerBatchControllerFindOneCsvJobResponseError = (offerBatchControllerFindOneCsvJobResponse400 | offerBatchControllerFindOneCsvJobResponse401 | offerBatchControllerFindOneCsvJobResponse403 | offerBatchControllerFindOneCsvJobResponse404 | offerBatchControllerFindOneCsvJobResponse500) & {
  headers: Headers;
};

export type offerBatchControllerFindOneCsvJobResponse = (offerBatchControllerFindOneCsvJobResponseSuccess | offerBatchControllerFindOneCsvJobResponseError)

export const getOfferBatchControllerFindOneCsvJobUrl = (jobId: string,) => {




  return `/offer-batch/job/${jobId}/csv`
}

export const offerBatchControllerFindOneCsvJob = async (jobId: string, options?: Parameters<typeof customFetch>[1]): Promise<offerBatchControllerFindOneCsvJobResponse> => {

  return customFetch<offerBatchControllerFindOneCsvJobResponse>(getOfferBatchControllerFindOneCsvJobUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferBatchControllerFindOneCsvJobQueryKey = (jobId: MaybeRefOrGetter<string>,) => {
    return [
    'offer-batch','job',jobId,'csv'
    ] as const;
    }


export const getOfferBatchControllerFindOneCsvJobQueryOptions = <TData = Awaited<ReturnType<typeof offerBatchControllerFindOneCsvJob>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(jobId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerBatchControllerFindOneCsvJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferBatchControllerFindOneCsvJobQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerBatchControllerFindOneCsvJob>>> = ({ signal }) => offerBatchControllerFindOneCsvJob(toValue(jobId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(jobId) !== null && toValue(jobId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerBatchControllerFindOneCsvJob>>, TError, TData>
}

export type OfferBatchControllerFindOneCsvJobQueryResult = NonNullable<Awaited<ReturnType<typeof offerBatchControllerFindOneCsvJob>>>
export type OfferBatchControllerFindOneCsvJobQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferBatchControllerFindOneCsvJob<TData = Awaited<ReturnType<typeof offerBatchControllerFindOneCsvJob>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 jobId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerBatchControllerFindOneCsvJob>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferBatchControllerFindOneCsvJobQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type batchCsvControllerCreateResponse201 = {
  data: ResponseBatchCsvDocumentDto
  status: 201
}

export type batchCsvControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type batchCsvControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type batchCsvControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type batchCsvControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type batchCsvControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type batchCsvControllerCreateResponseSuccess = (batchCsvControllerCreateResponse201) & {
  headers: Headers;
};
export type batchCsvControllerCreateResponseError = (batchCsvControllerCreateResponse400 | batchCsvControllerCreateResponse401 | batchCsvControllerCreateResponse403 | batchCsvControllerCreateResponse404 | batchCsvControllerCreateResponse500) & {
  headers: Headers;
};

export type batchCsvControllerCreateResponse = (batchCsvControllerCreateResponseSuccess | batchCsvControllerCreateResponseError)

export const getBatchCsvControllerCreateUrl = () => {




  return `/batch/csv`
}

export const batchCsvControllerCreate = async (createBatchCsvDocumentDto: CreateBatchCsvDocumentDto, options?: Parameters<typeof customFetch>[1]): Promise<batchCsvControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<batchCsvControllerCreateResponse>(getBatchCsvControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createBatchCsvDocumentDto)
  }
);}





export const getBatchCsvControllerCreateMutationKey = () => ['batchCsvControllerCreate'] as const;

export const getBatchCsvControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchCsvControllerCreate>>, TError,BatchCsvControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof batchCsvControllerCreate>>, TError,BatchCsvControllerCreateMutationVariables, TContext> => {

const mutationKey = getBatchCsvControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchCsvControllerCreate>>, BatchCsvControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  batchCsvControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BatchCsvControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof batchCsvControllerCreate>>>
    export type BatchCsvControllerCreateMutationBody = CreateBatchCsvDocumentDto
    export type BatchCsvControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type BatchCsvControllerCreateMutationVariables = {data: CreateBatchCsvDocumentDto}

    export const useBatchCsvControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchCsvControllerCreate>>, TError,BatchCsvControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof batchCsvControllerCreate>>,
        TError,
        BatchCsvControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBatchCsvControllerCreateMutationOptions(options), queryClient);
    }

export type batchCsvControllerFindAllPaginatedResponse200 = {
  data: BatchCsvControllerFindAllPaginated200
  status: 200
}

export type batchCsvControllerFindAllPaginatedResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type batchCsvControllerFindAllPaginatedResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type batchCsvControllerFindAllPaginatedResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type batchCsvControllerFindAllPaginatedResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type batchCsvControllerFindAllPaginatedResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type batchCsvControllerFindAllPaginatedResponseSuccess = (batchCsvControllerFindAllPaginatedResponse200) & {
  headers: Headers;
};
export type batchCsvControllerFindAllPaginatedResponseError = (batchCsvControllerFindAllPaginatedResponse400 | batchCsvControllerFindAllPaginatedResponse401 | batchCsvControllerFindAllPaginatedResponse403 | batchCsvControllerFindAllPaginatedResponse404 | batchCsvControllerFindAllPaginatedResponse500) & {
  headers: Headers;
};

export type batchCsvControllerFindAllPaginatedResponse = (batchCsvControllerFindAllPaginatedResponseSuccess | batchCsvControllerFindAllPaginatedResponseError)

export const getBatchCsvControllerFindAllPaginatedUrl = (params?: BatchCsvControllerFindAllPaginatedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.createdAt","filter.createdBy.id","sortBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/batch/csv?${stringifiedParams}` : `/batch/csv`
}

export const batchCsvControllerFindAllPaginated = async (params?: BatchCsvControllerFindAllPaginatedParams, options?: Parameters<typeof customFetch>[1]): Promise<batchCsvControllerFindAllPaginatedResponse> => {

  return customFetch<batchCsvControllerFindAllPaginatedResponse>(getBatchCsvControllerFindAllPaginatedUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBatchCsvControllerFindAllPaginatedQueryKey = (params?: MaybeRefOrGetter<BatchCsvControllerFindAllPaginatedParams>,) => {
    return [
    'batch','csv', ...(params ? [params] : [])
    ] as const;
    }


export const getBatchCsvControllerFindAllPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof batchCsvControllerFindAllPaginated>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<BatchCsvControllerFindAllPaginatedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindAllPaginated>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getBatchCsvControllerFindAllPaginatedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof batchCsvControllerFindAllPaginated>>> = ({ signal }) => batchCsvControllerFindAllPaginated(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindAllPaginated>>, TError, TData>
}

export type BatchCsvControllerFindAllPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof batchCsvControllerFindAllPaginated>>>
export type BatchCsvControllerFindAllPaginatedQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useBatchCsvControllerFindAllPaginated<TData = Awaited<ReturnType<typeof batchCsvControllerFindAllPaginated>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<BatchCsvControllerFindAllPaginatedParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindAllPaginated>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBatchCsvControllerFindAllPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type batchCsvControllerFindOneResponse200 = {
  data: ResponseBatchCsvDocumentDto
  status: 200
}

export type batchCsvControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type batchCsvControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type batchCsvControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type batchCsvControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type batchCsvControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type batchCsvControllerFindOneResponseSuccess = (batchCsvControllerFindOneResponse200) & {
  headers: Headers;
};
export type batchCsvControllerFindOneResponseError = (batchCsvControllerFindOneResponse400 | batchCsvControllerFindOneResponse401 | batchCsvControllerFindOneResponse403 | batchCsvControllerFindOneResponse404 | batchCsvControllerFindOneResponse500) & {
  headers: Headers;
};

export type batchCsvControllerFindOneResponse = (batchCsvControllerFindOneResponseSuccess | batchCsvControllerFindOneResponseError)

export const getBatchCsvControllerFindOneUrl = (csvId: number,) => {




  return `/batch/csv/${csvId}`
}

export const batchCsvControllerFindOne = async (csvId: number, options?: Parameters<typeof customFetch>[1]): Promise<batchCsvControllerFindOneResponse> => {

  return customFetch<batchCsvControllerFindOneResponse>(getBatchCsvControllerFindOneUrl(csvId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBatchCsvControllerFindOneQueryKey = (csvId: MaybeRefOrGetter<number>,) => {
    return [
    'batch','csv',csvId
    ] as const;
    }


export const getBatchCsvControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof batchCsvControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(csvId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getBatchCsvControllerFindOneQueryKey(csvId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof batchCsvControllerFindOne>>> = ({ signal }) => batchCsvControllerFindOne(toValue(csvId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(csvId) !== null && toValue(csvId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindOne>>, TError, TData>
}

export type BatchCsvControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof batchCsvControllerFindOne>>>
export type BatchCsvControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useBatchCsvControllerFindOne<TData = Awaited<ReturnType<typeof batchCsvControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 csvId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBatchCsvControllerFindOneQueryOptions(csvId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type batchCsvControllerFindHeadersResponse200 = {
  data: string[]
  status: 200
}

export type batchCsvControllerFindHeadersResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type batchCsvControllerFindHeadersResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type batchCsvControllerFindHeadersResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type batchCsvControllerFindHeadersResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type batchCsvControllerFindHeadersResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type batchCsvControllerFindHeadersResponseSuccess = (batchCsvControllerFindHeadersResponse200) & {
  headers: Headers;
};
export type batchCsvControllerFindHeadersResponseError = (batchCsvControllerFindHeadersResponse400 | batchCsvControllerFindHeadersResponse401 | batchCsvControllerFindHeadersResponse403 | batchCsvControllerFindHeadersResponse404 | batchCsvControllerFindHeadersResponse500) & {
  headers: Headers;
};

export type batchCsvControllerFindHeadersResponse = (batchCsvControllerFindHeadersResponseSuccess | batchCsvControllerFindHeadersResponseError)

export const getBatchCsvControllerFindHeadersUrl = (csvId: number,) => {




  return `/batch/csv/${csvId}/headers`
}

export const batchCsvControllerFindHeaders = async (csvId: number, options?: Parameters<typeof customFetch>[1]): Promise<batchCsvControllerFindHeadersResponse> => {

  return customFetch<batchCsvControllerFindHeadersResponse>(getBatchCsvControllerFindHeadersUrl(csvId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBatchCsvControllerFindHeadersQueryKey = (csvId: MaybeRefOrGetter<number>,) => {
    return [
    'batch','csv',csvId,'headers'
    ] as const;
    }


export const getBatchCsvControllerFindHeadersQueryOptions = <TData = Awaited<ReturnType<typeof batchCsvControllerFindHeaders>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(csvId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindHeaders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getBatchCsvControllerFindHeadersQueryKey(csvId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof batchCsvControllerFindHeaders>>> = ({ signal }) => batchCsvControllerFindHeaders(toValue(csvId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(csvId) !== null && toValue(csvId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindHeaders>>, TError, TData>
}

export type BatchCsvControllerFindHeadersQueryResult = NonNullable<Awaited<ReturnType<typeof batchCsvControllerFindHeaders>>>
export type BatchCsvControllerFindHeadersQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useBatchCsvControllerFindHeaders<TData = Awaited<ReturnType<typeof batchCsvControllerFindHeaders>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 csvId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof batchCsvControllerFindHeaders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBatchCsvControllerFindHeadersQueryOptions(csvId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type uploadS3ControllerPresignResponse201 = {
  data: ResponseUploadS3PresignDto
  status: 201
}

export type uploadS3ControllerPresignResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type uploadS3ControllerPresignResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type uploadS3ControllerPresignResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type uploadS3ControllerPresignResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type uploadS3ControllerPresignResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type uploadS3ControllerPresignResponseSuccess = (uploadS3ControllerPresignResponse201) & {
  headers: Headers;
};
export type uploadS3ControllerPresignResponseError = (uploadS3ControllerPresignResponse400 | uploadS3ControllerPresignResponse401 | uploadS3ControllerPresignResponse403 | uploadS3ControllerPresignResponse404 | uploadS3ControllerPresignResponse500) & {
  headers: Headers;
};

export type uploadS3ControllerPresignResponse = (uploadS3ControllerPresignResponseSuccess | uploadS3ControllerPresignResponseError)

export const getUploadS3ControllerPresignUrl = () => {




  return `/upload/s3/presign`
}

export const uploadS3ControllerPresign = async (uploadS3PresignBodyDto: UploadS3PresignBodyDto, options?: Parameters<typeof customFetch>[1]): Promise<uploadS3ControllerPresignResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<uploadS3ControllerPresignResponse>(getUploadS3ControllerPresignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadS3PresignBodyDto)
  }
);}





export const getUploadS3ControllerPresignMutationKey = () => ['uploadS3ControllerPresign'] as const;

export const getUploadS3ControllerPresignMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerPresign>>, TError,UploadS3ControllerPresignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerPresign>>, TError,UploadS3ControllerPresignMutationVariables, TContext> => {

const mutationKey = getUploadS3ControllerPresignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadS3ControllerPresign>>, UploadS3ControllerPresignMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadS3ControllerPresign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadS3ControllerPresignMutationResult = NonNullable<Awaited<ReturnType<typeof uploadS3ControllerPresign>>>
    export type UploadS3ControllerPresignMutationBody = UploadS3PresignBodyDto
    export type UploadS3ControllerPresignMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UploadS3ControllerPresignMutationVariables = {data: UploadS3PresignBodyDto}

    export const useUploadS3ControllerPresign = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerPresign>>, TError,UploadS3ControllerPresignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadS3ControllerPresign>>,
        TError,
        UploadS3ControllerPresignMutationVariables,
        TContext
      > => {
      return useMutation(getUploadS3ControllerPresignMutationOptions(options), queryClient);
    }

export type uploadS3ControllerSignWithParamsResponse200 = {
  data: ResponseUploadS3SignDto
  status: 200
}

export type uploadS3ControllerSignWithParamsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type uploadS3ControllerSignWithParamsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type uploadS3ControllerSignWithParamsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type uploadS3ControllerSignWithParamsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type uploadS3ControllerSignWithParamsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type uploadS3ControllerSignWithParamsResponseSuccess = (uploadS3ControllerSignWithParamsResponse200) & {
  headers: Headers;
};
export type uploadS3ControllerSignWithParamsResponseError = (uploadS3ControllerSignWithParamsResponse400 | uploadS3ControllerSignWithParamsResponse401 | uploadS3ControllerSignWithParamsResponse403 | uploadS3ControllerSignWithParamsResponse404 | uploadS3ControllerSignWithParamsResponse500) & {
  headers: Headers;
};

export type uploadS3ControllerSignWithParamsResponse = (uploadS3ControllerSignWithParamsResponseSuccess | uploadS3ControllerSignWithParamsResponseError)

export const getUploadS3ControllerSignWithParamsUrl = (params: UploadS3ControllerSignWithParamsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/upload/s3/params?${stringifiedParams}` : `/upload/s3/params`
}

/**
 * Deprecated: replaced by POST upload/s3/presign, which signs every S3 operation for Uppy 6. Kept for clients that have not been updated yet.
 * @deprecated
 */
export const uploadS3ControllerSignWithParams = async (params: UploadS3ControllerSignWithParamsParams, options?: Parameters<typeof customFetch>[1]): Promise<uploadS3ControllerSignWithParamsResponse> => {

  return customFetch<uploadS3ControllerSignWithParamsResponse>(getUploadS3ControllerSignWithParamsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUploadS3ControllerSignWithParamsQueryKey = (params?: MaybeRefOrGetter<UploadS3ControllerSignWithParamsParams>,) => {
    return [
    'upload','s3','params', ...(params ? [params] : [])
    ] as const;
    }


export const getUploadS3ControllerSignWithParamsQueryOptions = <TData = Awaited<ReturnType<typeof uploadS3ControllerSignWithParams>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params: MaybeRefOrGetter<UploadS3ControllerSignWithParamsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerSignWithParams>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUploadS3ControllerSignWithParamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof uploadS3ControllerSignWithParams>>> = ({ signal }) => uploadS3ControllerSignWithParams(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerSignWithParams>>, TError, TData>
}

export type UploadS3ControllerSignWithParamsQueryResult = NonNullable<Awaited<ReturnType<typeof uploadS3ControllerSignWithParams>>>
export type UploadS3ControllerSignWithParamsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @deprecated
 */

export function useUploadS3ControllerSignWithParams<TData = Awaited<ReturnType<typeof uploadS3ControllerSignWithParams>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params: MaybeRefOrGetter<UploadS3ControllerSignWithParamsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerSignWithParams>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUploadS3ControllerSignWithParamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type uploadS3ControllerSignWithBodyResponse201 = {
  data: ResponseUploadS3SignDto
  status: 201
}

export type uploadS3ControllerSignWithBodyResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type uploadS3ControllerSignWithBodyResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type uploadS3ControllerSignWithBodyResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type uploadS3ControllerSignWithBodyResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type uploadS3ControllerSignWithBodyResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type uploadS3ControllerSignWithBodyResponseSuccess = (uploadS3ControllerSignWithBodyResponse201) & {
  headers: Headers;
};
export type uploadS3ControllerSignWithBodyResponseError = (uploadS3ControllerSignWithBodyResponse400 | uploadS3ControllerSignWithBodyResponse401 | uploadS3ControllerSignWithBodyResponse403 | uploadS3ControllerSignWithBodyResponse404 | uploadS3ControllerSignWithBodyResponse500) & {
  headers: Headers;
};

export type uploadS3ControllerSignWithBodyResponse = (uploadS3ControllerSignWithBodyResponseSuccess | uploadS3ControllerSignWithBodyResponseError)

export const getUploadS3ControllerSignWithBodyUrl = () => {




  return `/upload/s3/sign`
}

/**
 * Deprecated: replaced by POST upload/s3/presign, which signs every S3 operation for Uppy 6. Kept for clients that have not been updated yet.
 * @deprecated
 */
export const uploadS3ControllerSignWithBody = async (uploadS3SignBodyDto: UploadS3SignBodyDto, options?: Parameters<typeof customFetch>[1]): Promise<uploadS3ControllerSignWithBodyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<uploadS3ControllerSignWithBodyResponse>(getUploadS3ControllerSignWithBodyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadS3SignBodyDto)
  }
);}





export const getUploadS3ControllerSignWithBodyMutationKey = () => ['uploadS3ControllerSignWithBody'] as const;

export const getUploadS3ControllerSignWithBodyMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerSignWithBody>>, TError,UploadS3ControllerSignWithBodyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerSignWithBody>>, TError,UploadS3ControllerSignWithBodyMutationVariables, TContext> => {

const mutationKey = getUploadS3ControllerSignWithBodyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadS3ControllerSignWithBody>>, UploadS3ControllerSignWithBodyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadS3ControllerSignWithBody(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadS3ControllerSignWithBodyMutationResult = NonNullable<Awaited<ReturnType<typeof uploadS3ControllerSignWithBody>>>
    export type UploadS3ControllerSignWithBodyMutationBody = UploadS3SignBodyDto
    export type UploadS3ControllerSignWithBodyMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UploadS3ControllerSignWithBodyMutationVariables = {data: UploadS3SignBodyDto}

    /**
 * @deprecated
 */
export const useUploadS3ControllerSignWithBody = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerSignWithBody>>, TError,UploadS3ControllerSignWithBodyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadS3ControllerSignWithBody>>,
        TError,
        UploadS3ControllerSignWithBodyMutationVariables,
        TContext
      > => {
      return useMutation(getUploadS3ControllerSignWithBodyMutationOptions(options), queryClient);
    }

export type uploadS3ControllerCreateMultipartResponse201 = {
  data: ResponseUploadS3MultipartCreateDto
  status: 201
}

export type uploadS3ControllerCreateMultipartResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type uploadS3ControllerCreateMultipartResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type uploadS3ControllerCreateMultipartResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type uploadS3ControllerCreateMultipartResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type uploadS3ControllerCreateMultipartResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type uploadS3ControllerCreateMultipartResponseSuccess = (uploadS3ControllerCreateMultipartResponse201) & {
  headers: Headers;
};
export type uploadS3ControllerCreateMultipartResponseError = (uploadS3ControllerCreateMultipartResponse400 | uploadS3ControllerCreateMultipartResponse401 | uploadS3ControllerCreateMultipartResponse403 | uploadS3ControllerCreateMultipartResponse404 | uploadS3ControllerCreateMultipartResponse500) & {
  headers: Headers;
};

export type uploadS3ControllerCreateMultipartResponse = (uploadS3ControllerCreateMultipartResponseSuccess | uploadS3ControllerCreateMultipartResponseError)

export const getUploadS3ControllerCreateMultipartUrl = () => {




  return `/upload/s3/multipart`
}

/**
 * Deprecated: replaced by POST upload/s3/presign, which signs every S3 operation for Uppy 6. Kept for clients that have not been updated yet.
 * @deprecated
 */
export const uploadS3ControllerCreateMultipart = async (createUploadS3MultipartDto: CreateUploadS3MultipartDto, options?: Parameters<typeof customFetch>[1]): Promise<uploadS3ControllerCreateMultipartResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<uploadS3ControllerCreateMultipartResponse>(getUploadS3ControllerCreateMultipartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUploadS3MultipartDto)
  }
);}





export const getUploadS3ControllerCreateMultipartMutationKey = () => ['uploadS3ControllerCreateMultipart'] as const;

export const getUploadS3ControllerCreateMultipartMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerCreateMultipart>>, TError,UploadS3ControllerCreateMultipartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerCreateMultipart>>, TError,UploadS3ControllerCreateMultipartMutationVariables, TContext> => {

const mutationKey = getUploadS3ControllerCreateMultipartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadS3ControllerCreateMultipart>>, UploadS3ControllerCreateMultipartMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadS3ControllerCreateMultipart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadS3ControllerCreateMultipartMutationResult = NonNullable<Awaited<ReturnType<typeof uploadS3ControllerCreateMultipart>>>
    export type UploadS3ControllerCreateMultipartMutationBody = CreateUploadS3MultipartDto
    export type UploadS3ControllerCreateMultipartMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UploadS3ControllerCreateMultipartMutationVariables = {data: CreateUploadS3MultipartDto}

    /**
 * @deprecated
 */
export const useUploadS3ControllerCreateMultipart = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerCreateMultipart>>, TError,UploadS3ControllerCreateMultipartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadS3ControllerCreateMultipart>>,
        TError,
        UploadS3ControllerCreateMultipartMutationVariables,
        TContext
      > => {
      return useMutation(getUploadS3ControllerCreateMultipartMutationOptions(options), queryClient);
    }

export type uploadS3ControllerSignMultipartPartResponse200 = {
  data: ResponseUploadS3MultipartSignPartDto
  status: 200
}

export type uploadS3ControllerSignMultipartPartResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type uploadS3ControllerSignMultipartPartResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type uploadS3ControllerSignMultipartPartResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type uploadS3ControllerSignMultipartPartResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type uploadS3ControllerSignMultipartPartResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type uploadS3ControllerSignMultipartPartResponseSuccess = (uploadS3ControllerSignMultipartPartResponse200) & {
  headers: Headers;
};
export type uploadS3ControllerSignMultipartPartResponseError = (uploadS3ControllerSignMultipartPartResponse400 | uploadS3ControllerSignMultipartPartResponse401 | uploadS3ControllerSignMultipartPartResponse403 | uploadS3ControllerSignMultipartPartResponse404 | uploadS3ControllerSignMultipartPartResponse500) & {
  headers: Headers;
};

export type uploadS3ControllerSignMultipartPartResponse = (uploadS3ControllerSignMultipartPartResponseSuccess | uploadS3ControllerSignMultipartPartResponseError)

export const getUploadS3ControllerSignMultipartPartUrl = (uploadId: string,
    partNumber: number,
    params: UploadS3ControllerSignMultipartPartParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/upload/s3/multipart/${uploadId}/${partNumber}?${stringifiedParams}` : `/upload/s3/multipart/${uploadId}/${partNumber}`
}

/**
 * Deprecated: replaced by POST upload/s3/presign, which signs every S3 operation for Uppy 6. Kept for clients that have not been updated yet.
 * @deprecated
 */
export const uploadS3ControllerSignMultipartPart = async (uploadId: string,
    partNumber: number,
    params: UploadS3ControllerSignMultipartPartParams, options?: Parameters<typeof customFetch>[1]): Promise<uploadS3ControllerSignMultipartPartResponse> => {

  return customFetch<uploadS3ControllerSignMultipartPartResponse>(getUploadS3ControllerSignMultipartPartUrl(uploadId,partNumber,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUploadS3ControllerSignMultipartPartQueryKey = (uploadId: MaybeRefOrGetter<string>,
    partNumber: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<UploadS3ControllerSignMultipartPartParams>,) => {
    return [
    'upload','s3','multipart',uploadId,partNumber, ...(params ? [params] : [])
    ] as const;
    }


export const getUploadS3ControllerSignMultipartPartQueryOptions = <TData = Awaited<ReturnType<typeof uploadS3ControllerSignMultipartPart>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(uploadId: MaybeRefOrGetter<string>,
    partNumber: MaybeRefOrGetter<number>,
    params: MaybeRefOrGetter<UploadS3ControllerSignMultipartPartParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerSignMultipartPart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUploadS3ControllerSignMultipartPartQueryKey(uploadId,partNumber,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof uploadS3ControllerSignMultipartPart>>> = ({ signal }) => uploadS3ControllerSignMultipartPart(toValue(uploadId),toValue(partNumber),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(uploadId) !== null && toValue(uploadId) !== undefined && toValue(partNumber) !== null && toValue(partNumber) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerSignMultipartPart>>, TError, TData>
}

export type UploadS3ControllerSignMultipartPartQueryResult = NonNullable<Awaited<ReturnType<typeof uploadS3ControllerSignMultipartPart>>>
export type UploadS3ControllerSignMultipartPartQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @deprecated
 */

export function useUploadS3ControllerSignMultipartPart<TData = Awaited<ReturnType<typeof uploadS3ControllerSignMultipartPart>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 uploadId: MaybeRefOrGetter<string>,
    partNumber: MaybeRefOrGetter<number>,
    params: MaybeRefOrGetter<UploadS3ControllerSignMultipartPartParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerSignMultipartPart>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUploadS3ControllerSignMultipartPartQueryOptions(uploadId,partNumber,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type uploadS3ControllerListMultipartPartsResponse200 = {
  data: ResponseUploadS3MultipartPartDto[]
  status: 200
}

export type uploadS3ControllerListMultipartPartsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type uploadS3ControllerListMultipartPartsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type uploadS3ControllerListMultipartPartsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type uploadS3ControllerListMultipartPartsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type uploadS3ControllerListMultipartPartsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type uploadS3ControllerListMultipartPartsResponseSuccess = (uploadS3ControllerListMultipartPartsResponse200) & {
  headers: Headers;
};
export type uploadS3ControllerListMultipartPartsResponseError = (uploadS3ControllerListMultipartPartsResponse400 | uploadS3ControllerListMultipartPartsResponse401 | uploadS3ControllerListMultipartPartsResponse403 | uploadS3ControllerListMultipartPartsResponse404 | uploadS3ControllerListMultipartPartsResponse500) & {
  headers: Headers;
};

export type uploadS3ControllerListMultipartPartsResponse = (uploadS3ControllerListMultipartPartsResponseSuccess | uploadS3ControllerListMultipartPartsResponseError)

export const getUploadS3ControllerListMultipartPartsUrl = (uploadId: string,
    params: UploadS3ControllerListMultipartPartsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/upload/s3/multipart/${uploadId}?${stringifiedParams}` : `/upload/s3/multipart/${uploadId}`
}

/**
 * Deprecated: replaced by POST upload/s3/presign, which signs every S3 operation for Uppy 6. Kept for clients that have not been updated yet.
 * @deprecated
 */
export const uploadS3ControllerListMultipartParts = async (uploadId: string,
    params: UploadS3ControllerListMultipartPartsParams, options?: Parameters<typeof customFetch>[1]): Promise<uploadS3ControllerListMultipartPartsResponse> => {

  return customFetch<uploadS3ControllerListMultipartPartsResponse>(getUploadS3ControllerListMultipartPartsUrl(uploadId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUploadS3ControllerListMultipartPartsQueryKey = (uploadId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<UploadS3ControllerListMultipartPartsParams>,) => {
    return [
    'upload','s3','multipart',uploadId, ...(params ? [params] : [])
    ] as const;
    }


export const getUploadS3ControllerListMultipartPartsQueryOptions = <TData = Awaited<ReturnType<typeof uploadS3ControllerListMultipartParts>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(uploadId: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<UploadS3ControllerListMultipartPartsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerListMultipartParts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getUploadS3ControllerListMultipartPartsQueryKey(uploadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof uploadS3ControllerListMultipartParts>>> = ({ signal }) => uploadS3ControllerListMultipartParts(toValue(uploadId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(uploadId) !== null && toValue(uploadId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerListMultipartParts>>, TError, TData>
}

export type UploadS3ControllerListMultipartPartsQueryResult = NonNullable<Awaited<ReturnType<typeof uploadS3ControllerListMultipartParts>>>
export type UploadS3ControllerListMultipartPartsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @deprecated
 */

export function useUploadS3ControllerListMultipartParts<TData = Awaited<ReturnType<typeof uploadS3ControllerListMultipartParts>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 uploadId: MaybeRefOrGetter<string>,
    params: MaybeRefOrGetter<UploadS3ControllerListMultipartPartsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uploadS3ControllerListMultipartParts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUploadS3ControllerListMultipartPartsQueryOptions(uploadId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type uploadS3ControllerAbortMultipartResponse200 = {
  data: ResponseUploadS3MultipartAbortDto
  status: 200
}

export type uploadS3ControllerAbortMultipartResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type uploadS3ControllerAbortMultipartResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type uploadS3ControllerAbortMultipartResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type uploadS3ControllerAbortMultipartResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type uploadS3ControllerAbortMultipartResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type uploadS3ControllerAbortMultipartResponseSuccess = (uploadS3ControllerAbortMultipartResponse200) & {
  headers: Headers;
};
export type uploadS3ControllerAbortMultipartResponseError = (uploadS3ControllerAbortMultipartResponse400 | uploadS3ControllerAbortMultipartResponse401 | uploadS3ControllerAbortMultipartResponse403 | uploadS3ControllerAbortMultipartResponse404 | uploadS3ControllerAbortMultipartResponse500) & {
  headers: Headers;
};

export type uploadS3ControllerAbortMultipartResponse = (uploadS3ControllerAbortMultipartResponseSuccess | uploadS3ControllerAbortMultipartResponseError)

export const getUploadS3ControllerAbortMultipartUrl = (uploadId: string,
    params: UploadS3ControllerAbortMultipartParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/upload/s3/multipart/${uploadId}?${stringifiedParams}` : `/upload/s3/multipart/${uploadId}`
}

/**
 * Deprecated: replaced by POST upload/s3/presign, which signs every S3 operation for Uppy 6. Kept for clients that have not been updated yet.
 * @deprecated
 */
export const uploadS3ControllerAbortMultipart = async (uploadId: string,
    params: UploadS3ControllerAbortMultipartParams, options?: Parameters<typeof customFetch>[1]): Promise<uploadS3ControllerAbortMultipartResponse> => {

  return customFetch<uploadS3ControllerAbortMultipartResponse>(getUploadS3ControllerAbortMultipartUrl(uploadId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUploadS3ControllerAbortMultipartMutationKey = () => ['uploadS3ControllerAbortMultipart'] as const;

export const getUploadS3ControllerAbortMultipartMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerAbortMultipart>>, TError,UploadS3ControllerAbortMultipartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerAbortMultipart>>, TError,UploadS3ControllerAbortMultipartMutationVariables, TContext> => {

const mutationKey = getUploadS3ControllerAbortMultipartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadS3ControllerAbortMultipart>>, UploadS3ControllerAbortMultipartMutationVariables> = (props) => {
          const {uploadId,params} = props ?? {};

          return  uploadS3ControllerAbortMultipart(uploadId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadS3ControllerAbortMultipartMutationResult = NonNullable<Awaited<ReturnType<typeof uploadS3ControllerAbortMultipart>>>

    export type UploadS3ControllerAbortMultipartMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UploadS3ControllerAbortMultipartMutationVariables = {uploadId: string;params: UploadS3ControllerAbortMultipartParams}

    /**
 * @deprecated
 */
export const useUploadS3ControllerAbortMultipart = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerAbortMultipart>>, TError,UploadS3ControllerAbortMultipartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadS3ControllerAbortMultipart>>,
        TError,
        UploadS3ControllerAbortMultipartMutationVariables,
        TContext
      > => {
      return useMutation(getUploadS3ControllerAbortMultipartMutationOptions(options), queryClient);
    }

export type uploadS3ControllerCompleteMultipartResponse201 = {
  data: ResponseUploadS3MultipartCompleteDto
  status: 201
}

export type uploadS3ControllerCompleteMultipartResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type uploadS3ControllerCompleteMultipartResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type uploadS3ControllerCompleteMultipartResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type uploadS3ControllerCompleteMultipartResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type uploadS3ControllerCompleteMultipartResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type uploadS3ControllerCompleteMultipartResponseSuccess = (uploadS3ControllerCompleteMultipartResponse201) & {
  headers: Headers;
};
export type uploadS3ControllerCompleteMultipartResponseError = (uploadS3ControllerCompleteMultipartResponse400 | uploadS3ControllerCompleteMultipartResponse401 | uploadS3ControllerCompleteMultipartResponse403 | uploadS3ControllerCompleteMultipartResponse404 | uploadS3ControllerCompleteMultipartResponse500) & {
  headers: Headers;
};

export type uploadS3ControllerCompleteMultipartResponse = (uploadS3ControllerCompleteMultipartResponseSuccess | uploadS3ControllerCompleteMultipartResponseError)

export const getUploadS3ControllerCompleteMultipartUrl = (uploadId: string,
    params: UploadS3ControllerCompleteMultipartParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/upload/s3/multipart/${uploadId}/complete?${stringifiedParams}` : `/upload/s3/multipart/${uploadId}/complete`
}

/**
 * Deprecated: replaced by POST upload/s3/presign, which signs every S3 operation for Uppy 6. Kept for clients that have not been updated yet.
 * @deprecated
 */
export const uploadS3ControllerCompleteMultipart = async (uploadId: string,
    uploadS3MultipartCompleteBodyDto: UploadS3MultipartCompleteBodyDto,
    params: UploadS3ControllerCompleteMultipartParams, options?: Parameters<typeof customFetch>[1]): Promise<uploadS3ControllerCompleteMultipartResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<uploadS3ControllerCompleteMultipartResponse>(getUploadS3ControllerCompleteMultipartUrl(uploadId,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadS3MultipartCompleteBodyDto)
  }
);}





export const getUploadS3ControllerCompleteMultipartMutationKey = () => ['uploadS3ControllerCompleteMultipart'] as const;

export const getUploadS3ControllerCompleteMultipartMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerCompleteMultipart>>, TError,UploadS3ControllerCompleteMultipartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerCompleteMultipart>>, TError,UploadS3ControllerCompleteMultipartMutationVariables, TContext> => {

const mutationKey = getUploadS3ControllerCompleteMultipartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadS3ControllerCompleteMultipart>>, UploadS3ControllerCompleteMultipartMutationVariables> = (props) => {
          const {uploadId,data,params} = props ?? {};

          return  uploadS3ControllerCompleteMultipart(uploadId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadS3ControllerCompleteMultipartMutationResult = NonNullable<Awaited<ReturnType<typeof uploadS3ControllerCompleteMultipart>>>
    export type UploadS3ControllerCompleteMultipartMutationBody = UploadS3MultipartCompleteBodyDto
    export type UploadS3ControllerCompleteMultipartMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type UploadS3ControllerCompleteMultipartMutationVariables = {uploadId: string;data: UploadS3MultipartCompleteBodyDto;params: UploadS3ControllerCompleteMultipartParams}

    /**
 * @deprecated
 */
export const useUploadS3ControllerCompleteMultipart = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadS3ControllerCompleteMultipart>>, TError,UploadS3ControllerCompleteMultipartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof uploadS3ControllerCompleteMultipart>>,
        TError,
        UploadS3ControllerCompleteMultipartMutationVariables,
        TContext
      > => {
      return useMutation(getUploadS3ControllerCompleteMultipartMutationOptions(options), queryClient);
    }

export type offerTemplateControllerCreateResponse201 = {
  data: ResponseOfferTemplateDto
  status: 201
}

export type offerTemplateControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTemplateControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTemplateControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTemplateControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTemplateControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTemplateControllerCreateResponseSuccess = (offerTemplateControllerCreateResponse201) & {
  headers: Headers;
};
export type offerTemplateControllerCreateResponseError = (offerTemplateControllerCreateResponse400 | offerTemplateControllerCreateResponse401 | offerTemplateControllerCreateResponse403 | offerTemplateControllerCreateResponse404 | offerTemplateControllerCreateResponse500) & {
  headers: Headers;
};

export type offerTemplateControllerCreateResponse = (offerTemplateControllerCreateResponseSuccess | offerTemplateControllerCreateResponseError)

export const getOfferTemplateControllerCreateUrl = () => {




  return `/offer-template`
}

export const offerTemplateControllerCreate = async (createOfferTemplateDto: CreateOfferTemplateDto, options?: Parameters<typeof customFetch>[1]): Promise<offerTemplateControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerTemplateControllerCreateResponse>(getOfferTemplateControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferTemplateDto)
  }
);}





export const getOfferTemplateControllerCreateMutationKey = () => ['offerTemplateControllerCreate'] as const;

export const getOfferTemplateControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerCreate>>, TError,OfferTemplateControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerCreate>>, TError,OfferTemplateControllerCreateMutationVariables, TContext> => {

const mutationKey = getOfferTemplateControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerTemplateControllerCreate>>, OfferTemplateControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  offerTemplateControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferTemplateControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof offerTemplateControllerCreate>>>
    export type OfferTemplateControllerCreateMutationBody = CreateOfferTemplateDto
    export type OfferTemplateControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferTemplateControllerCreateMutationVariables = {data: CreateOfferTemplateDto}

    export const useOfferTemplateControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerCreate>>, TError,OfferTemplateControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerTemplateControllerCreate>>,
        TError,
        OfferTemplateControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferTemplateControllerCreateMutationOptions(options), queryClient);
    }

export type offerTemplateControllerFindAllResponse200 = {
  data: OfferTemplateControllerFindAll200
  status: 200
}

export type offerTemplateControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTemplateControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTemplateControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTemplateControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTemplateControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTemplateControllerFindAllResponseSuccess = (offerTemplateControllerFindAllResponse200) & {
  headers: Headers;
};
export type offerTemplateControllerFindAllResponseError = (offerTemplateControllerFindAllResponse400 | offerTemplateControllerFindAllResponse401 | offerTemplateControllerFindAllResponse403 | offerTemplateControllerFindAllResponse404 | offerTemplateControllerFindAllResponse500) & {
  headers: Headers;
};

export type offerTemplateControllerFindAllResponse = (offerTemplateControllerFindAllResponseSuccess | offerTemplateControllerFindAllResponseError)

export const getOfferTemplateControllerFindAllUrl = (params?: OfferTemplateControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.guides.guideName","filter.offer.id","filter.offer.status","filter.createdBy.id","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer-template?${stringifiedParams}` : `/offer-template`
}

export const offerTemplateControllerFindAll = async (params?: OfferTemplateControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<offerTemplateControllerFindAllResponse> => {

  return customFetch<offerTemplateControllerFindAllResponse>(getOfferTemplateControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferTemplateControllerFindAllQueryKey = (params?: MaybeRefOrGetter<OfferTemplateControllerFindAllParams>,) => {
    return [
    'offer-template', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferTemplateControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof offerTemplateControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<OfferTemplateControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferTemplateControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerTemplateControllerFindAll>>> = ({ signal }) => offerTemplateControllerFindAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindAll>>, TError, TData>
}

export type OfferTemplateControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof offerTemplateControllerFindAll>>>
export type OfferTemplateControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferTemplateControllerFindAll<TData = Awaited<ReturnType<typeof offerTemplateControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<OfferTemplateControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferTemplateControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerTemplateControllerFindAllByGuideResponse200 = {
  data: ResponseOfferTemplateDto[]
  status: 200
}

export type offerTemplateControllerFindAllByGuideResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTemplateControllerFindAllByGuideResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTemplateControllerFindAllByGuideResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTemplateControllerFindAllByGuideResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTemplateControllerFindAllByGuideResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTemplateControllerFindAllByGuideResponseSuccess = (offerTemplateControllerFindAllByGuideResponse200) & {
  headers: Headers;
};
export type offerTemplateControllerFindAllByGuideResponseError = (offerTemplateControllerFindAllByGuideResponse400 | offerTemplateControllerFindAllByGuideResponse401 | offerTemplateControllerFindAllByGuideResponse403 | offerTemplateControllerFindAllByGuideResponse404 | offerTemplateControllerFindAllByGuideResponse500) & {
  headers: Headers;
};

export type offerTemplateControllerFindAllByGuideResponse = (offerTemplateControllerFindAllByGuideResponseSuccess | offerTemplateControllerFindAllByGuideResponseError)

export const getOfferTemplateControllerFindAllByGuideUrl = (guide: string,) => {




  return `/offer-template/by-guide/${guide}`
}

export const offerTemplateControllerFindAllByGuide = async (guide: string, options?: Parameters<typeof customFetch>[1]): Promise<offerTemplateControllerFindAllByGuideResponse> => {

  return customFetch<offerTemplateControllerFindAllByGuideResponse>(getOfferTemplateControllerFindAllByGuideUrl(guide),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferTemplateControllerFindAllByGuideQueryKey = (guide: MaybeRefOrGetter<string>,) => {
    return [
    'offer-template','by-guide',guide
    ] as const;
    }


export const getOfferTemplateControllerFindAllByGuideQueryOptions = <TData = Awaited<ReturnType<typeof offerTemplateControllerFindAllByGuide>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(guide: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindAllByGuide>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferTemplateControllerFindAllByGuideQueryKey(guide);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerTemplateControllerFindAllByGuide>>> = ({ signal }) => offerTemplateControllerFindAllByGuide(toValue(guide), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(guide) !== null && toValue(guide) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindAllByGuide>>, TError, TData>
}

export type OfferTemplateControllerFindAllByGuideQueryResult = NonNullable<Awaited<ReturnType<typeof offerTemplateControllerFindAllByGuide>>>
export type OfferTemplateControllerFindAllByGuideQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferTemplateControllerFindAllByGuide<TData = Awaited<ReturnType<typeof offerTemplateControllerFindAllByGuide>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 guide: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindAllByGuide>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferTemplateControllerFindAllByGuideQueryOptions(guide,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerTemplateControllerFindOneResponse200 = {
  data: ResponseOfferTemplateDto
  status: 200
}

export type offerTemplateControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTemplateControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTemplateControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTemplateControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTemplateControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTemplateControllerFindOneResponseSuccess = (offerTemplateControllerFindOneResponse200) & {
  headers: Headers;
};
export type offerTemplateControllerFindOneResponseError = (offerTemplateControllerFindOneResponse400 | offerTemplateControllerFindOneResponse401 | offerTemplateControllerFindOneResponse403 | offerTemplateControllerFindOneResponse404 | offerTemplateControllerFindOneResponse500) & {
  headers: Headers;
};

export type offerTemplateControllerFindOneResponse = (offerTemplateControllerFindOneResponseSuccess | offerTemplateControllerFindOneResponseError)

export const getOfferTemplateControllerFindOneUrl = (templateId: number,) => {




  return `/offer-template/${templateId}`
}

export const offerTemplateControllerFindOne = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerTemplateControllerFindOneResponse> => {

  return customFetch<offerTemplateControllerFindOneResponse>(getOfferTemplateControllerFindOneUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferTemplateControllerFindOneQueryKey = (templateId: MaybeRefOrGetter<number>,) => {
    return [
    'offer-template',templateId
    ] as const;
    }


export const getOfferTemplateControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof offerTemplateControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(templateId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferTemplateControllerFindOneQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerTemplateControllerFindOne>>> = ({ signal }) => offerTemplateControllerFindOne(toValue(templateId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(templateId) !== null && toValue(templateId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindOne>>, TError, TData>
}

export type OfferTemplateControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof offerTemplateControllerFindOne>>>
export type OfferTemplateControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferTemplateControllerFindOne<TData = Awaited<ReturnType<typeof offerTemplateControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 templateId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTemplateControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferTemplateControllerFindOneQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerTemplateControllerUpdateResponse200 = {
  data: ResponseOfferTemplateDto
  status: 200
}

export type offerTemplateControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTemplateControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTemplateControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTemplateControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTemplateControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTemplateControllerUpdateResponseSuccess = (offerTemplateControllerUpdateResponse200) & {
  headers: Headers;
};
export type offerTemplateControllerUpdateResponseError = (offerTemplateControllerUpdateResponse400 | offerTemplateControllerUpdateResponse401 | offerTemplateControllerUpdateResponse403 | offerTemplateControllerUpdateResponse404 | offerTemplateControllerUpdateResponse500) & {
  headers: Headers;
};

export type offerTemplateControllerUpdateResponse = (offerTemplateControllerUpdateResponseSuccess | offerTemplateControllerUpdateResponseError)

export const getOfferTemplateControllerUpdateUrl = (templateId: number,) => {




  return `/offer-template/${templateId}`
}

export const offerTemplateControllerUpdate = async (templateId: number,
    updateOfferTemplateDto: UpdateOfferTemplateDto, options?: Parameters<typeof customFetch>[1]): Promise<offerTemplateControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerTemplateControllerUpdateResponse>(getOfferTemplateControllerUpdateUrl(templateId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOfferTemplateDto)
  }
);}





export const getOfferTemplateControllerUpdateMutationKey = () => ['offerTemplateControllerUpdate'] as const;

export const getOfferTemplateControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerUpdate>>, TError,OfferTemplateControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerUpdate>>, TError,OfferTemplateControllerUpdateMutationVariables, TContext> => {

const mutationKey = getOfferTemplateControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerTemplateControllerUpdate>>, OfferTemplateControllerUpdateMutationVariables> = (props) => {
          const {templateId,data} = props ?? {};

          return  offerTemplateControllerUpdate(templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferTemplateControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof offerTemplateControllerUpdate>>>
    export type OfferTemplateControllerUpdateMutationBody = UpdateOfferTemplateDto
    export type OfferTemplateControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferTemplateControllerUpdateMutationVariables = {templateId: number;data: UpdateOfferTemplateDto}

    export const useOfferTemplateControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerUpdate>>, TError,OfferTemplateControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerTemplateControllerUpdate>>,
        TError,
        OfferTemplateControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferTemplateControllerUpdateMutationOptions(options), queryClient);
    }

export type offerTemplateControllerRemoveResponse200 = {
  data: ResponseOfferTemplateDto
  status: 200
}

export type offerTemplateControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTemplateControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTemplateControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTemplateControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTemplateControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTemplateControllerRemoveResponseSuccess = (offerTemplateControllerRemoveResponse200) & {
  headers: Headers;
};
export type offerTemplateControllerRemoveResponseError = (offerTemplateControllerRemoveResponse400 | offerTemplateControllerRemoveResponse401 | offerTemplateControllerRemoveResponse403 | offerTemplateControllerRemoveResponse404 | offerTemplateControllerRemoveResponse500) & {
  headers: Headers;
};

export type offerTemplateControllerRemoveResponse = (offerTemplateControllerRemoveResponseSuccess | offerTemplateControllerRemoveResponseError)

export const getOfferTemplateControllerRemoveUrl = (templateId: number,) => {




  return `/offer-template/${templateId}`
}

export const offerTemplateControllerRemove = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerTemplateControllerRemoveResponse> => {

  return customFetch<offerTemplateControllerRemoveResponse>(getOfferTemplateControllerRemoveUrl(templateId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getOfferTemplateControllerRemoveMutationKey = () => ['offerTemplateControllerRemove'] as const;

export const getOfferTemplateControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerRemove>>, TError,OfferTemplateControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerRemove>>, TError,OfferTemplateControllerRemoveMutationVariables, TContext> => {

const mutationKey = getOfferTemplateControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerTemplateControllerRemove>>, OfferTemplateControllerRemoveMutationVariables> = (props) => {
          const {templateId} = props ?? {};

          return  offerTemplateControllerRemove(templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferTemplateControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof offerTemplateControllerRemove>>>

    export type OfferTemplateControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferTemplateControllerRemoveMutationVariables = {templateId: number}

    export const useOfferTemplateControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerRemove>>, TError,OfferTemplateControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerTemplateControllerRemove>>,
        TError,
        OfferTemplateControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getOfferTemplateControllerRemoveMutationOptions(options), queryClient);
    }

export type offerTemplateControllerInstantiateResponse201 = {
  data: ResponseOfferDto
  status: 201
}

export type offerTemplateControllerInstantiateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTemplateControllerInstantiateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTemplateControllerInstantiateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTemplateControllerInstantiateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTemplateControllerInstantiateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTemplateControllerInstantiateResponseSuccess = (offerTemplateControllerInstantiateResponse201) & {
  headers: Headers;
};
export type offerTemplateControllerInstantiateResponseError = (offerTemplateControllerInstantiateResponse400 | offerTemplateControllerInstantiateResponse401 | offerTemplateControllerInstantiateResponse403 | offerTemplateControllerInstantiateResponse404 | offerTemplateControllerInstantiateResponse500) & {
  headers: Headers;
};

export type offerTemplateControllerInstantiateResponse = (offerTemplateControllerInstantiateResponseSuccess | offerTemplateControllerInstantiateResponseError)

export const getOfferTemplateControllerInstantiateUrl = (templateId: number,) => {




  return `/offer-template/${templateId}/instantiate`
}

export const offerTemplateControllerInstantiate = async (templateId: number,
    instantiateOfferTemplateDto: InstantiateOfferTemplateDto, options?: Parameters<typeof customFetch>[1]): Promise<offerTemplateControllerInstantiateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerTemplateControllerInstantiateResponse>(getOfferTemplateControllerInstantiateUrl(templateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(instantiateOfferTemplateDto)
  }
);}





export const getOfferTemplateControllerInstantiateMutationKey = () => ['offerTemplateControllerInstantiate'] as const;

export const getOfferTemplateControllerInstantiateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerInstantiate>>, TError,OfferTemplateControllerInstantiateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerInstantiate>>, TError,OfferTemplateControllerInstantiateMutationVariables, TContext> => {

const mutationKey = getOfferTemplateControllerInstantiateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerTemplateControllerInstantiate>>, OfferTemplateControllerInstantiateMutationVariables> = (props) => {
          const {templateId,data} = props ?? {};

          return  offerTemplateControllerInstantiate(templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferTemplateControllerInstantiateMutationResult = NonNullable<Awaited<ReturnType<typeof offerTemplateControllerInstantiate>>>
    export type OfferTemplateControllerInstantiateMutationBody = InstantiateOfferTemplateDto
    export type OfferTemplateControllerInstantiateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferTemplateControllerInstantiateMutationVariables = {templateId: number;data: InstantiateOfferTemplateDto}

    export const useOfferTemplateControllerInstantiate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTemplateControllerInstantiate>>, TError,OfferTemplateControllerInstantiateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerTemplateControllerInstantiate>>,
        TError,
        OfferTemplateControllerInstantiateMutationVariables,
        TContext
      > => {
      return useMutation(getOfferTemplateControllerInstantiateMutationOptions(options), queryClient);
    }

export type logOfferItemPriceControllerFindAllForOfferResponse200 = {
  data: LogOfferItemPriceControllerFindAllForOffer200
  status: 200
}

export type logOfferItemPriceControllerFindAllForOfferResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logOfferItemPriceControllerFindAllForOfferResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logOfferItemPriceControllerFindAllForOfferResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logOfferItemPriceControllerFindAllForOfferResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logOfferItemPriceControllerFindAllForOfferResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logOfferItemPriceControllerFindAllForOfferResponseSuccess = (logOfferItemPriceControllerFindAllForOfferResponse200) & {
  headers: Headers;
};
export type logOfferItemPriceControllerFindAllForOfferResponseError = (logOfferItemPriceControllerFindAllForOfferResponse400 | logOfferItemPriceControllerFindAllForOfferResponse401 | logOfferItemPriceControllerFindAllForOfferResponse403 | logOfferItemPriceControllerFindAllForOfferResponse404 | logOfferItemPriceControllerFindAllForOfferResponse500) & {
  headers: Headers;
};

export type logOfferItemPriceControllerFindAllForOfferResponse = (logOfferItemPriceControllerFindAllForOfferResponseSuccess | logOfferItemPriceControllerFindAllForOfferResponseError)

export const getLogOfferItemPriceControllerFindAllForOfferUrl = (offerId: number,
    params?: LogOfferItemPriceControllerFindAllForOfferParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.offer.id","filter.item.id","filter.reviewReason","filter.priceType","filter.timestamp","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/offer/${offerId}/item/price?${stringifiedParams}` : `/log/offer/${offerId}/item/price`
}

export const logOfferItemPriceControllerFindAllForOffer = async (offerId: number,
    params?: LogOfferItemPriceControllerFindAllForOfferParams, options?: Parameters<typeof customFetch>[1]): Promise<logOfferItemPriceControllerFindAllForOfferResponse> => {

  return customFetch<logOfferItemPriceControllerFindAllForOfferResponse>(getLogOfferItemPriceControllerFindAllForOfferUrl(offerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogOfferItemPriceControllerFindAllForOfferQueryKey = (offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferItemPriceControllerFindAllForOfferParams>,) => {
    return [
    'log','offer',offerId,'item','price', ...(params ? [params] : [])
    ] as const;
    }


export const getLogOfferItemPriceControllerFindAllForOfferQueryOptions = <TData = Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferItemPriceControllerFindAllForOfferParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogOfferItemPriceControllerFindAllForOfferQueryKey(offerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOffer>>> = ({ signal }) => logOfferItemPriceControllerFindAllForOffer(toValue(offerId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOffer>>, TError, TData>
}

export type LogOfferItemPriceControllerFindAllForOfferQueryResult = NonNullable<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOffer>>>
export type LogOfferItemPriceControllerFindAllForOfferQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogOfferItemPriceControllerFindAllForOffer<TData = Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferItemPriceControllerFindAllForOfferParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogOfferItemPriceControllerFindAllForOfferQueryOptions(offerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type logOfferItemPriceControllerFindAllForOfferItemResponse200 = {
  data: LogOfferItemPriceControllerFindAllForOfferItem200
  status: 200
}

export type logOfferItemPriceControllerFindAllForOfferItemResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logOfferItemPriceControllerFindAllForOfferItemResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logOfferItemPriceControllerFindAllForOfferItemResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logOfferItemPriceControllerFindAllForOfferItemResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logOfferItemPriceControllerFindAllForOfferItemResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logOfferItemPriceControllerFindAllForOfferItemResponseSuccess = (logOfferItemPriceControllerFindAllForOfferItemResponse200) & {
  headers: Headers;
};
export type logOfferItemPriceControllerFindAllForOfferItemResponseError = (logOfferItemPriceControllerFindAllForOfferItemResponse400 | logOfferItemPriceControllerFindAllForOfferItemResponse401 | logOfferItemPriceControllerFindAllForOfferItemResponse403 | logOfferItemPriceControllerFindAllForOfferItemResponse404 | logOfferItemPriceControllerFindAllForOfferItemResponse500) & {
  headers: Headers;
};

export type logOfferItemPriceControllerFindAllForOfferItemResponse = (logOfferItemPriceControllerFindAllForOfferItemResponseSuccess | logOfferItemPriceControllerFindAllForOfferItemResponseError)

export const getLogOfferItemPriceControllerFindAllForOfferItemUrl = (offerId: number,
    itemId: number,
    params?: LogOfferItemPriceControllerFindAllForOfferItemParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.offer.id","filter.item.id","filter.reviewReason","filter.priceType","filter.timestamp","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/offer/${offerId}/item/${itemId}/price?${stringifiedParams}` : `/log/offer/${offerId}/item/${itemId}/price`
}

export const logOfferItemPriceControllerFindAllForOfferItem = async (offerId: number,
    itemId: number,
    params?: LogOfferItemPriceControllerFindAllForOfferItemParams, options?: Parameters<typeof customFetch>[1]): Promise<logOfferItemPriceControllerFindAllForOfferItemResponse> => {

  return customFetch<logOfferItemPriceControllerFindAllForOfferItemResponse>(getLogOfferItemPriceControllerFindAllForOfferItemUrl(offerId,itemId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogOfferItemPriceControllerFindAllForOfferItemQueryKey = (offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferItemPriceControllerFindAllForOfferItemParams>,) => {
    return [
    'log','offer',offerId,'item',itemId,'price', ...(params ? [params] : [])
    ] as const;
    }


export const getLogOfferItemPriceControllerFindAllForOfferItemQueryOptions = <TData = Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOfferItem>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferItemPriceControllerFindAllForOfferItemParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOfferItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogOfferItemPriceControllerFindAllForOfferItemQueryKey(offerId,itemId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOfferItem>>> = ({ signal }) => logOfferItemPriceControllerFindAllForOfferItem(toValue(offerId),toValue(itemId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined && toValue(itemId) !== null && toValue(itemId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOfferItem>>, TError, TData>
}

export type LogOfferItemPriceControllerFindAllForOfferItemQueryResult = NonNullable<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOfferItem>>>
export type LogOfferItemPriceControllerFindAllForOfferItemQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogOfferItemPriceControllerFindAllForOfferItem<TData = Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOfferItem>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferItemPriceControllerFindAllForOfferItemParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logOfferItemPriceControllerFindAllForOfferItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogOfferItemPriceControllerFindAllForOfferItemQueryOptions(offerId,itemId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type transactionControllerGetAllTransactionsForOfferResponse200 = {
  data: ResponseOfferTransactionDto[]
  status: 200
}

export type transactionControllerGetAllTransactionsForOfferResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type transactionControllerGetAllTransactionsForOfferResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type transactionControllerGetAllTransactionsForOfferResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type transactionControllerGetAllTransactionsForOfferResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type transactionControllerGetAllTransactionsForOfferResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type transactionControllerGetAllTransactionsForOfferResponseSuccess = (transactionControllerGetAllTransactionsForOfferResponse200) & {
  headers: Headers;
};
export type transactionControllerGetAllTransactionsForOfferResponseError = (transactionControllerGetAllTransactionsForOfferResponse400 | transactionControllerGetAllTransactionsForOfferResponse401 | transactionControllerGetAllTransactionsForOfferResponse403 | transactionControllerGetAllTransactionsForOfferResponse404 | transactionControllerGetAllTransactionsForOfferResponse500) & {
  headers: Headers;
};

export type transactionControllerGetAllTransactionsForOfferResponse = (transactionControllerGetAllTransactionsForOfferResponseSuccess | transactionControllerGetAllTransactionsForOfferResponseError)

export const getTransactionControllerGetAllTransactionsForOfferUrl = (offerId: number,) => {




  return `/transaction/for-offer/${offerId}`
}

export const transactionControllerGetAllTransactionsForOffer = async (offerId: number, options?: Parameters<typeof customFetch>[1]): Promise<transactionControllerGetAllTransactionsForOfferResponse> => {

  return customFetch<transactionControllerGetAllTransactionsForOfferResponse>(getTransactionControllerGetAllTransactionsForOfferUrl(offerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTransactionControllerGetAllTransactionsForOfferQueryKey = (offerId: MaybeRefOrGetter<number>,) => {
    return [
    'transaction','for-offer',offerId
    ] as const;
    }


export const getTransactionControllerGetAllTransactionsForOfferQueryOptions = <TData = Awaited<ReturnType<typeof transactionControllerGetAllTransactionsForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionControllerGetAllTransactionsForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getTransactionControllerGetAllTransactionsForOfferQueryKey(offerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionControllerGetAllTransactionsForOffer>>> = ({ signal }) => transactionControllerGetAllTransactionsForOffer(toValue(offerId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionControllerGetAllTransactionsForOffer>>, TError, TData>
}

export type TransactionControllerGetAllTransactionsForOfferQueryResult = NonNullable<Awaited<ReturnType<typeof transactionControllerGetAllTransactionsForOffer>>>
export type TransactionControllerGetAllTransactionsForOfferQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useTransactionControllerGetAllTransactionsForOffer<TData = Awaited<ReturnType<typeof transactionControllerGetAllTransactionsForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionControllerGetAllTransactionsForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTransactionControllerGetAllTransactionsForOfferQueryOptions(offerId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type transactionControllerGetTransactionResponse200 = {
  data: ResponseOfferTransactionDto
  status: 200
}

export type transactionControllerGetTransactionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type transactionControllerGetTransactionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type transactionControllerGetTransactionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type transactionControllerGetTransactionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type transactionControllerGetTransactionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type transactionControllerGetTransactionResponseSuccess = (transactionControllerGetTransactionResponse200) & {
  headers: Headers;
};
export type transactionControllerGetTransactionResponseError = (transactionControllerGetTransactionResponse400 | transactionControllerGetTransactionResponse401 | transactionControllerGetTransactionResponse403 | transactionControllerGetTransactionResponse404 | transactionControllerGetTransactionResponse500) & {
  headers: Headers;
};

export type transactionControllerGetTransactionResponse = (transactionControllerGetTransactionResponseSuccess | transactionControllerGetTransactionResponseError)

export const getTransactionControllerGetTransactionUrl = (transactionId: number,) => {




  return `/transaction/${transactionId}`
}

export const transactionControllerGetTransaction = async (transactionId: number, options?: Parameters<typeof customFetch>[1]): Promise<transactionControllerGetTransactionResponse> => {

  return customFetch<transactionControllerGetTransactionResponse>(getTransactionControllerGetTransactionUrl(transactionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTransactionControllerGetTransactionQueryKey = (transactionId: MaybeRefOrGetter<number>,) => {
    return [
    'transaction',transactionId
    ] as const;
    }


export const getTransactionControllerGetTransactionQueryOptions = <TData = Awaited<ReturnType<typeof transactionControllerGetTransaction>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(transactionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionControllerGetTransaction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getTransactionControllerGetTransactionQueryKey(transactionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionControllerGetTransaction>>> = ({ signal }) => transactionControllerGetTransaction(toValue(transactionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(transactionId) !== null && toValue(transactionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionControllerGetTransaction>>, TError, TData>
}

export type TransactionControllerGetTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof transactionControllerGetTransaction>>>
export type TransactionControllerGetTransactionQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useTransactionControllerGetTransaction<TData = Awaited<ReturnType<typeof transactionControllerGetTransaction>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 transactionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionControllerGetTransaction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTransactionControllerGetTransactionQueryOptions(transactionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type transactionControllerCreateTransactionForReceiptResponse201 = {
  data: ResponseOfferTransactionDto
  status: 201
}

export type transactionControllerCreateTransactionForReceiptResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type transactionControllerCreateTransactionForReceiptResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type transactionControllerCreateTransactionForReceiptResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type transactionControllerCreateTransactionForReceiptResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type transactionControllerCreateTransactionForReceiptResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type transactionControllerCreateTransactionForReceiptResponseSuccess = (transactionControllerCreateTransactionForReceiptResponse201) & {
  headers: Headers;
};
export type transactionControllerCreateTransactionForReceiptResponseError = (transactionControllerCreateTransactionForReceiptResponse400 | transactionControllerCreateTransactionForReceiptResponse401 | transactionControllerCreateTransactionForReceiptResponse403 | transactionControllerCreateTransactionForReceiptResponse404 | transactionControllerCreateTransactionForReceiptResponse500) & {
  headers: Headers;
};

export type transactionControllerCreateTransactionForReceiptResponse = (transactionControllerCreateTransactionForReceiptResponseSuccess | transactionControllerCreateTransactionForReceiptResponseError)

export const getTransactionControllerCreateTransactionForReceiptUrl = () => {




  return `/transaction`
}

export const transactionControllerCreateTransactionForReceipt = async (createOfferTransactionDto: CreateOfferTransactionDto, options?: Parameters<typeof customFetch>[1]): Promise<transactionControllerCreateTransactionForReceiptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<transactionControllerCreateTransactionForReceiptResponse>(getTransactionControllerCreateTransactionForReceiptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferTransactionDto)
  }
);}





export const getTransactionControllerCreateTransactionForReceiptMutationKey = () => ['transactionControllerCreateTransactionForReceipt'] as const;

export const getTransactionControllerCreateTransactionForReceiptMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionControllerCreateTransactionForReceipt>>, TError,TransactionControllerCreateTransactionForReceiptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof transactionControllerCreateTransactionForReceipt>>, TError,TransactionControllerCreateTransactionForReceiptMutationVariables, TContext> => {

const mutationKey = getTransactionControllerCreateTransactionForReceiptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transactionControllerCreateTransactionForReceipt>>, TransactionControllerCreateTransactionForReceiptMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  transactionControllerCreateTransactionForReceipt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TransactionControllerCreateTransactionForReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof transactionControllerCreateTransactionForReceipt>>>
    export type TransactionControllerCreateTransactionForReceiptMutationBody = CreateOfferTransactionDto
    export type TransactionControllerCreateTransactionForReceiptMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type TransactionControllerCreateTransactionForReceiptMutationVariables = {data: CreateOfferTransactionDto}

    export const useTransactionControllerCreateTransactionForReceipt = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionControllerCreateTransactionForReceipt>>, TError,TransactionControllerCreateTransactionForReceiptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof transactionControllerCreateTransactionForReceipt>>,
        TError,
        TransactionControllerCreateTransactionForReceiptMutationVariables,
        TContext
      > => {
      return useMutation(getTransactionControllerCreateTransactionForReceiptMutationOptions(options), queryClient);
    }

export type transactionControllerProcessTransactionResponse201 = {
  data: ResponseOfferTransactionDto
  status: 201
}

export type transactionControllerProcessTransactionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type transactionControllerProcessTransactionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type transactionControllerProcessTransactionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type transactionControllerProcessTransactionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type transactionControllerProcessTransactionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type transactionControllerProcessTransactionResponseSuccess = (transactionControllerProcessTransactionResponse201) & {
  headers: Headers;
};
export type transactionControllerProcessTransactionResponseError = (transactionControllerProcessTransactionResponse400 | transactionControllerProcessTransactionResponse401 | transactionControllerProcessTransactionResponse403 | transactionControllerProcessTransactionResponse404 | transactionControllerProcessTransactionResponse500) & {
  headers: Headers;
};

export type transactionControllerProcessTransactionResponse = (transactionControllerProcessTransactionResponseSuccess | transactionControllerProcessTransactionResponseError)

export const getTransactionControllerProcessTransactionUrl = (transactionId: number,) => {




  return `/transaction/${transactionId}/process`
}

export const transactionControllerProcessTransaction = async (transactionId: number,
    processOfferTransactionDto: ProcessOfferTransactionDto, options?: Parameters<typeof customFetch>[1]): Promise<transactionControllerProcessTransactionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<transactionControllerProcessTransactionResponse>(getTransactionControllerProcessTransactionUrl(transactionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(processOfferTransactionDto)
  }
);}





export const getTransactionControllerProcessTransactionMutationKey = () => ['transactionControllerProcessTransaction'] as const;

export const getTransactionControllerProcessTransactionMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionControllerProcessTransaction>>, TError,TransactionControllerProcessTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof transactionControllerProcessTransaction>>, TError,TransactionControllerProcessTransactionMutationVariables, TContext> => {

const mutationKey = getTransactionControllerProcessTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transactionControllerProcessTransaction>>, TransactionControllerProcessTransactionMutationVariables> = (props) => {
          const {transactionId,data} = props ?? {};

          return  transactionControllerProcessTransaction(transactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TransactionControllerProcessTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof transactionControllerProcessTransaction>>>
    export type TransactionControllerProcessTransactionMutationBody = ProcessOfferTransactionDto
    export type TransactionControllerProcessTransactionMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type TransactionControllerProcessTransactionMutationVariables = {transactionId: number;data: ProcessOfferTransactionDto}

    export const useTransactionControllerProcessTransaction = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transactionControllerProcessTransaction>>, TError,TransactionControllerProcessTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof transactionControllerProcessTransaction>>,
        TError,
        TransactionControllerProcessTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getTransactionControllerProcessTransactionMutationOptions(options), queryClient);
    }

export type logMailControllerPaginateResponse200 = {
  data: LogMailControllerPaginate200
  status: 200
}

export type logMailControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logMailControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logMailControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logMailControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logMailControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logMailControllerPaginateResponseSuccess = (logMailControllerPaginateResponse200) & {
  headers: Headers;
};
export type logMailControllerPaginateResponseError = (logMailControllerPaginateResponse400 | logMailControllerPaginateResponse401 | logMailControllerPaginateResponse403 | logMailControllerPaginateResponse404 | logMailControllerPaginateResponse500) & {
  headers: Headers;
};

export type logMailControllerPaginateResponse = (logMailControllerPaginateResponseSuccess | logMailControllerPaginateResponseError)

export const getLogMailControllerPaginateUrl = (params?: LogMailControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.recipient","filter.template","filter.success","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/mail?${stringifiedParams}` : `/log/mail`
}

export const logMailControllerPaginate = async (params?: LogMailControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logMailControllerPaginateResponse> => {

  return customFetch<logMailControllerPaginateResponse>(getLogMailControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogMailControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogMailControllerPaginateParams>,) => {
    return [
    'log','mail', ...(params ? [params] : [])
    ] as const;
    }


export const getLogMailControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logMailControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogMailControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logMailControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogMailControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logMailControllerPaginate>>> = ({ signal }) => logMailControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logMailControllerPaginate>>, TError, TData>
}

export type LogMailControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logMailControllerPaginate>>>
export type LogMailControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogMailControllerPaginate<TData = Awaited<ReturnType<typeof logMailControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogMailControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logMailControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogMailControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse200 = {
  data: ResponseShopifyCashPayoutQueueDto[]
  status: 200
}

export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponseSuccess = (offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse200) & {
  headers: Headers;
};
export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponseError = (offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse400 | offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse401 | offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse403 | offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse404 | offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse500) & {
  headers: Headers;
};

export type offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse = (offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponseSuccess | offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponseError)

export const getOfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionUrl = (transactionId: number,) => {




  return `/transaction/${transactionId}/shopify-cash`
}

export const offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction = async (transactionId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse> => {

  return customFetch<offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionResponse>(getOfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionUrl(transactionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionQueryKey = (transactionId: MaybeRefOrGetter<number>,) => {
    return [
    'transaction',transactionId,'shopify-cash'
    ] as const;
    }


export const getOfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionQueryOptions = <TData = Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(transactionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionQueryKey(transactionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction>>> = ({ signal }) => offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction(toValue(transactionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(transactionId) !== null && toValue(transactionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction>>, TError, TData>
}

export type OfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction>>>
export type OfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction<TData = Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 transactionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransaction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferTransactionShopifyCashControllerFindAllCashPayoutQueuesForTransactionQueryOptions(transactionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse201 = {
  data: ResponseShopifyCashPayoutQueueDto
  status: 201
}

export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponseSuccess = (offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse201) & {
  headers: Headers;
};
export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponseError = (offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse400 | offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse401 | offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse403 | offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse404 | offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse500) & {
  headers: Headers;
};

export type offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse = (offerTransactionShopifyCashControllerCreateCashPayoutQueueResponseSuccess | offerTransactionShopifyCashControllerCreateCashPayoutQueueResponseError)

export const getOfferTransactionShopifyCashControllerCreateCashPayoutQueueUrl = (transactionId: number,) => {




  return `/transaction/${transactionId}/shopify-cash`
}

export const offerTransactionShopifyCashControllerCreateCashPayoutQueue = async (transactionId: number,
    createShopifyCashPayoutQueueDto: CreateShopifyCashPayoutQueueDto, options?: Parameters<typeof customFetch>[1]): Promise<offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerTransactionShopifyCashControllerCreateCashPayoutQueueResponse>(getOfferTransactionShopifyCashControllerCreateCashPayoutQueueUrl(transactionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createShopifyCashPayoutQueueDto)
  }
);}





export const getOfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationKey = () => ['offerTransactionShopifyCashControllerCreateCashPayoutQueue'] as const;

export const getOfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerCreateCashPayoutQueue>>, TError,OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerCreateCashPayoutQueue>>, TError,OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationVariables, TContext> => {

const mutationKey = getOfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerCreateCashPayoutQueue>>, OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationVariables> = (props) => {
          const {transactionId,data} = props ?? {};

          return  offerTransactionShopifyCashControllerCreateCashPayoutQueue(transactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationResult = NonNullable<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerCreateCashPayoutQueue>>>
    export type OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationBody = CreateShopifyCashPayoutQueueDto
    export type OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationVariables = {transactionId: number;data: CreateShopifyCashPayoutQueueDto}

    export const useOfferTransactionShopifyCashControllerCreateCashPayoutQueue = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerCreateCashPayoutQueue>>, TError,OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerTransactionShopifyCashControllerCreateCashPayoutQueue>>,
        TError,
        OfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationVariables,
        TContext
      > => {
      return useMutation(getOfferTransactionShopifyCashControllerCreateCashPayoutQueueMutationOptions(options), queryClient);
    }

export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse200 = {
  data: ResponseShopifyCashPayoutQueueDto
  status: 200
}

export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponseSuccess = (offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse200) & {
  headers: Headers;
};
export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponseError = (offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse400 | offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse401 | offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse403 | offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse404 | offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse500) & {
  headers: Headers;
};

export type offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse = (offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponseSuccess | offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponseError)

export const getOfferTransactionShopifyCashControllerFindOneCashPayoutQueueUrl = (transactionId: number,
    queueId: number,) => {




  return `/transaction/${transactionId}/shopify-cash/${queueId}`
}

export const offerTransactionShopifyCashControllerFindOneCashPayoutQueue = async (transactionId: number,
    queueId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse> => {

  return customFetch<offerTransactionShopifyCashControllerFindOneCashPayoutQueueResponse>(getOfferTransactionShopifyCashControllerFindOneCashPayoutQueueUrl(transactionId,queueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferTransactionShopifyCashControllerFindOneCashPayoutQueueQueryKey = (transactionId: MaybeRefOrGetter<number>,
    queueId: MaybeRefOrGetter<number>,) => {
    return [
    'transaction',transactionId,'shopify-cash',queueId
    ] as const;
    }


export const getOfferTransactionShopifyCashControllerFindOneCashPayoutQueueQueryOptions = <TData = Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindOneCashPayoutQueue>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(transactionId: MaybeRefOrGetter<number>,
    queueId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindOneCashPayoutQueue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferTransactionShopifyCashControllerFindOneCashPayoutQueueQueryKey(transactionId,queueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindOneCashPayoutQueue>>> = ({ signal }) => offerTransactionShopifyCashControllerFindOneCashPayoutQueue(toValue(transactionId),toValue(queueId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(transactionId) !== null && toValue(transactionId) !== undefined && toValue(queueId) !== null && toValue(queueId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindOneCashPayoutQueue>>, TError, TData>
}

export type OfferTransactionShopifyCashControllerFindOneCashPayoutQueueQueryResult = NonNullable<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindOneCashPayoutQueue>>>
export type OfferTransactionShopifyCashControllerFindOneCashPayoutQueueQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferTransactionShopifyCashControllerFindOneCashPayoutQueue<TData = Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindOneCashPayoutQueue>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 transactionId: MaybeRefOrGetter<number>,
    queueId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTransactionShopifyCashControllerFindOneCashPayoutQueue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferTransactionShopifyCashControllerFindOneCashPayoutQueueQueryOptions(transactionId,queueId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerTransactionExternalControllerCreateExternalTransactionResponse201 = {
  data: ResponseResponseOfferTransactionExternalDto
  status: 201
}

export type offerTransactionExternalControllerCreateExternalTransactionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTransactionExternalControllerCreateExternalTransactionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTransactionExternalControllerCreateExternalTransactionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTransactionExternalControllerCreateExternalTransactionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTransactionExternalControllerCreateExternalTransactionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTransactionExternalControllerCreateExternalTransactionResponseSuccess = (offerTransactionExternalControllerCreateExternalTransactionResponse201) & {
  headers: Headers;
};
export type offerTransactionExternalControllerCreateExternalTransactionResponseError = (offerTransactionExternalControllerCreateExternalTransactionResponse400 | offerTransactionExternalControllerCreateExternalTransactionResponse401 | offerTransactionExternalControllerCreateExternalTransactionResponse403 | offerTransactionExternalControllerCreateExternalTransactionResponse404 | offerTransactionExternalControllerCreateExternalTransactionResponse500) & {
  headers: Headers;
};

export type offerTransactionExternalControllerCreateExternalTransactionResponse = (offerTransactionExternalControllerCreateExternalTransactionResponseSuccess | offerTransactionExternalControllerCreateExternalTransactionResponseError)

export const getOfferTransactionExternalControllerCreateExternalTransactionUrl = (transactionId: number,) => {




  return `/transaction/${transactionId}/external`
}

export const offerTransactionExternalControllerCreateExternalTransaction = async (transactionId: number,
    createOfferTransactionExternalDto: CreateOfferTransactionExternalDto, options?: Parameters<typeof customFetch>[1]): Promise<offerTransactionExternalControllerCreateExternalTransactionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerTransactionExternalControllerCreateExternalTransactionResponse>(getOfferTransactionExternalControllerCreateExternalTransactionUrl(transactionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOfferTransactionExternalDto)
  }
);}





export const getOfferTransactionExternalControllerCreateExternalTransactionMutationKey = () => ['offerTransactionExternalControllerCreateExternalTransaction'] as const;

export const getOfferTransactionExternalControllerCreateExternalTransactionMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTransactionExternalControllerCreateExternalTransaction>>, TError,OfferTransactionExternalControllerCreateExternalTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerTransactionExternalControllerCreateExternalTransaction>>, TError,OfferTransactionExternalControllerCreateExternalTransactionMutationVariables, TContext> => {

const mutationKey = getOfferTransactionExternalControllerCreateExternalTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerTransactionExternalControllerCreateExternalTransaction>>, OfferTransactionExternalControllerCreateExternalTransactionMutationVariables> = (props) => {
          const {transactionId,data} = props ?? {};

          return  offerTransactionExternalControllerCreateExternalTransaction(transactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferTransactionExternalControllerCreateExternalTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof offerTransactionExternalControllerCreateExternalTransaction>>>
    export type OfferTransactionExternalControllerCreateExternalTransactionMutationBody = CreateOfferTransactionExternalDto
    export type OfferTransactionExternalControllerCreateExternalTransactionMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferTransactionExternalControllerCreateExternalTransactionMutationVariables = {transactionId: number;data: CreateOfferTransactionExternalDto}

    export const useOfferTransactionExternalControllerCreateExternalTransaction = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTransactionExternalControllerCreateExternalTransaction>>, TError,OfferTransactionExternalControllerCreateExternalTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerTransactionExternalControllerCreateExternalTransaction>>,
        TError,
        OfferTransactionExternalControllerCreateExternalTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getOfferTransactionExternalControllerCreateExternalTransactionMutationOptions(options), queryClient);
    }

export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse200 = {
  data: ResponsePaypalPayoutQueueDto[]
  status: 200
}

export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponseSuccess = (offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse200) & {
  headers: Headers;
};
export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponseError = (offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse400 | offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse401 | offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse403 | offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse404 | offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse500) & {
  headers: Headers;
};

export type offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse = (offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponseSuccess | offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponseError)

export const getOfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionUrl = (transactionId: number,
    params?: OfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["transactionStatus"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/transaction/${transactionId}/paypal-payout?${stringifiedParams}` : `/transaction/${transactionId}/paypal-payout`
}

export const offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction = async (transactionId: number,
    params?: OfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionParams, options?: Parameters<typeof customFetch>[1]): Promise<offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse> => {

  return customFetch<offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionResponse>(getOfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionUrl(transactionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionQueryKey = (transactionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionParams>,) => {
    return [
    'transaction',transactionId,'paypal-payout', ...(params ? [params] : [])
    ] as const;
    }


export const getOfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionQueryOptions = <TData = Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(transactionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionQueryKey(transactionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction>>> = ({ signal }) => offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction(toValue(transactionId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(transactionId) !== null && toValue(transactionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction>>, TError, TData>
}

export type OfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction>>>
export type OfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction<TData = Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 transactionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<OfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransaction>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferTransactionPaypalPayoutControllerFindAllPaypalPayoutQueuesForTransactionQueryOptions(transactionId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse201 = {
  data: ResponsePaypalPayoutQueueDto
  status: 201
}

export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponseSuccess = (offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse201) & {
  headers: Headers;
};
export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponseError = (offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse400 | offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse401 | offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse403 | offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse404 | offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse500) & {
  headers: Headers;
};

export type offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse = (offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponseSuccess | offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponseError)

export const getOfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueUrl = (transactionId: number,) => {




  return `/transaction/${transactionId}/paypal-payout`
}

export const offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue = async (transactionId: number,
    createPaypalPayoutQueueDto: CreatePaypalPayoutQueueDto, options?: Parameters<typeof customFetch>[1]): Promise<offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueueResponse>(getOfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueUrl(transactionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPaypalPayoutQueueDto)
  }
);}





export const getOfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationKey = () => ['offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue'] as const;

export const getOfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue>>, TError,OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue>>, TError,OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationVariables, TContext> => {

const mutationKey = getOfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue>>, OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationVariables> = (props) => {
          const {transactionId,data} = props ?? {};

          return  offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue(transactionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationResult = NonNullable<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue>>>
    export type OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationBody = CreatePaypalPayoutQueueDto
    export type OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationVariables = {transactionId: number;data: CreatePaypalPayoutQueueDto}

    export const useOfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueue = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue>>, TError,OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerCreatePaypalPayoutQueue>>,
        TError,
        OfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationVariables,
        TContext
      > => {
      return useMutation(getOfferTransactionPaypalPayoutControllerCreatePaypalPayoutQueueMutationOptions(options), queryClient);
    }

export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse200 = {
  data: ResponsePaypalPayoutQueueDto
  status: 200
}

export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponseSuccess = (offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse200) & {
  headers: Headers;
};
export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponseError = (offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse400 | offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse401 | offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse403 | offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse404 | offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse500) & {
  headers: Headers;
};

export type offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse = (offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponseSuccess | offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponseError)

export const getOfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueUrl = (transactionId: number,
    queueId: number,) => {




  return `/transaction/${transactionId}/paypal-payout/${queueId}`
}

export const offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue = async (transactionId: number,
    queueId: number, options?: Parameters<typeof customFetch>[1]): Promise<offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse> => {

  return customFetch<offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueResponse>(getOfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueUrl(transactionId,queueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueQueryKey = (transactionId: MaybeRefOrGetter<number>,
    queueId: MaybeRefOrGetter<number>,) => {
    return [
    'transaction',transactionId,'paypal-payout',queueId
    ] as const;
    }


export const getOfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueQueryOptions = <TData = Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(transactionId: MaybeRefOrGetter<number>,
    queueId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getOfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueQueryKey(transactionId,queueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue>>> = ({ signal }) => offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue(toValue(transactionId),toValue(queueId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(transactionId) !== null && toValue(transactionId) !== undefined && toValue(queueId) !== null && toValue(queueId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue>>, TError, TData>
}

export type OfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueQueryResult = NonNullable<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue>>>
export type OfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useOfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue<TData = Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 transactionId: MaybeRefOrGetter<number>,
    queueId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offerTransactionPaypalPayoutControllerFindOnePaypalPayoutQueue>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOfferTransactionPaypalPayoutControllerFindOnePaypalPayoutQueueQueryOptions(transactionId,queueId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type logApiPaypalControllerPaginateResponse200 = {
  data: LogApiPaypalControllerPaginate200
  status: 200
}

export type logApiPaypalControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logApiPaypalControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logApiPaypalControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logApiPaypalControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logApiPaypalControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logApiPaypalControllerPaginateResponseSuccess = (logApiPaypalControllerPaginateResponse200) & {
  headers: Headers;
};
export type logApiPaypalControllerPaginateResponseError = (logApiPaypalControllerPaginateResponse400 | logApiPaypalControllerPaginateResponse401 | logApiPaypalControllerPaginateResponse403 | logApiPaypalControllerPaginateResponse404 | logApiPaypalControllerPaginateResponse500) & {
  headers: Headers;
};

export type logApiPaypalControllerPaginateResponse = (logApiPaypalControllerPaginateResponseSuccess | logApiPaypalControllerPaginateResponseError)

export const getLogApiPaypalControllerPaginateUrl = (params?: LogApiPaypalControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.status","filter.method","filter.path","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/api-paypal?${stringifiedParams}` : `/log/api-paypal`
}

export const logApiPaypalControllerPaginate = async (params?: LogApiPaypalControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logApiPaypalControllerPaginateResponse> => {

  return customFetch<logApiPaypalControllerPaginateResponse>(getLogApiPaypalControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogApiPaypalControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogApiPaypalControllerPaginateParams>,) => {
    return [
    'log','api-paypal', ...(params ? [params] : [])
    ] as const;
    }


export const getLogApiPaypalControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logApiPaypalControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogApiPaypalControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiPaypalControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogApiPaypalControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logApiPaypalControllerPaginate>>> = ({ signal }) => logApiPaypalControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logApiPaypalControllerPaginate>>, TError, TData>
}

export type LogApiPaypalControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logApiPaypalControllerPaginate>>>
export type LogApiPaypalControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogApiPaypalControllerPaginate<TData = Awaited<ReturnType<typeof logApiPaypalControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogApiPaypalControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiPaypalControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogApiPaypalControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponse200 = {
  data: ResponsePushNotificationListHandlingItemDto[]
  status: 200
}

export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponseSuccess = (pushNotificationListHandlingItemControllerSetHandlingItemListsResponse200) & {
  headers: Headers;
};
export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponseError = (pushNotificationListHandlingItemControllerSetHandlingItemListsResponse400 | pushNotificationListHandlingItemControllerSetHandlingItemListsResponse401 | pushNotificationListHandlingItemControllerSetHandlingItemListsResponse403 | pushNotificationListHandlingItemControllerSetHandlingItemListsResponse404 | pushNotificationListHandlingItemControllerSetHandlingItemListsResponse500) & {
  headers: Headers;
};

export type pushNotificationListHandlingItemControllerSetHandlingItemListsResponse = (pushNotificationListHandlingItemControllerSetHandlingItemListsResponseSuccess | pushNotificationListHandlingItemControllerSetHandlingItemListsResponseError)

export const getPushNotificationListHandlingItemControllerSetHandlingItemListsUrl = () => {




  return `/push-notification/list/handling-item`
}

export const pushNotificationListHandlingItemControllerSetHandlingItemLists = async (putPushNotificationListHandlingItemDto: PutPushNotificationListHandlingItemDto, options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationListHandlingItemControllerSetHandlingItemListsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<pushNotificationListHandlingItemControllerSetHandlingItemListsResponse>(getPushNotificationListHandlingItemControllerSetHandlingItemListsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPushNotificationListHandlingItemDto)
  }
);}





export const getPushNotificationListHandlingItemControllerSetHandlingItemListsMutationKey = () => ['pushNotificationListHandlingItemControllerSetHandlingItemLists'] as const;

export const getPushNotificationListHandlingItemControllerSetHandlingItemListsMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerSetHandlingItemLists>>, TError,PushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerSetHandlingItemLists>>, TError,PushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables, TContext> => {

const mutationKey = getPushNotificationListHandlingItemControllerSetHandlingItemListsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerSetHandlingItemLists>>, PushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pushNotificationListHandlingItemControllerSetHandlingItemLists(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushNotificationListHandlingItemControllerSetHandlingItemListsMutationResult = NonNullable<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerSetHandlingItemLists>>>
    export type PushNotificationListHandlingItemControllerSetHandlingItemListsMutationBody = PutPushNotificationListHandlingItemDto
    export type PushNotificationListHandlingItemControllerSetHandlingItemListsMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables = {data: PutPushNotificationListHandlingItemDto}

    export const usePushNotificationListHandlingItemControllerSetHandlingItemLists = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerSetHandlingItemLists>>, TError,PushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerSetHandlingItemLists>>,
        TError,
        PushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables,
        TContext
      > => {
      return useMutation(getPushNotificationListHandlingItemControllerSetHandlingItemListsMutationOptions(options), queryClient);
    }

export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponse200 = {
  data: ResponsePushNotificationListHandlingItemDto[]
  status: 200
}

export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponseSuccess = (pushNotificationListHandlingItemControllerFindHandlingItemListsResponse200) & {
  headers: Headers;
};
export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponseError = (pushNotificationListHandlingItemControllerFindHandlingItemListsResponse400 | pushNotificationListHandlingItemControllerFindHandlingItemListsResponse401 | pushNotificationListHandlingItemControllerFindHandlingItemListsResponse403 | pushNotificationListHandlingItemControllerFindHandlingItemListsResponse404 | pushNotificationListHandlingItemControllerFindHandlingItemListsResponse500) & {
  headers: Headers;
};

export type pushNotificationListHandlingItemControllerFindHandlingItemListsResponse = (pushNotificationListHandlingItemControllerFindHandlingItemListsResponseSuccess | pushNotificationListHandlingItemControllerFindHandlingItemListsResponseError)

export const getPushNotificationListHandlingItemControllerFindHandlingItemListsUrl = () => {




  return `/push-notification/list/handling-item`
}

export const pushNotificationListHandlingItemControllerFindHandlingItemLists = async ( options?: Parameters<typeof customFetch>[1]): Promise<pushNotificationListHandlingItemControllerFindHandlingItemListsResponse> => {

  return customFetch<pushNotificationListHandlingItemControllerFindHandlingItemListsResponse>(getPushNotificationListHandlingItemControllerFindHandlingItemListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPushNotificationListHandlingItemControllerFindHandlingItemListsQueryKey = () => {
    return [
    'push-notification','list','handling-item'
    ] as const;
    }


export const getPushNotificationListHandlingItemControllerFindHandlingItemListsQueryOptions = <TData = Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPushNotificationListHandlingItemControllerFindHandlingItemListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerFindHandlingItemLists>>> = ({ signal }) => pushNotificationListHandlingItemControllerFindHandlingItemLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError, TData>
}

export type PushNotificationListHandlingItemControllerFindHandlingItemListsQueryResult = NonNullable<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerFindHandlingItemLists>>>
export type PushNotificationListHandlingItemControllerFindHandlingItemListsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePushNotificationListHandlingItemControllerFindHandlingItemLists<TData = Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPushNotificationListHandlingItemControllerFindHandlingItemListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse200 = {
  data: ResponsePushNotificationListHandlingItemDto[]
  status: 200
}

export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponseSuccess = (posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse200) & {
  headers: Headers;
};
export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponseError = (posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse400 | posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse401 | posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse403 | posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse404 | posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse500) & {
  headers: Headers;
};

export type posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse = (posPushNotificationListHandlingItemControllerSetHandlingItemListsResponseSuccess | posPushNotificationListHandlingItemControllerSetHandlingItemListsResponseError)

export const getPosPushNotificationListHandlingItemControllerSetHandlingItemListsUrl = () => {




  return `/push-notification/list/handling-item/pos`
}

export const posPushNotificationListHandlingItemControllerSetHandlingItemLists = async (putPushNotificationListHandlingItemDto: PutPushNotificationListHandlingItemDto, options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<posPushNotificationListHandlingItemControllerSetHandlingItemListsResponse>(getPosPushNotificationListHandlingItemControllerSetHandlingItemListsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPushNotificationListHandlingItemDto)
  }
);}





export const getPosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationKey = () => ['posPushNotificationListHandlingItemControllerSetHandlingItemLists'] as const;

export const getPosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerSetHandlingItemLists>>, TError,PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerSetHandlingItemLists>>, TError,PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables, TContext> => {

const mutationKey = getPosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerSetHandlingItemLists>>, PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  posPushNotificationListHandlingItemControllerSetHandlingItemLists(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerSetHandlingItemLists>>>
    export type PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationBody = PutPushNotificationListHandlingItemDto
    export type PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables = {data: PutPushNotificationListHandlingItemDto}

    export const usePosPushNotificationListHandlingItemControllerSetHandlingItemLists = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerSetHandlingItemLists>>, TError,PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerSetHandlingItemLists>>,
        TError,
        PosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationVariables,
        TContext
      > => {
      return useMutation(getPosPushNotificationListHandlingItemControllerSetHandlingItemListsMutationOptions(options), queryClient);
    }

export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse200 = {
  data: ResponsePushNotificationListHandlingItemDto[]
  status: 200
}

export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponseSuccess = (posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse200) & {
  headers: Headers;
};
export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponseError = (posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse400 | posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse401 | posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse403 | posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse404 | posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse500) & {
  headers: Headers;
};

export type posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse = (posPushNotificationListHandlingItemControllerFindHandlingItemListsResponseSuccess | posPushNotificationListHandlingItemControllerFindHandlingItemListsResponseError)

export const getPosPushNotificationListHandlingItemControllerFindHandlingItemListsUrl = () => {




  return `/push-notification/list/handling-item/pos`
}

export const posPushNotificationListHandlingItemControllerFindHandlingItemLists = async ( options?: Parameters<typeof customFetch>[1]): Promise<posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse> => {

  return customFetch<posPushNotificationListHandlingItemControllerFindHandlingItemListsResponse>(getPosPushNotificationListHandlingItemControllerFindHandlingItemListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPosPushNotificationListHandlingItemControllerFindHandlingItemListsQueryKey = () => {
    return [
    'push-notification','list','handling-item','pos'
    ] as const;
    }


export const getPosPushNotificationListHandlingItemControllerFindHandlingItemListsQueryOptions = <TData = Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPosPushNotificationListHandlingItemControllerFindHandlingItemListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerFindHandlingItemLists>>> = ({ signal }) => posPushNotificationListHandlingItemControllerFindHandlingItemLists({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError, TData>
}

export type PosPushNotificationListHandlingItemControllerFindHandlingItemListsQueryResult = NonNullable<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerFindHandlingItemLists>>>
export type PosPushNotificationListHandlingItemControllerFindHandlingItemListsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePosPushNotificationListHandlingItemControllerFindHandlingItemLists<TData = Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posPushNotificationListHandlingItemControllerFindHandlingItemLists>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPosPushNotificationListHandlingItemControllerFindHandlingItemListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type exportOfferControllerExportAllResponse200 = {
  data: string
  status: 200
}

export type exportOfferControllerExportAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type exportOfferControllerExportAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type exportOfferControllerExportAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type exportOfferControllerExportAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type exportOfferControllerExportAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type exportOfferControllerExportAllResponseSuccess = (exportOfferControllerExportAllResponse200) & {
  headers: Headers;
};
export type exportOfferControllerExportAllResponseError = (exportOfferControllerExportAllResponse400 | exportOfferControllerExportAllResponse401 | exportOfferControllerExportAllResponse403 | exportOfferControllerExportAllResponse404 | exportOfferControllerExportAllResponse500) & {
  headers: Headers;
};

export type exportOfferControllerExportAllResponse = (exportOfferControllerExportAllResponseSuccess | exportOfferControllerExportAllResponseError)

export const getExportOfferControllerExportAllUrl = (params?: ExportOfferControllerExportAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["quoteColumns","quoteHeaders","filter.needsReview","filter.status","filter.createdBy","filter.reviewedBy","filter.createdAt","filter.updatedAt","filter.source","filter.source.id","filter.receipts.transactionType","filter.frozenAt","filter.parentOffer.id","filter.jobId","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/export/offer?${stringifiedParams}` : `/export/offer`
}

export const exportOfferControllerExportAll = async (params?: ExportOfferControllerExportAllParams, options?: Parameters<typeof customFetch>[1]): Promise<exportOfferControllerExportAllResponse> => {

  return customFetch<exportOfferControllerExportAllResponse>(getExportOfferControllerExportAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportOfferControllerExportAllQueryKey = (params?: MaybeRefOrGetter<ExportOfferControllerExportAllParams>,) => {
    return [
    'export','offer', ...(params ? [params] : [])
    ] as const;
    }


export const getExportOfferControllerExportAllQueryOptions = <TData = Awaited<ReturnType<typeof exportOfferControllerExportAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<ExportOfferControllerExportAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOfferControllerExportAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExportOfferControllerExportAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOfferControllerExportAll>>> = ({ signal }) => exportOfferControllerExportAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportOfferControllerExportAll>>, TError, TData>
}

export type ExportOfferControllerExportAllQueryResult = NonNullable<Awaited<ReturnType<typeof exportOfferControllerExportAll>>>
export type ExportOfferControllerExportAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useExportOfferControllerExportAll<TData = Awaited<ReturnType<typeof exportOfferControllerExportAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<ExportOfferControllerExportAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOfferControllerExportAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportOfferControllerExportAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type exportOfferItemControllerExportAllResponse200 = {
  data: string
  status: 200
}

export type exportOfferItemControllerExportAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type exportOfferItemControllerExportAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type exportOfferItemControllerExportAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type exportOfferItemControllerExportAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type exportOfferItemControllerExportAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type exportOfferItemControllerExportAllResponseSuccess = (exportOfferItemControllerExportAllResponse200) & {
  headers: Headers;
};
export type exportOfferItemControllerExportAllResponseError = (exportOfferItemControllerExportAllResponse400 | exportOfferItemControllerExportAllResponse401 | exportOfferItemControllerExportAllResponse403 | exportOfferItemControllerExportAllResponse404 | exportOfferItemControllerExportAllResponse500) & {
  headers: Headers;
};

export type exportOfferItemControllerExportAllResponse = (exportOfferItemControllerExportAllResponseSuccess | exportOfferItemControllerExportAllResponseError)

export const getExportOfferItemControllerExportAllUrl = (params?: ExportOfferItemControllerExportAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["quoteColumns","quoteHeaders","filter.needsReview","filter.isIncluded","filter.createdAt","filter.offer.createdAt","filter.offer.id","filter.offer.status","filter.offer.source.id","filter.offer.createdBy.id","filter.handlingItems.id","filter.handlingItems.status","filter.handlingItems.handlingType","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/export/offer/item?${stringifiedParams}` : `/export/offer/item`
}

export const exportOfferItemControllerExportAll = async (params?: ExportOfferItemControllerExportAllParams, options?: Parameters<typeof customFetch>[1]): Promise<exportOfferItemControllerExportAllResponse> => {

  return customFetch<exportOfferItemControllerExportAllResponse>(getExportOfferItemControllerExportAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportOfferItemControllerExportAllQueryKey = (params?: MaybeRefOrGetter<ExportOfferItemControllerExportAllParams>,) => {
    return [
    'export','offer','item', ...(params ? [params] : [])
    ] as const;
    }


export const getExportOfferItemControllerExportAllQueryOptions = <TData = Awaited<ReturnType<typeof exportOfferItemControllerExportAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<ExportOfferItemControllerExportAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOfferItemControllerExportAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExportOfferItemControllerExportAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOfferItemControllerExportAll>>> = ({ signal }) => exportOfferItemControllerExportAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportOfferItemControllerExportAll>>, TError, TData>
}

export type ExportOfferItemControllerExportAllQueryResult = NonNullable<Awaited<ReturnType<typeof exportOfferItemControllerExportAll>>>
export type ExportOfferItemControllerExportAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useExportOfferItemControllerExportAll<TData = Awaited<ReturnType<typeof exportOfferItemControllerExportAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<ExportOfferItemControllerExportAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOfferItemControllerExportAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportOfferItemControllerExportAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type exportSourceStatsControllerExportReceiptStatsResponse200 = {
  data: string
  status: 200
}

export type exportSourceStatsControllerExportReceiptStatsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type exportSourceStatsControllerExportReceiptStatsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type exportSourceStatsControllerExportReceiptStatsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type exportSourceStatsControllerExportReceiptStatsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type exportSourceStatsControllerExportReceiptStatsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type exportSourceStatsControllerExportReceiptStatsResponseSuccess = (exportSourceStatsControllerExportReceiptStatsResponse200) & {
  headers: Headers;
};
export type exportSourceStatsControllerExportReceiptStatsResponseError = (exportSourceStatsControllerExportReceiptStatsResponse400 | exportSourceStatsControllerExportReceiptStatsResponse401 | exportSourceStatsControllerExportReceiptStatsResponse403 | exportSourceStatsControllerExportReceiptStatsResponse404 | exportSourceStatsControllerExportReceiptStatsResponse500) & {
  headers: Headers;
};

export type exportSourceStatsControllerExportReceiptStatsResponse = (exportSourceStatsControllerExportReceiptStatsResponseSuccess | exportSourceStatsControllerExportReceiptStatsResponseError)

export const getExportSourceStatsControllerExportReceiptStatsUrl = (params?: ExportSourceStatsControllerExportReceiptStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sourceId","status","quoteColumns","quoteHeaders"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/export/stats/source/receipt?${stringifiedParams}` : `/export/stats/source/receipt`
}

export const exportSourceStatsControllerExportReceiptStats = async (params?: ExportSourceStatsControllerExportReceiptStatsParams, options?: Parameters<typeof customFetch>[1]): Promise<exportSourceStatsControllerExportReceiptStatsResponse> => {

  return customFetch<exportSourceStatsControllerExportReceiptStatsResponse>(getExportSourceStatsControllerExportReceiptStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportSourceStatsControllerExportReceiptStatsQueryKey = (params?: MaybeRefOrGetter<ExportSourceStatsControllerExportReceiptStatsParams>,) => {
    return [
    'export','stats','source','receipt', ...(params ? [params] : [])
    ] as const;
    }


export const getExportSourceStatsControllerExportReceiptStatsQueryOptions = <TData = Awaited<ReturnType<typeof exportSourceStatsControllerExportReceiptStats>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<ExportSourceStatsControllerExportReceiptStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSourceStatsControllerExportReceiptStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExportSourceStatsControllerExportReceiptStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportSourceStatsControllerExportReceiptStats>>> = ({ signal }) => exportSourceStatsControllerExportReceiptStats(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportSourceStatsControllerExportReceiptStats>>, TError, TData>
}

export type ExportSourceStatsControllerExportReceiptStatsQueryResult = NonNullable<Awaited<ReturnType<typeof exportSourceStatsControllerExportReceiptStats>>>
export type ExportSourceStatsControllerExportReceiptStatsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useExportSourceStatsControllerExportReceiptStats<TData = Awaited<ReturnType<typeof exportSourceStatsControllerExportReceiptStats>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<ExportSourceStatsControllerExportReceiptStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportSourceStatsControllerExportReceiptStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportSourceStatsControllerExportReceiptStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type sourceStatsControllerFindReceiptStatsResponse200 = {
  data: ResponseSourceReceiptStatsDto[]
  status: 200
}

export type sourceStatsControllerFindReceiptStatsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type sourceStatsControllerFindReceiptStatsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type sourceStatsControllerFindReceiptStatsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type sourceStatsControllerFindReceiptStatsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type sourceStatsControllerFindReceiptStatsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type sourceStatsControllerFindReceiptStatsResponseSuccess = (sourceStatsControllerFindReceiptStatsResponse200) & {
  headers: Headers;
};
export type sourceStatsControllerFindReceiptStatsResponseError = (sourceStatsControllerFindReceiptStatsResponse400 | sourceStatsControllerFindReceiptStatsResponse401 | sourceStatsControllerFindReceiptStatsResponse403 | sourceStatsControllerFindReceiptStatsResponse404 | sourceStatsControllerFindReceiptStatsResponse500) & {
  headers: Headers;
};

export type sourceStatsControllerFindReceiptStatsResponse = (sourceStatsControllerFindReceiptStatsResponseSuccess | sourceStatsControllerFindReceiptStatsResponseError)

export const getSourceStatsControllerFindReceiptStatsUrl = (params?: SourceStatsControllerFindReceiptStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["sourceId","status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/stats/source/receipt?${stringifiedParams}` : `/stats/source/receipt`
}

export const sourceStatsControllerFindReceiptStats = async (params?: SourceStatsControllerFindReceiptStatsParams, options?: Parameters<typeof customFetch>[1]): Promise<sourceStatsControllerFindReceiptStatsResponse> => {

  return customFetch<sourceStatsControllerFindReceiptStatsResponse>(getSourceStatsControllerFindReceiptStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSourceStatsControllerFindReceiptStatsQueryKey = (params?: MaybeRefOrGetter<SourceStatsControllerFindReceiptStatsParams>,) => {
    return [
    'stats','source','receipt', ...(params ? [params] : [])
    ] as const;
    }


export const getSourceStatsControllerFindReceiptStatsQueryOptions = <TData = Awaited<ReturnType<typeof sourceStatsControllerFindReceiptStats>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<SourceStatsControllerFindReceiptStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceStatsControllerFindReceiptStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getSourceStatsControllerFindReceiptStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourceStatsControllerFindReceiptStats>>> = ({ signal }) => sourceStatsControllerFindReceiptStats(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourceStatsControllerFindReceiptStats>>, TError, TData>
}

export type SourceStatsControllerFindReceiptStatsQueryResult = NonNullable<Awaited<ReturnType<typeof sourceStatsControllerFindReceiptStats>>>
export type SourceStatsControllerFindReceiptStatsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useSourceStatsControllerFindReceiptStats<TData = Awaited<ReturnType<typeof sourceStatsControllerFindReceiptStats>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<SourceStatsControllerFindReceiptStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sourceStatsControllerFindReceiptStats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSourceStatsControllerFindReceiptStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type companionControllerCreateResponse201 = {
  data: ResponseCompanionPairingDto
  status: 201
}

export type companionControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionControllerCreateResponseSuccess = (companionControllerCreateResponse201) & {
  headers: Headers;
};
export type companionControllerCreateResponseError = (companionControllerCreateResponse400 | companionControllerCreateResponse401 | companionControllerCreateResponse403 | companionControllerCreateResponse404 | companionControllerCreateResponse500) & {
  headers: Headers;
};

export type companionControllerCreateResponse = (companionControllerCreateResponseSuccess | companionControllerCreateResponseError)

export const getCompanionControllerCreateUrl = () => {




  return `/companion`
}

export const companionControllerCreate = async (createCompanionSessionDto: CreateCompanionSessionDto, options?: Parameters<typeof customFetch>[1]): Promise<companionControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionControllerCreateResponse>(getCompanionControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCompanionSessionDto)
  }
);}





export const getCompanionControllerCreateMutationKey = () => ['companionControllerCreate'] as const;

export const getCompanionControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerCreate>>, TError,CompanionControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionControllerCreate>>, TError,CompanionControllerCreateMutationVariables, TContext> => {

const mutationKey = getCompanionControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionControllerCreate>>, CompanionControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  companionControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companionControllerCreate>>>
    export type CompanionControllerCreateMutationBody = CreateCompanionSessionDto
    export type CompanionControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionControllerCreateMutationVariables = {data: CreateCompanionSessionDto}

    export const useCompanionControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerCreate>>, TError,CompanionControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionControllerCreate>>,
        TError,
        CompanionControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionControllerCreateMutationOptions(options), queryClient);
    }

export type companionControllerReissuePairingTokenResponse201 = {
  data: ResponseCompanionPairingDto
  status: 201
}

export type companionControllerReissuePairingTokenResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionControllerReissuePairingTokenResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionControllerReissuePairingTokenResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionControllerReissuePairingTokenResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionControllerReissuePairingTokenResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionControllerReissuePairingTokenResponseSuccess = (companionControllerReissuePairingTokenResponse201) & {
  headers: Headers;
};
export type companionControllerReissuePairingTokenResponseError = (companionControllerReissuePairingTokenResponse400 | companionControllerReissuePairingTokenResponse401 | companionControllerReissuePairingTokenResponse403 | companionControllerReissuePairingTokenResponse404 | companionControllerReissuePairingTokenResponse500) & {
  headers: Headers;
};

export type companionControllerReissuePairingTokenResponse = (companionControllerReissuePairingTokenResponseSuccess | companionControllerReissuePairingTokenResponseError)

export const getCompanionControllerReissuePairingTokenUrl = (companionId: string,) => {




  return `/companion/${companionId}/pairing-token`
}

export const companionControllerReissuePairingToken = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionControllerReissuePairingTokenResponse> => {

  return customFetch<companionControllerReissuePairingTokenResponse>(getCompanionControllerReissuePairingTokenUrl(companionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompanionControllerReissuePairingTokenMutationKey = () => ['companionControllerReissuePairingToken'] as const;

export const getCompanionControllerReissuePairingTokenMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerReissuePairingToken>>, TError,CompanionControllerReissuePairingTokenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionControllerReissuePairingToken>>, TError,CompanionControllerReissuePairingTokenMutationVariables, TContext> => {

const mutationKey = getCompanionControllerReissuePairingTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionControllerReissuePairingToken>>, CompanionControllerReissuePairingTokenMutationVariables> = (props) => {
          const {companionId} = props ?? {};

          return  companionControllerReissuePairingToken(companionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionControllerReissuePairingTokenMutationResult = NonNullable<Awaited<ReturnType<typeof companionControllerReissuePairingToken>>>

    export type CompanionControllerReissuePairingTokenMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionControllerReissuePairingTokenMutationVariables = {companionId: string}

    export const useCompanionControllerReissuePairingToken = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerReissuePairingToken>>, TError,CompanionControllerReissuePairingTokenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionControllerReissuePairingToken>>,
        TError,
        CompanionControllerReissuePairingTokenMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionControllerReissuePairingTokenMutationOptions(options), queryClient);
    }

export type companionControllerExchangePairingTokenResponse200 = {
  data: ResponseCompanionAuthDto
  status: 200
}

export type companionControllerExchangePairingTokenResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionControllerExchangePairingTokenResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionControllerExchangePairingTokenResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionControllerExchangePairingTokenResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionControllerExchangePairingTokenResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionControllerExchangePairingTokenResponseSuccess = (companionControllerExchangePairingTokenResponse200) & {
  headers: Headers;
};
export type companionControllerExchangePairingTokenResponseError = (companionControllerExchangePairingTokenResponse400 | companionControllerExchangePairingTokenResponse401 | companionControllerExchangePairingTokenResponse403 | companionControllerExchangePairingTokenResponse404 | companionControllerExchangePairingTokenResponse500) & {
  headers: Headers;
};

export type companionControllerExchangePairingTokenResponse = (companionControllerExchangePairingTokenResponseSuccess | companionControllerExchangePairingTokenResponseError)

export const getCompanionControllerExchangePairingTokenUrl = () => {




  return `/companion/pairing-token`
}

export const companionControllerExchangePairingToken = async ( options?: Parameters<typeof customFetch>[1]): Promise<companionControllerExchangePairingTokenResponse> => {

  return customFetch<companionControllerExchangePairingTokenResponse>(getCompanionControllerExchangePairingTokenUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompanionControllerExchangePairingTokenMutationKey = () => ['companionControllerExchangePairingToken'] as const;

export const getCompanionControllerExchangePairingTokenMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerExchangePairingToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionControllerExchangePairingToken>>, TError,void, TContext> => {

const mutationKey = getCompanionControllerExchangePairingTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionControllerExchangePairingToken>>, void> = () => {


          return  companionControllerExchangePairingToken(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionControllerExchangePairingTokenMutationResult = NonNullable<Awaited<ReturnType<typeof companionControllerExchangePairingToken>>>

    export type CompanionControllerExchangePairingTokenMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


    export const useCompanionControllerExchangePairingToken = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerExchangePairingToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionControllerExchangePairingToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCompanionControllerExchangePairingTokenMutationOptions(options), queryClient);
    }

export type companionControllerRefreshTokenResponse200 = {
  data: ResponseCompanionAuthDto
  status: 200
}

export type companionControllerRefreshTokenResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionControllerRefreshTokenResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionControllerRefreshTokenResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionControllerRefreshTokenResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionControllerRefreshTokenResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionControllerRefreshTokenResponseSuccess = (companionControllerRefreshTokenResponse200) & {
  headers: Headers;
};
export type companionControllerRefreshTokenResponseError = (companionControllerRefreshTokenResponse400 | companionControllerRefreshTokenResponse401 | companionControllerRefreshTokenResponse403 | companionControllerRefreshTokenResponse404 | companionControllerRefreshTokenResponse500) & {
  headers: Headers;
};

export type companionControllerRefreshTokenResponse = (companionControllerRefreshTokenResponseSuccess | companionControllerRefreshTokenResponseError)

export const getCompanionControllerRefreshTokenUrl = () => {




  return `/companion/refresh-token`
}

export const companionControllerRefreshToken = async ( options?: Parameters<typeof customFetch>[1]): Promise<companionControllerRefreshTokenResponse> => {

  return customFetch<companionControllerRefreshTokenResponse>(getCompanionControllerRefreshTokenUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompanionControllerRefreshTokenMutationKey = () => ['companionControllerRefreshToken'] as const;

export const getCompanionControllerRefreshTokenMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerRefreshToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionControllerRefreshToken>>, TError,void, TContext> => {

const mutationKey = getCompanionControllerRefreshTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionControllerRefreshToken>>, void> = () => {


          return  companionControllerRefreshToken(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionControllerRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof companionControllerRefreshToken>>>

    export type CompanionControllerRefreshTokenMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


    export const useCompanionControllerRefreshToken = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerRefreshToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionControllerRefreshToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCompanionControllerRefreshTokenMutationOptions(options), queryClient);
    }

export type companionControllerFindManyResponse200 = {
  data: ResponseCompanionSessionStatusDto[]
  status: 200
}

export type companionControllerFindManyResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionControllerFindManyResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionControllerFindManyResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionControllerFindManyResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionControllerFindManyResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionControllerFindManyResponseSuccess = (companionControllerFindManyResponse200) & {
  headers: Headers;
};
export type companionControllerFindManyResponseError = (companionControllerFindManyResponse400 | companionControllerFindManyResponse401 | companionControllerFindManyResponse403 | companionControllerFindManyResponse404 | companionControllerFindManyResponse500) & {
  headers: Headers;
};

export type companionControllerFindManyResponse = (companionControllerFindManyResponseSuccess | companionControllerFindManyResponseError)

export const getCompanionControllerFindManyUrl = () => {




  return `/companion/list`
}

export const companionControllerFindMany = async ( options?: Parameters<typeof customFetch>[1]): Promise<companionControllerFindManyResponse> => {

  return customFetch<companionControllerFindManyResponse>(getCompanionControllerFindManyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanionControllerFindManyQueryKey = () => {
    return [
    'companion','list'
    ] as const;
    }


export const getCompanionControllerFindManyQueryOptions = <TData = Awaited<ReturnType<typeof companionControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getCompanionControllerFindManyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companionControllerFindMany>>> = ({ signal }) => companionControllerFindMany({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindMany>>, TError, TData>
}

export type CompanionControllerFindManyQueryResult = NonNullable<Awaited<ReturnType<typeof companionControllerFindMany>>>
export type CompanionControllerFindManyQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useCompanionControllerFindMany<TData = Awaited<ReturnType<typeof companionControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanionControllerFindManyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type companionControllerFindOneResponse200 = {
  data: ResponseCompanionSessionStatusDto
  status: 200
}

export type companionControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionControllerFindOneResponseSuccess = (companionControllerFindOneResponse200) & {
  headers: Headers;
};
export type companionControllerFindOneResponseError = (companionControllerFindOneResponse400 | companionControllerFindOneResponse401 | companionControllerFindOneResponse403 | companionControllerFindOneResponse404 | companionControllerFindOneResponse500) & {
  headers: Headers;
};

export type companionControllerFindOneResponse = (companionControllerFindOneResponseSuccess | companionControllerFindOneResponseError)

export const getCompanionControllerFindOneUrl = (companionId: string,) => {




  return `/companion/${companionId}`
}

export const companionControllerFindOne = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionControllerFindOneResponse> => {

  return customFetch<companionControllerFindOneResponse>(getCompanionControllerFindOneUrl(companionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanionControllerFindOneQueryKey = (companionId: MaybeRefOrGetter<string>,) => {
    return [
    'companion',companionId
    ] as const;
    }


export const getCompanionControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof companionControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getCompanionControllerFindOneQueryKey(companionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companionControllerFindOne>>> = ({ signal }) => companionControllerFindOne(toValue(companionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companionId) !== null && toValue(companionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindOne>>, TError, TData>
}

export type CompanionControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof companionControllerFindOne>>>
export type CompanionControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useCompanionControllerFindOne<TData = Awaited<ReturnType<typeof companionControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanionControllerFindOneQueryOptions(companionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type companionControllerDeleteResponse200 = {
  data: ResponseCompanionSessionDto
  status: 200
}

export type companionControllerDeleteResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionControllerDeleteResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionControllerDeleteResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionControllerDeleteResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionControllerDeleteResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionControllerDeleteResponseSuccess = (companionControllerDeleteResponse200) & {
  headers: Headers;
};
export type companionControllerDeleteResponseError = (companionControllerDeleteResponse400 | companionControllerDeleteResponse401 | companionControllerDeleteResponse403 | companionControllerDeleteResponse404 | companionControllerDeleteResponse500) & {
  headers: Headers;
};

export type companionControllerDeleteResponse = (companionControllerDeleteResponseSuccess | companionControllerDeleteResponseError)

export const getCompanionControllerDeleteUrl = (companionId: string,) => {




  return `/companion/${companionId}`
}

export const companionControllerDelete = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionControllerDeleteResponse> => {

  return customFetch<companionControllerDeleteResponse>(getCompanionControllerDeleteUrl(companionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCompanionControllerDeleteMutationKey = () => ['companionControllerDelete'] as const;

export const getCompanionControllerDeleteMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerDelete>>, TError,CompanionControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionControllerDelete>>, TError,CompanionControllerDeleteMutationVariables, TContext> => {

const mutationKey = getCompanionControllerDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionControllerDelete>>, CompanionControllerDeleteMutationVariables> = (props) => {
          const {companionId} = props ?? {};

          return  companionControllerDelete(companionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof companionControllerDelete>>>

    export type CompanionControllerDeleteMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionControllerDeleteMutationVariables = {companionId: string}

    export const useCompanionControllerDelete = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionControllerDelete>>, TError,CompanionControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionControllerDelete>>,
        TError,
        CompanionControllerDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionControllerDeleteMutationOptions(options), queryClient);
    }

export type companionControllerFindUserResponse200 = {
  data: RefUserDto
  status: 200
}

export type companionControllerFindUserResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionControllerFindUserResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionControllerFindUserResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionControllerFindUserResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionControllerFindUserResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionControllerFindUserResponseSuccess = (companionControllerFindUserResponse200) & {
  headers: Headers;
};
export type companionControllerFindUserResponseError = (companionControllerFindUserResponse400 | companionControllerFindUserResponse401 | companionControllerFindUserResponse403 | companionControllerFindUserResponse404 | companionControllerFindUserResponse500) & {
  headers: Headers;
};

export type companionControllerFindUserResponse = (companionControllerFindUserResponseSuccess | companionControllerFindUserResponseError)

export const getCompanionControllerFindUserUrl = (companionId: string,) => {




  return `/companion/${companionId}/user`
}

export const companionControllerFindUser = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionControllerFindUserResponse> => {

  return customFetch<companionControllerFindUserResponse>(getCompanionControllerFindUserUrl(companionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanionControllerFindUserQueryKey = (companionId: MaybeRefOrGetter<string>,) => {
    return [
    'companion',companionId,'user'
    ] as const;
    }


export const getCompanionControllerFindUserQueryOptions = <TData = Awaited<ReturnType<typeof companionControllerFindUser>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getCompanionControllerFindUserQueryKey(companionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companionControllerFindUser>>> = ({ signal }) => companionControllerFindUser(toValue(companionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companionId) !== null && toValue(companionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindUser>>, TError, TData>
}

export type CompanionControllerFindUserQueryResult = NonNullable<Awaited<ReturnType<typeof companionControllerFindUser>>>
export type CompanionControllerFindUserQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useCompanionControllerFindUser<TData = Awaited<ReturnType<typeof companionControllerFindUser>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionControllerFindUser>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanionControllerFindUserQueryOptions(companionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type companionBarcodeControllerCreateResponse200 = {
  data: CompanionBarcodeScanDto
  status: 200
}

export type companionBarcodeControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionBarcodeControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionBarcodeControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionBarcodeControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionBarcodeControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionBarcodeControllerCreateResponseSuccess = (companionBarcodeControllerCreateResponse200) & {
  headers: Headers;
};
export type companionBarcodeControllerCreateResponseError = (companionBarcodeControllerCreateResponse400 | companionBarcodeControllerCreateResponse401 | companionBarcodeControllerCreateResponse403 | companionBarcodeControllerCreateResponse404 | companionBarcodeControllerCreateResponse500) & {
  headers: Headers;
};

export type companionBarcodeControllerCreateResponse = (companionBarcodeControllerCreateResponseSuccess | companionBarcodeControllerCreateResponseError)

export const getCompanionBarcodeControllerCreateUrl = (companionId: string,) => {




  return `/companion/${companionId}/barcode`
}

export const companionBarcodeControllerCreate = async (companionId: string,
    createCompanionBarcodeScanDto: CreateCompanionBarcodeScanDto, options?: Parameters<typeof customFetch>[1]): Promise<companionBarcodeControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionBarcodeControllerCreateResponse>(getCompanionBarcodeControllerCreateUrl(companionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCompanionBarcodeScanDto)
  }
);}





export const getCompanionBarcodeControllerCreateMutationKey = () => ['companionBarcodeControllerCreate'] as const;

export const getCompanionBarcodeControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionBarcodeControllerCreate>>, TError,CompanionBarcodeControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionBarcodeControllerCreate>>, TError,CompanionBarcodeControllerCreateMutationVariables, TContext> => {

const mutationKey = getCompanionBarcodeControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionBarcodeControllerCreate>>, CompanionBarcodeControllerCreateMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionBarcodeControllerCreate(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionBarcodeControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companionBarcodeControllerCreate>>>
    export type CompanionBarcodeControllerCreateMutationBody = CreateCompanionBarcodeScanDto
    export type CompanionBarcodeControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionBarcodeControllerCreateMutationVariables = {companionId: string;data: CreateCompanionBarcodeScanDto}

    export const useCompanionBarcodeControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionBarcodeControllerCreate>>, TError,CompanionBarcodeControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionBarcodeControllerCreate>>,
        TError,
        CompanionBarcodeControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionBarcodeControllerCreateMutationOptions(options), queryClient);
    }

export type companionFileControllerFindManyResponse200 = {
  data: CompanionFileDto[]
  status: 200
}

export type companionFileControllerFindManyResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionFileControllerFindManyResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionFileControllerFindManyResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionFileControllerFindManyResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionFileControllerFindManyResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionFileControllerFindManyResponseSuccess = (companionFileControllerFindManyResponse200) & {
  headers: Headers;
};
export type companionFileControllerFindManyResponseError = (companionFileControllerFindManyResponse400 | companionFileControllerFindManyResponse401 | companionFileControllerFindManyResponse403 | companionFileControllerFindManyResponse404 | companionFileControllerFindManyResponse500) & {
  headers: Headers;
};

export type companionFileControllerFindManyResponse = (companionFileControllerFindManyResponseSuccess | companionFileControllerFindManyResponseError)

export const getCompanionFileControllerFindManyUrl = (companionId: string,) => {




  return `/companion/${companionId}/file`
}

export const companionFileControllerFindMany = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionFileControllerFindManyResponse> => {

  return customFetch<companionFileControllerFindManyResponse>(getCompanionFileControllerFindManyUrl(companionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanionFileControllerFindManyQueryKey = (companionId: MaybeRefOrGetter<string>,) => {
    return [
    'companion',companionId,'file'
    ] as const;
    }


export const getCompanionFileControllerFindManyQueryOptions = <TData = Awaited<ReturnType<typeof companionFileControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionFileControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getCompanionFileControllerFindManyQueryKey(companionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companionFileControllerFindMany>>> = ({ signal }) => companionFileControllerFindMany(toValue(companionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companionId) !== null && toValue(companionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companionFileControllerFindMany>>, TError, TData>
}

export type CompanionFileControllerFindManyQueryResult = NonNullable<Awaited<ReturnType<typeof companionFileControllerFindMany>>>
export type CompanionFileControllerFindManyQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useCompanionFileControllerFindMany<TData = Awaited<ReturnType<typeof companionFileControllerFindMany>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionFileControllerFindMany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanionFileControllerFindManyQueryOptions(companionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type companionFileControllerCreateResponse201 = {
  data: CompanionFileDto
  status: 201
}

export type companionFileControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionFileControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionFileControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionFileControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionFileControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionFileControllerCreateResponseSuccess = (companionFileControllerCreateResponse201) & {
  headers: Headers;
};
export type companionFileControllerCreateResponseError = (companionFileControllerCreateResponse400 | companionFileControllerCreateResponse401 | companionFileControllerCreateResponse403 | companionFileControllerCreateResponse404 | companionFileControllerCreateResponse500) & {
  headers: Headers;
};

export type companionFileControllerCreateResponse = (companionFileControllerCreateResponseSuccess | companionFileControllerCreateResponseError)

export const getCompanionFileControllerCreateUrl = (companionId: string,) => {




  return `/companion/${companionId}/file`
}

export const companionFileControllerCreate = async (companionId: string,
    createCompanionFileTokenDto: CreateCompanionFileTokenDto, options?: Parameters<typeof customFetch>[1]): Promise<companionFileControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionFileControllerCreateResponse>(getCompanionFileControllerCreateUrl(companionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCompanionFileTokenDto)
  }
);}





export const getCompanionFileControllerCreateMutationKey = () => ['companionFileControllerCreate'] as const;

export const getCompanionFileControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerCreate>>, TError,CompanionFileControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerCreate>>, TError,CompanionFileControllerCreateMutationVariables, TContext> => {

const mutationKey = getCompanionFileControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionFileControllerCreate>>, CompanionFileControllerCreateMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionFileControllerCreate(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionFileControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companionFileControllerCreate>>>
    export type CompanionFileControllerCreateMutationBody = CreateCompanionFileTokenDto
    export type CompanionFileControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionFileControllerCreateMutationVariables = {companionId: string;data: CreateCompanionFileTokenDto}

    export const useCompanionFileControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerCreate>>, TError,CompanionFileControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionFileControllerCreate>>,
        TError,
        CompanionFileControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionFileControllerCreateMutationOptions(options), queryClient);
    }

export type companionFileControllerSignResponse201 = {
  data: ResponseUploadS3SignDto
  status: 201
}

export type companionFileControllerSignResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionFileControllerSignResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionFileControllerSignResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionFileControllerSignResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionFileControllerSignResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionFileControllerSignResponseSuccess = (companionFileControllerSignResponse201) & {
  headers: Headers;
};
export type companionFileControllerSignResponseError = (companionFileControllerSignResponse400 | companionFileControllerSignResponse401 | companionFileControllerSignResponse403 | companionFileControllerSignResponse404 | companionFileControllerSignResponse500) & {
  headers: Headers;
};

export type companionFileControllerSignResponse = (companionFileControllerSignResponseSuccess | companionFileControllerSignResponseError)

export const getCompanionFileControllerSignUrl = (companionId: string,) => {




  return `/companion/${companionId}/file/sign`
}

export const companionFileControllerSign = async (companionId: string,
    signCompanionFileTokenDto: SignCompanionFileTokenDto, options?: Parameters<typeof customFetch>[1]): Promise<companionFileControllerSignResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionFileControllerSignResponse>(getCompanionFileControllerSignUrl(companionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(signCompanionFileTokenDto)
  }
);}





export const getCompanionFileControllerSignMutationKey = () => ['companionFileControllerSign'] as const;

export const getCompanionFileControllerSignMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerSign>>, TError,CompanionFileControllerSignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerSign>>, TError,CompanionFileControllerSignMutationVariables, TContext> => {

const mutationKey = getCompanionFileControllerSignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionFileControllerSign>>, CompanionFileControllerSignMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionFileControllerSign(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionFileControllerSignMutationResult = NonNullable<Awaited<ReturnType<typeof companionFileControllerSign>>>
    export type CompanionFileControllerSignMutationBody = SignCompanionFileTokenDto
    export type CompanionFileControllerSignMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionFileControllerSignMutationVariables = {companionId: string;data: SignCompanionFileTokenDto}

    export const useCompanionFileControllerSign = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerSign>>, TError,CompanionFileControllerSignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionFileControllerSign>>,
        TError,
        CompanionFileControllerSignMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionFileControllerSignMutationOptions(options), queryClient);
    }

export type companionFileControllerRemoveResponse200 = {
  data: CompanionFileDto
  status: 200
}

export type companionFileControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionFileControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionFileControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionFileControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionFileControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionFileControllerRemoveResponseSuccess = (companionFileControllerRemoveResponse200) & {
  headers: Headers;
};
export type companionFileControllerRemoveResponseError = (companionFileControllerRemoveResponse400 | companionFileControllerRemoveResponse401 | companionFileControllerRemoveResponse403 | companionFileControllerRemoveResponse404 | companionFileControllerRemoveResponse500) & {
  headers: Headers;
};

export type companionFileControllerRemoveResponse = (companionFileControllerRemoveResponseSuccess | companionFileControllerRemoveResponseError)

export const getCompanionFileControllerRemoveUrl = (companionId: string,
    fileId: string,) => {




  return `/companion/${companionId}/file/${fileId}`
}

export const companionFileControllerRemove = async (companionId: string,
    fileId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionFileControllerRemoveResponse> => {

  return customFetch<companionFileControllerRemoveResponse>(getCompanionFileControllerRemoveUrl(companionId,fileId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCompanionFileControllerRemoveMutationKey = () => ['companionFileControllerRemove'] as const;

export const getCompanionFileControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerRemove>>, TError,CompanionFileControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerRemove>>, TError,CompanionFileControllerRemoveMutationVariables, TContext> => {

const mutationKey = getCompanionFileControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionFileControllerRemove>>, CompanionFileControllerRemoveMutationVariables> = (props) => {
          const {companionId,fileId} = props ?? {};

          return  companionFileControllerRemove(companionId,fileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionFileControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof companionFileControllerRemove>>>

    export type CompanionFileControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionFileControllerRemoveMutationVariables = {companionId: string;fileId: string}

    export const useCompanionFileControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionFileControllerRemove>>, TError,CompanionFileControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionFileControllerRemove>>,
        TError,
        CompanionFileControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionFileControllerRemoveMutationOptions(options), queryClient);
    }

export type companionOfferCreateControllerFindStateResponse200 = {
  data: CompanionOfferCreateStateDto
  status: 200
}

export type companionOfferCreateControllerFindStateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferCreateControllerFindStateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferCreateControllerFindStateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferCreateControllerFindStateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferCreateControllerFindStateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferCreateControllerFindStateResponseSuccess = (companionOfferCreateControllerFindStateResponse200) & {
  headers: Headers;
};
export type companionOfferCreateControllerFindStateResponseError = (companionOfferCreateControllerFindStateResponse400 | companionOfferCreateControllerFindStateResponse401 | companionOfferCreateControllerFindStateResponse403 | companionOfferCreateControllerFindStateResponse404 | companionOfferCreateControllerFindStateResponse500) & {
  headers: Headers;
};

export type companionOfferCreateControllerFindStateResponse = (companionOfferCreateControllerFindStateResponseSuccess | companionOfferCreateControllerFindStateResponseError)

export const getCompanionOfferCreateControllerFindStateUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/create`
}

export const companionOfferCreateControllerFindState = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferCreateControllerFindStateResponse> => {

  return customFetch<companionOfferCreateControllerFindStateResponse>(getCompanionOfferCreateControllerFindStateUrl(companionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanionOfferCreateControllerFindStateQueryKey = (companionId: MaybeRefOrGetter<string>,) => {
    return [
    'companion',companionId,'offer','create'
    ] as const;
    }


export const getCompanionOfferCreateControllerFindStateQueryOptions = <TData = Awaited<ReturnType<typeof companionOfferCreateControllerFindState>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionOfferCreateControllerFindState>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getCompanionOfferCreateControllerFindStateQueryKey(companionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companionOfferCreateControllerFindState>>> = ({ signal }) => companionOfferCreateControllerFindState(toValue(companionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companionId) !== null && toValue(companionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companionOfferCreateControllerFindState>>, TError, TData>
}

export type CompanionOfferCreateControllerFindStateQueryResult = NonNullable<Awaited<ReturnType<typeof companionOfferCreateControllerFindState>>>
export type CompanionOfferCreateControllerFindStateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useCompanionOfferCreateControllerFindState<TData = Awaited<ReturnType<typeof companionOfferCreateControllerFindState>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionOfferCreateControllerFindState>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanionOfferCreateControllerFindStateQueryOptions(companionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type companionOfferCreateControllerCreateResponse201 = {
  data: RefOfferDto
  status: 201
}

export type companionOfferCreateControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferCreateControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferCreateControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferCreateControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferCreateControllerCreateResponse409 = {
  data: ErrorConflictDto
  status: 409
}

export type companionOfferCreateControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferCreateControllerCreateResponseSuccess = (companionOfferCreateControllerCreateResponse201) & {
  headers: Headers;
};
export type companionOfferCreateControllerCreateResponseError = (companionOfferCreateControllerCreateResponse400 | companionOfferCreateControllerCreateResponse401 | companionOfferCreateControllerCreateResponse403 | companionOfferCreateControllerCreateResponse404 | companionOfferCreateControllerCreateResponse409 | companionOfferCreateControllerCreateResponse500) & {
  headers: Headers;
};

export type companionOfferCreateControllerCreateResponse = (companionOfferCreateControllerCreateResponseSuccess | companionOfferCreateControllerCreateResponseError)

export const getCompanionOfferCreateControllerCreateUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/create`
}

export const companionOfferCreateControllerCreate = async (companionId: string,
    createCompanionOfferDto: CreateCompanionOfferDto, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferCreateControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionOfferCreateControllerCreateResponse>(getCompanionOfferCreateControllerCreateUrl(companionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCompanionOfferDto)
  }
);}





export const getCompanionOfferCreateControllerCreateMutationKey = () => ['companionOfferCreateControllerCreate'] as const;

export const getCompanionOfferCreateControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorConflictDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerCreate>>, TError,CompanionOfferCreateControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerCreate>>, TError,CompanionOfferCreateControllerCreateMutationVariables, TContext> => {

const mutationKey = getCompanionOfferCreateControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionOfferCreateControllerCreate>>, CompanionOfferCreateControllerCreateMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionOfferCreateControllerCreate(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionOfferCreateControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companionOfferCreateControllerCreate>>>
    export type CompanionOfferCreateControllerCreateMutationBody = CreateCompanionOfferDto
    export type CompanionOfferCreateControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorConflictDto | ErrorServerDto
    export type CompanionOfferCreateControllerCreateMutationVariables = {companionId: string;data: CreateCompanionOfferDto}

    export const useCompanionOfferCreateControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorConflictDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerCreate>>, TError,CompanionOfferCreateControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionOfferCreateControllerCreate>>,
        TError,
        CompanionOfferCreateControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionOfferCreateControllerCreateMutationOptions(options), queryClient);
    }

export type companionOfferCreateControllerSetSourceResponse200 = {
  data: CompanionOfferCreateStateDto
  status: 200
}

export type companionOfferCreateControllerSetSourceResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferCreateControllerSetSourceResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferCreateControllerSetSourceResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferCreateControllerSetSourceResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferCreateControllerSetSourceResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferCreateControllerSetSourceResponseSuccess = (companionOfferCreateControllerSetSourceResponse200) & {
  headers: Headers;
};
export type companionOfferCreateControllerSetSourceResponseError = (companionOfferCreateControllerSetSourceResponse400 | companionOfferCreateControllerSetSourceResponse401 | companionOfferCreateControllerSetSourceResponse403 | companionOfferCreateControllerSetSourceResponse404 | companionOfferCreateControllerSetSourceResponse500) & {
  headers: Headers;
};

export type companionOfferCreateControllerSetSourceResponse = (companionOfferCreateControllerSetSourceResponseSuccess | companionOfferCreateControllerSetSourceResponseError)

export const getCompanionOfferCreateControllerSetSourceUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/create/source`
}

export const companionOfferCreateControllerSetSource = async (companionId: string,
    setCompanionOfferSourceDto: SetCompanionOfferSourceDto, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferCreateControllerSetSourceResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionOfferCreateControllerSetSourceResponse>(getCompanionOfferCreateControllerSetSourceUrl(companionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setCompanionOfferSourceDto)
  }
);}





export const getCompanionOfferCreateControllerSetSourceMutationKey = () => ['companionOfferCreateControllerSetSource'] as const;

export const getCompanionOfferCreateControllerSetSourceMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerSetSource>>, TError,CompanionOfferCreateControllerSetSourceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerSetSource>>, TError,CompanionOfferCreateControllerSetSourceMutationVariables, TContext> => {

const mutationKey = getCompanionOfferCreateControllerSetSourceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionOfferCreateControllerSetSource>>, CompanionOfferCreateControllerSetSourceMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionOfferCreateControllerSetSource(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionOfferCreateControllerSetSourceMutationResult = NonNullable<Awaited<ReturnType<typeof companionOfferCreateControllerSetSource>>>
    export type CompanionOfferCreateControllerSetSourceMutationBody = SetCompanionOfferSourceDto
    export type CompanionOfferCreateControllerSetSourceMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionOfferCreateControllerSetSourceMutationVariables = {companionId: string;data: SetCompanionOfferSourceDto}

    export const useCompanionOfferCreateControllerSetSource = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerSetSource>>, TError,CompanionOfferCreateControllerSetSourceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionOfferCreateControllerSetSource>>,
        TError,
        CompanionOfferCreateControllerSetSourceMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionOfferCreateControllerSetSourceMutationOptions(options), queryClient);
    }

export type companionOfferCreateControllerSignImageResponse200 = {
  data: ResponseUploadS3SignDto
  status: 200
}

export type companionOfferCreateControllerSignImageResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferCreateControllerSignImageResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferCreateControllerSignImageResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferCreateControllerSignImageResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferCreateControllerSignImageResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferCreateControllerSignImageResponseSuccess = (companionOfferCreateControllerSignImageResponse200) & {
  headers: Headers;
};
export type companionOfferCreateControllerSignImageResponseError = (companionOfferCreateControllerSignImageResponse400 | companionOfferCreateControllerSignImageResponse401 | companionOfferCreateControllerSignImageResponse403 | companionOfferCreateControllerSignImageResponse404 | companionOfferCreateControllerSignImageResponse500) & {
  headers: Headers;
};

export type companionOfferCreateControllerSignImageResponse = (companionOfferCreateControllerSignImageResponseSuccess | companionOfferCreateControllerSignImageResponseError)

export const getCompanionOfferCreateControllerSignImageUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/create/image/sign`
}

export const companionOfferCreateControllerSignImage = async (companionId: string,
    signCompanionOfferImageDto: SignCompanionOfferImageDto, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferCreateControllerSignImageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionOfferCreateControllerSignImageResponse>(getCompanionOfferCreateControllerSignImageUrl(companionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(signCompanionOfferImageDto)
  }
);}





export const getCompanionOfferCreateControllerSignImageMutationKey = () => ['companionOfferCreateControllerSignImage'] as const;

export const getCompanionOfferCreateControllerSignImageMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerSignImage>>, TError,CompanionOfferCreateControllerSignImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerSignImage>>, TError,CompanionOfferCreateControllerSignImageMutationVariables, TContext> => {

const mutationKey = getCompanionOfferCreateControllerSignImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionOfferCreateControllerSignImage>>, CompanionOfferCreateControllerSignImageMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionOfferCreateControllerSignImage(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionOfferCreateControllerSignImageMutationResult = NonNullable<Awaited<ReturnType<typeof companionOfferCreateControllerSignImage>>>
    export type CompanionOfferCreateControllerSignImageMutationBody = SignCompanionOfferImageDto
    export type CompanionOfferCreateControllerSignImageMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionOfferCreateControllerSignImageMutationVariables = {companionId: string;data: SignCompanionOfferImageDto}

    export const useCompanionOfferCreateControllerSignImage = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerSignImage>>, TError,CompanionOfferCreateControllerSignImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionOfferCreateControllerSignImage>>,
        TError,
        CompanionOfferCreateControllerSignImageMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionOfferCreateControllerSignImageMutationOptions(options), queryClient);
    }

export type companionOfferCreateControllerCreateImageResponse201 = {
  data: ResponseOfferImageDto
  status: 201
}

export type companionOfferCreateControllerCreateImageResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferCreateControllerCreateImageResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferCreateControllerCreateImageResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferCreateControllerCreateImageResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferCreateControllerCreateImageResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferCreateControllerCreateImageResponseSuccess = (companionOfferCreateControllerCreateImageResponse201) & {
  headers: Headers;
};
export type companionOfferCreateControllerCreateImageResponseError = (companionOfferCreateControllerCreateImageResponse400 | companionOfferCreateControllerCreateImageResponse401 | companionOfferCreateControllerCreateImageResponse403 | companionOfferCreateControllerCreateImageResponse404 | companionOfferCreateControllerCreateImageResponse500) & {
  headers: Headers;
};

export type companionOfferCreateControllerCreateImageResponse = (companionOfferCreateControllerCreateImageResponseSuccess | companionOfferCreateControllerCreateImageResponseError)

export const getCompanionOfferCreateControllerCreateImageUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/create/image`
}

export const companionOfferCreateControllerCreateImage = async (companionId: string,
    createCompanionOfferImageDto: CreateCompanionOfferImageDto, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferCreateControllerCreateImageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionOfferCreateControllerCreateImageResponse>(getCompanionOfferCreateControllerCreateImageUrl(companionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCompanionOfferImageDto)
  }
);}





export const getCompanionOfferCreateControllerCreateImageMutationKey = () => ['companionOfferCreateControllerCreateImage'] as const;

export const getCompanionOfferCreateControllerCreateImageMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerCreateImage>>, TError,CompanionOfferCreateControllerCreateImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerCreateImage>>, TError,CompanionOfferCreateControllerCreateImageMutationVariables, TContext> => {

const mutationKey = getCompanionOfferCreateControllerCreateImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionOfferCreateControllerCreateImage>>, CompanionOfferCreateControllerCreateImageMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionOfferCreateControllerCreateImage(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionOfferCreateControllerCreateImageMutationResult = NonNullable<Awaited<ReturnType<typeof companionOfferCreateControllerCreateImage>>>
    export type CompanionOfferCreateControllerCreateImageMutationBody = CreateCompanionOfferImageDto
    export type CompanionOfferCreateControllerCreateImageMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionOfferCreateControllerCreateImageMutationVariables = {companionId: string;data: CreateCompanionOfferImageDto}

    export const useCompanionOfferCreateControllerCreateImage = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferCreateControllerCreateImage>>, TError,CompanionOfferCreateControllerCreateImageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionOfferCreateControllerCreateImage>>,
        TError,
        CompanionOfferCreateControllerCreateImageMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionOfferCreateControllerCreateImageMutationOptions(options), queryClient);
    }

export type companionOfferDisplayControllerFindDisplayResponse200 = {
  data: CompanionOfferDisplayDto
  status: 200
}

export type companionOfferDisplayControllerFindDisplayResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferDisplayControllerFindDisplayResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferDisplayControllerFindDisplayResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferDisplayControllerFindDisplayResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferDisplayControllerFindDisplayResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferDisplayControllerFindDisplayResponseSuccess = (companionOfferDisplayControllerFindDisplayResponse200) & {
  headers: Headers;
};
export type companionOfferDisplayControllerFindDisplayResponseError = (companionOfferDisplayControllerFindDisplayResponse400 | companionOfferDisplayControllerFindDisplayResponse401 | companionOfferDisplayControllerFindDisplayResponse403 | companionOfferDisplayControllerFindDisplayResponse404 | companionOfferDisplayControllerFindDisplayResponse500) & {
  headers: Headers;
};

export type companionOfferDisplayControllerFindDisplayResponse = (companionOfferDisplayControllerFindDisplayResponseSuccess | companionOfferDisplayControllerFindDisplayResponseError)

export const getCompanionOfferDisplayControllerFindDisplayUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/display`
}

export const companionOfferDisplayControllerFindDisplay = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferDisplayControllerFindDisplayResponse> => {

  return customFetch<companionOfferDisplayControllerFindDisplayResponse>(getCompanionOfferDisplayControllerFindDisplayUrl(companionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanionOfferDisplayControllerFindDisplayQueryKey = (companionId: MaybeRefOrGetter<string>,) => {
    return [
    'companion',companionId,'offer','display'
    ] as const;
    }


export const getCompanionOfferDisplayControllerFindDisplayQueryOptions = <TData = Awaited<ReturnType<typeof companionOfferDisplayControllerFindDisplay>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerFindDisplay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getCompanionOfferDisplayControllerFindDisplayQueryKey(companionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companionOfferDisplayControllerFindDisplay>>> = ({ signal }) => companionOfferDisplayControllerFindDisplay(toValue(companionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companionId) !== null && toValue(companionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerFindDisplay>>, TError, TData>
}

export type CompanionOfferDisplayControllerFindDisplayQueryResult = NonNullable<Awaited<ReturnType<typeof companionOfferDisplayControllerFindDisplay>>>
export type CompanionOfferDisplayControllerFindDisplayQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useCompanionOfferDisplayControllerFindDisplay<TData = Awaited<ReturnType<typeof companionOfferDisplayControllerFindDisplay>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerFindDisplay>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanionOfferDisplayControllerFindDisplayQueryOptions(companionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type companionOfferDisplayControllerSetOfferResponse200 = {
  data: CompanionOfferDisplayDto
  status: 200
}

export type companionOfferDisplayControllerSetOfferResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferDisplayControllerSetOfferResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferDisplayControllerSetOfferResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferDisplayControllerSetOfferResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferDisplayControllerSetOfferResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferDisplayControllerSetOfferResponseSuccess = (companionOfferDisplayControllerSetOfferResponse200) & {
  headers: Headers;
};
export type companionOfferDisplayControllerSetOfferResponseError = (companionOfferDisplayControllerSetOfferResponse400 | companionOfferDisplayControllerSetOfferResponse401 | companionOfferDisplayControllerSetOfferResponse403 | companionOfferDisplayControllerSetOfferResponse404 | companionOfferDisplayControllerSetOfferResponse500) & {
  headers: Headers;
};

export type companionOfferDisplayControllerSetOfferResponse = (companionOfferDisplayControllerSetOfferResponseSuccess | companionOfferDisplayControllerSetOfferResponseError)

export const getCompanionOfferDisplayControllerSetOfferUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/display`
}

export const companionOfferDisplayControllerSetOffer = async (companionId: string,
    setCompanionOfferDisplayDto: SetCompanionOfferDisplayDto, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferDisplayControllerSetOfferResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionOfferDisplayControllerSetOfferResponse>(getCompanionOfferDisplayControllerSetOfferUrl(companionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setCompanionOfferDisplayDto)
  }
);}





export const getCompanionOfferDisplayControllerSetOfferMutationKey = () => ['companionOfferDisplayControllerSetOffer'] as const;

export const getCompanionOfferDisplayControllerSetOfferMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerSetOffer>>, TError,CompanionOfferDisplayControllerSetOfferMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerSetOffer>>, TError,CompanionOfferDisplayControllerSetOfferMutationVariables, TContext> => {

const mutationKey = getCompanionOfferDisplayControllerSetOfferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionOfferDisplayControllerSetOffer>>, CompanionOfferDisplayControllerSetOfferMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionOfferDisplayControllerSetOffer(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionOfferDisplayControllerSetOfferMutationResult = NonNullable<Awaited<ReturnType<typeof companionOfferDisplayControllerSetOffer>>>
    export type CompanionOfferDisplayControllerSetOfferMutationBody = SetCompanionOfferDisplayDto
    export type CompanionOfferDisplayControllerSetOfferMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionOfferDisplayControllerSetOfferMutationVariables = {companionId: string;data: SetCompanionOfferDisplayDto}

    export const useCompanionOfferDisplayControllerSetOffer = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerSetOffer>>, TError,CompanionOfferDisplayControllerSetOfferMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionOfferDisplayControllerSetOffer>>,
        TError,
        CompanionOfferDisplayControllerSetOfferMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionOfferDisplayControllerSetOfferMutationOptions(options), queryClient);
    }

export type companionOfferDisplayControllerUpdateResponse200 = {
  data: CompanionOfferDisplayDto
  status: 200
}

export type companionOfferDisplayControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferDisplayControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferDisplayControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferDisplayControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferDisplayControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferDisplayControllerUpdateResponseSuccess = (companionOfferDisplayControllerUpdateResponse200) & {
  headers: Headers;
};
export type companionOfferDisplayControllerUpdateResponseError = (companionOfferDisplayControllerUpdateResponse400 | companionOfferDisplayControllerUpdateResponse401 | companionOfferDisplayControllerUpdateResponse403 | companionOfferDisplayControllerUpdateResponse404 | companionOfferDisplayControllerUpdateResponse500) & {
  headers: Headers;
};

export type companionOfferDisplayControllerUpdateResponse = (companionOfferDisplayControllerUpdateResponseSuccess | companionOfferDisplayControllerUpdateResponseError)

export const getCompanionOfferDisplayControllerUpdateUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/display/update`
}

export const companionOfferDisplayControllerUpdate = async (companionId: string,
    updateCompanionOfferDisplayDto: UpdateCompanionOfferDisplayDto, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferDisplayControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionOfferDisplayControllerUpdateResponse>(getCompanionOfferDisplayControllerUpdateUrl(companionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCompanionOfferDisplayDto)
  }
);}





export const getCompanionOfferDisplayControllerUpdateMutationKey = () => ['companionOfferDisplayControllerUpdate'] as const;

export const getCompanionOfferDisplayControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerUpdate>>, TError,CompanionOfferDisplayControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerUpdate>>, TError,CompanionOfferDisplayControllerUpdateMutationVariables, TContext> => {

const mutationKey = getCompanionOfferDisplayControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionOfferDisplayControllerUpdate>>, CompanionOfferDisplayControllerUpdateMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionOfferDisplayControllerUpdate(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionOfferDisplayControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companionOfferDisplayControllerUpdate>>>
    export type CompanionOfferDisplayControllerUpdateMutationBody = UpdateCompanionOfferDisplayDto
    export type CompanionOfferDisplayControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionOfferDisplayControllerUpdateMutationVariables = {companionId: string;data: UpdateCompanionOfferDisplayDto}

    export const useCompanionOfferDisplayControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerUpdate>>, TError,CompanionOfferDisplayControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionOfferDisplayControllerUpdate>>,
        TError,
        CompanionOfferDisplayControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionOfferDisplayControllerUpdateMutationOptions(options), queryClient);
    }

export type companionOfferDisplayControllerSetReceiptResponse204 = {
  data: void
  status: 204
}

export type companionOfferDisplayControllerSetReceiptResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferDisplayControllerSetReceiptResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferDisplayControllerSetReceiptResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferDisplayControllerSetReceiptResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferDisplayControllerSetReceiptResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferDisplayControllerSetReceiptResponseSuccess = (companionOfferDisplayControllerSetReceiptResponse204) & {
  headers: Headers;
};
export type companionOfferDisplayControllerSetReceiptResponseError = (companionOfferDisplayControllerSetReceiptResponse400 | companionOfferDisplayControllerSetReceiptResponse401 | companionOfferDisplayControllerSetReceiptResponse403 | companionOfferDisplayControllerSetReceiptResponse404 | companionOfferDisplayControllerSetReceiptResponse500) & {
  headers: Headers;
};

export type companionOfferDisplayControllerSetReceiptResponse = (companionOfferDisplayControllerSetReceiptResponseSuccess | companionOfferDisplayControllerSetReceiptResponseError)

export const getCompanionOfferDisplayControllerSetReceiptUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/display/receipt`
}

export const companionOfferDisplayControllerSetReceipt = async (companionId: string,
    setCompanionOfferDisplayReceiptDto: SetCompanionOfferDisplayReceiptDto, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferDisplayControllerSetReceiptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<companionOfferDisplayControllerSetReceiptResponse>(getCompanionOfferDisplayControllerSetReceiptUrl(companionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setCompanionOfferDisplayReceiptDto)
  }
);}





export const getCompanionOfferDisplayControllerSetReceiptMutationKey = () => ['companionOfferDisplayControllerSetReceipt'] as const;

export const getCompanionOfferDisplayControllerSetReceiptMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerSetReceipt>>, TError,CompanionOfferDisplayControllerSetReceiptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerSetReceipt>>, TError,CompanionOfferDisplayControllerSetReceiptMutationVariables, TContext> => {

const mutationKey = getCompanionOfferDisplayControllerSetReceiptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionOfferDisplayControllerSetReceipt>>, CompanionOfferDisplayControllerSetReceiptMutationVariables> = (props) => {
          const {companionId,data} = props ?? {};

          return  companionOfferDisplayControllerSetReceipt(companionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionOfferDisplayControllerSetReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof companionOfferDisplayControllerSetReceipt>>>
    export type CompanionOfferDisplayControllerSetReceiptMutationBody = SetCompanionOfferDisplayReceiptDto
    export type CompanionOfferDisplayControllerSetReceiptMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionOfferDisplayControllerSetReceiptMutationVariables = {companionId: string;data: SetCompanionOfferDisplayReceiptDto}

    export const useCompanionOfferDisplayControllerSetReceipt = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerSetReceipt>>, TError,CompanionOfferDisplayControllerSetReceiptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionOfferDisplayControllerSetReceipt>>,
        TError,
        CompanionOfferDisplayControllerSetReceiptMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionOfferDisplayControllerSetReceiptMutationOptions(options), queryClient);
    }

export type companionOfferDisplayControllerFindReceiptResponse200 = {
  data: CompanionOfferDisplayReceiptDto
  status: 200
}

export type companionOfferDisplayControllerFindReceiptResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionOfferDisplayControllerFindReceiptResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionOfferDisplayControllerFindReceiptResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionOfferDisplayControllerFindReceiptResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionOfferDisplayControllerFindReceiptResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionOfferDisplayControllerFindReceiptResponseSuccess = (companionOfferDisplayControllerFindReceiptResponse200) & {
  headers: Headers;
};
export type companionOfferDisplayControllerFindReceiptResponseError = (companionOfferDisplayControllerFindReceiptResponse400 | companionOfferDisplayControllerFindReceiptResponse401 | companionOfferDisplayControllerFindReceiptResponse403 | companionOfferDisplayControllerFindReceiptResponse404 | companionOfferDisplayControllerFindReceiptResponse500) & {
  headers: Headers;
};

export type companionOfferDisplayControllerFindReceiptResponse = (companionOfferDisplayControllerFindReceiptResponseSuccess | companionOfferDisplayControllerFindReceiptResponseError)

export const getCompanionOfferDisplayControllerFindReceiptUrl = (companionId: string,) => {




  return `/companion/${companionId}/offer/display/receipt`
}

export const companionOfferDisplayControllerFindReceipt = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionOfferDisplayControllerFindReceiptResponse> => {

  return customFetch<companionOfferDisplayControllerFindReceiptResponse>(getCompanionOfferDisplayControllerFindReceiptUrl(companionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanionOfferDisplayControllerFindReceiptQueryKey = (companionId: MaybeRefOrGetter<string>,) => {
    return [
    'companion',companionId,'offer','display','receipt'
    ] as const;
    }


export const getCompanionOfferDisplayControllerFindReceiptQueryOptions = <TData = Awaited<ReturnType<typeof companionOfferDisplayControllerFindReceipt>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerFindReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getCompanionOfferDisplayControllerFindReceiptQueryKey(companionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companionOfferDisplayControllerFindReceipt>>> = ({ signal }) => companionOfferDisplayControllerFindReceipt(toValue(companionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companionId) !== null && toValue(companionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerFindReceipt>>, TError, TData>
}

export type CompanionOfferDisplayControllerFindReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof companionOfferDisplayControllerFindReceipt>>>
export type CompanionOfferDisplayControllerFindReceiptQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useCompanionOfferDisplayControllerFindReceipt<TData = Awaited<ReturnType<typeof companionOfferDisplayControllerFindReceipt>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionOfferDisplayControllerFindReceipt>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanionOfferDisplayControllerFindReceiptQueryOptions(companionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type companionSseControllerTicketResponse200 = {
  data: ResponseCompanionSseTicketDto
  status: 200
}

export type companionSseControllerTicketResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionSseControllerTicketResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionSseControllerTicketResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionSseControllerTicketResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionSseControllerTicketResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionSseControllerTicketResponseSuccess = (companionSseControllerTicketResponse200) & {
  headers: Headers;
};
export type companionSseControllerTicketResponseError = (companionSseControllerTicketResponse400 | companionSseControllerTicketResponse401 | companionSseControllerTicketResponse403 | companionSseControllerTicketResponse404 | companionSseControllerTicketResponse500) & {
  headers: Headers;
};

export type companionSseControllerTicketResponse = (companionSseControllerTicketResponseSuccess | companionSseControllerTicketResponseError)

export const getCompanionSseControllerTicketUrl = (companionId: string,) => {




  return `/companion/${companionId}/sse/ticket`
}

export const companionSseControllerTicket = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionSseControllerTicketResponse> => {

  return customFetch<companionSseControllerTicketResponse>(getCompanionSseControllerTicketUrl(companionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompanionSseControllerTicketMutationKey = () => ['companionSseControllerTicket'] as const;

export const getCompanionSseControllerTicketMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionSseControllerTicket>>, TError,CompanionSseControllerTicketMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof companionSseControllerTicket>>, TError,CompanionSseControllerTicketMutationVariables, TContext> => {

const mutationKey = getCompanionSseControllerTicketMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companionSseControllerTicket>>, CompanionSseControllerTicketMutationVariables> = (props) => {
          const {companionId} = props ?? {};

          return  companionSseControllerTicket(companionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompanionSseControllerTicketMutationResult = NonNullable<Awaited<ReturnType<typeof companionSseControllerTicket>>>

    export type CompanionSseControllerTicketMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type CompanionSseControllerTicketMutationVariables = {companionId: string}

    export const useCompanionSseControllerTicket = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companionSseControllerTicket>>, TError,CompanionSseControllerTicketMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof companionSseControllerTicket>>,
        TError,
        CompanionSseControllerTicketMutationVariables,
        TContext
      > => {
      return useMutation(getCompanionSseControllerTicketMutationOptions(options), queryClient);
    }

export type companionSseControllerConnectResponse200 = {
  data: CompanionSseMessageDto
  status: 200
}

export type companionSseControllerConnectResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type companionSseControllerConnectResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type companionSseControllerConnectResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type companionSseControllerConnectResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type companionSseControllerConnectResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type companionSseControllerConnectResponseSuccess = (companionSseControllerConnectResponse200) & {
  headers: Headers;
};
export type companionSseControllerConnectResponseError = (companionSseControllerConnectResponse400 | companionSseControllerConnectResponse401 | companionSseControllerConnectResponse403 | companionSseControllerConnectResponse404 | companionSseControllerConnectResponse500) & {
  headers: Headers;
};

export type companionSseControllerConnectResponse = (companionSseControllerConnectResponseSuccess | companionSseControllerConnectResponseError)

export const getCompanionSseControllerConnectUrl = (companionId: string,) => {




  return `/companion/${companionId}/sse`
}

export const companionSseControllerConnect = async (companionId: string, options?: Parameters<typeof customFetch>[1]): Promise<companionSseControllerConnectResponse> => {

  return customFetch<companionSseControllerConnectResponse>(getCompanionSseControllerConnectUrl(companionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompanionSseControllerConnectQueryKey = (companionId: MaybeRefOrGetter<string>,) => {
    return [
    'companion',companionId,'sse'
    ] as const;
    }


export const getCompanionSseControllerConnectQueryOptions = <TData = Awaited<ReturnType<typeof companionSseControllerConnect>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionSseControllerConnect>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getCompanionSseControllerConnectQueryKey(companionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof companionSseControllerConnect>>> = ({ signal }) => companionSseControllerConnect(toValue(companionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(companionId) !== null && toValue(companionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companionSseControllerConnect>>, TError, TData>
}

export type CompanionSseControllerConnectQueryResult = NonNullable<Awaited<ReturnType<typeof companionSseControllerConnect>>>
export type CompanionSseControllerConnectQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useCompanionSseControllerConnect<TData = Awaited<ReturnType<typeof companionSseControllerConnect>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 companionId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companionSseControllerConnect>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompanionSseControllerConnectQueryOptions(companionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type posDeviceControllerFindAllResponse200 = {
  data: PosDeviceControllerFindAll200
  status: 200
}

export type posDeviceControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posDeviceControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posDeviceControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posDeviceControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posDeviceControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posDeviceControllerFindAllResponseSuccess = (posDeviceControllerFindAllResponse200) & {
  headers: Headers;
};
export type posDeviceControllerFindAllResponseError = (posDeviceControllerFindAllResponse400 | posDeviceControllerFindAllResponse401 | posDeviceControllerFindAllResponse403 | posDeviceControllerFindAllResponse404 | posDeviceControllerFindAllResponse500) & {
  headers: Headers;
};

export type posDeviceControllerFindAllResponse = (posDeviceControllerFindAllResponseSuccess | posDeviceControllerFindAllResponseError)

export const getPosDeviceControllerFindAllUrl = (params?: PosDeviceControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.source.id","filter.registeredBy.id","filter.lastSeenAt","filter.createdAt","filter.deletedAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/pos/device?${stringifiedParams}` : `/pos/device`
}

export const posDeviceControllerFindAll = async (params?: PosDeviceControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<posDeviceControllerFindAllResponse> => {

  return customFetch<posDeviceControllerFindAllResponse>(getPosDeviceControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPosDeviceControllerFindAllQueryKey = (params?: MaybeRefOrGetter<PosDeviceControllerFindAllParams>,) => {
    return [
    'pos','device', ...(params ? [params] : [])
    ] as const;
    }


export const getPosDeviceControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof posDeviceControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<PosDeviceControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posDeviceControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPosDeviceControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof posDeviceControllerFindAll>>> = ({ signal }) => posDeviceControllerFindAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof posDeviceControllerFindAll>>, TError, TData>
}

export type PosDeviceControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof posDeviceControllerFindAll>>>
export type PosDeviceControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePosDeviceControllerFindAll<TData = Awaited<ReturnType<typeof posDeviceControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<PosDeviceControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posDeviceControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPosDeviceControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type posDeviceControllerFindOneResponse200 = {
  data: ResponsePosDeviceDto
  status: 200
}

export type posDeviceControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posDeviceControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posDeviceControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posDeviceControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posDeviceControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posDeviceControllerFindOneResponseSuccess = (posDeviceControllerFindOneResponse200) & {
  headers: Headers;
};
export type posDeviceControllerFindOneResponseError = (posDeviceControllerFindOneResponse400 | posDeviceControllerFindOneResponse401 | posDeviceControllerFindOneResponse403 | posDeviceControllerFindOneResponse404 | posDeviceControllerFindOneResponse500) & {
  headers: Headers;
};

export type posDeviceControllerFindOneResponse = (posDeviceControllerFindOneResponseSuccess | posDeviceControllerFindOneResponseError)

export const getPosDeviceControllerFindOneUrl = (deviceId: string,) => {




  return `/pos/device/${deviceId}`
}

export const posDeviceControllerFindOne = async (deviceId: string, options?: Parameters<typeof customFetch>[1]): Promise<posDeviceControllerFindOneResponse> => {

  return customFetch<posDeviceControllerFindOneResponse>(getPosDeviceControllerFindOneUrl(deviceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPosDeviceControllerFindOneQueryKey = (deviceId: MaybeRefOrGetter<string>,) => {
    return [
    'pos','device',deviceId
    ] as const;
    }


export const getPosDeviceControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof posDeviceControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(deviceId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posDeviceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getPosDeviceControllerFindOneQueryKey(deviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof posDeviceControllerFindOne>>> = ({ signal }) => posDeviceControllerFindOne(toValue(deviceId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(deviceId) !== null && toValue(deviceId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof posDeviceControllerFindOne>>, TError, TData>
}

export type PosDeviceControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof posDeviceControllerFindOne>>>
export type PosDeviceControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function usePosDeviceControllerFindOne<TData = Awaited<ReturnType<typeof posDeviceControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 deviceId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof posDeviceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPosDeviceControllerFindOneQueryOptions(deviceId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type posDeviceControllerUpdateResponse200 = {
  data: ResponsePosDeviceDto
  status: 200
}

export type posDeviceControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posDeviceControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posDeviceControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posDeviceControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posDeviceControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posDeviceControllerUpdateResponseSuccess = (posDeviceControllerUpdateResponse200) & {
  headers: Headers;
};
export type posDeviceControllerUpdateResponseError = (posDeviceControllerUpdateResponse400 | posDeviceControllerUpdateResponse401 | posDeviceControllerUpdateResponse403 | posDeviceControllerUpdateResponse404 | posDeviceControllerUpdateResponse500) & {
  headers: Headers;
};

export type posDeviceControllerUpdateResponse = (posDeviceControllerUpdateResponseSuccess | posDeviceControllerUpdateResponseError)

export const getPosDeviceControllerUpdateUrl = (deviceId: string,) => {




  return `/pos/device/${deviceId}`
}

export const posDeviceControllerUpdate = async (deviceId: string,
    updatePosDeviceDto: UpdatePosDeviceDto, options?: Parameters<typeof customFetch>[1]): Promise<posDeviceControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<posDeviceControllerUpdateResponse>(getPosDeviceControllerUpdateUrl(deviceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePosDeviceDto)
  }
);}





export const getPosDeviceControllerUpdateMutationKey = () => ['posDeviceControllerUpdate'] as const;

export const getPosDeviceControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posDeviceControllerUpdate>>, TError,PosDeviceControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posDeviceControllerUpdate>>, TError,PosDeviceControllerUpdateMutationVariables, TContext> => {

const mutationKey = getPosDeviceControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posDeviceControllerUpdate>>, PosDeviceControllerUpdateMutationVariables> = (props) => {
          const {deviceId,data} = props ?? {};

          return  posDeviceControllerUpdate(deviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosDeviceControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof posDeviceControllerUpdate>>>
    export type PosDeviceControllerUpdateMutationBody = UpdatePosDeviceDto
    export type PosDeviceControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PosDeviceControllerUpdateMutationVariables = {deviceId: string;data: UpdatePosDeviceDto}

    export const usePosDeviceControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posDeviceControllerUpdate>>, TError,PosDeviceControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posDeviceControllerUpdate>>,
        TError,
        PosDeviceControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getPosDeviceControllerUpdateMutationOptions(options), queryClient);
    }

export type posDeviceControllerDecommissionResponse200 = {
  data: ResponsePosDeviceDto
  status: 200
}

export type posDeviceControllerDecommissionResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posDeviceControllerDecommissionResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posDeviceControllerDecommissionResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posDeviceControllerDecommissionResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posDeviceControllerDecommissionResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posDeviceControllerDecommissionResponseSuccess = (posDeviceControllerDecommissionResponse200) & {
  headers: Headers;
};
export type posDeviceControllerDecommissionResponseError = (posDeviceControllerDecommissionResponse400 | posDeviceControllerDecommissionResponse401 | posDeviceControllerDecommissionResponse403 | posDeviceControllerDecommissionResponse404 | posDeviceControllerDecommissionResponse500) & {
  headers: Headers;
};

export type posDeviceControllerDecommissionResponse = (posDeviceControllerDecommissionResponseSuccess | posDeviceControllerDecommissionResponseError)

export const getPosDeviceControllerDecommissionUrl = (deviceId: string,) => {




  return `/pos/device/${deviceId}`
}

export const posDeviceControllerDecommission = async (deviceId: string, options?: Parameters<typeof customFetch>[1]): Promise<posDeviceControllerDecommissionResponse> => {

  return customFetch<posDeviceControllerDecommissionResponse>(getPosDeviceControllerDecommissionUrl(deviceId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPosDeviceControllerDecommissionMutationKey = () => ['posDeviceControllerDecommission'] as const;

export const getPosDeviceControllerDecommissionMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posDeviceControllerDecommission>>, TError,PosDeviceControllerDecommissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posDeviceControllerDecommission>>, TError,PosDeviceControllerDecommissionMutationVariables, TContext> => {

const mutationKey = getPosDeviceControllerDecommissionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posDeviceControllerDecommission>>, PosDeviceControllerDecommissionMutationVariables> = (props) => {
          const {deviceId} = props ?? {};

          return  posDeviceControllerDecommission(deviceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosDeviceControllerDecommissionMutationResult = NonNullable<Awaited<ReturnType<typeof posDeviceControllerDecommission>>>

    export type PosDeviceControllerDecommissionMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PosDeviceControllerDecommissionMutationVariables = {deviceId: string}

    export const usePosDeviceControllerDecommission = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posDeviceControllerDecommission>>, TError,PosDeviceControllerDecommissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posDeviceControllerDecommission>>,
        TError,
        PosDeviceControllerDecommissionMutationVariables,
        TContext
      > => {
      return useMutation(getPosDeviceControllerDecommissionMutationOptions(options), queryClient);
    }

export type posAuthControllerRegisterResponse200 = {
  data: PosTokenResponseDto
  status: 200
}

export type posAuthControllerRegisterResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posAuthControllerRegisterResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posAuthControllerRegisterResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posAuthControllerRegisterResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posAuthControllerRegisterResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posAuthControllerRegisterResponseSuccess = (posAuthControllerRegisterResponse200) & {
  headers: Headers;
};
export type posAuthControllerRegisterResponseError = (posAuthControllerRegisterResponse400 | posAuthControllerRegisterResponse401 | posAuthControllerRegisterResponse403 | posAuthControllerRegisterResponse404 | posAuthControllerRegisterResponse500) & {
  headers: Headers;
};

export type posAuthControllerRegisterResponse = (posAuthControllerRegisterResponseSuccess | posAuthControllerRegisterResponseError)

export const getPosAuthControllerRegisterUrl = () => {




  return `/pos/register`
}

export const posAuthControllerRegister = async (registerPosDto: RegisterPosDto, options?: Parameters<typeof customFetch>[1]): Promise<posAuthControllerRegisterResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<posAuthControllerRegisterResponse>(getPosAuthControllerRegisterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(registerPosDto)
  }
);}





export const getPosAuthControllerRegisterMutationKey = () => ['posAuthControllerRegister'] as const;

export const getPosAuthControllerRegisterMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posAuthControllerRegister>>, TError,PosAuthControllerRegisterMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posAuthControllerRegister>>, TError,PosAuthControllerRegisterMutationVariables, TContext> => {

const mutationKey = getPosAuthControllerRegisterMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posAuthControllerRegister>>, PosAuthControllerRegisterMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  posAuthControllerRegister(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosAuthControllerRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof posAuthControllerRegister>>>
    export type PosAuthControllerRegisterMutationBody = RegisterPosDto
    export type PosAuthControllerRegisterMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type PosAuthControllerRegisterMutationVariables = {data: RegisterPosDto}

    export const usePosAuthControllerRegister = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posAuthControllerRegister>>, TError,PosAuthControllerRegisterMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posAuthControllerRegister>>,
        TError,
        PosAuthControllerRegisterMutationVariables,
        TContext
      > => {
      return useMutation(getPosAuthControllerRegisterMutationOptions(options), queryClient);
    }

export type posAuthControllerRefreshResponse201 = {
  data: PosTokenResponseDto
  status: 201
}

export type posAuthControllerRefreshResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type posAuthControllerRefreshResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type posAuthControllerRefreshResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type posAuthControllerRefreshResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type posAuthControllerRefreshResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type posAuthControllerRefreshResponseSuccess = (posAuthControllerRefreshResponse201) & {
  headers: Headers;
};
export type posAuthControllerRefreshResponseError = (posAuthControllerRefreshResponse400 | posAuthControllerRefreshResponse401 | posAuthControllerRefreshResponse403 | posAuthControllerRefreshResponse404 | posAuthControllerRefreshResponse500) & {
  headers: Headers;
};

export type posAuthControllerRefreshResponse = (posAuthControllerRefreshResponseSuccess | posAuthControllerRefreshResponseError)

export const getPosAuthControllerRefreshUrl = () => {




  return `/pos/refresh`
}

export const posAuthControllerRefresh = async ( options?: Parameters<typeof customFetch>[1]): Promise<posAuthControllerRefreshResponse> => {

  return customFetch<posAuthControllerRefreshResponse>(getPosAuthControllerRefreshUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPosAuthControllerRefreshMutationKey = () => ['posAuthControllerRefresh'] as const;

export const getPosAuthControllerRefreshMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posAuthControllerRefresh>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof posAuthControllerRefresh>>, TError,void, TContext> => {

const mutationKey = getPosAuthControllerRefreshMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof posAuthControllerRefresh>>, void> = () => {


          return  posAuthControllerRefresh(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PosAuthControllerRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof posAuthControllerRefresh>>>

    export type PosAuthControllerRefreshMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


    export const usePosAuthControllerRefresh = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof posAuthControllerRefresh>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof posAuthControllerRefresh>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPosAuthControllerRefreshMutationOptions(options), queryClient);
    }

export type externalIntegrationOfferControllerCreateResponse201 = {
  data: ResponseExternalIntegrationCreateOfferDto
  status: 201
}

export type externalIntegrationOfferControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationOfferControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationOfferControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationOfferControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationOfferControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationOfferControllerCreateResponseSuccess = (externalIntegrationOfferControllerCreateResponse201) & {
  headers: Headers;
};
export type externalIntegrationOfferControllerCreateResponseError = (externalIntegrationOfferControllerCreateResponse400 | externalIntegrationOfferControllerCreateResponse401 | externalIntegrationOfferControllerCreateResponse403 | externalIntegrationOfferControllerCreateResponse404 | externalIntegrationOfferControllerCreateResponse500) & {
  headers: Headers;
};

export type externalIntegrationOfferControllerCreateResponse = (externalIntegrationOfferControllerCreateResponseSuccess | externalIntegrationOfferControllerCreateResponseError)

export const getExternalIntegrationOfferControllerCreateUrl = () => {




  return `/ext/offer`
}

/**
 * Creates a new offer for the client.
 * @summary Create a new offer
 */
export const externalIntegrationOfferControllerCreate = async (createExternalIntegrationOfferDto: CreateExternalIntegrationOfferDto, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationOfferControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<externalIntegrationOfferControllerCreateResponse>(getExternalIntegrationOfferControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExternalIntegrationOfferDto)
  }
);}





export const getExternalIntegrationOfferControllerCreateMutationKey = () => ['externalIntegrationOfferControllerCreate'] as const;

export const getExternalIntegrationOfferControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferControllerCreate>>, TError,ExternalIntegrationOfferControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferControllerCreate>>, TError,ExternalIntegrationOfferControllerCreateMutationVariables, TContext> => {

const mutationKey = getExternalIntegrationOfferControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalIntegrationOfferControllerCreate>>, ExternalIntegrationOfferControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  externalIntegrationOfferControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExternalIntegrationOfferControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationOfferControllerCreate>>>
    export type ExternalIntegrationOfferControllerCreateMutationBody = CreateExternalIntegrationOfferDto
    export type ExternalIntegrationOfferControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type ExternalIntegrationOfferControllerCreateMutationVariables = {data: CreateExternalIntegrationOfferDto}

    /**
 * @summary Create a new offer
 */
export const useExternalIntegrationOfferControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferControllerCreate>>, TError,ExternalIntegrationOfferControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof externalIntegrationOfferControllerCreate>>,
        TError,
        ExternalIntegrationOfferControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getExternalIntegrationOfferControllerCreateMutationOptions(options), queryClient);
    }

export type externalIntegrationOfferControllerFindOneResponse200 = {
  data: ResponseExternalIntegrationOfferDto
  status: 200
}

export type externalIntegrationOfferControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationOfferControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationOfferControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationOfferControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationOfferControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationOfferControllerFindOneResponseSuccess = (externalIntegrationOfferControllerFindOneResponse200) & {
  headers: Headers;
};
export type externalIntegrationOfferControllerFindOneResponseError = (externalIntegrationOfferControllerFindOneResponse400 | externalIntegrationOfferControllerFindOneResponse401 | externalIntegrationOfferControllerFindOneResponse403 | externalIntegrationOfferControllerFindOneResponse404 | externalIntegrationOfferControllerFindOneResponse500) & {
  headers: Headers;
};

export type externalIntegrationOfferControllerFindOneResponse = (externalIntegrationOfferControllerFindOneResponseSuccess | externalIntegrationOfferControllerFindOneResponseError)

export const getExternalIntegrationOfferControllerFindOneUrl = (offerId: number,) => {




  return `/ext/offer/${offerId}`
}

/**
 * Returns the details of a specific offer.
 * @summary Find a specific offer by ID
 */
export const externalIntegrationOfferControllerFindOne = async (offerId: number, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationOfferControllerFindOneResponse> => {

  return customFetch<externalIntegrationOfferControllerFindOneResponse>(getExternalIntegrationOfferControllerFindOneUrl(offerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExternalIntegrationOfferControllerFindOneQueryKey = (offerId: MaybeRefOrGetter<number>,) => {
    return [
    'ext','offer',offerId
    ] as const;
    }


export const getExternalIntegrationOfferControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof externalIntegrationOfferControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationOfferControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExternalIntegrationOfferControllerFindOneQueryKey(offerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof externalIntegrationOfferControllerFindOne>>> = ({ signal }) => externalIntegrationOfferControllerFindOne(toValue(offerId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationOfferControllerFindOne>>, TError, TData>
}

export type ExternalIntegrationOfferControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationOfferControllerFindOne>>>
export type ExternalIntegrationOfferControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @summary Find a specific offer by ID
 */

export function useExternalIntegrationOfferControllerFindOne<TData = Awaited<ReturnType<typeof externalIntegrationOfferControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationOfferControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExternalIntegrationOfferControllerFindOneQueryOptions(offerId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type externalIntegrationOfferImageControllerUploadFileResponse201 = {
  data: ResponseExternalIntegrationOfferImageDto
  status: 201
}

export type externalIntegrationOfferImageControllerUploadFileResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationOfferImageControllerUploadFileResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationOfferImageControllerUploadFileResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationOfferImageControllerUploadFileResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationOfferImageControllerUploadFileResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationOfferImageControllerUploadFileResponseSuccess = (externalIntegrationOfferImageControllerUploadFileResponse201) & {
  headers: Headers;
};
export type externalIntegrationOfferImageControllerUploadFileResponseError = (externalIntegrationOfferImageControllerUploadFileResponse400 | externalIntegrationOfferImageControllerUploadFileResponse401 | externalIntegrationOfferImageControllerUploadFileResponse403 | externalIntegrationOfferImageControllerUploadFileResponse404 | externalIntegrationOfferImageControllerUploadFileResponse500) & {
  headers: Headers;
};

export type externalIntegrationOfferImageControllerUploadFileResponse = (externalIntegrationOfferImageControllerUploadFileResponseSuccess | externalIntegrationOfferImageControllerUploadFileResponseError)

export const getExternalIntegrationOfferImageControllerUploadFileUrl = (offerId: number,) => {




  return `/ext/offer/${offerId}/image`
}

/**
 * Add an image for a specific offer or offer item. If offerItemId is provided, the image will be associated with that item, otherwise, it will be associated with the offer.
 * @summary Upload an offer image
 */
export const externalIntegrationOfferImageControllerUploadFile = async (offerId: number,
    createExternalIntegrationOfferImageDto: CreateExternalIntegrationOfferImageDto, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationOfferImageControllerUploadFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<externalIntegrationOfferImageControllerUploadFileResponse>(getExternalIntegrationOfferImageControllerUploadFileUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExternalIntegrationOfferImageDto)
  }
);}





export const getExternalIntegrationOfferImageControllerUploadFileMutationKey = () => ['externalIntegrationOfferImageControllerUploadFile'] as const;

export const getExternalIntegrationOfferImageControllerUploadFileMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferImageControllerUploadFile>>, TError,ExternalIntegrationOfferImageControllerUploadFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferImageControllerUploadFile>>, TError,ExternalIntegrationOfferImageControllerUploadFileMutationVariables, TContext> => {

const mutationKey = getExternalIntegrationOfferImageControllerUploadFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalIntegrationOfferImageControllerUploadFile>>, ExternalIntegrationOfferImageControllerUploadFileMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  externalIntegrationOfferImageControllerUploadFile(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExternalIntegrationOfferImageControllerUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationOfferImageControllerUploadFile>>>
    export type ExternalIntegrationOfferImageControllerUploadFileMutationBody = CreateExternalIntegrationOfferImageDto
    export type ExternalIntegrationOfferImageControllerUploadFileMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type ExternalIntegrationOfferImageControllerUploadFileMutationVariables = {offerId: number;data: CreateExternalIntegrationOfferImageDto}

    /**
 * @summary Upload an offer image
 */
export const useExternalIntegrationOfferImageControllerUploadFile = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferImageControllerUploadFile>>, TError,ExternalIntegrationOfferImageControllerUploadFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof externalIntegrationOfferImageControllerUploadFile>>,
        TError,
        ExternalIntegrationOfferImageControllerUploadFileMutationVariables,
        TContext
      > => {
      return useMutation(getExternalIntegrationOfferImageControllerUploadFileMutationOptions(options), queryClient);
    }

export type externalIntegrationOfferItemImageControllerUploadFileResponse201 = {
  data: ResponseExternalIntegrationOfferImageDto
  status: 201
}

export type externalIntegrationOfferItemImageControllerUploadFileResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationOfferItemImageControllerUploadFileResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationOfferItemImageControllerUploadFileResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationOfferItemImageControllerUploadFileResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationOfferItemImageControllerUploadFileResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationOfferItemImageControllerUploadFileResponseSuccess = (externalIntegrationOfferItemImageControllerUploadFileResponse201) & {
  headers: Headers;
};
export type externalIntegrationOfferItemImageControllerUploadFileResponseError = (externalIntegrationOfferItemImageControllerUploadFileResponse400 | externalIntegrationOfferItemImageControllerUploadFileResponse401 | externalIntegrationOfferItemImageControllerUploadFileResponse403 | externalIntegrationOfferItemImageControllerUploadFileResponse404 | externalIntegrationOfferItemImageControllerUploadFileResponse500) & {
  headers: Headers;
};

export type externalIntegrationOfferItemImageControllerUploadFileResponse = (externalIntegrationOfferItemImageControllerUploadFileResponseSuccess | externalIntegrationOfferItemImageControllerUploadFileResponseError)

export const getExternalIntegrationOfferItemImageControllerUploadFileUrl = (offerId: number,
    offerItemId: number,) => {




  return `/ext/offer/${offerId}/item/${offerItemId}/image`
}

/**
 * Add an image for a specific offer or offer item. If offerItemId is provided, the image will be associated with that item, otherwise, it will be associated with the offer.
 * @summary Upload an offer image
 */
export const externalIntegrationOfferItemImageControllerUploadFile = async (offerId: number,
    offerItemId: number,
    createExternalIntegrationOfferImageDto: CreateExternalIntegrationOfferImageDto, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationOfferItemImageControllerUploadFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<externalIntegrationOfferItemImageControllerUploadFileResponse>(getExternalIntegrationOfferItemImageControllerUploadFileUrl(offerId,offerItemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExternalIntegrationOfferImageDto)
  }
);}





export const getExternalIntegrationOfferItemImageControllerUploadFileMutationKey = () => ['externalIntegrationOfferItemImageControllerUploadFile'] as const;

export const getExternalIntegrationOfferItemImageControllerUploadFileMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemImageControllerUploadFile>>, TError,ExternalIntegrationOfferItemImageControllerUploadFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemImageControllerUploadFile>>, TError,ExternalIntegrationOfferItemImageControllerUploadFileMutationVariables, TContext> => {

const mutationKey = getExternalIntegrationOfferItemImageControllerUploadFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalIntegrationOfferItemImageControllerUploadFile>>, ExternalIntegrationOfferItemImageControllerUploadFileMutationVariables> = (props) => {
          const {offerId,offerItemId,data} = props ?? {};

          return  externalIntegrationOfferItemImageControllerUploadFile(offerId,offerItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExternalIntegrationOfferItemImageControllerUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationOfferItemImageControllerUploadFile>>>
    export type ExternalIntegrationOfferItemImageControllerUploadFileMutationBody = CreateExternalIntegrationOfferImageDto
    export type ExternalIntegrationOfferItemImageControllerUploadFileMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type ExternalIntegrationOfferItemImageControllerUploadFileMutationVariables = {offerId: number;offerItemId: number;data: CreateExternalIntegrationOfferImageDto}

    /**
 * @summary Upload an offer image
 */
export const useExternalIntegrationOfferItemImageControllerUploadFile = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemImageControllerUploadFile>>, TError,ExternalIntegrationOfferItemImageControllerUploadFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof externalIntegrationOfferItemImageControllerUploadFile>>,
        TError,
        ExternalIntegrationOfferItemImageControllerUploadFileMutationVariables,
        TContext
      > => {
      return useMutation(getExternalIntegrationOfferItemImageControllerUploadFileMutationOptions(options), queryClient);
    }

export type externalIntegrationOfferItemControllerCreateResponse201 = {
  data: RefExternalIntegrationOfferItemDto
  status: 201
}

export type externalIntegrationOfferItemControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationOfferItemControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationOfferItemControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationOfferItemControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationOfferItemControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationOfferItemControllerCreateResponseSuccess = (externalIntegrationOfferItemControllerCreateResponse201) & {
  headers: Headers;
};
export type externalIntegrationOfferItemControllerCreateResponseError = (externalIntegrationOfferItemControllerCreateResponse400 | externalIntegrationOfferItemControllerCreateResponse401 | externalIntegrationOfferItemControllerCreateResponse403 | externalIntegrationOfferItemControllerCreateResponse404 | externalIntegrationOfferItemControllerCreateResponse500) & {
  headers: Headers;
};

export type externalIntegrationOfferItemControllerCreateResponse = (externalIntegrationOfferItemControllerCreateResponseSuccess | externalIntegrationOfferItemControllerCreateResponseError)

export const getExternalIntegrationOfferItemControllerCreateUrl = (offerId: number,) => {




  return `/ext/offer/${offerId}/item`
}

/**
 * Creates a new offer item for the specified offer. The `reference.key` can be used for a custom identifier to match the item with an external system. If no `reference.productCode` is set, it will always have to be reviewed before a final price is returned
 * @summary Create a new offer item
 */
export const externalIntegrationOfferItemControllerCreate = async (offerId: number,
    createExternalIntegrationOfferItemDto: CreateExternalIntegrationOfferItemDto, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationOfferItemControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<externalIntegrationOfferItemControllerCreateResponse>(getExternalIntegrationOfferItemControllerCreateUrl(offerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExternalIntegrationOfferItemDto)
  }
);}





export const getExternalIntegrationOfferItemControllerCreateMutationKey = () => ['externalIntegrationOfferItemControllerCreate'] as const;

export const getExternalIntegrationOfferItemControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerCreate>>, TError,ExternalIntegrationOfferItemControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerCreate>>, TError,ExternalIntegrationOfferItemControllerCreateMutationVariables, TContext> => {

const mutationKey = getExternalIntegrationOfferItemControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerCreate>>, ExternalIntegrationOfferItemControllerCreateMutationVariables> = (props) => {
          const {offerId,data} = props ?? {};

          return  externalIntegrationOfferItemControllerCreate(offerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExternalIntegrationOfferItemControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerCreate>>>
    export type ExternalIntegrationOfferItemControllerCreateMutationBody = CreateExternalIntegrationOfferItemDto
    export type ExternalIntegrationOfferItemControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type ExternalIntegrationOfferItemControllerCreateMutationVariables = {offerId: number;data: CreateExternalIntegrationOfferItemDto}

    /**
 * @summary Create a new offer item
 */
export const useExternalIntegrationOfferItemControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerCreate>>, TError,ExternalIntegrationOfferItemControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof externalIntegrationOfferItemControllerCreate>>,
        TError,
        ExternalIntegrationOfferItemControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getExternalIntegrationOfferItemControllerCreateMutationOptions(options), queryClient);
    }

export type externalIntegrationOfferItemControllerFindOneResponse200 = {
  data: RefExternalIntegrationOfferItemDto
  status: 200
}

export type externalIntegrationOfferItemControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationOfferItemControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationOfferItemControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationOfferItemControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationOfferItemControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationOfferItemControllerFindOneResponseSuccess = (externalIntegrationOfferItemControllerFindOneResponse200) & {
  headers: Headers;
};
export type externalIntegrationOfferItemControllerFindOneResponseError = (externalIntegrationOfferItemControllerFindOneResponse400 | externalIntegrationOfferItemControllerFindOneResponse401 | externalIntegrationOfferItemControllerFindOneResponse403 | externalIntegrationOfferItemControllerFindOneResponse404 | externalIntegrationOfferItemControllerFindOneResponse500) & {
  headers: Headers;
};

export type externalIntegrationOfferItemControllerFindOneResponse = (externalIntegrationOfferItemControllerFindOneResponseSuccess | externalIntegrationOfferItemControllerFindOneResponseError)

export const getExternalIntegrationOfferItemControllerFindOneUrl = (offerId: number,
    itemId: number,) => {




  return `/ext/offer/${offerId}/item/${itemId}`
}

/**
 * Retrieves the details of a specific offer item by its ID.
 * @summary Get an offer item
 */
export const externalIntegrationOfferItemControllerFindOne = async (offerId: number,
    itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationOfferItemControllerFindOneResponse> => {

  return customFetch<externalIntegrationOfferItemControllerFindOneResponse>(getExternalIntegrationOfferItemControllerFindOneUrl(offerId,itemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExternalIntegrationOfferItemControllerFindOneQueryKey = (offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>,) => {
    return [
    'ext','offer',offerId,'item',itemId
    ] as const;
    }


export const getExternalIntegrationOfferItemControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof externalIntegrationOfferItemControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExternalIntegrationOfferItemControllerFindOneQueryKey(offerId,itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerFindOne>>> = ({ signal }) => externalIntegrationOfferItemControllerFindOne(toValue(offerId),toValue(itemId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined && toValue(itemId) !== null && toValue(itemId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerFindOne>>, TError, TData>
}

export type ExternalIntegrationOfferItemControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerFindOne>>>
export type ExternalIntegrationOfferItemControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @summary Get an offer item
 */

export function useExternalIntegrationOfferItemControllerFindOne<TData = Awaited<ReturnType<typeof externalIntegrationOfferItemControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    itemId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExternalIntegrationOfferItemControllerFindOneQueryOptions(offerId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type externalIntegrationOfferItemControllerUpdateResponse200 = {
  data: RefExternalIntegrationOfferItemDto
  status: 200
}

export type externalIntegrationOfferItemControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationOfferItemControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationOfferItemControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationOfferItemControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationOfferItemControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationOfferItemControllerUpdateResponseSuccess = (externalIntegrationOfferItemControllerUpdateResponse200) & {
  headers: Headers;
};
export type externalIntegrationOfferItemControllerUpdateResponseError = (externalIntegrationOfferItemControllerUpdateResponse400 | externalIntegrationOfferItemControllerUpdateResponse401 | externalIntegrationOfferItemControllerUpdateResponse403 | externalIntegrationOfferItemControllerUpdateResponse404 | externalIntegrationOfferItemControllerUpdateResponse500) & {
  headers: Headers;
};

export type externalIntegrationOfferItemControllerUpdateResponse = (externalIntegrationOfferItemControllerUpdateResponseSuccess | externalIntegrationOfferItemControllerUpdateResponseError)

export const getExternalIntegrationOfferItemControllerUpdateUrl = (offerId: number,
    itemId: number,) => {




  return `/ext/offer/${offerId}/item/${itemId}`
}

/**
 * Updates the details of a specific offer item. When the `reference.productCode` of the item changes, it must be deleted and recreated.
 * @summary Update an offer item
 */
export const externalIntegrationOfferItemControllerUpdate = async (offerId: number,
    itemId: number,
    updateExternalIntegrationOfferItemDto: UpdateExternalIntegrationOfferItemDto, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationOfferItemControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<externalIntegrationOfferItemControllerUpdateResponse>(getExternalIntegrationOfferItemControllerUpdateUrl(offerId,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateExternalIntegrationOfferItemDto)
  }
);}





export const getExternalIntegrationOfferItemControllerUpdateMutationKey = () => ['externalIntegrationOfferItemControllerUpdate'] as const;

export const getExternalIntegrationOfferItemControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerUpdate>>, TError,ExternalIntegrationOfferItemControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerUpdate>>, TError,ExternalIntegrationOfferItemControllerUpdateMutationVariables, TContext> => {

const mutationKey = getExternalIntegrationOfferItemControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerUpdate>>, ExternalIntegrationOfferItemControllerUpdateMutationVariables> = (props) => {
          const {offerId,itemId,data} = props ?? {};

          return  externalIntegrationOfferItemControllerUpdate(offerId,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExternalIntegrationOfferItemControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerUpdate>>>
    export type ExternalIntegrationOfferItemControllerUpdateMutationBody = UpdateExternalIntegrationOfferItemDto
    export type ExternalIntegrationOfferItemControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type ExternalIntegrationOfferItemControllerUpdateMutationVariables = {offerId: number;itemId: number;data: UpdateExternalIntegrationOfferItemDto}

    /**
 * @summary Update an offer item
 */
export const useExternalIntegrationOfferItemControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerUpdate>>, TError,ExternalIntegrationOfferItemControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof externalIntegrationOfferItemControllerUpdate>>,
        TError,
        ExternalIntegrationOfferItemControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getExternalIntegrationOfferItemControllerUpdateMutationOptions(options), queryClient);
    }

export type externalIntegrationOfferItemControllerRemoveResponse200 = {
  data: RefExternalIntegrationOfferItemDto
  status: 200
}

export type externalIntegrationOfferItemControllerRemoveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationOfferItemControllerRemoveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationOfferItemControllerRemoveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationOfferItemControllerRemoveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationOfferItemControllerRemoveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationOfferItemControllerRemoveResponseSuccess = (externalIntegrationOfferItemControllerRemoveResponse200) & {
  headers: Headers;
};
export type externalIntegrationOfferItemControllerRemoveResponseError = (externalIntegrationOfferItemControllerRemoveResponse400 | externalIntegrationOfferItemControllerRemoveResponse401 | externalIntegrationOfferItemControllerRemoveResponse403 | externalIntegrationOfferItemControllerRemoveResponse404 | externalIntegrationOfferItemControllerRemoveResponse500) & {
  headers: Headers;
};

export type externalIntegrationOfferItemControllerRemoveResponse = (externalIntegrationOfferItemControllerRemoveResponseSuccess | externalIntegrationOfferItemControllerRemoveResponseError)

export const getExternalIntegrationOfferItemControllerRemoveUrl = (offerId: number,
    itemId: number,) => {




  return `/ext/offer/${offerId}/item/${itemId}`
}

/**
 * Deletes a specific offer item by its ID.
 * @summary Delete an offer item
 */
export const externalIntegrationOfferItemControllerRemove = async (offerId: number,
    itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationOfferItemControllerRemoveResponse> => {

  return customFetch<externalIntegrationOfferItemControllerRemoveResponse>(getExternalIntegrationOfferItemControllerRemoveUrl(offerId,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getExternalIntegrationOfferItemControllerRemoveMutationKey = () => ['externalIntegrationOfferItemControllerRemove'] as const;

export const getExternalIntegrationOfferItemControllerRemoveMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerRemove>>, TError,ExternalIntegrationOfferItemControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerRemove>>, TError,ExternalIntegrationOfferItemControllerRemoveMutationVariables, TContext> => {

const mutationKey = getExternalIntegrationOfferItemControllerRemoveMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerRemove>>, ExternalIntegrationOfferItemControllerRemoveMutationVariables> = (props) => {
          const {offerId,itemId} = props ?? {};

          return  externalIntegrationOfferItemControllerRemove(offerId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExternalIntegrationOfferItemControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerRemove>>>

    export type ExternalIntegrationOfferItemControllerRemoveMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type ExternalIntegrationOfferItemControllerRemoveMutationVariables = {offerId: number;itemId: number}

    /**
 * @summary Delete an offer item
 */
export const useExternalIntegrationOfferItemControllerRemove = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationOfferItemControllerRemove>>, TError,ExternalIntegrationOfferItemControllerRemoveMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof externalIntegrationOfferItemControllerRemove>>,
        TError,
        ExternalIntegrationOfferItemControllerRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getExternalIntegrationOfferItemControllerRemoveMutationOptions(options), queryClient);
    }

export type externalIntegrationSourceControllerFindAllResponse200 = {
  data: ResponseExternalIntegrationSourceDto[]
  status: 200
}

export type externalIntegrationSourceControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationSourceControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationSourceControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationSourceControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationSourceControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationSourceControllerFindAllResponseSuccess = (externalIntegrationSourceControllerFindAllResponse200) & {
  headers: Headers;
};
export type externalIntegrationSourceControllerFindAllResponseError = (externalIntegrationSourceControllerFindAllResponse400 | externalIntegrationSourceControllerFindAllResponse401 | externalIntegrationSourceControllerFindAllResponse403 | externalIntegrationSourceControllerFindAllResponse404 | externalIntegrationSourceControllerFindAllResponse500) & {
  headers: Headers;
};

export type externalIntegrationSourceControllerFindAllResponse = (externalIntegrationSourceControllerFindAllResponseSuccess | externalIntegrationSourceControllerFindAllResponseError)

export const getExternalIntegrationSourceControllerFindAllUrl = () => {




  return `/ext/source`
}

/**
 * Returns a list of sources that the client has access to. This includes sources that are owned by the client as well as sources that are shared with the client.
 * @summary Find all sources the client has access to
 */
export const externalIntegrationSourceControllerFindAll = async ( options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationSourceControllerFindAllResponse> => {

  return customFetch<externalIntegrationSourceControllerFindAllResponse>(getExternalIntegrationSourceControllerFindAllUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExternalIntegrationSourceControllerFindAllQueryKey = () => {
    return [
    'ext','source'
    ] as const;
    }


export const getExternalIntegrationSourceControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof externalIntegrationSourceControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExternalIntegrationSourceControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindAll>>> = ({ signal }) => externalIntegrationSourceControllerFindAll({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindAll>>, TError, TData>
}

export type ExternalIntegrationSourceControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindAll>>>
export type ExternalIntegrationSourceControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @summary Find all sources the client has access to
 */

export function useExternalIntegrationSourceControllerFindAll<TData = Awaited<ReturnType<typeof externalIntegrationSourceControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExternalIntegrationSourceControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type externalIntegrationSourceControllerFindOneResponse200 = {
  data: ResponseExternalIntegrationSourceDto
  status: 200
}

export type externalIntegrationSourceControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationSourceControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationSourceControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationSourceControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationSourceControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationSourceControllerFindOneResponseSuccess = (externalIntegrationSourceControllerFindOneResponse200) & {
  headers: Headers;
};
export type externalIntegrationSourceControllerFindOneResponseError = (externalIntegrationSourceControllerFindOneResponse400 | externalIntegrationSourceControllerFindOneResponse401 | externalIntegrationSourceControllerFindOneResponse403 | externalIntegrationSourceControllerFindOneResponse404 | externalIntegrationSourceControllerFindOneResponse500) & {
  headers: Headers;
};

export type externalIntegrationSourceControllerFindOneResponse = (externalIntegrationSourceControllerFindOneResponseSuccess | externalIntegrationSourceControllerFindOneResponseError)

export const getExternalIntegrationSourceControllerFindOneUrl = (sourceId: number,) => {




  return `/ext/source/${sourceId}`
}

/**
 * Returns the details of a specific source.
 * @summary Find a specific source by ID
 */
export const externalIntegrationSourceControllerFindOne = async (sourceId: number, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationSourceControllerFindOneResponse> => {

  return customFetch<externalIntegrationSourceControllerFindOneResponse>(getExternalIntegrationSourceControllerFindOneUrl(sourceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExternalIntegrationSourceControllerFindOneQueryKey = (sourceId: MaybeRefOrGetter<number>,) => {
    return [
    'ext','source',sourceId
    ] as const;
    }


export const getExternalIntegrationSourceControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof externalIntegrationSourceControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(sourceId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExternalIntegrationSourceControllerFindOneQueryKey(sourceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindOne>>> = ({ signal }) => externalIntegrationSourceControllerFindOne(toValue(sourceId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(sourceId) !== null && toValue(sourceId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindOne>>, TError, TData>
}

export type ExternalIntegrationSourceControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindOne>>>
export type ExternalIntegrationSourceControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @summary Find a specific source by ID
 */

export function useExternalIntegrationSourceControllerFindOne<TData = Awaited<ReturnType<typeof externalIntegrationSourceControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 sourceId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationSourceControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExternalIntegrationSourceControllerFindOneQueryOptions(sourceId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type logExternalIntegrationControllerPaginateResponse200 = {
  data: LogExternalIntegrationControllerPaginate200
  status: 200
}

export type logExternalIntegrationControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logExternalIntegrationControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logExternalIntegrationControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logExternalIntegrationControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logExternalIntegrationControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logExternalIntegrationControllerPaginateResponseSuccess = (logExternalIntegrationControllerPaginateResponse200) & {
  headers: Headers;
};
export type logExternalIntegrationControllerPaginateResponseError = (logExternalIntegrationControllerPaginateResponse400 | logExternalIntegrationControllerPaginateResponse401 | logExternalIntegrationControllerPaginateResponse403 | logExternalIntegrationControllerPaginateResponse404 | logExternalIntegrationControllerPaginateResponse500) & {
  headers: Headers;
};

export type logExternalIntegrationControllerPaginateResponse = (logExternalIntegrationControllerPaginateResponseSuccess | logExternalIntegrationControllerPaginateResponseError)

export const getLogExternalIntegrationControllerPaginateUrl = (params?: LogExternalIntegrationControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.status","filter.method","filter.path","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/external-integration?${stringifiedParams}` : `/log/external-integration`
}

export const logExternalIntegrationControllerPaginate = async (params?: LogExternalIntegrationControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logExternalIntegrationControllerPaginateResponse> => {

  return customFetch<logExternalIntegrationControllerPaginateResponse>(getLogExternalIntegrationControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogExternalIntegrationControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogExternalIntegrationControllerPaginateParams>,) => {
    return [
    'log','external-integration', ...(params ? [params] : [])
    ] as const;
    }


export const getLogExternalIntegrationControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logExternalIntegrationControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogExternalIntegrationControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logExternalIntegrationControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogExternalIntegrationControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logExternalIntegrationControllerPaginate>>> = ({ signal }) => logExternalIntegrationControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logExternalIntegrationControllerPaginate>>, TError, TData>
}

export type LogExternalIntegrationControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logExternalIntegrationControllerPaginate>>>
export type LogExternalIntegrationControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogExternalIntegrationControllerPaginate<TData = Awaited<ReturnType<typeof logExternalIntegrationControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogExternalIntegrationControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logExternalIntegrationControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogExternalIntegrationControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type externalIntegrationWebhookControllerFindAllResponse200 = {
  data: ResponseExternalIntegrationWebhookDto[]
  status: 200
}

export type externalIntegrationWebhookControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationWebhookControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationWebhookControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationWebhookControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationWebhookControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationWebhookControllerFindAllResponseSuccess = (externalIntegrationWebhookControllerFindAllResponse200) & {
  headers: Headers;
};
export type externalIntegrationWebhookControllerFindAllResponseError = (externalIntegrationWebhookControllerFindAllResponse400 | externalIntegrationWebhookControllerFindAllResponse401 | externalIntegrationWebhookControllerFindAllResponse403 | externalIntegrationWebhookControllerFindAllResponse404 | externalIntegrationWebhookControllerFindAllResponse500) & {
  headers: Headers;
};

export type externalIntegrationWebhookControllerFindAllResponse = (externalIntegrationWebhookControllerFindAllResponseSuccess | externalIntegrationWebhookControllerFindAllResponseError)

export const getExternalIntegrationWebhookControllerFindAllUrl = () => {




  return `/ext/webhook`
}

/**
 * Returns a list of webhooks that have been registered by the client and are active
 *
 * When a webhook is triggered, it will send a POST request with a application/json body to the specified callbackUrl. See [ExternalIntegrationWebhookPayloadDto](#model-ExternalIntegrationWebhookPayloadDto) for information about the body format. Possible payload formats are:
 *
 * - [ExternalIntegrationWebhookPayloadDto](#model-ExternalIntegrationWebhookPayloadDto)
 *
 * The request will include an `X-Webhook-Signature` header, which contains a SHA256 digest of the request body. This allows the receiving server to verify the authenticity of the request. The signature is generated as a JWT Token signed using the webhook secretToken and has the following format (see [ExternalIntegrationWebhookSignatureDto](#model-ExternalIntegrationWebhookSignatureDto)):
 *
 * ```json
 * {
 *   "iss": "Konsolenkost GmbH",
 *   "iat": 1773402635,
 *   "sha256": "ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad"
 * }
 * ```
 * @summary Find all webhooks registered by the client
 */
export const externalIntegrationWebhookControllerFindAll = async ( options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationWebhookControllerFindAllResponse> => {

  return customFetch<externalIntegrationWebhookControllerFindAllResponse>(getExternalIntegrationWebhookControllerFindAllUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExternalIntegrationWebhookControllerFindAllQueryKey = () => {
    return [
    'ext','webhook'
    ] as const;
    }


export const getExternalIntegrationWebhookControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExternalIntegrationWebhookControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindAll>>> = ({ signal }) => externalIntegrationWebhookControllerFindAll({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindAll>>, TError, TData>
}

export type ExternalIntegrationWebhookControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindAll>>>
export type ExternalIntegrationWebhookControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @summary Find all webhooks registered by the client
 */

export function useExternalIntegrationWebhookControllerFindAll<TData = Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExternalIntegrationWebhookControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type externalIntegrationWebhookControllerCreateResponse201 = {
  data: ResponseExternalIntegrationWebhookDto
  status: 201
}

export type externalIntegrationWebhookControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationWebhookControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationWebhookControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationWebhookControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationWebhookControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationWebhookControllerCreateResponseSuccess = (externalIntegrationWebhookControllerCreateResponse201) & {
  headers: Headers;
};
export type externalIntegrationWebhookControllerCreateResponseError = (externalIntegrationWebhookControllerCreateResponse400 | externalIntegrationWebhookControllerCreateResponse401 | externalIntegrationWebhookControllerCreateResponse403 | externalIntegrationWebhookControllerCreateResponse404 | externalIntegrationWebhookControllerCreateResponse500) & {
  headers: Headers;
};

export type externalIntegrationWebhookControllerCreateResponse = (externalIntegrationWebhookControllerCreateResponseSuccess | externalIntegrationWebhookControllerCreateResponseError)

export const getExternalIntegrationWebhookControllerCreateUrl = () => {




  return `/ext/webhook`
}

/**
 * Registers a new webhook for the client. The webhook will be active immediately after creation.
 *
 * When a webhook is triggered, it will send a POST request with a application/json body to the specified callbackUrl. See [ExternalIntegrationWebhookPayloadDto](#model-ExternalIntegrationWebhookPayloadDto) for information about the body format. Possible payload formats are:
 *
 * - [ExternalIntegrationWebhookPayloadDto](#model-ExternalIntegrationWebhookPayloadDto)
 *
 * The request will include an `X-Webhook-Signature` header, which contains a SHA256 digest of the request body. This allows the receiving server to verify the authenticity of the request. The signature is generated as a JWT Token signed using the webhook secretToken and has the following format (see [ExternalIntegrationWebhookSignatureDto](#model-ExternalIntegrationWebhookSignatureDto)):
 *
 * ```json
 * {
 *   "iss": "Konsolenkost GmbH",
 *   "iat": 1773402635,
 *   "sha256": "ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad"
 * }
 * ```
 * @summary Create a new webhook
 */
export const externalIntegrationWebhookControllerCreate = async (createExternalIntegrationWebhookDto: CreateExternalIntegrationWebhookDto, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationWebhookControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<externalIntegrationWebhookControllerCreateResponse>(getExternalIntegrationWebhookControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExternalIntegrationWebhookDto)
  }
);}





export const getExternalIntegrationWebhookControllerCreateMutationKey = () => ['externalIntegrationWebhookControllerCreate'] as const;

export const getExternalIntegrationWebhookControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerCreate>>, TError,ExternalIntegrationWebhookControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerCreate>>, TError,ExternalIntegrationWebhookControllerCreateMutationVariables, TContext> => {

const mutationKey = getExternalIntegrationWebhookControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalIntegrationWebhookControllerCreate>>, ExternalIntegrationWebhookControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  externalIntegrationWebhookControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExternalIntegrationWebhookControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationWebhookControllerCreate>>>
    export type ExternalIntegrationWebhookControllerCreateMutationBody = CreateExternalIntegrationWebhookDto
    export type ExternalIntegrationWebhookControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type ExternalIntegrationWebhookControllerCreateMutationVariables = {data: CreateExternalIntegrationWebhookDto}

    /**
 * @summary Create a new webhook
 */
export const useExternalIntegrationWebhookControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerCreate>>, TError,ExternalIntegrationWebhookControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof externalIntegrationWebhookControllerCreate>>,
        TError,
        ExternalIntegrationWebhookControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getExternalIntegrationWebhookControllerCreateMutationOptions(options), queryClient);
    }

export type externalIntegrationWebhookControllerFindOneResponse200 = {
  data: ResponseExternalIntegrationWebhookDto
  status: 200
}

export type externalIntegrationWebhookControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationWebhookControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationWebhookControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationWebhookControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationWebhookControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationWebhookControllerFindOneResponseSuccess = (externalIntegrationWebhookControllerFindOneResponse200) & {
  headers: Headers;
};
export type externalIntegrationWebhookControllerFindOneResponseError = (externalIntegrationWebhookControllerFindOneResponse400 | externalIntegrationWebhookControllerFindOneResponse401 | externalIntegrationWebhookControllerFindOneResponse403 | externalIntegrationWebhookControllerFindOneResponse404 | externalIntegrationWebhookControllerFindOneResponse500) & {
  headers: Headers;
};

export type externalIntegrationWebhookControllerFindOneResponse = (externalIntegrationWebhookControllerFindOneResponseSuccess | externalIntegrationWebhookControllerFindOneResponseError)

export const getExternalIntegrationWebhookControllerFindOneUrl = (webhookId: number,) => {




  return `/ext/webhook/${webhookId}`
}

/**
 * Returns the details of a specific webhook registered by the client.
 *
 * When a webhook is triggered, it will send a POST request with a application/json body to the specified callbackUrl. See [ExternalIntegrationWebhookPayloadDto](#model-ExternalIntegrationWebhookPayloadDto) for information about the body format. Possible payload formats are:
 *
 * - [ExternalIntegrationWebhookPayloadDto](#model-ExternalIntegrationWebhookPayloadDto)
 *
 * The request will include an `X-Webhook-Signature` header, which contains a SHA256 digest of the request body. This allows the receiving server to verify the authenticity of the request. The signature is generated as a JWT Token signed using the webhook secretToken and has the following format (see [ExternalIntegrationWebhookSignatureDto](#model-ExternalIntegrationWebhookSignatureDto)):
 *
 * ```json
 * {
 *   "iss": "Konsolenkost GmbH",
 *   "iat": 1773402635,
 *   "sha256": "ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad"
 * }
 * ```
 * @summary Find a specific webhook by ID
 */
export const externalIntegrationWebhookControllerFindOne = async (webhookId: number, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationWebhookControllerFindOneResponse> => {

  return customFetch<externalIntegrationWebhookControllerFindOneResponse>(getExternalIntegrationWebhookControllerFindOneUrl(webhookId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExternalIntegrationWebhookControllerFindOneQueryKey = (webhookId: MaybeRefOrGetter<number>,) => {
    return [
    'ext','webhook',webhookId
    ] as const;
    }


export const getExternalIntegrationWebhookControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(webhookId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getExternalIntegrationWebhookControllerFindOneQueryKey(webhookId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindOne>>> = ({ signal }) => externalIntegrationWebhookControllerFindOne(toValue(webhookId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(webhookId) !== null && toValue(webhookId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindOne>>, TError, TData>
}

export type ExternalIntegrationWebhookControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindOne>>>
export type ExternalIntegrationWebhookControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @summary Find a specific webhook by ID
 */

export function useExternalIntegrationWebhookControllerFindOne<TData = Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 webhookId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExternalIntegrationWebhookControllerFindOneQueryOptions(webhookId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type externalIntegrationWebhookControllerDeleteResponse200 = {
  data: ResponseExternalIntegrationWebhookDto
  status: 200
}

export type externalIntegrationWebhookControllerDeleteResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type externalIntegrationWebhookControllerDeleteResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type externalIntegrationWebhookControllerDeleteResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type externalIntegrationWebhookControllerDeleteResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type externalIntegrationWebhookControllerDeleteResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type externalIntegrationWebhookControllerDeleteResponseSuccess = (externalIntegrationWebhookControllerDeleteResponse200) & {
  headers: Headers;
};
export type externalIntegrationWebhookControllerDeleteResponseError = (externalIntegrationWebhookControllerDeleteResponse400 | externalIntegrationWebhookControllerDeleteResponse401 | externalIntegrationWebhookControllerDeleteResponse403 | externalIntegrationWebhookControllerDeleteResponse404 | externalIntegrationWebhookControllerDeleteResponse500) & {
  headers: Headers;
};

export type externalIntegrationWebhookControllerDeleteResponse = (externalIntegrationWebhookControllerDeleteResponseSuccess | externalIntegrationWebhookControllerDeleteResponseError)

export const getExternalIntegrationWebhookControllerDeleteUrl = (webhookId: number,) => {




  return `/ext/webhook/${webhookId}`
}

/**
 * Deletes a webhook registered by the client. The webhook will be deactivated and will no longer receive events.
 *
 * When a webhook is triggered, it will send a POST request with a application/json body to the specified callbackUrl. See [ExternalIntegrationWebhookPayloadDto](#model-ExternalIntegrationWebhookPayloadDto) for information about the body format. Possible payload formats are:
 *
 * - [ExternalIntegrationWebhookPayloadDto](#model-ExternalIntegrationWebhookPayloadDto)
 *
 * The request will include an `X-Webhook-Signature` header, which contains a SHA256 digest of the request body. This allows the receiving server to verify the authenticity of the request. The signature is generated as a JWT Token signed using the webhook secretToken and has the following format (see [ExternalIntegrationWebhookSignatureDto](#model-ExternalIntegrationWebhookSignatureDto)):
 *
 * ```json
 * {
 *   "iss": "Konsolenkost GmbH",
 *   "iat": 1773402635,
 *   "sha256": "ba7816bf8f01cfea414140de5dae2223b00361a396177a9cb410ff61f20015ad"
 * }
 * ```
 * @summary Delete a webhook
 */
export const externalIntegrationWebhookControllerDelete = async (webhookId: number, options?: Parameters<typeof customFetch>[1]): Promise<externalIntegrationWebhookControllerDeleteResponse> => {

  return customFetch<externalIntegrationWebhookControllerDeleteResponse>(getExternalIntegrationWebhookControllerDeleteUrl(webhookId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getExternalIntegrationWebhookControllerDeleteMutationKey = () => ['externalIntegrationWebhookControllerDelete'] as const;

export const getExternalIntegrationWebhookControllerDeleteMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerDelete>>, TError,ExternalIntegrationWebhookControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerDelete>>, TError,ExternalIntegrationWebhookControllerDeleteMutationVariables, TContext> => {

const mutationKey = getExternalIntegrationWebhookControllerDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof externalIntegrationWebhookControllerDelete>>, ExternalIntegrationWebhookControllerDeleteMutationVariables> = (props) => {
          const {webhookId} = props ?? {};

          return  externalIntegrationWebhookControllerDelete(webhookId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExternalIntegrationWebhookControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof externalIntegrationWebhookControllerDelete>>>

    export type ExternalIntegrationWebhookControllerDeleteMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type ExternalIntegrationWebhookControllerDeleteMutationVariables = {webhookId: number}

    /**
 * @summary Delete a webhook
 */
export const useExternalIntegrationWebhookControllerDelete = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof externalIntegrationWebhookControllerDelete>>, TError,ExternalIntegrationWebhookControllerDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof externalIntegrationWebhookControllerDelete>>,
        TError,
        ExternalIntegrationWebhookControllerDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getExternalIntegrationWebhookControllerDeleteMutationOptions(options), queryClient);
    }

export type logApiLlmControllerPaginateResponse200 = {
  data: LogApiLlmControllerPaginate200
  status: 200
}

export type logApiLlmControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logApiLlmControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logApiLlmControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logApiLlmControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logApiLlmControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logApiLlmControllerPaginateResponseSuccess = (logApiLlmControllerPaginateResponse200) & {
  headers: Headers;
};
export type logApiLlmControllerPaginateResponseError = (logApiLlmControllerPaginateResponse400 | logApiLlmControllerPaginateResponse401 | logApiLlmControllerPaginateResponse403 | logApiLlmControllerPaginateResponse404 | logApiLlmControllerPaginateResponse500) & {
  headers: Headers;
};

export type logApiLlmControllerPaginateResponse = (logApiLlmControllerPaginateResponseSuccess | logApiLlmControllerPaginateResponseError)

export const getLogApiLlmControllerPaginateUrl = (params?: LogApiLlmControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.provider","filter.model","filter.operation","filter.success","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/api-llm?${stringifiedParams}` : `/log/api-llm`
}

export const logApiLlmControllerPaginate = async (params?: LogApiLlmControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logApiLlmControllerPaginateResponse> => {

  return customFetch<logApiLlmControllerPaginateResponse>(getLogApiLlmControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogApiLlmControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogApiLlmControllerPaginateParams>,) => {
    return [
    'log','api-llm', ...(params ? [params] : [])
    ] as const;
    }


export const getLogApiLlmControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logApiLlmControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogApiLlmControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiLlmControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogApiLlmControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logApiLlmControllerPaginate>>> = ({ signal }) => logApiLlmControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logApiLlmControllerPaginate>>, TError, TData>
}

export type LogApiLlmControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logApiLlmControllerPaginate>>>
export type LogApiLlmControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogApiLlmControllerPaginate<TData = Awaited<ReturnType<typeof logApiLlmControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogApiLlmControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logApiLlmControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogApiLlmControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type logAuthControllerPaginateResponse200 = {
  data: LogAuthControllerPaginate200
  status: 200
}

export type logAuthControllerPaginateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logAuthControllerPaginateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logAuthControllerPaginateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logAuthControllerPaginateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logAuthControllerPaginateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logAuthControllerPaginateResponseSuccess = (logAuthControllerPaginateResponse200) & {
  headers: Headers;
};
export type logAuthControllerPaginateResponseError = (logAuthControllerPaginateResponse400 | logAuthControllerPaginateResponse401 | logAuthControllerPaginateResponse403 | logAuthControllerPaginateResponse404 | logAuthControllerPaginateResponse500) & {
  headers: Headers;
};

export type logAuthControllerPaginateResponse = (logAuthControllerPaginateResponseSuccess | logAuthControllerPaginateResponseError)

export const getLogAuthControllerPaginateUrl = (params?: LogAuthControllerPaginateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.event","filter.success","filter.reason","filter.userId","filter.sourceId","filter.authorizedById","filter.deviceId","filter.ip","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/auth?${stringifiedParams}` : `/log/auth`
}

export const logAuthControllerPaginate = async (params?: LogAuthControllerPaginateParams, options?: Parameters<typeof customFetch>[1]): Promise<logAuthControllerPaginateResponse> => {

  return customFetch<logAuthControllerPaginateResponse>(getLogAuthControllerPaginateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogAuthControllerPaginateQueryKey = (params?: MaybeRefOrGetter<LogAuthControllerPaginateParams>,) => {
    return [
    'log','auth', ...(params ? [params] : [])
    ] as const;
    }


export const getLogAuthControllerPaginateQueryOptions = <TData = Awaited<ReturnType<typeof logAuthControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<LogAuthControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logAuthControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogAuthControllerPaginateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logAuthControllerPaginate>>> = ({ signal }) => logAuthControllerPaginate(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logAuthControllerPaginate>>, TError, TData>
}

export type LogAuthControllerPaginateQueryResult = NonNullable<Awaited<ReturnType<typeof logAuthControllerPaginate>>>
export type LogAuthControllerPaginateQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogAuthControllerPaginate<TData = Awaited<ReturnType<typeof logAuthControllerPaginate>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<LogAuthControllerPaginateParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logAuthControllerPaginate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogAuthControllerPaginateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type logOfferTransitionControllerFindAllForOfferResponse200 = {
  data: LogOfferTransitionControllerFindAllForOffer200
  status: 200
}

export type logOfferTransitionControllerFindAllForOfferResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logOfferTransitionControllerFindAllForOfferResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logOfferTransitionControllerFindAllForOfferResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logOfferTransitionControllerFindAllForOfferResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logOfferTransitionControllerFindAllForOfferResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logOfferTransitionControllerFindAllForOfferResponseSuccess = (logOfferTransitionControllerFindAllForOfferResponse200) & {
  headers: Headers;
};
export type logOfferTransitionControllerFindAllForOfferResponseError = (logOfferTransitionControllerFindAllForOfferResponse400 | logOfferTransitionControllerFindAllForOfferResponse401 | logOfferTransitionControllerFindAllForOfferResponse403 | logOfferTransitionControllerFindAllForOfferResponse404 | logOfferTransitionControllerFindAllForOfferResponse500) & {
  headers: Headers;
};

export type logOfferTransitionControllerFindAllForOfferResponse = (logOfferTransitionControllerFindAllForOfferResponseSuccess | logOfferTransitionControllerFindAllForOfferResponseError)

export const getLogOfferTransitionControllerFindAllForOfferUrl = (offerId: number,
    params?: LogOfferTransitionControllerFindAllForOfferParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.transition","filter.fromStatus","filter.toStatus","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/offer/${offerId}/transition?${stringifiedParams}` : `/log/offer/${offerId}/transition`
}

export const logOfferTransitionControllerFindAllForOffer = async (offerId: number,
    params?: LogOfferTransitionControllerFindAllForOfferParams, options?: Parameters<typeof customFetch>[1]): Promise<logOfferTransitionControllerFindAllForOfferResponse> => {

  return customFetch<logOfferTransitionControllerFindAllForOfferResponse>(getLogOfferTransitionControllerFindAllForOfferUrl(offerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogOfferTransitionControllerFindAllForOfferQueryKey = (offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferTransitionControllerFindAllForOfferParams>,) => {
    return [
    'log','offer',offerId,'transition', ...(params ? [params] : [])
    ] as const;
    }


export const getLogOfferTransitionControllerFindAllForOfferQueryOptions = <TData = Awaited<ReturnType<typeof logOfferTransitionControllerFindAllForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferTransitionControllerFindAllForOfferParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logOfferTransitionControllerFindAllForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogOfferTransitionControllerFindAllForOfferQueryKey(offerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logOfferTransitionControllerFindAllForOffer>>> = ({ signal }) => logOfferTransitionControllerFindAllForOffer(toValue(offerId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(offerId) !== null && toValue(offerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logOfferTransitionControllerFindAllForOffer>>, TError, TData>
}

export type LogOfferTransitionControllerFindAllForOfferQueryResult = NonNullable<Awaited<ReturnType<typeof logOfferTransitionControllerFindAllForOffer>>>
export type LogOfferTransitionControllerFindAllForOfferQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogOfferTransitionControllerFindAllForOffer<TData = Awaited<ReturnType<typeof logOfferTransitionControllerFindAllForOffer>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 offerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogOfferTransitionControllerFindAllForOfferParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logOfferTransitionControllerFindAllForOffer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogOfferTransitionControllerFindAllForOfferQueryOptions(offerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type logHandlingItemTransitionControllerFindAllForItemResponse200 = {
  data: LogHandlingItemTransitionControllerFindAllForItem200
  status: 200
}

export type logHandlingItemTransitionControllerFindAllForItemResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type logHandlingItemTransitionControllerFindAllForItemResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type logHandlingItemTransitionControllerFindAllForItemResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type logHandlingItemTransitionControllerFindAllForItemResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type logHandlingItemTransitionControllerFindAllForItemResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type logHandlingItemTransitionControllerFindAllForItemResponseSuccess = (logHandlingItemTransitionControllerFindAllForItemResponse200) & {
  headers: Headers;
};
export type logHandlingItemTransitionControllerFindAllForItemResponseError = (logHandlingItemTransitionControllerFindAllForItemResponse400 | logHandlingItemTransitionControllerFindAllForItemResponse401 | logHandlingItemTransitionControllerFindAllForItemResponse403 | logHandlingItemTransitionControllerFindAllForItemResponse404 | logHandlingItemTransitionControllerFindAllForItemResponse500) & {
  headers: Headers;
};

export type logHandlingItemTransitionControllerFindAllForItemResponse = (logHandlingItemTransitionControllerFindAllForItemResponseSuccess | logHandlingItemTransitionControllerFindAllForItemResponseError)

export const getLogHandlingItemTransitionControllerFindAllForItemUrl = (itemId: number,
    params?: LogHandlingItemTransitionControllerFindAllForItemParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.transition","filter.fromStatus","filter.toStatus","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/log/handling/item/${itemId}/transition?${stringifiedParams}` : `/log/handling/item/${itemId}/transition`
}

export const logHandlingItemTransitionControllerFindAllForItem = async (itemId: number,
    params?: LogHandlingItemTransitionControllerFindAllForItemParams, options?: Parameters<typeof customFetch>[1]): Promise<logHandlingItemTransitionControllerFindAllForItemResponse> => {

  return customFetch<logHandlingItemTransitionControllerFindAllForItemResponse>(getLogHandlingItemTransitionControllerFindAllForItemUrl(itemId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLogHandlingItemTransitionControllerFindAllForItemQueryKey = (itemId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogHandlingItemTransitionControllerFindAllForItemParams>,) => {
    return [
    'log','handling','item',itemId,'transition', ...(params ? [params] : [])
    ] as const;
    }


export const getLogHandlingItemTransitionControllerFindAllForItemQueryOptions = <TData = Awaited<ReturnType<typeof logHandlingItemTransitionControllerFindAllForItem>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(itemId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogHandlingItemTransitionControllerFindAllForItemParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logHandlingItemTransitionControllerFindAllForItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getLogHandlingItemTransitionControllerFindAllForItemQueryKey(itemId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof logHandlingItemTransitionControllerFindAllForItem>>> = ({ signal }) => logHandlingItemTransitionControllerFindAllForItem(toValue(itemId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(itemId) !== null && toValue(itemId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logHandlingItemTransitionControllerFindAllForItem>>, TError, TData>
}

export type LogHandlingItemTransitionControllerFindAllForItemQueryResult = NonNullable<Awaited<ReturnType<typeof logHandlingItemTransitionControllerFindAllForItem>>>
export type LogHandlingItemTransitionControllerFindAllForItemQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useLogHandlingItemTransitionControllerFindAllForItem<TData = Awaited<ReturnType<typeof logHandlingItemTransitionControllerFindAllForItem>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 itemId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<LogHandlingItemTransitionControllerFindAllForItemParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logHandlingItemTransitionControllerFindAllForItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogHandlingItemTransitionControllerFindAllForItemQueryOptions(itemId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type changelogControllerGetVersionsResponse200 = {
  data: ChangelogControllerGetVersions200
  status: 200
}

export type changelogControllerGetVersionsResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type changelogControllerGetVersionsResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type changelogControllerGetVersionsResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type changelogControllerGetVersionsResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type changelogControllerGetVersionsResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type changelogControllerGetVersionsResponseSuccess = (changelogControllerGetVersionsResponse200) & {
  headers: Headers;
};
export type changelogControllerGetVersionsResponseError = (changelogControllerGetVersionsResponse400 | changelogControllerGetVersionsResponse401 | changelogControllerGetVersionsResponse403 | changelogControllerGetVersionsResponse404 | changelogControllerGetVersionsResponse500) & {
  headers: Headers;
};

export type changelogControllerGetVersionsResponse = (changelogControllerGetVersionsResponseSuccess | changelogControllerGetVersionsResponseError)

export const getChangelogControllerGetVersionsUrl = (params?: ChangelogControllerGetVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.package","filter.major","filter.minor","filter.patch","filter.prerelease","filter.channel","filter.date","sortBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/changelog/versions?${stringifiedParams}` : `/changelog/versions`
}

/**
 * Returns paginated versions matching the given filters. Supports filtering by package, major, minor, patch, prerelease, channel, and date ranges. Results are ordered by date (newest first) by default. Use Accept-Language header to filter summaries by locale.
 * @summary Query changelog versions with pagination and filtering
 */
export const changelogControllerGetVersions = async (params?: ChangelogControllerGetVersionsParams, options?: Parameters<typeof customFetch>[1]): Promise<changelogControllerGetVersionsResponse> => {

  return customFetch<changelogControllerGetVersionsResponse>(getChangelogControllerGetVersionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChangelogControllerGetVersionsQueryKey = (params?: MaybeRefOrGetter<ChangelogControllerGetVersionsParams>,) => {
    return [
    'changelog','versions', ...(params ? [params] : [])
    ] as const;
    }


export const getChangelogControllerGetVersionsQueryOptions = <TData = Awaited<ReturnType<typeof changelogControllerGetVersions>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<ChangelogControllerGetVersionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changelogControllerGetVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getChangelogControllerGetVersionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof changelogControllerGetVersions>>> = ({ signal }) => changelogControllerGetVersions(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof changelogControllerGetVersions>>, TError, TData>
}

export type ChangelogControllerGetVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof changelogControllerGetVersions>>>
export type ChangelogControllerGetVersionsQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


/**
 * @summary Query changelog versions with pagination and filtering
 */

export function useChangelogControllerGetVersions<TData = Awaited<ReturnType<typeof changelogControllerGetVersions>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<ChangelogControllerGetVersionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof changelogControllerGetVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChangelogControllerGetVersionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type changelogControllerHandleWebhookResponse202 = {
  data: void
  status: 202
}

export type changelogControllerHandleWebhookResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type changelogControllerHandleWebhookResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type changelogControllerHandleWebhookResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type changelogControllerHandleWebhookResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type changelogControllerHandleWebhookResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type changelogControllerHandleWebhookResponseSuccess = (changelogControllerHandleWebhookResponse202) & {
  headers: Headers;
};
export type changelogControllerHandleWebhookResponseError = (changelogControllerHandleWebhookResponse400 | changelogControllerHandleWebhookResponse401 | changelogControllerHandleWebhookResponse403 | changelogControllerHandleWebhookResponse404 | changelogControllerHandleWebhookResponse500) & {
  headers: Headers;
};

export type changelogControllerHandleWebhookResponse = (changelogControllerHandleWebhookResponseSuccess | changelogControllerHandleWebhookResponseError)

export const getChangelogControllerHandleWebhookUrl = () => {




  return `/changelog/webhook`
}

/**
 * @summary Trigger changelog sync via webhook
 */
export const changelogControllerHandleWebhook = async ( options?: Parameters<typeof customFetch>[1]): Promise<changelogControllerHandleWebhookResponse> => {

  return customFetch<changelogControllerHandleWebhookResponse>(getChangelogControllerHandleWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getChangelogControllerHandleWebhookMutationKey = () => ['changelogControllerHandleWebhook'] as const;

export const getChangelogControllerHandleWebhookMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changelogControllerHandleWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changelogControllerHandleWebhook>>, TError,void, TContext> => {

const mutationKey = getChangelogControllerHandleWebhookMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changelogControllerHandleWebhook>>, void> = () => {


          return  changelogControllerHandleWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangelogControllerHandleWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof changelogControllerHandleWebhook>>>

    export type ChangelogControllerHandleWebhookMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto


    /**
 * @summary Trigger changelog sync via webhook
 */
export const useChangelogControllerHandleWebhook = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changelogControllerHandleWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof changelogControllerHandleWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getChangelogControllerHandleWebhookMutationOptions(options), queryClient);
    }

export type internalLedgerControllerCreateResponse201 = {
  data: ResponseInternalLedgerDto
  status: 201
}

export type internalLedgerControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerControllerCreateResponseSuccess = (internalLedgerControllerCreateResponse201) & {
  headers: Headers;
};
export type internalLedgerControllerCreateResponseError = (internalLedgerControllerCreateResponse400 | internalLedgerControllerCreateResponse401 | internalLedgerControllerCreateResponse403 | internalLedgerControllerCreateResponse404 | internalLedgerControllerCreateResponse500) & {
  headers: Headers;
};

export type internalLedgerControllerCreateResponse = (internalLedgerControllerCreateResponseSuccess | internalLedgerControllerCreateResponseError)

export const getInternalLedgerControllerCreateUrl = () => {




  return `/internal-ledger`
}

export const internalLedgerControllerCreate = async (createInternalLedgerDto: CreateInternalLedgerDto, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<internalLedgerControllerCreateResponse>(getInternalLedgerControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInternalLedgerDto)
  }
);}





export const getInternalLedgerControllerCreateMutationKey = () => ['internalLedgerControllerCreate'] as const;

export const getInternalLedgerControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerControllerCreate>>, TError,InternalLedgerControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLedgerControllerCreate>>, TError,InternalLedgerControllerCreateMutationVariables, TContext> => {

const mutationKey = getInternalLedgerControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLedgerControllerCreate>>, InternalLedgerControllerCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  internalLedgerControllerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalLedgerControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalLedgerControllerCreate>>>
    export type InternalLedgerControllerCreateMutationBody = CreateInternalLedgerDto
    export type InternalLedgerControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type InternalLedgerControllerCreateMutationVariables = {data: CreateInternalLedgerDto}

    export const useInternalLedgerControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerControllerCreate>>, TError,InternalLedgerControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof internalLedgerControllerCreate>>,
        TError,
        InternalLedgerControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getInternalLedgerControllerCreateMutationOptions(options), queryClient);
    }

export type internalLedgerControllerFindAllResponse200 = {
  data: InternalLedgerControllerFindAll200
  status: 200
}

export type internalLedgerControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerControllerFindAllResponseSuccess = (internalLedgerControllerFindAllResponse200) & {
  headers: Headers;
};
export type internalLedgerControllerFindAllResponseError = (internalLedgerControllerFindAllResponse400 | internalLedgerControllerFindAllResponse401 | internalLedgerControllerFindAllResponse403 | internalLedgerControllerFindAllResponse404 | internalLedgerControllerFindAllResponse500) & {
  headers: Headers;
};

export type internalLedgerControllerFindAllResponse = (internalLedgerControllerFindAllResponseSuccess | internalLedgerControllerFindAllResponseError)

export const getInternalLedgerControllerFindAllUrl = (params?: InternalLedgerControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.source.id","filter.createdBy.id","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/internal-ledger?${stringifiedParams}` : `/internal-ledger`
}

export const internalLedgerControllerFindAll = async (params?: InternalLedgerControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerControllerFindAllResponse> => {

  return customFetch<internalLedgerControllerFindAllResponse>(getInternalLedgerControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInternalLedgerControllerFindAllQueryKey = (params?: MaybeRefOrGetter<InternalLedgerControllerFindAllParams>,) => {
    return [
    'internal-ledger', ...(params ? [params] : [])
    ] as const;
    }


export const getInternalLedgerControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof internalLedgerControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(params?: MaybeRefOrGetter<InternalLedgerControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getInternalLedgerControllerFindAllQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLedgerControllerFindAll>>> = ({ signal }) => internalLedgerControllerFindAll(toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLedgerControllerFindAll>>, TError, TData>
}

export type InternalLedgerControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof internalLedgerControllerFindAll>>>
export type InternalLedgerControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useInternalLedgerControllerFindAll<TData = Awaited<ReturnType<typeof internalLedgerControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 params?: MaybeRefOrGetter<InternalLedgerControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInternalLedgerControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type internalLedgerControllerFindOneResponse200 = {
  data: ResponseInternalLedgerDto
  status: 200
}

export type internalLedgerControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerControllerFindOneResponseSuccess = (internalLedgerControllerFindOneResponse200) & {
  headers: Headers;
};
export type internalLedgerControllerFindOneResponseError = (internalLedgerControllerFindOneResponse400 | internalLedgerControllerFindOneResponse401 | internalLedgerControllerFindOneResponse403 | internalLedgerControllerFindOneResponse404 | internalLedgerControllerFindOneResponse500) & {
  headers: Headers;
};

export type internalLedgerControllerFindOneResponse = (internalLedgerControllerFindOneResponseSuccess | internalLedgerControllerFindOneResponseError)

export const getInternalLedgerControllerFindOneUrl = (ledgerId: number,) => {




  return `/internal-ledger/${ledgerId}`
}

export const internalLedgerControllerFindOne = async (ledgerId: number, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerControllerFindOneResponse> => {

  return customFetch<internalLedgerControllerFindOneResponse>(getInternalLedgerControllerFindOneUrl(ledgerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInternalLedgerControllerFindOneQueryKey = (ledgerId: MaybeRefOrGetter<number>,) => {
    return [
    'internal-ledger',ledgerId
    ] as const;
    }


export const getInternalLedgerControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof internalLedgerControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(ledgerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getInternalLedgerControllerFindOneQueryKey(ledgerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLedgerControllerFindOne>>> = ({ signal }) => internalLedgerControllerFindOne(toValue(ledgerId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(ledgerId) !== null && toValue(ledgerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLedgerControllerFindOne>>, TError, TData>
}

export type InternalLedgerControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof internalLedgerControllerFindOne>>>
export type InternalLedgerControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useInternalLedgerControllerFindOne<TData = Awaited<ReturnType<typeof internalLedgerControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 ledgerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInternalLedgerControllerFindOneQueryOptions(ledgerId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type internalLedgerControllerUpdateResponse200 = {
  data: ResponseInternalLedgerDto
  status: 200
}

export type internalLedgerControllerUpdateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerControllerUpdateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerControllerUpdateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerControllerUpdateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerControllerUpdateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerControllerUpdateResponseSuccess = (internalLedgerControllerUpdateResponse200) & {
  headers: Headers;
};
export type internalLedgerControllerUpdateResponseError = (internalLedgerControllerUpdateResponse400 | internalLedgerControllerUpdateResponse401 | internalLedgerControllerUpdateResponse403 | internalLedgerControllerUpdateResponse404 | internalLedgerControllerUpdateResponse500) & {
  headers: Headers;
};

export type internalLedgerControllerUpdateResponse = (internalLedgerControllerUpdateResponseSuccess | internalLedgerControllerUpdateResponseError)

export const getInternalLedgerControllerUpdateUrl = (ledgerId: number,) => {




  return `/internal-ledger/${ledgerId}`
}

export const internalLedgerControllerUpdate = async (ledgerId: number,
    updateInternalLedgerDto: UpdateInternalLedgerDto, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerControllerUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<internalLedgerControllerUpdateResponse>(getInternalLedgerControllerUpdateUrl(ledgerId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateInternalLedgerDto)
  }
);}





export const getInternalLedgerControllerUpdateMutationKey = () => ['internalLedgerControllerUpdate'] as const;

export const getInternalLedgerControllerUpdateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerControllerUpdate>>, TError,InternalLedgerControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLedgerControllerUpdate>>, TError,InternalLedgerControllerUpdateMutationVariables, TContext> => {

const mutationKey = getInternalLedgerControllerUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLedgerControllerUpdate>>, InternalLedgerControllerUpdateMutationVariables> = (props) => {
          const {ledgerId,data} = props ?? {};

          return  internalLedgerControllerUpdate(ledgerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalLedgerControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof internalLedgerControllerUpdate>>>
    export type InternalLedgerControllerUpdateMutationBody = UpdateInternalLedgerDto
    export type InternalLedgerControllerUpdateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type InternalLedgerControllerUpdateMutationVariables = {ledgerId: number;data: UpdateInternalLedgerDto}

    export const useInternalLedgerControllerUpdate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerControllerUpdate>>, TError,InternalLedgerControllerUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof internalLedgerControllerUpdate>>,
        TError,
        InternalLedgerControllerUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getInternalLedgerControllerUpdateMutationOptions(options), queryClient);
    }

export type internalLedgerSessionControllerOpenResponse201 = {
  data: ResponseInternalLedgerSessionDto
  status: 201
}

export type internalLedgerSessionControllerOpenResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionControllerOpenResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionControllerOpenResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionControllerOpenResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionControllerOpenResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionControllerOpenResponseSuccess = (internalLedgerSessionControllerOpenResponse201) & {
  headers: Headers;
};
export type internalLedgerSessionControllerOpenResponseError = (internalLedgerSessionControllerOpenResponse400 | internalLedgerSessionControllerOpenResponse401 | internalLedgerSessionControllerOpenResponse403 | internalLedgerSessionControllerOpenResponse404 | internalLedgerSessionControllerOpenResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionControllerOpenResponse = (internalLedgerSessionControllerOpenResponseSuccess | internalLedgerSessionControllerOpenResponseError)

export const getInternalLedgerSessionControllerOpenUrl = (ledgerId: number,) => {




  return `/internal-ledger/${ledgerId}/session`
}

export const internalLedgerSessionControllerOpen = async (ledgerId: number,
    openInternalLedgerSessionDto: OpenInternalLedgerSessionDto, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionControllerOpenResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<internalLedgerSessionControllerOpenResponse>(getInternalLedgerSessionControllerOpenUrl(ledgerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(openInternalLedgerSessionDto)
  }
);}





export const getInternalLedgerSessionControllerOpenMutationKey = () => ['internalLedgerSessionControllerOpen'] as const;

export const getInternalLedgerSessionControllerOpenMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerOpen>>, TError,InternalLedgerSessionControllerOpenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerOpen>>, TError,InternalLedgerSessionControllerOpenMutationVariables, TContext> => {

const mutationKey = getInternalLedgerSessionControllerOpenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLedgerSessionControllerOpen>>, InternalLedgerSessionControllerOpenMutationVariables> = (props) => {
          const {ledgerId,data} = props ?? {};

          return  internalLedgerSessionControllerOpen(ledgerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalLedgerSessionControllerOpenMutationResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionControllerOpen>>>
    export type InternalLedgerSessionControllerOpenMutationBody = OpenInternalLedgerSessionDto
    export type InternalLedgerSessionControllerOpenMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type InternalLedgerSessionControllerOpenMutationVariables = {ledgerId: number;data: OpenInternalLedgerSessionDto}

    export const useInternalLedgerSessionControllerOpen = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerOpen>>, TError,InternalLedgerSessionControllerOpenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof internalLedgerSessionControllerOpen>>,
        TError,
        InternalLedgerSessionControllerOpenMutationVariables,
        TContext
      > => {
      return useMutation(getInternalLedgerSessionControllerOpenMutationOptions(options), queryClient);
    }

export type internalLedgerSessionControllerFindAllResponse200 = {
  data: InternalLedgerSessionControllerFindAll200
  status: 200
}

export type internalLedgerSessionControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionControllerFindAllResponseSuccess = (internalLedgerSessionControllerFindAllResponse200) & {
  headers: Headers;
};
export type internalLedgerSessionControllerFindAllResponseError = (internalLedgerSessionControllerFindAllResponse400 | internalLedgerSessionControllerFindAllResponse401 | internalLedgerSessionControllerFindAllResponse403 | internalLedgerSessionControllerFindAllResponse404 | internalLedgerSessionControllerFindAllResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionControllerFindAllResponse = (internalLedgerSessionControllerFindAllResponseSuccess | internalLedgerSessionControllerFindAllResponseError)

export const getInternalLedgerSessionControllerFindAllUrl = (ledgerId: number,
    params?: InternalLedgerSessionControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.status","filter.internalLedger.id","filter.internalLedger.source.id","filter.openedBy.id","filter.closedBy.id","filter.openingCountAttempts","filter.closingCountAttempts","filter.openingFloatDiscrepancy","filter.closingFloatDiscrepancy","filter.openedAt","filter.closedAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/internal-ledger/${ledgerId}/session?${stringifiedParams}` : `/internal-ledger/${ledgerId}/session`
}

export const internalLedgerSessionControllerFindAll = async (ledgerId: number,
    params?: InternalLedgerSessionControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionControllerFindAllResponse> => {

  return customFetch<internalLedgerSessionControllerFindAllResponse>(getInternalLedgerSessionControllerFindAllUrl(ledgerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInternalLedgerSessionControllerFindAllQueryKey = (ledgerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<InternalLedgerSessionControllerFindAllParams>,) => {
    return [
    'internal-ledger',ledgerId,'session', ...(params ? [params] : [])
    ] as const;
    }


export const getInternalLedgerSessionControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof internalLedgerSessionControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(ledgerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<InternalLedgerSessionControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getInternalLedgerSessionControllerFindAllQueryKey(ledgerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLedgerSessionControllerFindAll>>> = ({ signal }) => internalLedgerSessionControllerFindAll(toValue(ledgerId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(ledgerId) !== null && toValue(ledgerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindAll>>, TError, TData>
}

export type InternalLedgerSessionControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionControllerFindAll>>>
export type InternalLedgerSessionControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useInternalLedgerSessionControllerFindAll<TData = Awaited<ReturnType<typeof internalLedgerSessionControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 ledgerId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<InternalLedgerSessionControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInternalLedgerSessionControllerFindAllQueryOptions(ledgerId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type internalLedgerSessionControllerCountResponse201 = {
  data: ResponseInternalLedgerSessionDto
  status: 201
}

export type internalLedgerSessionControllerCountResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionControllerCountResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionControllerCountResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionControllerCountResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionControllerCountResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionControllerCountResponseSuccess = (internalLedgerSessionControllerCountResponse201) & {
  headers: Headers;
};
export type internalLedgerSessionControllerCountResponseError = (internalLedgerSessionControllerCountResponse400 | internalLedgerSessionControllerCountResponse401 | internalLedgerSessionControllerCountResponse403 | internalLedgerSessionControllerCountResponse404 | internalLedgerSessionControllerCountResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionControllerCountResponse = (internalLedgerSessionControllerCountResponseSuccess | internalLedgerSessionControllerCountResponseError)

export const getInternalLedgerSessionControllerCountUrl = (ledgerId: number,
    sessionId: number,) => {




  return `/internal-ledger/${ledgerId}/session/${sessionId}/count`
}

export const internalLedgerSessionControllerCount = async (ledgerId: number,
    sessionId: number,
    countInternalLedgerSessionDto: CountInternalLedgerSessionDto, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionControllerCountResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<internalLedgerSessionControllerCountResponse>(getInternalLedgerSessionControllerCountUrl(ledgerId,sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(countInternalLedgerSessionDto)
  }
);}





export const getInternalLedgerSessionControllerCountMutationKey = () => ['internalLedgerSessionControllerCount'] as const;

export const getInternalLedgerSessionControllerCountMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerCount>>, TError,InternalLedgerSessionControllerCountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerCount>>, TError,InternalLedgerSessionControllerCountMutationVariables, TContext> => {

const mutationKey = getInternalLedgerSessionControllerCountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLedgerSessionControllerCount>>, InternalLedgerSessionControllerCountMutationVariables> = (props) => {
          const {ledgerId,sessionId,data} = props ?? {};

          return  internalLedgerSessionControllerCount(ledgerId,sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalLedgerSessionControllerCountMutationResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionControllerCount>>>
    export type InternalLedgerSessionControllerCountMutationBody = CountInternalLedgerSessionDto
    export type InternalLedgerSessionControllerCountMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type InternalLedgerSessionControllerCountMutationVariables = {ledgerId: number;sessionId: number;data: CountInternalLedgerSessionDto}

    export const useInternalLedgerSessionControllerCount = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerCount>>, TError,InternalLedgerSessionControllerCountMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof internalLedgerSessionControllerCount>>,
        TError,
        InternalLedgerSessionControllerCountMutationVariables,
        TContext
      > => {
      return useMutation(getInternalLedgerSessionControllerCountMutationOptions(options), queryClient);
    }

export type internalLedgerSessionControllerCloseResponse201 = {
  data: ResponseInternalLedgerSessionDto
  status: 201
}

export type internalLedgerSessionControllerCloseResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionControllerCloseResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionControllerCloseResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionControllerCloseResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionControllerCloseResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionControllerCloseResponseSuccess = (internalLedgerSessionControllerCloseResponse201) & {
  headers: Headers;
};
export type internalLedgerSessionControllerCloseResponseError = (internalLedgerSessionControllerCloseResponse400 | internalLedgerSessionControllerCloseResponse401 | internalLedgerSessionControllerCloseResponse403 | internalLedgerSessionControllerCloseResponse404 | internalLedgerSessionControllerCloseResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionControllerCloseResponse = (internalLedgerSessionControllerCloseResponseSuccess | internalLedgerSessionControllerCloseResponseError)

export const getInternalLedgerSessionControllerCloseUrl = (ledgerId: number,
    sessionId: number,) => {




  return `/internal-ledger/${ledgerId}/session/${sessionId}/close`
}

export const internalLedgerSessionControllerClose = async (ledgerId: number,
    sessionId: number,
    closeInternalLedgerSessionDto: CloseInternalLedgerSessionDto, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionControllerCloseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<internalLedgerSessionControllerCloseResponse>(getInternalLedgerSessionControllerCloseUrl(ledgerId,sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(closeInternalLedgerSessionDto)
  }
);}





export const getInternalLedgerSessionControllerCloseMutationKey = () => ['internalLedgerSessionControllerClose'] as const;

export const getInternalLedgerSessionControllerCloseMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerClose>>, TError,InternalLedgerSessionControllerCloseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerClose>>, TError,InternalLedgerSessionControllerCloseMutationVariables, TContext> => {

const mutationKey = getInternalLedgerSessionControllerCloseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLedgerSessionControllerClose>>, InternalLedgerSessionControllerCloseMutationVariables> = (props) => {
          const {ledgerId,sessionId,data} = props ?? {};

          return  internalLedgerSessionControllerClose(ledgerId,sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalLedgerSessionControllerCloseMutationResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionControllerClose>>>
    export type InternalLedgerSessionControllerCloseMutationBody = CloseInternalLedgerSessionDto
    export type InternalLedgerSessionControllerCloseMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type InternalLedgerSessionControllerCloseMutationVariables = {ledgerId: number;sessionId: number;data: CloseInternalLedgerSessionDto}

    export const useInternalLedgerSessionControllerClose = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerClose>>, TError,InternalLedgerSessionControllerCloseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof internalLedgerSessionControllerClose>>,
        TError,
        InternalLedgerSessionControllerCloseMutationVariables,
        TContext
      > => {
      return useMutation(getInternalLedgerSessionControllerCloseMutationOptions(options), queryClient);
    }

export type internalLedgerSessionControllerEndResponse201 = {
  data: ResponseInternalLedgerSessionDto
  status: 201
}

export type internalLedgerSessionControllerEndResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionControllerEndResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionControllerEndResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionControllerEndResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionControllerEndResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionControllerEndResponseSuccess = (internalLedgerSessionControllerEndResponse201) & {
  headers: Headers;
};
export type internalLedgerSessionControllerEndResponseError = (internalLedgerSessionControllerEndResponse400 | internalLedgerSessionControllerEndResponse401 | internalLedgerSessionControllerEndResponse403 | internalLedgerSessionControllerEndResponse404 | internalLedgerSessionControllerEndResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionControllerEndResponse = (internalLedgerSessionControllerEndResponseSuccess | internalLedgerSessionControllerEndResponseError)

export const getInternalLedgerSessionControllerEndUrl = (ledgerId: number,
    sessionId: number,) => {




  return `/internal-ledger/${ledgerId}/session/${sessionId}/end`
}

export const internalLedgerSessionControllerEnd = async (ledgerId: number,
    sessionId: number, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionControllerEndResponse> => {

  return customFetch<internalLedgerSessionControllerEndResponse>(getInternalLedgerSessionControllerEndUrl(ledgerId,sessionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getInternalLedgerSessionControllerEndMutationKey = () => ['internalLedgerSessionControllerEnd'] as const;

export const getInternalLedgerSessionControllerEndMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerEnd>>, TError,InternalLedgerSessionControllerEndMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerEnd>>, TError,InternalLedgerSessionControllerEndMutationVariables, TContext> => {

const mutationKey = getInternalLedgerSessionControllerEndMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLedgerSessionControllerEnd>>, InternalLedgerSessionControllerEndMutationVariables> = (props) => {
          const {ledgerId,sessionId} = props ?? {};

          return  internalLedgerSessionControllerEnd(ledgerId,sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalLedgerSessionControllerEndMutationResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionControllerEnd>>>

    export type InternalLedgerSessionControllerEndMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type InternalLedgerSessionControllerEndMutationVariables = {ledgerId: number;sessionId: number}

    export const useInternalLedgerSessionControllerEnd = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerEnd>>, TError,InternalLedgerSessionControllerEndMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof internalLedgerSessionControllerEnd>>,
        TError,
        InternalLedgerSessionControllerEndMutationVariables,
        TContext
      > => {
      return useMutation(getInternalLedgerSessionControllerEndMutationOptions(options), queryClient);
    }

export type internalLedgerSessionControllerStartResponse201 = {
  data: ResponseInternalLedgerSessionDto
  status: 201
}

export type internalLedgerSessionControllerStartResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionControllerStartResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionControllerStartResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionControllerStartResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionControllerStartResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionControllerStartResponseSuccess = (internalLedgerSessionControllerStartResponse201) & {
  headers: Headers;
};
export type internalLedgerSessionControllerStartResponseError = (internalLedgerSessionControllerStartResponse400 | internalLedgerSessionControllerStartResponse401 | internalLedgerSessionControllerStartResponse403 | internalLedgerSessionControllerStartResponse404 | internalLedgerSessionControllerStartResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionControllerStartResponse = (internalLedgerSessionControllerStartResponseSuccess | internalLedgerSessionControllerStartResponseError)

export const getInternalLedgerSessionControllerStartUrl = (ledgerId: number,
    sessionId: number,) => {




  return `/internal-ledger/${ledgerId}/session/${sessionId}/start`
}

export const internalLedgerSessionControllerStart = async (ledgerId: number,
    sessionId: number, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionControllerStartResponse> => {

  return customFetch<internalLedgerSessionControllerStartResponse>(getInternalLedgerSessionControllerStartUrl(ledgerId,sessionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getInternalLedgerSessionControllerStartMutationKey = () => ['internalLedgerSessionControllerStart'] as const;

export const getInternalLedgerSessionControllerStartMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerStart>>, TError,InternalLedgerSessionControllerStartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerStart>>, TError,InternalLedgerSessionControllerStartMutationVariables, TContext> => {

const mutationKey = getInternalLedgerSessionControllerStartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLedgerSessionControllerStart>>, InternalLedgerSessionControllerStartMutationVariables> = (props) => {
          const {ledgerId,sessionId} = props ?? {};

          return  internalLedgerSessionControllerStart(ledgerId,sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalLedgerSessionControllerStartMutationResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionControllerStart>>>

    export type InternalLedgerSessionControllerStartMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type InternalLedgerSessionControllerStartMutationVariables = {ledgerId: number;sessionId: number}

    export const useInternalLedgerSessionControllerStart = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerStart>>, TError,InternalLedgerSessionControllerStartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof internalLedgerSessionControllerStart>>,
        TError,
        InternalLedgerSessionControllerStartMutationVariables,
        TContext
      > => {
      return useMutation(getInternalLedgerSessionControllerStartMutationOptions(options), queryClient);
    }

export type internalLedgerSessionControllerFindOneActiveResponse200 = {
  data: ResponseInternalLedgerSessionDto
  status: 200
}

export type internalLedgerSessionControllerFindOneActiveResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionControllerFindOneActiveResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionControllerFindOneActiveResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionControllerFindOneActiveResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionControllerFindOneActiveResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionControllerFindOneActiveResponseSuccess = (internalLedgerSessionControllerFindOneActiveResponse200) & {
  headers: Headers;
};
export type internalLedgerSessionControllerFindOneActiveResponseError = (internalLedgerSessionControllerFindOneActiveResponse400 | internalLedgerSessionControllerFindOneActiveResponse401 | internalLedgerSessionControllerFindOneActiveResponse403 | internalLedgerSessionControllerFindOneActiveResponse404 | internalLedgerSessionControllerFindOneActiveResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionControllerFindOneActiveResponse = (internalLedgerSessionControllerFindOneActiveResponseSuccess | internalLedgerSessionControllerFindOneActiveResponseError)

export const getInternalLedgerSessionControllerFindOneActiveUrl = (ledgerId: number,) => {




  return `/internal-ledger/${ledgerId}/session/active`
}

export const internalLedgerSessionControllerFindOneActive = async (ledgerId: number, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionControllerFindOneActiveResponse> => {

  return customFetch<internalLedgerSessionControllerFindOneActiveResponse>(getInternalLedgerSessionControllerFindOneActiveUrl(ledgerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInternalLedgerSessionControllerFindOneActiveQueryKey = (ledgerId: MaybeRefOrGetter<number>,) => {
    return [
    'internal-ledger',ledgerId,'session','active'
    ] as const;
    }


export const getInternalLedgerSessionControllerFindOneActiveQueryOptions = <TData = Awaited<ReturnType<typeof internalLedgerSessionControllerFindOneActive>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(ledgerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOneActive>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getInternalLedgerSessionControllerFindOneActiveQueryKey(ledgerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOneActive>>> = ({ signal }) => internalLedgerSessionControllerFindOneActive(toValue(ledgerId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(ledgerId) !== null && toValue(ledgerId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOneActive>>, TError, TData>
}

export type InternalLedgerSessionControllerFindOneActiveQueryResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOneActive>>>
export type InternalLedgerSessionControllerFindOneActiveQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useInternalLedgerSessionControllerFindOneActive<TData = Awaited<ReturnType<typeof internalLedgerSessionControllerFindOneActive>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 ledgerId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOneActive>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInternalLedgerSessionControllerFindOneActiveQueryOptions(ledgerId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type internalLedgerSessionControllerFindOneResponse200 = {
  data: ResponseInternalLedgerSessionDto
  status: 200
}

export type internalLedgerSessionControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionControllerFindOneResponseSuccess = (internalLedgerSessionControllerFindOneResponse200) & {
  headers: Headers;
};
export type internalLedgerSessionControllerFindOneResponseError = (internalLedgerSessionControllerFindOneResponse400 | internalLedgerSessionControllerFindOneResponse401 | internalLedgerSessionControllerFindOneResponse403 | internalLedgerSessionControllerFindOneResponse404 | internalLedgerSessionControllerFindOneResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionControllerFindOneResponse = (internalLedgerSessionControllerFindOneResponseSuccess | internalLedgerSessionControllerFindOneResponseError)

export const getInternalLedgerSessionControllerFindOneUrl = (ledgerId: number,
    sessionId: number,) => {




  return `/internal-ledger/${ledgerId}/session/${sessionId}`
}

export const internalLedgerSessionControllerFindOne = async (ledgerId: number,
    sessionId: number, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionControllerFindOneResponse> => {

  return customFetch<internalLedgerSessionControllerFindOneResponse>(getInternalLedgerSessionControllerFindOneUrl(ledgerId,sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInternalLedgerSessionControllerFindOneQueryKey = (ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>,) => {
    return [
    'internal-ledger',ledgerId,'session',sessionId
    ] as const;
    }


export const getInternalLedgerSessionControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof internalLedgerSessionControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getInternalLedgerSessionControllerFindOneQueryKey(ledgerId,sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOne>>> = ({ signal }) => internalLedgerSessionControllerFindOne(toValue(ledgerId),toValue(sessionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(ledgerId) !== null && toValue(ledgerId) !== undefined && toValue(sessionId) !== null && toValue(sessionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOne>>, TError, TData>
}

export type InternalLedgerSessionControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOne>>>
export type InternalLedgerSessionControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useInternalLedgerSessionControllerFindOne<TData = Awaited<ReturnType<typeof internalLedgerSessionControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInternalLedgerSessionControllerFindOneQueryOptions(ledgerId,sessionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type internalLedgerSessionLookupControllerFindOneResponse200 = {
  data: ResponseInternalLedgerSessionDto
  status: 200
}

export type internalLedgerSessionLookupControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerSessionLookupControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerSessionLookupControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerSessionLookupControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerSessionLookupControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerSessionLookupControllerFindOneResponseSuccess = (internalLedgerSessionLookupControllerFindOneResponse200) & {
  headers: Headers;
};
export type internalLedgerSessionLookupControllerFindOneResponseError = (internalLedgerSessionLookupControllerFindOneResponse400 | internalLedgerSessionLookupControllerFindOneResponse401 | internalLedgerSessionLookupControllerFindOneResponse403 | internalLedgerSessionLookupControllerFindOneResponse404 | internalLedgerSessionLookupControllerFindOneResponse500) & {
  headers: Headers;
};

export type internalLedgerSessionLookupControllerFindOneResponse = (internalLedgerSessionLookupControllerFindOneResponseSuccess | internalLedgerSessionLookupControllerFindOneResponseError)

export const getInternalLedgerSessionLookupControllerFindOneUrl = (sessionId: number,) => {




  return `/internal-ledger/session/${sessionId}`
}

export const internalLedgerSessionLookupControllerFindOne = async (sessionId: number, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerSessionLookupControllerFindOneResponse> => {

  return customFetch<internalLedgerSessionLookupControllerFindOneResponse>(getInternalLedgerSessionLookupControllerFindOneUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInternalLedgerSessionLookupControllerFindOneQueryKey = (sessionId: MaybeRefOrGetter<number>,) => {
    return [
    'internal-ledger','session',sessionId
    ] as const;
    }


export const getInternalLedgerSessionLookupControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof internalLedgerSessionLookupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(sessionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionLookupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getInternalLedgerSessionLookupControllerFindOneQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLedgerSessionLookupControllerFindOne>>> = ({ signal }) => internalLedgerSessionLookupControllerFindOne(toValue(sessionId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(sessionId) !== null && toValue(sessionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionLookupControllerFindOne>>, TError, TData>
}

export type InternalLedgerSessionLookupControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof internalLedgerSessionLookupControllerFindOne>>>
export type InternalLedgerSessionLookupControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useInternalLedgerSessionLookupControllerFindOne<TData = Awaited<ReturnType<typeof internalLedgerSessionLookupControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 sessionId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerSessionLookupControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInternalLedgerSessionLookupControllerFindOneQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type internalLedgerAdjustmentControllerCreateResponse201 = {
  data: ResponseInternalLedgerAdjustmentDto
  status: 201
}

export type internalLedgerAdjustmentControllerCreateResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerAdjustmentControllerCreateResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerAdjustmentControllerCreateResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerAdjustmentControllerCreateResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerAdjustmentControllerCreateResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerAdjustmentControllerCreateResponseSuccess = (internalLedgerAdjustmentControllerCreateResponse201) & {
  headers: Headers;
};
export type internalLedgerAdjustmentControllerCreateResponseError = (internalLedgerAdjustmentControllerCreateResponse400 | internalLedgerAdjustmentControllerCreateResponse401 | internalLedgerAdjustmentControllerCreateResponse403 | internalLedgerAdjustmentControllerCreateResponse404 | internalLedgerAdjustmentControllerCreateResponse500) & {
  headers: Headers;
};

export type internalLedgerAdjustmentControllerCreateResponse = (internalLedgerAdjustmentControllerCreateResponseSuccess | internalLedgerAdjustmentControllerCreateResponseError)

export const getInternalLedgerAdjustmentControllerCreateUrl = (ledgerId: number,
    sessionId: number,) => {




  return `/internal-ledger/${ledgerId}/session/${sessionId}/adjustment`
}

export const internalLedgerAdjustmentControllerCreate = async (ledgerId: number,
    sessionId: number,
    createInternalLedgerAdjustmentDto: CreateInternalLedgerAdjustmentDto, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerAdjustmentControllerCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<internalLedgerAdjustmentControllerCreateResponse>(getInternalLedgerAdjustmentControllerCreateUrl(ledgerId,sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInternalLedgerAdjustmentDto)
  }
);}





export const getInternalLedgerAdjustmentControllerCreateMutationKey = () => ['internalLedgerAdjustmentControllerCreate'] as const;

export const getInternalLedgerAdjustmentControllerCreateMutationOptions = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerCreate>>, TError,InternalLedgerAdjustmentControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerCreate>>, TError,InternalLedgerAdjustmentControllerCreateMutationVariables, TContext> => {

const mutationKey = getInternalLedgerAdjustmentControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerCreate>>, InternalLedgerAdjustmentControllerCreateMutationVariables> = (props) => {
          const {ledgerId,sessionId,data} = props ?? {};

          return  internalLedgerAdjustmentControllerCreate(ledgerId,sessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalLedgerAdjustmentControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerCreate>>>
    export type InternalLedgerAdjustmentControllerCreateMutationBody = CreateInternalLedgerAdjustmentDto
    export type InternalLedgerAdjustmentControllerCreateMutationError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto
    export type InternalLedgerAdjustmentControllerCreateMutationVariables = {ledgerId: number;sessionId: number;data: CreateInternalLedgerAdjustmentDto}

    export const useInternalLedgerAdjustmentControllerCreate = <TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerCreate>>, TError,InternalLedgerAdjustmentControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof internalLedgerAdjustmentControllerCreate>>,
        TError,
        InternalLedgerAdjustmentControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getInternalLedgerAdjustmentControllerCreateMutationOptions(options), queryClient);
    }

export type internalLedgerAdjustmentControllerFindAllResponse200 = {
  data: InternalLedgerAdjustmentControllerFindAll200
  status: 200
}

export type internalLedgerAdjustmentControllerFindAllResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerAdjustmentControllerFindAllResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerAdjustmentControllerFindAllResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerAdjustmentControllerFindAllResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerAdjustmentControllerFindAllResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerAdjustmentControllerFindAllResponseSuccess = (internalLedgerAdjustmentControllerFindAllResponse200) & {
  headers: Headers;
};
export type internalLedgerAdjustmentControllerFindAllResponseError = (internalLedgerAdjustmentControllerFindAllResponse400 | internalLedgerAdjustmentControllerFindAllResponse401 | internalLedgerAdjustmentControllerFindAllResponse403 | internalLedgerAdjustmentControllerFindAllResponse404 | internalLedgerAdjustmentControllerFindAllResponse500) & {
  headers: Headers;
};

export type internalLedgerAdjustmentControllerFindAllResponse = (internalLedgerAdjustmentControllerFindAllResponseSuccess | internalLedgerAdjustmentControllerFindAllResponseError)

export const getInternalLedgerAdjustmentControllerFindAllUrl = (ledgerId: number,
    sessionId: number,
    params?: InternalLedgerAdjustmentControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter.type","filter.createdBy.id","filter.amount","filter.createdAt","sortBy","searchBy"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/internal-ledger/${ledgerId}/session/${sessionId}/adjustment?${stringifiedParams}` : `/internal-ledger/${ledgerId}/session/${sessionId}/adjustment`
}

export const internalLedgerAdjustmentControllerFindAll = async (ledgerId: number,
    sessionId: number,
    params?: InternalLedgerAdjustmentControllerFindAllParams, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerAdjustmentControllerFindAllResponse> => {

  return customFetch<internalLedgerAdjustmentControllerFindAllResponse>(getInternalLedgerAdjustmentControllerFindAllUrl(ledgerId,sessionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInternalLedgerAdjustmentControllerFindAllQueryKey = (ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<InternalLedgerAdjustmentControllerFindAllParams>,) => {
    return [
    'internal-ledger',ledgerId,'session',sessionId,'adjustment', ...(params ? [params] : [])
    ] as const;
    }


export const getInternalLedgerAdjustmentControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<InternalLedgerAdjustmentControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getInternalLedgerAdjustmentControllerFindAllQueryKey(ledgerId,sessionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindAll>>> = ({ signal }) => internalLedgerAdjustmentControllerFindAll(toValue(ledgerId),toValue(sessionId),toValue(params), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(ledgerId) !== null && toValue(ledgerId) !== undefined && toValue(sessionId) !== null && toValue(sessionId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindAll>>, TError, TData>
}

export type InternalLedgerAdjustmentControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindAll>>>
export type InternalLedgerAdjustmentControllerFindAllQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useInternalLedgerAdjustmentControllerFindAll<TData = Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindAll>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<InternalLedgerAdjustmentControllerFindAllParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInternalLedgerAdjustmentControllerFindAllQueryOptions(ledgerId,sessionId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







export type internalLedgerAdjustmentControllerFindOneResponse200 = {
  data: ResponseInternalLedgerAdjustmentDto
  status: 200
}

export type internalLedgerAdjustmentControllerFindOneResponse400 = {
  data: ErrorBadRequestDto
  status: 400
}

export type internalLedgerAdjustmentControllerFindOneResponse401 = {
  data: ErrorUnauthorizedDto
  status: 401
}

export type internalLedgerAdjustmentControllerFindOneResponse403 = {
  data: ErrorForbiddenDto
  status: 403
}

export type internalLedgerAdjustmentControllerFindOneResponse404 = {
  data: ErrorNotFoundDto
  status: 404
}

export type internalLedgerAdjustmentControllerFindOneResponse500 = {
  data: ErrorServerDto
  status: 500
}

export type internalLedgerAdjustmentControllerFindOneResponseSuccess = (internalLedgerAdjustmentControllerFindOneResponse200) & {
  headers: Headers;
};
export type internalLedgerAdjustmentControllerFindOneResponseError = (internalLedgerAdjustmentControllerFindOneResponse400 | internalLedgerAdjustmentControllerFindOneResponse401 | internalLedgerAdjustmentControllerFindOneResponse403 | internalLedgerAdjustmentControllerFindOneResponse404 | internalLedgerAdjustmentControllerFindOneResponse500) & {
  headers: Headers;
};

export type internalLedgerAdjustmentControllerFindOneResponse = (internalLedgerAdjustmentControllerFindOneResponseSuccess | internalLedgerAdjustmentControllerFindOneResponseError)

export const getInternalLedgerAdjustmentControllerFindOneUrl = (ledgerId: number,
    sessionId: number,
    adjustmentId: number,) => {




  return `/internal-ledger/${ledgerId}/session/${sessionId}/adjustment/${adjustmentId}`
}

export const internalLedgerAdjustmentControllerFindOne = async (ledgerId: number,
    sessionId: number,
    adjustmentId: number, options?: Parameters<typeof customFetch>[1]): Promise<internalLedgerAdjustmentControllerFindOneResponse> => {

  return customFetch<internalLedgerAdjustmentControllerFindOneResponse>(getInternalLedgerAdjustmentControllerFindOneUrl(ledgerId,sessionId,adjustmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInternalLedgerAdjustmentControllerFindOneQueryKey = (ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>,
    adjustmentId: MaybeRefOrGetter<number>,) => {
    return [
    'internal-ledger',ledgerId,'session',sessionId,'adjustment',adjustmentId
    ] as const;
    }


export const getInternalLedgerAdjustmentControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>,
    adjustmentId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getInternalLedgerAdjustmentControllerFindOneQueryKey(ledgerId,sessionId,adjustmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindOne>>> = ({ signal }) => internalLedgerAdjustmentControllerFindOne(toValue(ledgerId),toValue(sessionId),toValue(adjustmentId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => toValue(ledgerId) !== null && toValue(ledgerId) !== undefined && toValue(sessionId) !== null && toValue(sessionId) !== undefined && toValue(adjustmentId) !== null && toValue(adjustmentId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindOne>>, TError, TData>
}

export type InternalLedgerAdjustmentControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindOne>>>
export type InternalLedgerAdjustmentControllerFindOneQueryError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto



export function useInternalLedgerAdjustmentControllerFindOne<TData = Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindOne>>, TError = ErrorBadRequestDto | ErrorUnauthorizedDto | ErrorForbiddenDto | ErrorNotFoundDto | ErrorServerDto>(
 ledgerId: MaybeRefOrGetter<number>,
    sessionId: MaybeRefOrGetter<number>,
    adjustmentId: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalLedgerAdjustmentControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInternalLedgerAdjustmentControllerFindOneQueryOptions(ledgerId,sessionId,adjustmentId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}







